
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire984a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire984a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7we3r", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    var context = new $ewFRw(defaultConfig);
    var instance = $jJbMR($ewFRw.prototype.request, context);
    // Copy axios.prototype to instance
    $gKvUL.extend(instance, $ewFRw.prototype, context);
    // Copy context to instance
    $gKvUL.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance($lJY4v);
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = $ewFRw;
// Factory for creating new instances
$57966c7e0affc4cb$var$axios.create = function create(instanceConfig) {
    return $57966c7e0affc4cb$var$createInstance($lk5EI($57966c7e0affc4cb$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.Cancel = (parcelRequire("4Tkeq"));

$57966c7e0affc4cb$var$axios.CancelToken = (parcelRequire("lAKPy"));

$57966c7e0affc4cb$var$axios.isCancel = (parcelRequire("7L4QX"));
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$57966c7e0affc4cb$var$axios.spread = (parcelRequire("JEeti"));

// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (parcelRequire("dxy9O"));
module.exports = $57966c7e0affc4cb$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $57966c7e0affc4cb$var$axios;

});
parcelRegister("gKvUL", function(module, exports) {
'use strict';

var $jJbMR = parcelRequire("jJbMR");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $c319b2c832c2914a$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $c319b2c832c2914a$var$isArray(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $c319b2c832c2914a$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBuffer(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $c319b2c832c2914a$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $c319b2c832c2914a$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $c319b2c832c2914a$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $c319b2c832c2914a$var$isPlainObject(val) {
    if ($c319b2c832c2914a$var$toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $c319b2c832c2914a$var$isDate(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $c319b2c832c2914a$var$isFile(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $c319b2c832c2914a$var$isBlob(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $c319b2c832c2914a$var$isFunction(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $c319b2c832c2914a$var$isStream(val) {
    return $c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $c319b2c832c2914a$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $c319b2c832c2914a$var$trim(str) {
    return str.replace(/^\s*/, '').replace(/\s*$/, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $c319b2c832c2914a$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $c319b2c832c2914a$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($c319b2c832c2914a$var$isPlainObject(result[key]) && $c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge(result[key], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $c319b2c832c2914a$var$extend(a, b, thisArg) {
    $c319b2c832c2914a$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $jJbMR(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $c319b2c832c2914a$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isStandardBrowserEnv: $c319b2c832c2914a$var$isStandardBrowserEnv,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM
};

});
parcelRegister("jJbMR", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("ewFRw", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $a93486d2307f31c3$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $83RYu(),
        response: new $83RYu()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $a93486d2307f31c3$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $lk5EI(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    // Hook up interceptors middleware
    var chain = [
        $dlZEJ,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
$a93486d2307f31c3$var$Axios.prototype.getUri = function getUri(config) {
    config = $lk5EI(this.defaults, config);
    return $cbIsf(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$gKvUL.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$gKvUL.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $a93486d2307f31c3$var$Axios;

});
parcelRegister("cbIsf", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($gKvUL.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $gKvUL.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($gKvUL.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $gKvUL.forEach(val, function parseValue(v) {
                if ($gKvUL.isDate(v)) v = v.toISOString();
                else if ($gKvUL.isObject(v)) v = JSON.stringify(v);
                parts.push($8df8fedf1c1e4428$var$encode(key) + '=' + $8df8fedf1c1e4428$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("83RYu", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
function $5de878cd737ef277$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $5de878cd737ef277$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $5de878cd737ef277$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $5de878cd737ef277$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $gKvUL.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $5de878cd737ef277$var$InterceptorManager;

});

parcelRegister("dlZEJ", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $7YJ0v(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $gKvUL.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $gKvUL.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $lJY4v.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $7YJ0v(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$7L4QX(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $7YJ0v(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("7YJ0v", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $gKvUL.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRegister("7L4QX", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("lJY4v", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");

var $kiL6T = parcelRequire("kiL6T");
var $fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, value) {
    if (!$gKvUL.isUndefined(headers) && $gKvUL.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $fd3c65eeb28abd71$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("at5cb"));
    return adapter;
}
var $fd3c65eeb28abd71$var$defaults = {
    adapter: $fd3c65eeb28abd71$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $kiL6T(headers, 'Accept');
            $kiL6T(headers, 'Content-Type');
            if ($gKvUL.isFormData(data) || $gKvUL.isArrayBuffer(data) || $gKvUL.isBuffer(data) || $gKvUL.isStream(data) || $gKvUL.isFile(data) || $gKvUL.isBlob(data)) return data;
            if ($gKvUL.isArrayBufferView(data)) return data.buffer;
            if ($gKvUL.isURLSearchParams(data)) {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($gKvUL.isObject(data)) {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === 'string') try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$fd3c65eeb28abd71$var$defaults.headers = {
    common: {
        'Accept': 'application/json, text/plain, */*'
    }
};
$gKvUL.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = {};
});
$gKvUL.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = $gKvUL.merge($fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $fd3c65eeb28abd71$var$defaults;

});
parcelRegister("kiL6T", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $gKvUL.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("at5cb", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $8JRzs = parcelRequire("8JRzs");

var $cbIsf = parcelRequire("cbIsf");

var $7GD7a = parcelRequire("7GD7a");

var $lDriZ = parcelRequire("lDriZ");

var $889er = parcelRequire("889er");

var $kjF3e = parcelRequire("kjF3e");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($gKvUL.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $7GD7a(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $cbIsf(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $lDriZ(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $kk0E9(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($kjF3e('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($kjF3e('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($kjF3e(timeoutErrorMessage, config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($gKvUL.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $889er(fullPath)) && config.xsrfCookieName ? $8JRzs.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $gKvUL.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$gKvUL.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== 'json') throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("kk0E9", function(module, exports) {
'use strict';

var $kjF3e = parcelRequire("kjF3e");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($kjF3e('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("kjF3e", function(module, exports) {
'use strict';

var $8v8A7 = parcelRequire("8v8A7");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $8v8A7(error, config, code, request, response);
};

});
parcelRegister("8v8A7", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});



parcelRegister("8JRzs", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($gKvUL.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($gKvUL.isString(path)) cookie.push('path=' + path);
            if ($gKvUL.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("7GD7a", function(module, exports) {
'use strict';

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$ckHwb(requestedURL)) return $fE4ul(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("ckHwb", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("fE4ul", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("lDriZ", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $fc026bbf9ee156f1$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $gKvUL.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $gKvUL.trim(line.substr(0, i)).toLowerCase();
        val = $gKvUL.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("889er", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $gKvUL.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("lk5EI", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        'url',
        'method',
        'data'
    ];
    var mergeDeepPropertiesKeys = [
        'headers',
        'auth',
        'proxy',
        'params'
    ];
    var defaultToConfig2Keys = [
        'baseURL',
        'transformRequest',
        'transformResponse',
        'paramsSerializer',
        'timeout',
        'timeoutMessage',
        'withCredentials',
        'adapter',
        'responseType',
        'xsrfCookieName',
        'xsrfHeaderName',
        'onUploadProgress',
        'onDownloadProgress',
        'decompress',
        'maxContentLength',
        'maxBodyLength',
        'maxRedirects',
        'transport',
        'httpAgent',
        'httpsAgent',
        'cancelToken',
        'socketPath',
        'responseEncoding'
    ];
    var directMergeKeys = [
        'validateStatus'
    ];
    function getMergedValue(target, source) {
        if ($gKvUL.isPlainObject(target) && $gKvUL.isPlainObject(source)) return $gKvUL.merge(target, source);
        else if ($gKvUL.isPlainObject(source)) return $gKvUL.merge({}, source);
        else if ($gKvUL.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $gKvUL.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $gKvUL.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $gKvUL.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $gKvUL.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $gKvUL.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});


parcelRegister("4Tkeq", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $38fbfe0afbd5bf1e$var$Cancel(message) {
    this.message = message;
}
$38fbfe0afbd5bf1e$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$38fbfe0afbd5bf1e$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $38fbfe0afbd5bf1e$var$Cancel;

});

parcelRegister("lAKPy", function(module, exports) {
'use strict';

var $4Tkeq = parcelRequire("4Tkeq");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $fb81495929d8a282$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $4Tkeq(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $fb81495929d8a282$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $fb81495929d8a282$var$CancelToken.source = function source() {
    var cancel;
    var token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $fb81495929d8a282$var$CancelToken;

});

parcelRegister("JEeti", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("dxy9O", function(module, exports) {
'use strict';
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === 'object' && payload.isAxiosError === true;
};

});


var $bfc2f5739098ea1c$exports = {};
(function(global1, factory) {
    factory($bfc2f5739098ea1c$exports);
})($bfc2f5739098ea1c$exports, function(exports1) {
    'use strict';
    /**
 * TODO: Ideally this would be a NodeList.prototype.forEach polyfill
 * This seems to fail in IE8, requires more investigation.
 * See: https://github.com/imagitama/nodelist-foreach-polyfill
 */ function nodeListForEach(nodes, callback) {
        if (window.NodeList.prototype.forEach) return nodes.forEach(callback);
        for(var i = 0; i < nodes.length; i++)callback.call(window, nodes[i], i, nodes);
    }
    // Used to generate a unique string, allows multiple instances of the component without
    // Them conflicting with each other.
    // https://stackoverflow.com/a/8809472
    function generateUniqueID() {
        var d = new Date().getTime();
        if (typeof window.performance !== 'undefined' && typeof window.performance.now === 'function') d += window.performance.now(); // use high-precision timer if available
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
        });
    }
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Object/defineProperty/detect.js
        var detect = // In IE8, defineProperty could only act on DOM elements, so full support
        // for the feature requires the ability to set a property on an arbitrary object
        'defineProperty' in Object && function() {
            try {
                var a = {};
                Object.defineProperty(a, 'test', {
                    value: 42
                });
                return true;
            } catch (e) {
                return false;
            }
        }();
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Object.defineProperty&flags=always
        (function(nativeDefineProperty) {
            var supportsAccessors = Object.prototype.hasOwnProperty('__defineGetter__');
            var ERR_ACCESSORS_NOT_SUPPORTED = 'Getters & setters cannot be defined on this javascript engine';
            var ERR_VALUE_ACCESSORS = 'A property cannot both have accessors and be writable or have a value';
            Object.defineProperty = function defineProperty(object, property, descriptor) {
                // Where native support exists, assume it
                if (nativeDefineProperty && (object === window || object === document || object === Element.prototype || object instanceof Element)) return nativeDefineProperty(object, property, descriptor);
                if (object === null || !(object instanceof Object || typeof object === 'object')) throw new TypeError('Object.defineProperty called on non-object');
                if (!(descriptor instanceof Object)) throw new TypeError('Property description must be an object');
                var propertyString = String(property);
                var hasValueOrWritable = 'value' in descriptor || 'writable' in descriptor;
                var getterType = 'get' in descriptor && typeof descriptor.get;
                var setterType = 'set' in descriptor && typeof descriptor.set;
                // handle descriptor.get
                if (getterType) {
                    if (getterType !== 'function') throw new TypeError('Getter must be a function');
                    if (!supportsAccessors) throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
                    if (hasValueOrWritable) throw new TypeError(ERR_VALUE_ACCESSORS);
                    Object.__defineGetter__.call(object, propertyString, descriptor.get);
                } else object[propertyString] = descriptor.value;
                // handle descriptor.set
                if (setterType) {
                    if (setterType !== 'function') throw new TypeError('Setter must be a function');
                    if (!supportsAccessors) throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
                    if (hasValueOrWritable) throw new TypeError(ERR_VALUE_ACCESSORS);
                    Object.__defineSetter__.call(object, propertyString, descriptor.set);
                }
                // OK to define value unconditionally - if a getter has been specified as well, an error would be thrown above
                if ('value' in descriptor) object[propertyString] = descriptor.value;
                return object;
            };
        })(Object.defineProperty);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Function/prototype/bind/detect.js
        var detect = 'bind' in Function.prototype;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Function.prototype.bind&flags=always
        Object.defineProperty(Function.prototype, 'bind', {
            value: function bind(that) {
                // add necessary es5-shim utilities
                var $Array = Array;
                var $Object = Object;
                var ObjectPrototype = $Object.prototype;
                var ArrayPrototype = $Array.prototype;
                var Empty = function Empty() {};
                var to_string = ObjectPrototype.toString;
                var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
                var isCallable; /* inlined from https://npmjs.com/is-callable */ 
                var fnToStr = Function.prototype.toString, tryFunctionObject = function tryFunctionObject(value) {
                    try {
                        fnToStr.call(value);
                        return true;
                    } catch (e) {
                        return false;
                    }
                }, fnClass = '[object Function]', genClass = '[object GeneratorFunction]';
                isCallable = function isCallable(value) {
                    if (typeof value !== 'function') return false;
                    if (hasToStringTag) return tryFunctionObject(value);
                    var strClass = to_string.call(value);
                    return strClass === fnClass || strClass === genClass;
                };
                var array_slice = ArrayPrototype.slice;
                var array_concat = ArrayPrototype.concat;
                var array_push = ArrayPrototype.push;
                var max = Math.max;
                // /add necessary es5-shim utilities
                // 1. Let Target be the this value.
                var target = this;
                // 2. If IsCallable(Target) is false, throw a TypeError exception.
                if (!isCallable(target)) throw new TypeError('Function.prototype.bind called on incompatible ' + target);
                // 3. Let A be a new (possibly empty) internal list of all of the
                //   argument values provided after thisArg (arg1, arg2 etc), in order.
                // XXX slicedArgs will stand in for "A" if used
                var args = array_slice.call(arguments, 1); // for normal call
                // 4. Let F be a new native ECMAScript object.
                // 11. Set the [[Prototype]] internal property of F to the standard
                //   built-in Function prototype object as specified in 15.3.3.1.
                // 12. Set the [[Call]] internal property of F as described in
                //   15.3.4.5.1.
                // 13. Set the [[Construct]] internal property of F as described in
                //   15.3.4.5.2.
                // 14. Set the [[HasInstance]] internal property of F as described in
                //   15.3.4.5.3.
                var bound;
                var binder = function() {
                    if (this instanceof bound) {
                        // 15.3.4.5.2 [[Construct]]
                        // When the [[Construct]] internal method of a function object,
                        // F that was created using the bind function is called with a
                        // list of arguments ExtraArgs, the following steps are taken:
                        // 1. Let target be the value of F's [[TargetFunction]]
                        //   internal property.
                        // 2. If target has no [[Construct]] internal method, a
                        //   TypeError exception is thrown.
                        // 3. Let boundArgs be the value of F's [[BoundArgs]] internal
                        //   property.
                        // 4. Let args be a new list containing the same values as the
                        //   list boundArgs in the same order followed by the same
                        //   values as the list ExtraArgs in the same order.
                        // 5. Return the result of calling the [[Construct]] internal
                        //   method of target providing args as the arguments.
                        var result = target.apply(this, array_concat.call(args, array_slice.call(arguments)));
                        if ($Object(result) === result) return result;
                        return this;
                    } else // 15.3.4.5.1 [[Call]]
                    // When the [[Call]] internal method of a function object, F,
                    // which was created using the bind function is called with a
                    // this value and a list of arguments ExtraArgs, the following
                    // steps are taken:
                    // 1. Let boundArgs be the value of F's [[BoundArgs]] internal
                    //   property.
                    // 2. Let boundThis be the value of F's [[BoundThis]] internal
                    //   property.
                    // 3. Let target be the value of F's [[TargetFunction]] internal
                    //   property.
                    // 4. Let args be a new list containing the same values as the
                    //   list boundArgs in the same order followed by the same
                    //   values as the list ExtraArgs in the same order.
                    // 5. Return the result of calling the [[Call]] internal method
                    //   of target providing boundThis as the this value and
                    //   providing args as the arguments.
                    // equiv: target.call(this, ...boundArgs, ...args)
                    return target.apply(that, array_concat.call(args, array_slice.call(arguments)));
                };
                // 15. If the [[Class]] internal property of Target is "Function", then
                //     a. Let L be the length property of Target minus the length of A.
                //     b. Set the length own property of F to either 0 or L, whichever is
                //       larger.
                // 16. Else set the length own property of F to 0.
                var boundLength = max(0, target.length - args.length);
                // 17. Set the attributes of the length own property of F to the values
                //   specified in 15.3.5.1.
                var boundArgs = [];
                for(var i = 0; i < boundLength; i++)array_push.call(boundArgs, '$' + i);
                // XXX Build a dynamic function with desired amount of arguments is the only
                // way to set the length property of a function.
                // In environments where Content Security Policies enabled (Chrome extensions,
                // for ex.) all use of eval or Function costructor throws an exception.
                // However in all of these environments Function.prototype.bind exists
                // and so this code will never be executed.
                bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this, arguments); }')(binder);
                if (target.prototype) {
                    Empty.prototype = target.prototype;
                    bound.prototype = new Empty();
                    // Clean up dangling references.
                    Empty.prototype = null;
                }
                // TODO
                // 18. Set the [[Extensible]] internal property of F to true.
                // TODO
                // 19. Let thrower be the [[ThrowTypeError]] function Object (13.2.3).
                // 20. Call the [[DefineOwnProperty]] internal method of F with
                //   arguments "caller", PropertyDescriptor {[[Get]]: thrower, [[Set]]:
                //   thrower, [[Enumerable]]: false, [[Configurable]]: false}, and
                //   false.
                // 21. Call the [[DefineOwnProperty]] internal method of F with
                //   arguments "arguments", PropertyDescriptor {[[Get]]: thrower,
                //   [[Set]]: thrower, [[Enumerable]]: false, [[Configurable]]: false},
                //   and false.
                // TODO
                // NOTE Function objects created using Function.prototype.bind do not
                // have a prototype property or the [[Code]], [[FormalParameters]], and
                // [[Scope]] internal properties.
                // XXX can't delete prototype in pure-js.
                // 22. Return F.
                return bound;
            }
        });
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-service/master/packages/polyfill-library/polyfills/DOMTokenList/detect.js
        var detect = 'DOMTokenList' in this && function(x) {
            return 'classList' in x ? !x.classList.toggle('x', false) && !x.className : true;
        }(document.createElement('x'));
        if (detect) return;
        // Polyfill from https://raw.githubusercontent.com/Financial-Times/polyfill-service/master/packages/polyfill-library/polyfills/DOMTokenList/polyfill.js
        (function(global1) {
            var nativeImpl = "DOMTokenList" in global1 && global1.DOMTokenList;
            if (!nativeImpl || !!document.createElementNS && !!document.createElementNS('http://www.w3.org/2000/svg', 'svg') && !(document.createElementNS("http://www.w3.org/2000/svg", "svg").classList instanceof DOMTokenList)) global1.DOMTokenList = function() {
                var dpSupport = true;
                var defineGetter = function(object, name, fn, configurable) {
                    if (Object.defineProperty) Object.defineProperty(object, name, {
                        configurable: false === dpSupport ? true : !!configurable,
                        get: fn
                    });
                    else object.__defineGetter__(name, fn);
                };
                /** Ensure the browser allows Object.defineProperty to be used on native JavaScript objects. */ try {
                    defineGetter({}, "support");
                } catch (e) {
                    dpSupport = false;
                }
                var _DOMTokenList = function(el, prop) {
                    var that = this;
                    var tokens = [];
                    var tokenMap = {};
                    var length = 0;
                    var maxLength = 0;
                    var addIndexGetter = function(i) {
                        defineGetter(that, i, function() {
                            preop();
                            return tokens[i];
                        }, false);
                    };
                    var reindex = function() {
                        /** Define getter functions for array-like access to the tokenList's contents. */ if (length >= maxLength) for(; maxLength < length; ++maxLength)addIndexGetter(maxLength);
                    };
                    /** Helper function called at the start of each class method. Internal use only. */ var preop = function() {
                        var error;
                        var i;
                        var args = arguments;
                        var rSpace = /\s+/;
                        /** Validate the token/s passed to an instance method, if any. */ if (args.length) {
                            for(i = 0; i < args.length; ++i)if (rSpace.test(args[i])) {
                                error = new SyntaxError('String "' + args[i] + '" ' + "contains" + ' an invalid character');
                                error.code = 5;
                                error.name = "InvalidCharacterError";
                                throw error;
                            }
                        }
                        /** Split the new value apart by whitespace*/ if (typeof el[prop] === "object") tokens = ("" + el[prop].baseVal).replace(/^\s+|\s+$/g, "").split(rSpace);
                        else tokens = ("" + el[prop]).replace(/^\s+|\s+$/g, "").split(rSpace);
                        /** Avoid treating blank strings as single-item token lists */ if ("" === tokens[0]) tokens = [];
                        /** Repopulate the internal token lists */ tokenMap = {};
                        for(i = 0; i < tokens.length; ++i)tokenMap[tokens[i]] = true;
                        length = tokens.length;
                        reindex();
                    };
                    /** Populate our internal token list if the targeted attribute of the subject element isn't empty. */ preop();
                    /** Return the number of tokens in the underlying string. Read-only. */ defineGetter(that, "length", function() {
                        preop();
                        return length;
                    });
                    /** Override the default toString/toLocaleString methods to return a space-delimited list of tokens when typecast. */ that.toLocaleString = that.toString = function() {
                        preop();
                        return tokens.join(" ");
                    };
                    that.item = function(idx) {
                        preop();
                        return tokens[idx];
                    };
                    that.contains = function(token) {
                        preop();
                        return !!tokenMap[token];
                    };
                    that.add = function() {
                        preop.apply(that, args = arguments);
                        for(var args, token, i = 0, l = args.length; i < l; ++i){
                            token = args[i];
                            if (!tokenMap[token]) {
                                tokens.push(token);
                                tokenMap[token] = true;
                            }
                        }
                        /** Update the targeted attribute of the attached element if the token list's changed. */ if (length !== tokens.length) {
                            length = tokens.length >>> 0;
                            if (typeof el[prop] === "object") el[prop].baseVal = tokens.join(" ");
                            else el[prop] = tokens.join(" ");
                            reindex();
                        }
                    };
                    that.remove = function() {
                        preop.apply(that, args = arguments);
                        /** Build a hash of token names to compare against when recollecting our token list. */ for(var args, ignore = {}, i = 0, t = []; i < args.length; ++i){
                            ignore[args[i]] = true;
                            delete tokenMap[args[i]];
                        }
                        /** Run through our tokens list and reassign only those that aren't defined in the hash declared above. */ for(i = 0; i < tokens.length; ++i)if (!ignore[tokens[i]]) t.push(tokens[i]);
                        tokens = t;
                        length = t.length >>> 0;
                        /** Update the targeted attribute of the attached element. */ if (typeof el[prop] === "object") el[prop].baseVal = tokens.join(" ");
                        else el[prop] = tokens.join(" ");
                        reindex();
                    };
                    that.toggle = function(token, force) {
                        preop.apply(that, [
                            token
                        ]);
                        /** Token state's being forced. */ if (undefined !== force) {
                            if (force) {
                                that.add(token);
                                return true;
                            } else {
                                that.remove(token);
                                return false;
                            }
                        }
                        /** Token already exists in tokenList. Remove it, and return FALSE. */ if (tokenMap[token]) {
                            that.remove(token);
                            return false;
                        }
                        /** Otherwise, add the token and return TRUE. */ that.add(token);
                        return true;
                    };
                    return that;
                };
                return _DOMTokenList;
            }();
            // Add second argument to native DOMTokenList.toggle() if necessary
            (function() {
                var e = document.createElement('span');
                if (!('classList' in e)) return;
                e.classList.toggle('x', false);
                if (!e.classList.contains('x')) return;
                e.classList.constructor.prototype.toggle = function toggle(token /*, force*/ ) {
                    var force = arguments[1];
                    if (force === undefined) {
                        var add = !this.contains(token);
                        this[add ? 'add' : 'remove'](token);
                        return add;
                    }
                    force = !!force;
                    this[force ? 'add' : 'remove'](token);
                    return force;
                };
            })();
            // Add multiple arguments to native DOMTokenList.add() if necessary
            (function() {
                var e = document.createElement('span');
                if (!('classList' in e)) return;
                e.classList.add('a', 'b');
                if (e.classList.contains('b')) return;
                var native = e.classList.constructor.prototype.add;
                e.classList.constructor.prototype.add = function() {
                    var args = arguments;
                    var l = arguments.length;
                    for(var i = 0; i < l; i++)native.call(this, args[i]);
                };
            })();
            // Add multiple arguments to native DOMTokenList.remove() if necessary
            (function() {
                var e = document.createElement('span');
                if (!('classList' in e)) return;
                e.classList.add('a');
                e.classList.add('b');
                e.classList.remove('a', 'b');
                if (!e.classList.contains('b')) return;
                var native = e.classList.constructor.prototype.remove;
                e.classList.constructor.prototype.remove = function() {
                    var args = arguments;
                    var l = arguments.length;
                    for(var i = 0; i < l; i++)native.call(this, args[i]);
                };
            })();
        })(this);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Document/detect.js
        var detect = "Document" in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Document&flags=always
        if (typeof WorkerGlobalScope === "undefined" && typeof importScripts !== "function") {
            if (this.HTMLDocument) // HTMLDocument is an extension of Document.  If the browser has HTMLDocument but not Document, the former will suffice as an alias for the latter.
            this.Document = this.HTMLDocument;
            else {
                // Create an empty function to act as the missing constructor for the document object, attach the document object as its prototype.  The function needs to be anonymous else it is hoisted and causes the feature detect to prematurely pass, preventing the assignments below being made.
                this.Document = this.HTMLDocument = document.constructor = new Function('return function Document() {}')();
                this.Document.prototype = document;
            }
        }
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Element/detect.js
        var detect = 'Element' in this && 'HTMLElement' in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Element&flags=always
        (function() {
            // IE8
            if (window.Element && !window.HTMLElement) {
                window.HTMLElement = window.Element;
                return;
            }
            // create Element constructor
            window.Element = window.HTMLElement = new Function('return function Element() {}')();
            // generate sandboxed iframe
            var vbody = document.appendChild(document.createElement('body'));
            var frame = vbody.appendChild(document.createElement('iframe'));
            // use sandboxed iframe to replicate Element functionality
            var frameDocument = frame.contentWindow.document;
            var prototype = Element.prototype = frameDocument.appendChild(frameDocument.createElement('*'));
            var cache = {};
            // polyfill Element.prototype on an element
            var shiv = function(element, deep) {
                var childNodes = element.childNodes || [], index = -1, key, value, childNode;
                if (element.nodeType === 1 && element.constructor !== Element) {
                    element.constructor = Element;
                    for(key in cache){
                        value = cache[key];
                        element[key] = value;
                    }
                }
                while(childNode = deep && childNodes[++index])shiv(childNode, deep);
                return element;
            };
            var elements = document.getElementsByTagName('*');
            var nativeCreateElement = document.createElement;
            var interval;
            var loopLimit = 100;
            prototype.attachEvent('onpropertychange', function(event) {
                var propertyName = event.propertyName, nonValue = !cache.hasOwnProperty(propertyName), newValue = prototype[propertyName], oldValue = cache[propertyName], index = -1, element;
                while(element = elements[++index]){
                    if (element.nodeType === 1) {
                        if (nonValue || element[propertyName] === oldValue) element[propertyName] = newValue;
                    }
                }
                cache[propertyName] = newValue;
            });
            prototype.constructor = Element;
            if (!prototype.hasAttribute) // <Element>.hasAttribute
            prototype.hasAttribute = function hasAttribute(name) {
                return this.getAttribute(name) !== null;
            };
            // Apply Element prototype to the pre-existing DOM as soon as the body element appears.
            function bodyCheck() {
                if (!loopLimit--) clearTimeout(interval);
                if (document.body && !document.body.prototype && /(complete|interactive)/.test(document.readyState)) {
                    shiv(document, true);
                    if (interval && document.body.prototype) clearTimeout(interval);
                    return !!document.body.prototype;
                }
                return false;
            }
            if (!bodyCheck()) {
                document.onreadystatechange = bodyCheck;
                interval = setInterval(bodyCheck, 25);
            }
            // Apply to any new elements created after load
            document.createElement = function createElement(nodeName) {
                var element = nativeCreateElement(String(nodeName).toLowerCase());
                return shiv(element);
            };
            // remove sandboxed iframe
            document.removeChild(vbody);
        })();
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-service/8717a9e04ac7aff99b4980fbedead98036b0929a/packages/polyfill-library/polyfills/Element/prototype/classList/detect.js
        var detect = 'document' in this && "classList" in document.documentElement && 'Element' in this && 'classList' in Element.prototype && function() {
            var e = document.createElement('span');
            e.classList.add('a', 'b');
            return e.classList.contains('b');
        }();
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Element.prototype.classList&flags=always
        (function(global1) {
            var dpSupport = true;
            var defineGetter = function(object, name, fn, configurable) {
                if (Object.defineProperty) Object.defineProperty(object, name, {
                    configurable: false === dpSupport ? true : !!configurable,
                    get: fn
                });
                else object.__defineGetter__(name, fn);
            };
            /** Ensure the browser allows Object.defineProperty to be used on native JavaScript objects. */ try {
                defineGetter({}, "support");
            } catch (e) {
                dpSupport = false;
            }
            /** Polyfills a property with a DOMTokenList */ var addProp = function(o, name, attr) {
                defineGetter(o.prototype, name, function() {
                    var tokenList;
                    var THIS = this, /** Prevent this from firing twice for some reason. What the hell, IE. */ gibberishProperty = "__defineGetter__DEFINE_PROPERTY" + name;
                    if (THIS[gibberishProperty]) return tokenList;
                    THIS[gibberishProperty] = true;
                    /**
           * IE8 can't define properties on native JavaScript objects, so we'll use a dumb hack instead.
           *
           * What this is doing is creating a dummy element ("reflection") inside a detached phantom node ("mirror")
           * that serves as the target of Object.defineProperty instead. While we could simply use the subject HTML
           * element instead, this would conflict with element types which use indexed properties (such as forms and
           * select lists).
           */ if (false === dpSupport) {
                        var visage;
                        var mirror = addProp.mirror || document.createElement("div");
                        var reflections = mirror.childNodes;
                        var l = reflections.length;
                        for(var i = 0; i < l; ++i)if (reflections[i]._R === THIS) {
                            visage = reflections[i];
                            break;
                        }
                        /** Couldn't find an element's reflection inside the mirror. Materialise one. */ visage || (visage = mirror.appendChild(document.createElement("div")));
                        tokenList = DOMTokenList.call(visage, THIS, attr);
                    } else tokenList = new DOMTokenList(THIS, attr);
                    defineGetter(THIS, name, function() {
                        return tokenList;
                    });
                    delete THIS[gibberishProperty];
                    return tokenList;
                }, true);
            };
            addProp(global1.Element, "classList", "className");
            addProp(global1.HTMLElement, "classList", "className");
            addProp(global1.HTMLLinkElement, "relList", "rel");
            addProp(global1.HTMLAnchorElement, "relList", "rel");
            addProp(global1.HTMLAreaElement, "relList", "rel");
        })(this);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    function Accordion($module) {
        this.$module = $module;
        this.moduleId = $module.getAttribute('id');
        this.$sections = $module.querySelectorAll('.govuk-accordion__section');
        this.$openAllButton = '';
        this.browserSupportsSessionStorage = helper.checkForSessionStorage();
        this.controlsClass = 'govuk-accordion__controls';
        this.openAllClass = 'govuk-accordion__open-all';
        this.iconClass = 'govuk-accordion__icon';
        this.sectionHeaderClass = 'govuk-accordion__section-header';
        this.sectionHeaderFocusedClass = 'govuk-accordion__section-header--focused';
        this.sectionHeadingClass = 'govuk-accordion__section-heading';
        this.sectionSummaryClass = 'govuk-accordion__section-summary';
        this.sectionButtonClass = 'govuk-accordion__section-button';
        this.sectionExpandedClass = 'govuk-accordion__section--expanded';
    }
    // Initialize component
    Accordion.prototype.init = function() {
        // Check for module
        if (!this.$module) return;
        this.initControls();
        this.initSectionHeaders();
        // See if "Open all" button text should be updated
        var areAllSectionsOpen = this.checkIfAllSectionsOpen();
        this.updateOpenAllButton(areAllSectionsOpen);
    };
    // Initialise controls and set attributes
    Accordion.prototype.initControls = function() {
        // Create "Open all" button and set attributes
        this.$openAllButton = document.createElement('button');
        this.$openAllButton.setAttribute('type', 'button');
        this.$openAllButton.innerHTML = 'Open all <span class="govuk-visually-hidden">sections</span>';
        this.$openAllButton.setAttribute('class', this.openAllClass);
        this.$openAllButton.setAttribute('aria-expanded', 'false');
        this.$openAllButton.setAttribute('type', 'button');
        // Create control wrapper and add controls to it
        var accordionControls = document.createElement('div');
        accordionControls.setAttribute('class', this.controlsClass);
        accordionControls.appendChild(this.$openAllButton);
        this.$module.insertBefore(accordionControls, this.$module.firstChild);
        // Handle events for the controls
        this.$openAllButton.addEventListener('click', this.onOpenOrCloseAllToggle.bind(this));
    };
    // Initialise section headers
    Accordion.prototype.initSectionHeaders = function() {
        // Loop through section headers
        nodeListForEach(this.$sections, (function($section, i) {
            // Set header attributes
            var header = $section.querySelector('.' + this.sectionHeaderClass);
            this.initHeaderAttributes(header, i);
            this.setExpanded(this.isExpanded($section), $section);
            // Handle events
            header.addEventListener('click', this.onSectionToggle.bind(this, $section));
            // See if there is any state stored in sessionStorage and set the sections to
            // open or closed.
            this.setInitialState($section);
        }).bind(this));
    };
    // Set individual header attributes
    Accordion.prototype.initHeaderAttributes = function($headerWrapper, index) {
        var $module = this;
        var $span = $headerWrapper.querySelector('.' + this.sectionButtonClass);
        var $heading = $headerWrapper.querySelector('.' + this.sectionHeadingClass);
        var $summary = $headerWrapper.querySelector('.' + this.sectionSummaryClass);
        // Copy existing span element to an actual button element, for improved accessibility.
        var $button = document.createElement('button');
        $button.setAttribute('type', 'button');
        $button.setAttribute('id', this.moduleId + '-heading-' + (index + 1));
        $button.setAttribute('aria-controls', this.moduleId + '-content-' + (index + 1));
        // Copy all attributes (https://developer.mozilla.org/en-US/docs/Web/API/Element/attributes) from $span to $button
        for(var i = 0; i < $span.attributes.length; i++){
            var attr = $span.attributes.item(i);
            $button.setAttribute(attr.nodeName, attr.nodeValue);
        }
        $button.addEventListener('focusin', function(e) {
            if (!$headerWrapper.classList.contains($module.sectionHeaderFocusedClass)) $headerWrapper.className += ' ' + $module.sectionHeaderFocusedClass;
        });
        $button.addEventListener('blur', function(e) {
            $headerWrapper.classList.remove($module.sectionHeaderFocusedClass);
        });
        if (typeof $summary !== 'undefined' && $summary !== null) $button.setAttribute('aria-describedby', this.moduleId + '-summary-' + (index + 1));
        // $span could contain HTML elements (see https://www.w3.org/TR/2011/WD-html5-20110525/content-models.html#phrasing-content)
        $button.innerHTML = $span.innerHTML;
        $heading.removeChild($span);
        $heading.appendChild($button);
        // Add "+/-" icon
        var icon = document.createElement('span');
        icon.className = this.iconClass;
        icon.setAttribute('aria-hidden', 'true');
        $button.appendChild(icon);
    };
    // When section toggled, set and store state
    Accordion.prototype.onSectionToggle = function($section) {
        var expanded = this.isExpanded($section);
        this.setExpanded(!expanded, $section);
        // Store the state in sessionStorage when a change is triggered
        this.storeState($section);
    };
    // When Open/Close All toggled, set and store state
    Accordion.prototype.onOpenOrCloseAllToggle = function() {
        var $module = this;
        var $sections = this.$sections;
        var nowExpanded = !this.checkIfAllSectionsOpen();
        nodeListForEach($sections, function($section) {
            $module.setExpanded(nowExpanded, $section);
            // Store the state in sessionStorage when a change is triggered
            $module.storeState($section);
        });
        $module.updateOpenAllButton(nowExpanded);
    };
    // Set section attributes when opened/closed
    Accordion.prototype.setExpanded = function(expanded, $section) {
        var $button = $section.querySelector('.' + this.sectionButtonClass);
        $button.setAttribute('aria-expanded', expanded);
        if (expanded) $section.classList.add(this.sectionExpandedClass);
        else $section.classList.remove(this.sectionExpandedClass);
        // See if "Open all" button text should be updated
        var areAllSectionsOpen = this.checkIfAllSectionsOpen();
        this.updateOpenAllButton(areAllSectionsOpen);
    };
    // Get state of section
    Accordion.prototype.isExpanded = function($section) {
        return $section.classList.contains(this.sectionExpandedClass);
    };
    // Check if all sections are open
    Accordion.prototype.checkIfAllSectionsOpen = function() {
        // Get a count of all the Accordion sections
        var sectionsCount = this.$sections.length;
        // Get a count of all Accordion sections that are expanded
        var expandedSectionCount = this.$module.querySelectorAll('.' + this.sectionExpandedClass).length;
        var areAllSectionsOpen = sectionsCount === expandedSectionCount;
        return areAllSectionsOpen;
    };
    // Update "Open all" button
    Accordion.prototype.updateOpenAllButton = function(expanded) {
        var newButtonText = expanded ? 'Close all' : 'Open all';
        newButtonText += '<span class="govuk-visually-hidden"> sections</span>';
        this.$openAllButton.setAttribute('aria-expanded', expanded);
        this.$openAllButton.innerHTML = newButtonText;
    };
    // Check for `window.sessionStorage`, and that it actually works.
    var helper = {
        checkForSessionStorage: function() {
            var testString = 'this is the test string';
            var result;
            try {
                window.sessionStorage.setItem(testString, testString);
                result = window.sessionStorage.getItem(testString) === testString.toString();
                window.sessionStorage.removeItem(testString);
                return result;
            } catch (exception) {
                if (typeof console === 'undefined' || typeof console.log === 'undefined') console.log('Notice: sessionStorage not available.');
            }
        }
    };
    // Set the state of the accordions in sessionStorage
    Accordion.prototype.storeState = function($section) {
        if (this.browserSupportsSessionStorage) {
            // We need a unique way of identifying each content in the accordion. Since
            // an `#id` should be unique and an `id` is required for `aria-` attributes
            // `id` can be safely used.
            var $button = $section.querySelector('.' + this.sectionButtonClass);
            if ($button) {
                var contentId = $button.getAttribute('aria-controls');
                var contentState = $button.getAttribute('aria-expanded');
                if (typeof contentId === 'undefined' && (typeof console === 'undefined' || typeof console.log === 'undefined')) console.error(new Error('No aria controls present in accordion section heading.'));
                if (typeof contentState === 'undefined' && (typeof console === 'undefined' || typeof console.log === 'undefined')) console.error(new Error('No aria expanded present in accordion section heading.'));
                // Only set the state when both `contentId` and `contentState` are taken from the DOM.
                if (contentId && contentState) window.sessionStorage.setItem(contentId, contentState);
            }
        }
    };
    // Read the state of the accordions from sessionStorage
    Accordion.prototype.setInitialState = function($section) {
        if (this.browserSupportsSessionStorage) {
            var $button = $section.querySelector('.' + this.sectionButtonClass);
            if ($button) {
                var contentId = $button.getAttribute('aria-controls');
                var contentState = contentId ? window.sessionStorage.getItem(contentId) : null;
                if (contentState !== null) this.setExpanded(contentState === 'true', $section);
            }
        }
    };
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Window/detect.js
        var detect = 'Window' in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Window&flags=always
        if (typeof WorkerGlobalScope === "undefined" && typeof importScripts !== "function") (function(global1) {
            if (global1.constructor) global1.Window = global1.constructor;
            else (global1.Window = global1.constructor = new Function('return function Window() {}')()).prototype = this;
        })(this);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Event/detect.js
        var detect = function(global1) {
            if (!('Event' in global1)) return false;
            if (typeof global1.Event === 'function') return true;
            try {
                // In IE 9-11, the Event object exists but cannot be instantiated
                new Event('click');
                return true;
            } catch (e) {
                return false;
            }
        }(this);
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Event&flags=always
        (function() {
            var unlistenableWindowEvents = {
                click: 1,
                dblclick: 1,
                keyup: 1,
                keypress: 1,
                keydown: 1,
                mousedown: 1,
                mouseup: 1,
                mousemove: 1,
                mouseover: 1,
                mouseenter: 1,
                mouseleave: 1,
                mouseout: 1,
                storage: 1,
                storagecommit: 1,
                textinput: 1
            };
            // This polyfill depends on availability of `document` so will not run in a worker
            // However, we asssume there are no browsers with worker support that lack proper
            // support for `Event` within the worker
            if (typeof document === 'undefined' || typeof window === 'undefined') return;
            function indexOf(array, element) {
                var index = -1, length = array.length;
                while(++index < length){
                    if (index in array && array[index] === element) return index;
                }
                return -1;
            }
            var existingProto = window.Event && window.Event.prototype || null;
            window.Event = Window.prototype.Event = function Event1(type, eventInitDict) {
                if (!type) throw new Error('Not enough arguments');
                var event;
                // Shortcut if browser supports createEvent
                if ('createEvent' in document) {
                    event = document.createEvent('Event');
                    var bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
                    var cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;
                    event.initEvent(type, bubbles, cancelable);
                    return event;
                }
                event = document.createEventObject();
                event.type = type;
                event.bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
                event.cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;
                return event;
            };
            if (existingProto) Object.defineProperty(window.Event, 'prototype', {
                configurable: false,
                enumerable: false,
                writable: true,
                value: existingProto
            });
            if (!('createEvent' in document)) {
                window.addEventListener = Window.prototype.addEventListener = Document.prototype.addEventListener = Element.prototype.addEventListener = function addEventListener() {
                    var element = this, type = arguments[0], listener = arguments[1];
                    if (element === window && type in unlistenableWindowEvents) throw new Error('In IE8 the event: ' + type + ' is not available on the window object. Please see https://github.com/Financial-Times/polyfill-service/issues/317 for more information.');
                    if (!element._events) element._events = {};
                    if (!element._events[type]) {
                        element._events[type] = function(event) {
                            var list = element._events[event.type].list, events = list.slice(), index = -1, length = events.length, eventElement;
                            event.preventDefault = function preventDefault() {
                                if (event.cancelable !== false) event.returnValue = false;
                            };
                            event.stopPropagation = function stopPropagation() {
                                event.cancelBubble = true;
                            };
                            event.stopImmediatePropagation = function stopImmediatePropagation() {
                                event.cancelBubble = true;
                                event.cancelImmediate = true;
                            };
                            event.currentTarget = element;
                            event.relatedTarget = event.fromElement || null;
                            event.target = event.target || event.srcElement || element;
                            event.timeStamp = new Date().getTime();
                            if (event.clientX) {
                                event.pageX = event.clientX + document.documentElement.scrollLeft;
                                event.pageY = event.clientY + document.documentElement.scrollTop;
                            }
                            while(++index < length && !event.cancelImmediate)if (index in events) {
                                eventElement = events[index];
                                if (indexOf(list, eventElement) !== -1 && typeof eventElement === 'function') eventElement.call(element, event);
                            }
                        };
                        element._events[type].list = [];
                        if (element.attachEvent) element.attachEvent('on' + type, element._events[type]);
                    }
                    element._events[type].list.push(listener);
                };
                window.removeEventListener = Window.prototype.removeEventListener = Document.prototype.removeEventListener = Element.prototype.removeEventListener = function removeEventListener() {
                    var element = this, type = arguments[0], listener = arguments[1], index;
                    if (element._events && element._events[type] && element._events[type].list) {
                        index = indexOf(element._events[type].list, listener);
                        if (index !== -1) {
                            element._events[type].list.splice(index, 1);
                            if (!element._events[type].list.length) {
                                if (element.detachEvent) element.detachEvent('on' + type, element._events[type]);
                                delete element._events[type];
                            }
                        }
                    }
                };
                window.dispatchEvent = Window.prototype.dispatchEvent = Document.prototype.dispatchEvent = Element.prototype.dispatchEvent = function dispatchEvent(event) {
                    if (!arguments.length) throw new Error('Not enough arguments');
                    if (!event || typeof event.type !== 'string') throw new Error('DOM Events Exception 0');
                    var element = this, type = event.type;
                    try {
                        if (!event.bubbles) {
                            event.cancelBubble = true;
                            var cancelBubbleEvent = function(event) {
                                event.cancelBubble = true;
                                (element || window).detachEvent('on' + type, cancelBubbleEvent);
                            };
                            this.attachEvent('on' + type, cancelBubbleEvent);
                        }
                        this.fireEvent('on' + type, event);
                    } catch (error) {
                        event.target = element;
                        do {
                            event.currentTarget = element;
                            if ('_events' in element && typeof element._events[type] === 'function') element._events[type].call(element, event);
                            if (typeof element['on' + type] === 'function') element['on' + type].call(element, event);
                            element = element.nodeType === 9 ? element.parentWindow : element.parentNode;
                        }while (element && !event.cancelBubble);
                    }
                    return true;
                };
                // Add the DOMContentLoaded Event
                document.attachEvent('onreadystatechange', function() {
                    if (document.readyState === 'complete') document.dispatchEvent(new Event('DOMContentLoaded', {
                        bubbles: true
                    }));
                });
            }
        })();
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    var KEY_SPACE = 32;
    var DEBOUNCE_TIMEOUT_IN_SECONDS = 1;
    function Button($module) {
        this.$module = $module;
        this.debounceFormSubmitTimer = null;
    }
    /**
* JavaScript 'shim' to trigger the click event of element(s) when the space key is pressed.
*
* Created since some Assistive Technologies (for example some Screenreaders)
* will tell a user to press space on a 'button', so this functionality needs to be shimmed
* See https://github.com/alphagov/govuk_elements/pull/272#issuecomment-233028270
*
* @param {object} event event
*/ Button.prototype.handleKeyDown = function(event) {
        // get the target element
        var target = event.target;
        // if the element has a role='button' and the pressed key is a space, we'll simulate a click
        if (target.getAttribute('role') === 'button' && event.keyCode === KEY_SPACE) {
            event.preventDefault();
            // trigger the target's click event
            target.click();
        }
    };
    /**
* If the click quickly succeeds a previous click then nothing will happen.
* This stops people accidentally causing multiple form submissions by
* double clicking buttons.
*/ Button.prototype.debounce = function(event) {
        var target = event.target;
        // Check the button that is clicked on has the preventDoubleClick feature enabled
        if (target.getAttribute('data-prevent-double-click') !== 'true') return;
        // If the timer is still running then we want to prevent the click from submitting the form
        if (this.debounceFormSubmitTimer) {
            event.preventDefault();
            return false;
        }
        this.debounceFormSubmitTimer = setTimeout((function() {
            this.debounceFormSubmitTimer = null;
        }).bind(this), DEBOUNCE_TIMEOUT_IN_SECONDS * 1000);
    };
    /**
* Initialise an event listener for keydown at document level
* this will help listening for later inserted elements with a role="button"
*/ Button.prototype.init = function() {
        this.$module.addEventListener('keydown', this.handleKeyDown);
        this.$module.addEventListener('click', this.debounce);
    };
    /**
 * JavaScript 'polyfill' for HTML5's <details> and <summary> elements
 * and 'shim' to add accessiblity enhancements for all browsers
 *
 * http://caniuse.com/#feat=details
 */ var KEY_ENTER = 13;
    var KEY_SPACE$1 = 32;
    function Details($module) {
        this.$module = $module;
    }
    Details.prototype.init = function() {
        if (!this.$module) return;
        // If there is native details support, we want to avoid running code to polyfill native behaviour.
        var hasNativeDetails = typeof this.$module.open === 'boolean';
        if (hasNativeDetails) return;
        this.polyfillDetails();
    };
    Details.prototype.polyfillDetails = function() {
        var $module = this.$module;
        // Save shortcuts to the inner summary and content elements
        var $summary = this.$summary = $module.getElementsByTagName('summary').item(0);
        var $content = this.$content = $module.getElementsByTagName('div').item(0);
        // If <details> doesn't have a <summary> and a <div> representing the content
        // it means the required HTML structure is not met so the script will stop
        if (!$summary || !$content) return;
        // If the content doesn't have an ID, assign it one now
        // which we'll need for the summary's aria-controls assignment
        if (!$content.id) $content.id = 'details-content-' + generateUniqueID();
        // Add ARIA role="group" to details
        $module.setAttribute('role', 'group');
        // Add role=button to summary
        $summary.setAttribute('role', 'button');
        // Add aria-controls
        $summary.setAttribute('aria-controls', $content.id);
        // Set tabIndex so the summary is keyboard accessible for non-native elements
        //
        // We have to use the camelcase `tabIndex` property as there is a bug in IE6/IE7 when we set the correct attribute lowercase:
        // See http://web.archive.org/web/20170120194036/http://www.saliences.com/browserBugs/tabIndex.html for more information.
        $summary.tabIndex = 0;
        // Detect initial open state
        var openAttr = $module.getAttribute('open') !== null;
        if (openAttr === true) {
            $summary.setAttribute('aria-expanded', 'true');
            $content.setAttribute('aria-hidden', 'false');
        } else {
            $summary.setAttribute('aria-expanded', 'false');
            $content.setAttribute('aria-hidden', 'true');
            $content.style.display = 'none';
        }
        // Bind an event to handle summary elements
        this.polyfillHandleInputs($summary, this.polyfillSetAttributes.bind(this));
    };
    /**
* Define a statechange function that updates aria-expanded and style.display
* @param {object} summary element
*/ Details.prototype.polyfillSetAttributes = function() {
        var $module = this.$module;
        var $summary = this.$summary;
        var $content = this.$content;
        var expanded = $summary.getAttribute('aria-expanded') === 'true';
        var hidden = $content.getAttribute('aria-hidden') === 'true';
        $summary.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        $content.setAttribute('aria-hidden', hidden ? 'false' : 'true');
        $content.style.display = expanded ? 'none' : '';
        var hasOpenAttr = $module.getAttribute('open') !== null;
        if (!hasOpenAttr) $module.setAttribute('open', 'open');
        else $module.removeAttribute('open');
        return true;
    };
    /**
* Handle cross-modal click events
* @param {object} node element
* @param {function} callback function
*/ Details.prototype.polyfillHandleInputs = function(node, callback) {
        node.addEventListener('keypress', function(event) {
            var target = event.target;
            // When the key gets pressed - check if it is enter or space
            if (event.keyCode === KEY_ENTER || event.keyCode === KEY_SPACE$1) {
                if (target.nodeName.toLowerCase() === 'summary') {
                    // Prevent space from scrolling the page
                    // and enter from submitting a form
                    event.preventDefault();
                    // Click to let the click event do all the necessary action
                    if (target.click) target.click();
                    else // except Safari 5.1 and under don't support .click() here
                    callback(event);
                }
            }
        });
        // Prevent keyup to prevent clicking twice in Firefox when using space key
        node.addEventListener('keyup', function(event) {
            var target = event.target;
            if (event.keyCode === KEY_SPACE$1) {
                if (target.nodeName.toLowerCase() === 'summary') event.preventDefault();
            }
        });
        node.addEventListener('click', callback);
    };
    function CharacterCount($module) {
        this.$module = $module;
        this.$textarea = $module.querySelector('.govuk-js-character-count');
        if (this.$textarea) this.$countMessage = $module.querySelector('[id="' + this.$textarea.id + '-info"]');
    }
    CharacterCount.prototype.defaults = {
        characterCountAttribute: 'data-maxlength',
        wordCountAttribute: 'data-maxwords'
    };
    // Initialize component
    CharacterCount.prototype.init = function() {
        // Check for module
        var $module = this.$module;
        var $textarea = this.$textarea;
        var $countMessage = this.$countMessage;
        if (!$textarea || !$countMessage) return;
        // We move count message right after the field
        // Kept for backwards compatibility
        $textarea.insertAdjacentElement('afterend', $countMessage);
        // Read options set using dataset ('data-' values)
        this.options = this.getDataset($module);
        // Determine the limit attribute (characters or words)
        var countAttribute = this.defaults.characterCountAttribute;
        if (this.options.maxwords) countAttribute = this.defaults.wordCountAttribute;
        // Save the element limit
        this.maxLength = $module.getAttribute(countAttribute);
        // Check for limit
        if (!this.maxLength) return;
        // Remove hard limit if set
        $module.removeAttribute('maxlength');
        // When the page is restored after navigating 'back' in some browsers the
        // state of the character count is not restored until *after* the DOMContentLoaded
        // event is fired, so we need to sync after the pageshow event in browsers
        // that support it.
        if ('onpageshow' in window) window.addEventListener('pageshow', this.sync.bind(this));
        else window.addEventListener('DOMContentLoaded', this.sync.bind(this));
        this.sync();
    };
    CharacterCount.prototype.sync = function() {
        this.bindChangeEvents();
        this.updateCountMessage();
    };
    // Read data attributes
    CharacterCount.prototype.getDataset = function(element) {
        var dataset = {};
        var attributes = element.attributes;
        if (attributes) for(var i = 0; i < attributes.length; i++){
            var attribute = attributes[i];
            var match = attribute.name.match(/^data-(.+)/);
            if (match) dataset[match[1]] = attribute.value;
        }
        return dataset;
    };
    // Counts characters or words in text
    CharacterCount.prototype.count = function(text) {
        var length;
        if (this.options.maxwords) {
            var tokens = text.match(/\S+/g) || []; // Matches consecutive non-whitespace chars
            length = tokens.length;
        } else length = text.length;
        return length;
    };
    // Bind input propertychange to the elements and update based on the change
    CharacterCount.prototype.bindChangeEvents = function() {
        var $textarea = this.$textarea;
        $textarea.addEventListener('keyup', this.checkIfValueChanged.bind(this));
        // Bind focus/blur events to start/stop polling
        $textarea.addEventListener('focus', this.handleFocus.bind(this));
        $textarea.addEventListener('blur', this.handleBlur.bind(this));
    };
    // Speech recognition software such as Dragon NaturallySpeaking will modify the
    // fields by directly changing its `value`. These changes don't trigger events
    // in JavaScript, so we need to poll to handle when and if they occur.
    CharacterCount.prototype.checkIfValueChanged = function() {
        if (!this.$textarea.oldValue) this.$textarea.oldValue = '';
        if (this.$textarea.value !== this.$textarea.oldValue) {
            this.$textarea.oldValue = this.$textarea.value;
            this.updateCountMessage();
        }
    };
    // Update message box
    CharacterCount.prototype.updateCountMessage = function() {
        var countElement = this.$textarea;
        var options = this.options;
        var countMessage = this.$countMessage;
        // Determine the remaining number of characters/words
        var currentLength = this.count(countElement.value);
        var maxLength = this.maxLength;
        var remainingNumber = maxLength - currentLength;
        // Set threshold if presented in options
        var thresholdPercent = options.threshold ? options.threshold : 0;
        var thresholdValue = maxLength * thresholdPercent / 100;
        if (thresholdValue > currentLength) {
            countMessage.classList.add('govuk-character-count__message--disabled');
            // Ensure threshold is hidden for users of assistive technologies
            countMessage.setAttribute('aria-hidden', true);
        } else {
            countMessage.classList.remove('govuk-character-count__message--disabled');
            // Ensure threshold is visible for users of assistive technologies
            countMessage.removeAttribute('aria-hidden');
        }
        // Update styles
        if (remainingNumber < 0) {
            countElement.classList.add('govuk-textarea--error');
            countMessage.classList.remove('govuk-hint');
            countMessage.classList.add('govuk-error-message');
        } else {
            countElement.classList.remove('govuk-textarea--error');
            countMessage.classList.remove('govuk-error-message');
            countMessage.classList.add('govuk-hint');
        }
        // Update message
        var charVerb = 'remaining';
        var charNoun = 'character';
        var displayNumber = remainingNumber;
        if (options.maxwords) charNoun = 'word';
        charNoun = charNoun + (remainingNumber === -1 || remainingNumber === 1 ? '' : 's');
        charVerb = remainingNumber < 0 ? 'too many' : 'remaining';
        displayNumber = Math.abs(remainingNumber);
        countMessage.innerHTML = 'You have ' + displayNumber + ' ' + charNoun + ' ' + charVerb;
    };
    CharacterCount.prototype.handleFocus = function() {
        // Check if value changed on focus
        this.valueChecker = setInterval(this.checkIfValueChanged.bind(this), 1000);
    };
    CharacterCount.prototype.handleBlur = function() {
        // Cancel value checking on blur
        clearInterval(this.valueChecker);
    };
    function Checkboxes($module) {
        this.$module = $module;
        this.$inputs = $module.querySelectorAll('input[type="checkbox"]');
    }
    /**
 * Initialise Checkboxes
 *
 * Checkboxes can be associated with a 'conditionally revealed' content block –
 * for example, a checkbox for 'Phone' could reveal an additional form field for
 * the user to enter their phone number.
 *
 * These associations are made using a `data-aria-controls` attribute, which is
 * promoted to an aria-controls attribute during initialisation.
 *
 * We also need to restore the state of any conditional reveals on the page (for
 * example if the user has navigated back), and set up event handlers to keep
 * the reveal in sync with the checkbox state.
 */ Checkboxes.prototype.init = function() {
        var $module = this.$module;
        var $inputs = this.$inputs;
        nodeListForEach($inputs, function($input) {
            var target = $input.getAttribute('data-aria-controls');
            // Skip checkboxes without data-aria-controls attributes, or where the
            // target element does not exist.
            if (!target || !$module.querySelector('#' + target)) return;
            // Promote the data-aria-controls attribute to a aria-controls attribute
            // so that the relationship is exposed in the AOM
            $input.setAttribute('aria-controls', target);
            $input.removeAttribute('data-aria-controls');
        });
        // When the page is restored after navigating 'back' in some browsers the
        // state of form controls is not restored until *after* the DOMContentLoaded
        // event is fired, so we need to sync after the pageshow event in browsers
        // that support it.
        if ('onpageshow' in window) window.addEventListener('pageshow', this.syncAllConditionalReveals.bind(this));
        else window.addEventListener('DOMContentLoaded', this.syncAllConditionalReveals.bind(this));
        // Although we've set up handlers to sync state on the pageshow or
        // DOMContentLoaded event, init could be called after those events have fired,
        // for example if they are added to the page dynamically, so sync now too.
        this.syncAllConditionalReveals();
        $module.addEventListener('click', this.handleClick.bind(this));
    };
    /**
 * Sync the conditional reveal states for all inputs in this $module.
 */ Checkboxes.prototype.syncAllConditionalReveals = function() {
        nodeListForEach(this.$inputs, this.syncConditionalRevealWithInputState.bind(this));
    };
    /**
 * Sync conditional reveal with the input state
 *
 * Synchronise the visibility of the conditional reveal, and its accessible
 * state, with the input's checked state.
 *
 * @param {HTMLInputElement} $input Checkbox input
 */ Checkboxes.prototype.syncConditionalRevealWithInputState = function($input) {
        var $target = this.$module.querySelector('#' + $input.getAttribute('aria-controls'));
        if ($target && $target.classList.contains('govuk-checkboxes__conditional')) {
            var inputIsChecked = $input.checked;
            $input.setAttribute('aria-expanded', inputIsChecked);
            $target.classList.toggle('govuk-checkboxes__conditional--hidden', !inputIsChecked);
        }
    };
    /**
 * Uncheck other checkboxes
 *
 * Find any other checkbox inputs with the same name value, and uncheck them.
 * This is useful for when a “None of these" checkbox is checked.
 */ Checkboxes.prototype.unCheckAllInputsExcept = function($input) {
        var allInputsWithSameName = document.querySelectorAll('input[type="checkbox"][name="' + $input.name + '"]');
        nodeListForEach(allInputsWithSameName, function($inputWithSameName) {
            var hasSameFormOwner = $input.form === $inputWithSameName.form;
            if (hasSameFormOwner && $inputWithSameName !== $input) $inputWithSameName.checked = false;
        });
        this.syncAllConditionalReveals();
    };
    /**
 * Uncheck exclusive inputs
 *
 * Find any checkbox inputs with the same name value and the 'exclusive' behaviour,
 * and uncheck them. This helps prevent someone checking both a regular checkbox and a
 * "None of these" checkbox in the same fieldset.
 */ Checkboxes.prototype.unCheckExclusiveInputs = function($input) {
        var allInputsWithSameNameAndExclusiveBehaviour = document.querySelectorAll('input[data-behaviour="exclusive"][type="checkbox"][name="' + $input.name + '"]');
        nodeListForEach(allInputsWithSameNameAndExclusiveBehaviour, function($exclusiveInput) {
            var hasSameFormOwner = $input.form === $exclusiveInput.form;
            if (hasSameFormOwner) $exclusiveInput.checked = false;
        });
        this.syncAllConditionalReveals();
    };
    /**
 * Click event handler
 *
 * Handle a click within the $module – if the click occurred on a checkbox, sync
 * the state of any associated conditional reveal with the checkbox state.
 *
 * @param {MouseEvent} event Click event
 */ Checkboxes.prototype.handleClick = function(event) {
        var $target = event.target;
        // Ignore clicks on things that aren't checkbox inputs
        if ($target.type !== 'checkbox') return;
        // If the checkbox conditionally-reveals some content, sync the state
        var hasAriaControls = $target.getAttribute('aria-controls');
        if (hasAriaControls) this.syncConditionalRevealWithInputState($target);
        // No further behaviour needed for unchecking
        if (!$target.checked) return;
        // Handle 'exclusive' checkbox behaviour (ie "None of these")
        var hasBehaviourExclusive = $target.getAttribute('data-behaviour') === 'exclusive';
        if (hasBehaviourExclusive) this.unCheckAllInputsExcept($target);
        else this.unCheckExclusiveInputs($target);
    };
    (function(undefined) {
        // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-service/1f3c09b402f65bf6e393f933a15ba63f1b86ef1f/packages/polyfill-library/polyfills/Element/prototype/matches/detect.js
        var detect = 'document' in this && "matches" in document.documentElement;
        if (detect) return;
        // Polyfill from https://raw.githubusercontent.com/Financial-Times/polyfill-service/1f3c09b402f65bf6e393f933a15ba63f1b86ef1f/packages/polyfill-library/polyfills/Element/prototype/matches/polyfill.js
        Element.prototype.matches = Element.prototype.webkitMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.mozMatchesSelector || function matches(selector) {
            var element = this;
            var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
            var index = 0;
            while(elements[index] && elements[index] !== element)++index;
            return !!elements[index];
        };
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-service/1f3c09b402f65bf6e393f933a15ba63f1b86ef1f/packages/polyfill-library/polyfills/Element/prototype/closest/detect.js
        var detect = 'document' in this && "closest" in document.documentElement;
        if (detect) return;
        // Polyfill from https://raw.githubusercontent.com/Financial-Times/polyfill-service/1f3c09b402f65bf6e393f933a15ba63f1b86ef1f/packages/polyfill-library/polyfills/Element/prototype/closest/polyfill.js
        Element.prototype.closest = function closest(selector) {
            var node = this;
            while(node){
                if (node.matches(selector)) return node;
                else node = 'SVGElement' in window && node instanceof SVGElement ? node.parentNode : node.parentElement;
            }
            return null;
        };
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    function ErrorSummary($module) {
        this.$module = $module;
    }
    ErrorSummary.prototype.init = function() {
        var $module = this.$module;
        if (!$module) return;
        $module.focus();
        $module.addEventListener('click', this.handleClick.bind(this));
    };
    /**
* Click event handler
*
* @param {MouseEvent} event - Click event
*/ ErrorSummary.prototype.handleClick = function(event) {
        var target = event.target;
        if (this.focusTarget(target)) event.preventDefault();
    };
    /**
 * Focus the target element
 *
 * By default, the browser will scroll the target into view. Because our labels
 * or legends appear above the input, this means the user will be presented with
 * an input without any context, as the label or legend will be off the top of
 * the screen.
 *
 * Manually handling the click event, scrolling the question into view and then
 * focussing the element solves this.
 *
 * This also results in the label and/or legend being announced correctly in
 * NVDA (as tested in 2018.3.2) - without this only the field type is announced
 * (e.g. "Edit, has autocomplete").
 *
 * @param {HTMLElement} $target - Event target
 * @returns {boolean} True if the target was able to be focussed
 */ ErrorSummary.prototype.focusTarget = function($target) {
        // If the element that was clicked was not a link, return early
        if ($target.tagName !== 'A' || $target.href === false) return false;
        var inputId = this.getFragmentFromUrl($target.href);
        var $input = document.getElementById(inputId);
        if (!$input) return false;
        var $legendOrLabel = this.getAssociatedLegendOrLabel($input);
        if (!$legendOrLabel) return false;
        // Scroll the legend or label into view *before* calling focus on the input to
        // avoid extra scrolling in browsers that don't support `preventScroll` (which
        // at time of writing is most of them...)
        $legendOrLabel.scrollIntoView();
        $input.focus({
            preventScroll: true
        });
        return true;
    };
    /**
 * Get fragment from URL
 *
 * Extract the fragment (everything after the hash) from a URL, but not including
 * the hash.
 *
 * @param {string} url - URL
 * @returns {string} Fragment from URL, without the hash
 */ ErrorSummary.prototype.getFragmentFromUrl = function(url) {
        if (url.indexOf('#') === -1) return false;
        return url.split('#').pop();
    };
    /**
 * Get associated legend or label
 *
 * Returns the first element that exists from this list:
 *
 * - The `<legend>` associated with the closest `<fieldset>` ancestor, as long
 *   as the top of it is no more than half a viewport height away from the
 *   bottom of the input
 * - The first `<label>` that is associated with the input using for="inputId"
 * - The closest parent `<label>`
 *
 * @param {HTMLElement} $input - The input
 * @returns {HTMLElement} Associated legend or label, or null if no associated
 *                        legend or label can be found
 */ ErrorSummary.prototype.getAssociatedLegendOrLabel = function($input) {
        var $fieldset = $input.closest('fieldset');
        if ($fieldset) {
            var legends = $fieldset.getElementsByTagName('legend');
            if (legends.length) {
                var $candidateLegend = legends[0];
                // If the input type is radio or checkbox, always use the legend if there
                // is one.
                if ($input.type === 'checkbox' || $input.type === 'radio') return $candidateLegend;
                // For other input types, only scroll to the fieldset’s legend (instead of
                // the label associated with the input) if the input would end up in the
                // top half of the screen.
                //
                // This should avoid situations where the input either ends up off the
                // screen, or obscured by a software keyboard.
                var legendTop = $candidateLegend.getBoundingClientRect().top;
                var inputRect = $input.getBoundingClientRect();
                // If the browser doesn't support Element.getBoundingClientRect().height
                // or window.innerHeight (like IE8), bail and just link to the label.
                if (inputRect.height && window.innerHeight) {
                    var inputBottom = inputRect.top + inputRect.height;
                    if (inputBottom - legendTop < window.innerHeight / 2) return $candidateLegend;
                }
            }
        }
        return document.querySelector("label[for='" + $input.getAttribute('id') + "']") || $input.closest('label');
    };
    function NotificationBanner($module) {
        this.$module = $module;
    }
    /**
 * Initialise the component
 */ NotificationBanner.prototype.init = function() {
        var $module = this.$module;
        // Check for module
        if (!$module) return;
        this.setFocus();
    };
    /**
 * Focus the element
 *
 * If `role="alert"` is set, focus the element to help some assistive technologies
 * prioritise announcing it.
 *
 * You can turn off the auto-focus functionality by setting `data-disable-auto-focus="true"` in the
 * component HTML. You might wish to do this based on user research findings, or to avoid a clash
 * with another element which should be focused when the page loads.
 */ NotificationBanner.prototype.setFocus = function() {
        var $module = this.$module;
        if ($module.getAttribute('data-disable-auto-focus') === 'true') return;
        if ($module.getAttribute('role') !== 'alert') return;
        // Set tabindex to -1 to make the element focusable with JavaScript.
        // Remove the tabindex on blur as the component doesn't need to be focusable after the page has
        // loaded.
        if (!$module.getAttribute('tabindex')) {
            $module.setAttribute('tabindex', '-1');
            $module.addEventListener('blur', function() {
                $module.removeAttribute('tabindex');
            });
        }
        $module.focus();
    };
    function Header($module) {
        this.$module = $module;
        this.$menuButton = $module && $module.querySelector('.govuk-js-header-toggle');
        this.$menu = this.$menuButton && $module.querySelector('#' + this.$menuButton.getAttribute('aria-controls'));
    }
    /**
 * Initialise header
 *
 * Check for the presence of the header, menu and menu button – if any are
 * missing then there's nothing to do so return early.
 */ Header.prototype.init = function() {
        if (!this.$module || !this.$menuButton || !this.$menu) return;
        this.syncState(this.$menu.classList.contains('govuk-header__navigation--open'));
        this.$menuButton.addEventListener('click', this.handleMenuButtonClick.bind(this));
    };
    /**
 * Sync menu state
 *
 * Sync the menu button class and the accessible state of the menu and the menu
 * button with the visible state of the menu
 *
 * @param {boolean} isVisible Whether the menu is currently visible
 */ Header.prototype.syncState = function(isVisible) {
        this.$menuButton.classList.toggle('govuk-header__menu-button--open', isVisible);
        this.$menuButton.setAttribute('aria-expanded', isVisible);
    };
    /**
 * Handle menu button click
 *
 * When the menu button is clicked, change the visibility of the menu and then
 * sync the accessibility state and menu button state
 */ Header.prototype.handleMenuButtonClick = function() {
        var isVisible = this.$menu.classList.toggle('govuk-header__navigation--open');
        this.syncState(isVisible);
    };
    function Radios($module) {
        this.$module = $module;
        this.$inputs = $module.querySelectorAll('input[type="radio"]');
    }
    /**
 * Initialise Radios
 *
 * Radios can be associated with a 'conditionally revealed' content block – for
 * example, a radio for 'Phone' could reveal an additional form field for the
 * user to enter their phone number.
 *
 * These associations are made using a `data-aria-controls` attribute, which is
 * promoted to an aria-controls attribute during initialisation.
 *
 * We also need to restore the state of any conditional reveals on the page (for
 * example if the user has navigated back), and set up event handlers to keep
 * the reveal in sync with the radio state.
 */ Radios.prototype.init = function() {
        var $module = this.$module;
        var $inputs = this.$inputs;
        nodeListForEach($inputs, function($input) {
            var target = $input.getAttribute('data-aria-controls');
            // Skip radios without data-aria-controls attributes, or where the
            // target element does not exist.
            if (!target || !$module.querySelector('#' + target)) return;
            // Promote the data-aria-controls attribute to a aria-controls attribute
            // so that the relationship is exposed in the AOM
            $input.setAttribute('aria-controls', target);
            $input.removeAttribute('data-aria-controls');
        });
        // When the page is restored after navigating 'back' in some browsers the
        // state of form controls is not restored until *after* the DOMContentLoaded
        // event is fired, so we need to sync after the pageshow event in browsers
        // that support it.
        if ('onpageshow' in window) window.addEventListener('pageshow', this.syncAllConditionalReveals.bind(this));
        else window.addEventListener('DOMContentLoaded', this.syncAllConditionalReveals.bind(this));
        // Although we've set up handlers to sync state on the pageshow or
        // DOMContentLoaded event, init could be called after those events have fired,
        // for example if they are added to the page dynamically, so sync now too.
        this.syncAllConditionalReveals();
        // Handle events
        $module.addEventListener('click', this.handleClick.bind(this));
    };
    /**
 * Sync the conditional reveal states for all inputs in this $module.
 */ Radios.prototype.syncAllConditionalReveals = function() {
        nodeListForEach(this.$inputs, this.syncConditionalRevealWithInputState.bind(this));
    };
    /**
 * Sync conditional reveal with the input state
 *
 * Synchronise the visibility of the conditional reveal, and its accessible
 * state, with the input's checked state.
 *
 * @param {HTMLInputElement} $input Radio input
 */ Radios.prototype.syncConditionalRevealWithInputState = function($input) {
        var $target = document.querySelector('#' + $input.getAttribute('aria-controls'));
        if ($target && $target.classList.contains('govuk-radios__conditional')) {
            var inputIsChecked = $input.checked;
            $input.setAttribute('aria-expanded', inputIsChecked);
            $target.classList.toggle('govuk-radios__conditional--hidden', !inputIsChecked);
        }
    };
    /**
 * Click event handler
 *
 * Handle a click within the $module – if the click occurred on a radio, sync
 * the state of the conditional reveal for all radio buttons in the same form
 * with the same name (because checking one radio could have un-checked a radio
 * in another $module)
 *
 * @param {MouseEvent} event Click event
 */ Radios.prototype.handleClick = function(event) {
        var $clickedInput = event.target;
        // Ignore clicks on things that aren't radio buttons
        if ($clickedInput.type !== 'radio') return;
        // We only need to consider radios with conditional reveals, which will have
        // aria-controls attributes.
        var $allInputs = document.querySelectorAll('input[type="radio"][aria-controls]');
        nodeListForEach($allInputs, (function($input) {
            var hasSameFormOwner = $input.form === $clickedInput.form;
            var hasSameName = $input.name === $clickedInput.name;
            if (hasSameName && hasSameFormOwner) this.syncConditionalRevealWithInputState($input);
        }).bind(this));
    };
    (function(undefined) {
        // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-library/master/polyfills/Element/prototype/nextElementSibling/detect.js
        var detect = 'document' in this && "nextElementSibling" in document.documentElement;
        if (detect) return;
        // Polyfill from https://raw.githubusercontent.com/Financial-Times/polyfill-library/master/polyfills/Element/prototype/nextElementSibling/polyfill.js
        Object.defineProperty(Element.prototype, "nextElementSibling", {
            get: function() {
                var el = this.nextSibling;
                while(el && el.nodeType !== 1)el = el.nextSibling;
                return el;
            }
        });
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-library/master/polyfills/Element/prototype/previousElementSibling/detect.js
        var detect = 'document' in this && "previousElementSibling" in document.documentElement;
        if (detect) return;
        // Polyfill from https://raw.githubusercontent.com/Financial-Times/polyfill-library/master/polyfills/Element/prototype/previousElementSibling/polyfill.js
        Object.defineProperty(Element.prototype, 'previousElementSibling', {
            get: function() {
                var el = this.previousSibling;
                while(el && el.nodeType !== 1)el = el.previousSibling;
                return el;
            }
        });
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    function Tabs($module) {
        this.$module = $module;
        this.$tabs = $module.querySelectorAll('.govuk-tabs__tab');
        this.keys = {
            left: 37,
            right: 39,
            up: 38,
            down: 40
        };
        this.jsHiddenClass = 'govuk-tabs__panel--hidden';
    }
    Tabs.prototype.init = function() {
        if (typeof window.matchMedia === 'function') this.setupResponsiveChecks();
        else this.setup();
    };
    Tabs.prototype.setupResponsiveChecks = function() {
        this.mql = window.matchMedia('(min-width: 40.0625em)');
        this.mql.addListener(this.checkMode.bind(this));
        this.checkMode();
    };
    Tabs.prototype.checkMode = function() {
        if (this.mql.matches) this.setup();
        else this.teardown();
    };
    Tabs.prototype.setup = function() {
        var $module = this.$module;
        var $tabs = this.$tabs;
        var $tabList = $module.querySelector('.govuk-tabs__list');
        var $tabListItems = $module.querySelectorAll('.govuk-tabs__list-item');
        if (!$tabs || !$tabList || !$tabListItems) return;
        $tabList.setAttribute('role', 'tablist');
        nodeListForEach($tabListItems, function($item) {
            $item.setAttribute('role', 'presentation');
        });
        nodeListForEach($tabs, (function($tab) {
            // Set HTML attributes
            this.setAttributes($tab);
            // Save bounded functions to use when removing event listeners during teardown
            $tab.boundTabClick = this.onTabClick.bind(this);
            $tab.boundTabKeydown = this.onTabKeydown.bind(this);
            // Handle events
            $tab.addEventListener('click', $tab.boundTabClick, true);
            $tab.addEventListener('keydown', $tab.boundTabKeydown, true);
            // Remove old active panels
            this.hideTab($tab);
        }).bind(this));
        // Show either the active tab according to the URL's hash or the first tab
        var $activeTab = this.getTab(window.location.hash) || this.$tabs[0];
        this.showTab($activeTab);
        // Handle hashchange events
        $module.boundOnHashChange = this.onHashChange.bind(this);
        window.addEventListener('hashchange', $module.boundOnHashChange, true);
    };
    Tabs.prototype.teardown = function() {
        var $module = this.$module;
        var $tabs = this.$tabs;
        var $tabList = $module.querySelector('.govuk-tabs__list');
        var $tabListItems = $module.querySelectorAll('.govuk-tabs__list-item');
        if (!$tabs || !$tabList || !$tabListItems) return;
        $tabList.removeAttribute('role');
        nodeListForEach($tabListItems, function($item) {
            $item.removeAttribute('role', 'presentation');
        });
        nodeListForEach($tabs, (function($tab) {
            // Remove events
            $tab.removeEventListener('click', $tab.boundTabClick, true);
            $tab.removeEventListener('keydown', $tab.boundTabKeydown, true);
            // Unset HTML attributes
            this.unsetAttributes($tab);
        }).bind(this));
        // Remove hashchange event handler
        window.removeEventListener('hashchange', $module.boundOnHashChange, true);
    };
    Tabs.prototype.onHashChange = function(e) {
        var hash = window.location.hash;
        var $tabWithHash = this.getTab(hash);
        if (!$tabWithHash) return;
        // Prevent changing the hash
        if (this.changingHash) {
            this.changingHash = false;
            return;
        }
        // Show either the active tab according to the URL's hash or the first tab
        var $previousTab = this.getCurrentTab();
        this.hideTab($previousTab);
        this.showTab($tabWithHash);
        $tabWithHash.focus();
    };
    Tabs.prototype.hideTab = function($tab) {
        this.unhighlightTab($tab);
        this.hidePanel($tab);
    };
    Tabs.prototype.showTab = function($tab) {
        this.highlightTab($tab);
        this.showPanel($tab);
    };
    Tabs.prototype.getTab = function(hash) {
        return this.$module.querySelector('.govuk-tabs__tab[href="' + hash + '"]');
    };
    Tabs.prototype.setAttributes = function($tab) {
        // set tab attributes
        var panelId = this.getHref($tab).slice(1);
        $tab.setAttribute('id', 'tab_' + panelId);
        $tab.setAttribute('role', 'tab');
        $tab.setAttribute('aria-controls', panelId);
        $tab.setAttribute('aria-selected', 'false');
        $tab.setAttribute('tabindex', '-1');
        // set panel attributes
        var $panel = this.getPanel($tab);
        $panel.setAttribute('role', 'tabpanel');
        $panel.setAttribute('aria-labelledby', $tab.id);
        $panel.classList.add(this.jsHiddenClass);
    };
    Tabs.prototype.unsetAttributes = function($tab) {
        // unset tab attributes
        $tab.removeAttribute('id');
        $tab.removeAttribute('role');
        $tab.removeAttribute('aria-controls');
        $tab.removeAttribute('aria-selected');
        $tab.removeAttribute('tabindex');
        // unset panel attributes
        var $panel = this.getPanel($tab);
        $panel.removeAttribute('role');
        $panel.removeAttribute('aria-labelledby');
        $panel.classList.remove(this.jsHiddenClass);
    };
    Tabs.prototype.onTabClick = function(e) {
        if (!e.target.classList.contains('govuk-tabs__tab')) // Allow events on child DOM elements to bubble up to tab parent
        return false;
        e.preventDefault();
        var $newTab = e.target;
        var $currentTab = this.getCurrentTab();
        this.hideTab($currentTab);
        this.showTab($newTab);
        this.createHistoryEntry($newTab);
    };
    Tabs.prototype.createHistoryEntry = function($tab) {
        var $panel = this.getPanel($tab);
        // Save and restore the id
        // so the page doesn't jump when a user clicks a tab (which changes the hash)
        var id = $panel.id;
        $panel.id = '';
        this.changingHash = true;
        window.location.hash = this.getHref($tab).slice(1);
        $panel.id = id;
    };
    Tabs.prototype.onTabKeydown = function(e) {
        switch(e.keyCode){
            case this.keys.left:
            case this.keys.up:
                this.activatePreviousTab();
                e.preventDefault();
                break;
            case this.keys.right:
            case this.keys.down:
                this.activateNextTab();
                e.preventDefault();
                break;
        }
    };
    Tabs.prototype.activateNextTab = function() {
        var currentTab = this.getCurrentTab();
        var nextTabListItem = currentTab.parentNode.nextElementSibling;
        if (nextTabListItem) var nextTab = nextTabListItem.querySelector('.govuk-tabs__tab');
        if (nextTab) {
            this.hideTab(currentTab);
            this.showTab(nextTab);
            nextTab.focus();
            this.createHistoryEntry(nextTab);
        }
    };
    Tabs.prototype.activatePreviousTab = function() {
        var currentTab = this.getCurrentTab();
        var previousTabListItem = currentTab.parentNode.previousElementSibling;
        if (previousTabListItem) var previousTab = previousTabListItem.querySelector('.govuk-tabs__tab');
        if (previousTab) {
            this.hideTab(currentTab);
            this.showTab(previousTab);
            previousTab.focus();
            this.createHistoryEntry(previousTab);
        }
    };
    Tabs.prototype.getPanel = function($tab) {
        var $panel = this.$module.querySelector(this.getHref($tab));
        return $panel;
    };
    Tabs.prototype.showPanel = function($tab) {
        var $panel = this.getPanel($tab);
        $panel.classList.remove(this.jsHiddenClass);
    };
    Tabs.prototype.hidePanel = function(tab) {
        var $panel = this.getPanel(tab);
        $panel.classList.add(this.jsHiddenClass);
    };
    Tabs.prototype.unhighlightTab = function($tab) {
        $tab.setAttribute('aria-selected', 'false');
        $tab.parentNode.classList.remove('govuk-tabs__list-item--selected');
        $tab.setAttribute('tabindex', '-1');
    };
    Tabs.prototype.highlightTab = function($tab) {
        $tab.setAttribute('aria-selected', 'true');
        $tab.parentNode.classList.add('govuk-tabs__list-item--selected');
        $tab.setAttribute('tabindex', '0');
    };
    Tabs.prototype.getCurrentTab = function() {
        return this.$module.querySelector('.govuk-tabs__list-item--selected .govuk-tabs__tab');
    };
    // this is because IE doesn't always return the actual value but a relative full path
    // should be a utility function most prob
    // http://labs.thesedays.com/blog/2010/01/08/getting-the-href-value-with-jquery-in-ie/
    Tabs.prototype.getHref = function($tab) {
        var href = $tab.getAttribute('href');
        var hash = href.slice(href.indexOf('#'), href.length);
        return hash;
    };
    function initAll(options) {
        // Set the options to an empty object by default if no options are passed.
        options = typeof options !== 'undefined' ? options : {};
        // Allow the user to initialise GOV.UK Frontend in only certain sections of the page
        // Defaults to the entire document if nothing is set.
        var scope = typeof options.scope !== 'undefined' ? options.scope : document;
        var $buttons = scope.querySelectorAll('[data-module="govuk-button"]');
        nodeListForEach($buttons, function($button) {
            new Button($button).init();
        });
        var $accordions = scope.querySelectorAll('[data-module="govuk-accordion"]');
        nodeListForEach($accordions, function($accordion) {
            new Accordion($accordion).init();
        });
        var $details = scope.querySelectorAll('[data-module="govuk-details"]');
        nodeListForEach($details, function($detail) {
            new Details($detail).init();
        });
        var $characterCounts = scope.querySelectorAll('[data-module="govuk-character-count"]');
        nodeListForEach($characterCounts, function($characterCount) {
            new CharacterCount($characterCount).init();
        });
        var $checkboxes = scope.querySelectorAll('[data-module="govuk-checkboxes"]');
        nodeListForEach($checkboxes, function($checkbox) {
            new Checkboxes($checkbox).init();
        });
        // Find first error summary module to enhance.
        var $errorSummary = scope.querySelector('[data-module="govuk-error-summary"]');
        new ErrorSummary($errorSummary).init();
        // Find first header module to enhance.
        var $toggleButton = scope.querySelector('[data-module="govuk-header"]');
        new Header($toggleButton).init();
        var $notificationBanners = scope.querySelectorAll('[data-module="govuk-notification-banner"]');
        nodeListForEach($notificationBanners, function($notificationBanner) {
            new NotificationBanner($notificationBanner).init();
        });
        var $radios = scope.querySelectorAll('[data-module="govuk-radios"]');
        nodeListForEach($radios, function($radio) {
            new Radios($radio).init();
        });
        var $tabs = scope.querySelectorAll('[data-module="govuk-tabs"]');
        nodeListForEach($tabs, function($tabs) {
            new Tabs($tabs).init();
        });
    }
    exports1.initAll = initAll;
    exports1.Accordion = Accordion;
    exports1.Button = Button;
    exports1.Details = Details;
    exports1.CharacterCount = CharacterCount;
    exports1.Checkboxes = Checkboxes;
    exports1.ErrorSummary = ErrorSummary;
    exports1.Header = Header;
    exports1.Radios = Radios;
    exports1.Tabs = Tabs;
});


var $b2fca1e5c52c6e7b$exports = {};
(function(global1, factory) {
    $b2fca1e5c52c6e7b$exports = factory();
})($b2fca1e5c52c6e7b$exports, function() {
    'use strict';
    /**
 * TODO: Ideally this would be a NodeList.prototype.forEach polyfill
 * This seems to fail in IE8, requires more investigation.
 * See: https://github.com/imagitama/nodelist-foreach-polyfill
 */ function nodeListForEach(nodes, callback) {
        if (window.NodeList.prototype.forEach) return nodes.forEach(callback);
        for(var i = 0; i < nodes.length; i++)callback.call(window, nodes[i], i, nodes);
    }
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Object/defineProperty/detect.js
        var detect = // In IE8, defineProperty could only act on DOM elements, so full support
        // for the feature requires the ability to set a property on an arbitrary object
        'defineProperty' in Object && function() {
            try {
                var a = {};
                Object.defineProperty(a, 'test', {
                    value: 42
                });
                return true;
            } catch (e) {
                return false;
            }
        }();
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Object.defineProperty&flags=always
        (function(nativeDefineProperty) {
            var supportsAccessors = Object.prototype.hasOwnProperty('__defineGetter__');
            var ERR_ACCESSORS_NOT_SUPPORTED = 'Getters & setters cannot be defined on this javascript engine';
            var ERR_VALUE_ACCESSORS = 'A property cannot both have accessors and be writable or have a value';
            Object.defineProperty = function defineProperty(object, property, descriptor) {
                // Where native support exists, assume it
                if (nativeDefineProperty && (object === window || object === document || object === Element.prototype || object instanceof Element)) return nativeDefineProperty(object, property, descriptor);
                if (object === null || !(object instanceof Object || typeof object === 'object')) throw new TypeError('Object.defineProperty called on non-object');
                if (!(descriptor instanceof Object)) throw new TypeError('Property description must be an object');
                var propertyString = String(property);
                var hasValueOrWritable = 'value' in descriptor || 'writable' in descriptor;
                var getterType = 'get' in descriptor && typeof descriptor.get;
                var setterType = 'set' in descriptor && typeof descriptor.set;
                // handle descriptor.get
                if (getterType) {
                    if (getterType !== 'function') throw new TypeError('Getter must be a function');
                    if (!supportsAccessors) throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
                    if (hasValueOrWritable) throw new TypeError(ERR_VALUE_ACCESSORS);
                    Object.__defineGetter__.call(object, propertyString, descriptor.get);
                } else object[propertyString] = descriptor.value;
                // handle descriptor.set
                if (setterType) {
                    if (setterType !== 'function') throw new TypeError('Setter must be a function');
                    if (!supportsAccessors) throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
                    if (hasValueOrWritable) throw new TypeError(ERR_VALUE_ACCESSORS);
                    Object.__defineSetter__.call(object, propertyString, descriptor.set);
                }
                // OK to define value unconditionally - if a getter has been specified as well, an error would be thrown above
                if ('value' in descriptor) object[propertyString] = descriptor.value;
                return object;
            };
        })(Object.defineProperty);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Function/prototype/bind/detect.js
        var detect = 'bind' in Function.prototype;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Function.prototype.bind&flags=always
        Object.defineProperty(Function.prototype, 'bind', {
            value: function bind(that) {
                // add necessary es5-shim utilities
                var $Array = Array;
                var $Object = Object;
                var ObjectPrototype = $Object.prototype;
                var ArrayPrototype = $Array.prototype;
                var Empty = function Empty() {};
                var to_string = ObjectPrototype.toString;
                var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
                var isCallable; /* inlined from https://npmjs.com/is-callable */ 
                var fnToStr = Function.prototype.toString, tryFunctionObject = function tryFunctionObject(value) {
                    try {
                        fnToStr.call(value);
                        return true;
                    } catch (e) {
                        return false;
                    }
                }, fnClass = '[object Function]', genClass = '[object GeneratorFunction]';
                isCallable = function isCallable(value) {
                    if (typeof value !== 'function') return false;
                    if (hasToStringTag) return tryFunctionObject(value);
                    var strClass = to_string.call(value);
                    return strClass === fnClass || strClass === genClass;
                };
                var array_slice = ArrayPrototype.slice;
                var array_concat = ArrayPrototype.concat;
                var array_push = ArrayPrototype.push;
                var max = Math.max;
                // /add necessary es5-shim utilities
                // 1. Let Target be the this value.
                var target = this;
                // 2. If IsCallable(Target) is false, throw a TypeError exception.
                if (!isCallable(target)) throw new TypeError('Function.prototype.bind called on incompatible ' + target);
                // 3. Let A be a new (possibly empty) internal list of all of the
                //   argument values provided after thisArg (arg1, arg2 etc), in order.
                // XXX slicedArgs will stand in for "A" if used
                var args = array_slice.call(arguments, 1); // for normal call
                // 4. Let F be a new native ECMAScript object.
                // 11. Set the [[Prototype]] internal property of F to the standard
                //   built-in Function prototype object as specified in 15.3.3.1.
                // 12. Set the [[Call]] internal property of F as described in
                //   15.3.4.5.1.
                // 13. Set the [[Construct]] internal property of F as described in
                //   15.3.4.5.2.
                // 14. Set the [[HasInstance]] internal property of F as described in
                //   15.3.4.5.3.
                var bound;
                var binder = function() {
                    if (this instanceof bound) {
                        // 15.3.4.5.2 [[Construct]]
                        // When the [[Construct]] internal method of a function object,
                        // F that was created using the bind function is called with a
                        // list of arguments ExtraArgs, the following steps are taken:
                        // 1. Let target be the value of F's [[TargetFunction]]
                        //   internal property.
                        // 2. If target has no [[Construct]] internal method, a
                        //   TypeError exception is thrown.
                        // 3. Let boundArgs be the value of F's [[BoundArgs]] internal
                        //   property.
                        // 4. Let args be a new list containing the same values as the
                        //   list boundArgs in the same order followed by the same
                        //   values as the list ExtraArgs in the same order.
                        // 5. Return the result of calling the [[Construct]] internal
                        //   method of target providing args as the arguments.
                        var result = target.apply(this, array_concat.call(args, array_slice.call(arguments)));
                        if ($Object(result) === result) return result;
                        return this;
                    } else // 15.3.4.5.1 [[Call]]
                    // When the [[Call]] internal method of a function object, F,
                    // which was created using the bind function is called with a
                    // this value and a list of arguments ExtraArgs, the following
                    // steps are taken:
                    // 1. Let boundArgs be the value of F's [[BoundArgs]] internal
                    //   property.
                    // 2. Let boundThis be the value of F's [[BoundThis]] internal
                    //   property.
                    // 3. Let target be the value of F's [[TargetFunction]] internal
                    //   property.
                    // 4. Let args be a new list containing the same values as the
                    //   list boundArgs in the same order followed by the same
                    //   values as the list ExtraArgs in the same order.
                    // 5. Return the result of calling the [[Call]] internal method
                    //   of target providing boundThis as the this value and
                    //   providing args as the arguments.
                    // equiv: target.call(this, ...boundArgs, ...args)
                    return target.apply(that, array_concat.call(args, array_slice.call(arguments)));
                };
                // 15. If the [[Class]] internal property of Target is "Function", then
                //     a. Let L be the length property of Target minus the length of A.
                //     b. Set the length own property of F to either 0 or L, whichever is
                //       larger.
                // 16. Else set the length own property of F to 0.
                var boundLength = max(0, target.length - args.length);
                // 17. Set the attributes of the length own property of F to the values
                //   specified in 15.3.5.1.
                var boundArgs = [];
                for(var i = 0; i < boundLength; i++)array_push.call(boundArgs, '$' + i);
                // XXX Build a dynamic function with desired amount of arguments is the only
                // way to set the length property of a function.
                // In environments where Content Security Policies enabled (Chrome extensions,
                // for ex.) all use of eval or Function costructor throws an exception.
                // However in all of these environments Function.prototype.bind exists
                // and so this code will never be executed.
                bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this, arguments); }')(binder);
                if (target.prototype) {
                    Empty.prototype = target.prototype;
                    bound.prototype = new Empty();
                    // Clean up dangling references.
                    Empty.prototype = null;
                }
                // TODO
                // 18. Set the [[Extensible]] internal property of F to true.
                // TODO
                // 19. Let thrower be the [[ThrowTypeError]] function Object (13.2.3).
                // 20. Call the [[DefineOwnProperty]] internal method of F with
                //   arguments "caller", PropertyDescriptor {[[Get]]: thrower, [[Set]]:
                //   thrower, [[Enumerable]]: false, [[Configurable]]: false}, and
                //   false.
                // 21. Call the [[DefineOwnProperty]] internal method of F with
                //   arguments "arguments", PropertyDescriptor {[[Get]]: thrower,
                //   [[Set]]: thrower, [[Enumerable]]: false, [[Configurable]]: false},
                //   and false.
                // TODO
                // NOTE Function objects created using Function.prototype.bind do not
                // have a prototype property or the [[Code]], [[FormalParameters]], and
                // [[Scope]] internal properties.
                // XXX can't delete prototype in pure-js.
                // 22. Return F.
                return bound;
            }
        });
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-service/master/packages/polyfill-library/polyfills/DOMTokenList/detect.js
        var detect = 'DOMTokenList' in this && function(x) {
            return 'classList' in x ? !x.classList.toggle('x', false) && !x.className : true;
        }(document.createElement('x'));
        if (detect) return;
        // Polyfill from https://raw.githubusercontent.com/Financial-Times/polyfill-service/master/packages/polyfill-library/polyfills/DOMTokenList/polyfill.js
        (function(global1) {
            var nativeImpl = "DOMTokenList" in global1 && global1.DOMTokenList;
            if (!nativeImpl || !!document.createElementNS && !!document.createElementNS('http://www.w3.org/2000/svg', 'svg') && !(document.createElementNS("http://www.w3.org/2000/svg", "svg").classList instanceof DOMTokenList)) global1.DOMTokenList = function() {
                var dpSupport = true;
                var defineGetter = function(object, name, fn, configurable) {
                    if (Object.defineProperty) Object.defineProperty(object, name, {
                        configurable: false === dpSupport ? true : !!configurable,
                        get: fn
                    });
                    else object.__defineGetter__(name, fn);
                };
                /** Ensure the browser allows Object.defineProperty to be used on native JavaScript objects. */ try {
                    defineGetter({}, "support");
                } catch (e) {
                    dpSupport = false;
                }
                var _DOMTokenList = function(el, prop) {
                    var that = this;
                    var tokens = [];
                    var tokenMap = {};
                    var length = 0;
                    var maxLength = 0;
                    var addIndexGetter = function(i) {
                        defineGetter(that, i, function() {
                            preop();
                            return tokens[i];
                        }, false);
                    };
                    var reindex = function() {
                        /** Define getter functions for array-like access to the tokenList's contents. */ if (length >= maxLength) for(; maxLength < length; ++maxLength)addIndexGetter(maxLength);
                    };
                    /** Helper function called at the start of each class method. Internal use only. */ var preop = function() {
                        var error;
                        var i;
                        var args = arguments;
                        var rSpace = /\s+/;
                        /** Validate the token/s passed to an instance method, if any. */ if (args.length) {
                            for(i = 0; i < args.length; ++i)if (rSpace.test(args[i])) {
                                error = new SyntaxError('String "' + args[i] + '" ' + "contains" + ' an invalid character');
                                error.code = 5;
                                error.name = "InvalidCharacterError";
                                throw error;
                            }
                        }
                        /** Split the new value apart by whitespace*/ if (typeof el[prop] === "object") tokens = ("" + el[prop].baseVal).replace(/^\s+|\s+$/g, "").split(rSpace);
                        else tokens = ("" + el[prop]).replace(/^\s+|\s+$/g, "").split(rSpace);
                        /** Avoid treating blank strings as single-item token lists */ if ("" === tokens[0]) tokens = [];
                        /** Repopulate the internal token lists */ tokenMap = {};
                        for(i = 0; i < tokens.length; ++i)tokenMap[tokens[i]] = true;
                        length = tokens.length;
                        reindex();
                    };
                    /** Populate our internal token list if the targeted attribute of the subject element isn't empty. */ preop();
                    /** Return the number of tokens in the underlying string. Read-only. */ defineGetter(that, "length", function() {
                        preop();
                        return length;
                    });
                    /** Override the default toString/toLocaleString methods to return a space-delimited list of tokens when typecast. */ that.toLocaleString = that.toString = function() {
                        preop();
                        return tokens.join(" ");
                    };
                    that.item = function(idx) {
                        preop();
                        return tokens[idx];
                    };
                    that.contains = function(token) {
                        preop();
                        return !!tokenMap[token];
                    };
                    that.add = function() {
                        preop.apply(that, args = arguments);
                        for(var args, token, i = 0, l = args.length; i < l; ++i){
                            token = args[i];
                            if (!tokenMap[token]) {
                                tokens.push(token);
                                tokenMap[token] = true;
                            }
                        }
                        /** Update the targeted attribute of the attached element if the token list's changed. */ if (length !== tokens.length) {
                            length = tokens.length >>> 0;
                            if (typeof el[prop] === "object") el[prop].baseVal = tokens.join(" ");
                            else el[prop] = tokens.join(" ");
                            reindex();
                        }
                    };
                    that.remove = function() {
                        preop.apply(that, args = arguments);
                        /** Build a hash of token names to compare against when recollecting our token list. */ for(var args, ignore = {}, i = 0, t = []; i < args.length; ++i){
                            ignore[args[i]] = true;
                            delete tokenMap[args[i]];
                        }
                        /** Run through our tokens list and reassign only those that aren't defined in the hash declared above. */ for(i = 0; i < tokens.length; ++i)if (!ignore[tokens[i]]) t.push(tokens[i]);
                        tokens = t;
                        length = t.length >>> 0;
                        /** Update the targeted attribute of the attached element. */ if (typeof el[prop] === "object") el[prop].baseVal = tokens.join(" ");
                        else el[prop] = tokens.join(" ");
                        reindex();
                    };
                    that.toggle = function(token, force) {
                        preop.apply(that, [
                            token
                        ]);
                        /** Token state's being forced. */ if (undefined !== force) {
                            if (force) {
                                that.add(token);
                                return true;
                            } else {
                                that.remove(token);
                                return false;
                            }
                        }
                        /** Token already exists in tokenList. Remove it, and return FALSE. */ if (tokenMap[token]) {
                            that.remove(token);
                            return false;
                        }
                        /** Otherwise, add the token and return TRUE. */ that.add(token);
                        return true;
                    };
                    return that;
                };
                return _DOMTokenList;
            }();
            // Add second argument to native DOMTokenList.toggle() if necessary
            (function() {
                var e = document.createElement('span');
                if (!('classList' in e)) return;
                e.classList.toggle('x', false);
                if (!e.classList.contains('x')) return;
                e.classList.constructor.prototype.toggle = function toggle(token /*, force*/ ) {
                    var force = arguments[1];
                    if (force === undefined) {
                        var add = !this.contains(token);
                        this[add ? 'add' : 'remove'](token);
                        return add;
                    }
                    force = !!force;
                    this[force ? 'add' : 'remove'](token);
                    return force;
                };
            })();
            // Add multiple arguments to native DOMTokenList.add() if necessary
            (function() {
                var e = document.createElement('span');
                if (!('classList' in e)) return;
                e.classList.add('a', 'b');
                if (e.classList.contains('b')) return;
                var native = e.classList.constructor.prototype.add;
                e.classList.constructor.prototype.add = function() {
                    var args = arguments;
                    var l = arguments.length;
                    for(var i = 0; i < l; i++)native.call(this, args[i]);
                };
            })();
            // Add multiple arguments to native DOMTokenList.remove() if necessary
            (function() {
                var e = document.createElement('span');
                if (!('classList' in e)) return;
                e.classList.add('a');
                e.classList.add('b');
                e.classList.remove('a', 'b');
                if (!e.classList.contains('b')) return;
                var native = e.classList.constructor.prototype.remove;
                e.classList.constructor.prototype.remove = function() {
                    var args = arguments;
                    var l = arguments.length;
                    for(var i = 0; i < l; i++)native.call(this, args[i]);
                };
            })();
        })(this);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Document/detect.js
        var detect = "Document" in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Document&flags=always
        if (typeof WorkerGlobalScope === "undefined" && typeof importScripts !== "function") {
            if (this.HTMLDocument) // HTMLDocument is an extension of Document.  If the browser has HTMLDocument but not Document, the former will suffice as an alias for the latter.
            this.Document = this.HTMLDocument;
            else {
                // Create an empty function to act as the missing constructor for the document object, attach the document object as its prototype.  The function needs to be anonymous else it is hoisted and causes the feature detect to prematurely pass, preventing the assignments below being made.
                this.Document = this.HTMLDocument = document.constructor = new Function('return function Document() {}')();
                this.Document.prototype = document;
            }
        }
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Element/detect.js
        var detect = 'Element' in this && 'HTMLElement' in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Element&flags=always
        (function() {
            // IE8
            if (window.Element && !window.HTMLElement) {
                window.HTMLElement = window.Element;
                return;
            }
            // create Element constructor
            window.Element = window.HTMLElement = new Function('return function Element() {}')();
            // generate sandboxed iframe
            var vbody = document.appendChild(document.createElement('body'));
            var frame = vbody.appendChild(document.createElement('iframe'));
            // use sandboxed iframe to replicate Element functionality
            var frameDocument = frame.contentWindow.document;
            var prototype = Element.prototype = frameDocument.appendChild(frameDocument.createElement('*'));
            var cache = {};
            // polyfill Element.prototype on an element
            var shiv = function(element, deep) {
                var childNodes = element.childNodes || [], index = -1, key, value, childNode;
                if (element.nodeType === 1 && element.constructor !== Element) {
                    element.constructor = Element;
                    for(key in cache){
                        value = cache[key];
                        element[key] = value;
                    }
                }
                while(childNode = deep && childNodes[++index])shiv(childNode, deep);
                return element;
            };
            var elements = document.getElementsByTagName('*');
            var nativeCreateElement = document.createElement;
            var interval;
            var loopLimit = 100;
            prototype.attachEvent('onpropertychange', function(event) {
                var propertyName = event.propertyName, nonValue = !cache.hasOwnProperty(propertyName), newValue = prototype[propertyName], oldValue = cache[propertyName], index = -1, element;
                while(element = elements[++index]){
                    if (element.nodeType === 1) {
                        if (nonValue || element[propertyName] === oldValue) element[propertyName] = newValue;
                    }
                }
                cache[propertyName] = newValue;
            });
            prototype.constructor = Element;
            if (!prototype.hasAttribute) // <Element>.hasAttribute
            prototype.hasAttribute = function hasAttribute(name) {
                return this.getAttribute(name) !== null;
            };
            // Apply Element prototype to the pre-existing DOM as soon as the body element appears.
            function bodyCheck() {
                if (!loopLimit--) clearTimeout(interval);
                if (document.body && !document.body.prototype && /(complete|interactive)/.test(document.readyState)) {
                    shiv(document, true);
                    if (interval && document.body.prototype) clearTimeout(interval);
                    return !!document.body.prototype;
                }
                return false;
            }
            if (!bodyCheck()) {
                document.onreadystatechange = bodyCheck;
                interval = setInterval(bodyCheck, 25);
            }
            // Apply to any new elements created after load
            document.createElement = function createElement(nodeName) {
                var element = nativeCreateElement(String(nodeName).toLowerCase());
                return shiv(element);
            };
            // remove sandboxed iframe
            document.removeChild(vbody);
        })();
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-service/8717a9e04ac7aff99b4980fbedead98036b0929a/packages/polyfill-library/polyfills/Element/prototype/classList/detect.js
        var detect = 'document' in this && "classList" in document.documentElement && 'Element' in this && 'classList' in Element.prototype && function() {
            var e = document.createElement('span');
            e.classList.add('a', 'b');
            return e.classList.contains('b');
        }();
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Element.prototype.classList&flags=always
        (function(global1) {
            var dpSupport = true;
            var defineGetter = function(object, name, fn, configurable) {
                if (Object.defineProperty) Object.defineProperty(object, name, {
                    configurable: false === dpSupport ? true : !!configurable,
                    get: fn
                });
                else object.__defineGetter__(name, fn);
            };
            /** Ensure the browser allows Object.defineProperty to be used on native JavaScript objects. */ try {
                defineGetter({}, "support");
            } catch (e) {
                dpSupport = false;
            }
            /** Polyfills a property with a DOMTokenList */ var addProp = function(o, name, attr) {
                defineGetter(o.prototype, name, function() {
                    var tokenList;
                    var THIS = this, /** Prevent this from firing twice for some reason. What the hell, IE. */ gibberishProperty = "__defineGetter__DEFINE_PROPERTY" + name;
                    if (THIS[gibberishProperty]) return tokenList;
                    THIS[gibberishProperty] = true;
                    /**
           * IE8 can't define properties on native JavaScript objects, so we'll use a dumb hack instead.
           *
           * What this is doing is creating a dummy element ("reflection") inside a detached phantom node ("mirror")
           * that serves as the target of Object.defineProperty instead. While we could simply use the subject HTML
           * element instead, this would conflict with element types which use indexed properties (such as forms and
           * select lists).
           */ if (false === dpSupport) {
                        var visage;
                        var mirror = addProp.mirror || document.createElement("div");
                        var reflections = mirror.childNodes;
                        var l = reflections.length;
                        for(var i = 0; i < l; ++i)if (reflections[i]._R === THIS) {
                            visage = reflections[i];
                            break;
                        }
                        /** Couldn't find an element's reflection inside the mirror. Materialise one. */ visage || (visage = mirror.appendChild(document.createElement("div")));
                        tokenList = DOMTokenList.call(visage, THIS, attr);
                    } else tokenList = new DOMTokenList(THIS, attr);
                    defineGetter(THIS, name, function() {
                        return tokenList;
                    });
                    delete THIS[gibberishProperty];
                    return tokenList;
                }, true);
            };
            addProp(global1.Element, "classList", "className");
            addProp(global1.HTMLElement, "classList", "className");
            addProp(global1.HTMLLinkElement, "relList", "rel");
            addProp(global1.HTMLAnchorElement, "relList", "rel");
            addProp(global1.HTMLAreaElement, "relList", "rel");
        })(this);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    function Accordion($module) {
        this.$module = $module;
        this.moduleId = $module.getAttribute('id');
        this.$sections = $module.querySelectorAll('.govuk-accordion__section');
        this.$openAllButton = '';
        this.browserSupportsSessionStorage = helper.checkForSessionStorage();
        this.controlsClass = 'govuk-accordion__controls';
        this.openAllClass = 'govuk-accordion__open-all';
        this.iconClass = 'govuk-accordion__icon';
        this.sectionHeaderClass = 'govuk-accordion__section-header';
        this.sectionHeaderFocusedClass = 'govuk-accordion__section-header--focused';
        this.sectionHeadingClass = 'govuk-accordion__section-heading';
        this.sectionSummaryClass = 'govuk-accordion__section-summary';
        this.sectionButtonClass = 'govuk-accordion__section-button';
        this.sectionExpandedClass = 'govuk-accordion__section--expanded';
    }
    // Initialize component
    Accordion.prototype.init = function() {
        // Check for module
        if (!this.$module) return;
        this.initControls();
        this.initSectionHeaders();
        // See if "Open all" button text should be updated
        var areAllSectionsOpen = this.checkIfAllSectionsOpen();
        this.updateOpenAllButton(areAllSectionsOpen);
    };
    // Initialise controls and set attributes
    Accordion.prototype.initControls = function() {
        // Create "Open all" button and set attributes
        this.$openAllButton = document.createElement('button');
        this.$openAllButton.setAttribute('type', 'button');
        this.$openAllButton.innerHTML = 'Open all <span class="govuk-visually-hidden">sections</span>';
        this.$openAllButton.setAttribute('class', this.openAllClass);
        this.$openAllButton.setAttribute('aria-expanded', 'false');
        this.$openAllButton.setAttribute('type', 'button');
        // Create control wrapper and add controls to it
        var accordionControls = document.createElement('div');
        accordionControls.setAttribute('class', this.controlsClass);
        accordionControls.appendChild(this.$openAllButton);
        this.$module.insertBefore(accordionControls, this.$module.firstChild);
        // Handle events for the controls
        this.$openAllButton.addEventListener('click', this.onOpenOrCloseAllToggle.bind(this));
    };
    // Initialise section headers
    Accordion.prototype.initSectionHeaders = function() {
        // Loop through section headers
        nodeListForEach(this.$sections, (function($section, i) {
            // Set header attributes
            var header = $section.querySelector('.' + this.sectionHeaderClass);
            this.initHeaderAttributes(header, i);
            this.setExpanded(this.isExpanded($section), $section);
            // Handle events
            header.addEventListener('click', this.onSectionToggle.bind(this, $section));
            // See if there is any state stored in sessionStorage and set the sections to
            // open or closed.
            this.setInitialState($section);
        }).bind(this));
    };
    // Set individual header attributes
    Accordion.prototype.initHeaderAttributes = function($headerWrapper, index) {
        var $module = this;
        var $span = $headerWrapper.querySelector('.' + this.sectionButtonClass);
        var $heading = $headerWrapper.querySelector('.' + this.sectionHeadingClass);
        var $summary = $headerWrapper.querySelector('.' + this.sectionSummaryClass);
        // Copy existing span element to an actual button element, for improved accessibility.
        var $button = document.createElement('button');
        $button.setAttribute('type', 'button');
        $button.setAttribute('id', this.moduleId + '-heading-' + (index + 1));
        $button.setAttribute('aria-controls', this.moduleId + '-content-' + (index + 1));
        // Copy all attributes (https://developer.mozilla.org/en-US/docs/Web/API/Element/attributes) from $span to $button
        for(var i = 0; i < $span.attributes.length; i++){
            var attr = $span.attributes.item(i);
            $button.setAttribute(attr.nodeName, attr.nodeValue);
        }
        $button.addEventListener('focusin', function(e) {
            if (!$headerWrapper.classList.contains($module.sectionHeaderFocusedClass)) $headerWrapper.className += ' ' + $module.sectionHeaderFocusedClass;
        });
        $button.addEventListener('blur', function(e) {
            $headerWrapper.classList.remove($module.sectionHeaderFocusedClass);
        });
        if (typeof $summary !== 'undefined' && $summary !== null) $button.setAttribute('aria-describedby', this.moduleId + '-summary-' + (index + 1));
        // $span could contain HTML elements (see https://www.w3.org/TR/2011/WD-html5-20110525/content-models.html#phrasing-content)
        $button.innerHTML = $span.innerHTML;
        $heading.removeChild($span);
        $heading.appendChild($button);
        // Add "+/-" icon
        var icon = document.createElement('span');
        icon.className = this.iconClass;
        icon.setAttribute('aria-hidden', 'true');
        $button.appendChild(icon);
    };
    // When section toggled, set and store state
    Accordion.prototype.onSectionToggle = function($section) {
        var expanded = this.isExpanded($section);
        this.setExpanded(!expanded, $section);
        // Store the state in sessionStorage when a change is triggered
        this.storeState($section);
    };
    // When Open/Close All toggled, set and store state
    Accordion.prototype.onOpenOrCloseAllToggle = function() {
        var $module = this;
        var $sections = this.$sections;
        var nowExpanded = !this.checkIfAllSectionsOpen();
        nodeListForEach($sections, function($section) {
            $module.setExpanded(nowExpanded, $section);
            // Store the state in sessionStorage when a change is triggered
            $module.storeState($section);
        });
        $module.updateOpenAllButton(nowExpanded);
    };
    // Set section attributes when opened/closed
    Accordion.prototype.setExpanded = function(expanded, $section) {
        var $button = $section.querySelector('.' + this.sectionButtonClass);
        $button.setAttribute('aria-expanded', expanded);
        if (expanded) $section.classList.add(this.sectionExpandedClass);
        else $section.classList.remove(this.sectionExpandedClass);
        // See if "Open all" button text should be updated
        var areAllSectionsOpen = this.checkIfAllSectionsOpen();
        this.updateOpenAllButton(areAllSectionsOpen);
    };
    // Get state of section
    Accordion.prototype.isExpanded = function($section) {
        return $section.classList.contains(this.sectionExpandedClass);
    };
    // Check if all sections are open
    Accordion.prototype.checkIfAllSectionsOpen = function() {
        // Get a count of all the Accordion sections
        var sectionsCount = this.$sections.length;
        // Get a count of all Accordion sections that are expanded
        var expandedSectionCount = this.$module.querySelectorAll('.' + this.sectionExpandedClass).length;
        var areAllSectionsOpen = sectionsCount === expandedSectionCount;
        return areAllSectionsOpen;
    };
    // Update "Open all" button
    Accordion.prototype.updateOpenAllButton = function(expanded) {
        var newButtonText = expanded ? 'Close all' : 'Open all';
        newButtonText += '<span class="govuk-visually-hidden"> sections</span>';
        this.$openAllButton.setAttribute('aria-expanded', expanded);
        this.$openAllButton.innerHTML = newButtonText;
    };
    // Check for `window.sessionStorage`, and that it actually works.
    var helper = {
        checkForSessionStorage: function() {
            var testString = 'this is the test string';
            var result;
            try {
                window.sessionStorage.setItem(testString, testString);
                result = window.sessionStorage.getItem(testString) === testString.toString();
                window.sessionStorage.removeItem(testString);
                return result;
            } catch (exception) {
                if (typeof console === 'undefined' || typeof console.log === 'undefined') console.log('Notice: sessionStorage not available.');
            }
        }
    };
    // Set the state of the accordions in sessionStorage
    Accordion.prototype.storeState = function($section) {
        if (this.browserSupportsSessionStorage) {
            // We need a unique way of identifying each content in the accordion. Since
            // an `#id` should be unique and an `id` is required for `aria-` attributes
            // `id` can be safely used.
            var $button = $section.querySelector('.' + this.sectionButtonClass);
            if ($button) {
                var contentId = $button.getAttribute('aria-controls');
                var contentState = $button.getAttribute('aria-expanded');
                if (typeof contentId === 'undefined' && (typeof console === 'undefined' || typeof console.log === 'undefined')) console.error(new Error('No aria controls present in accordion section heading.'));
                if (typeof contentState === 'undefined' && (typeof console === 'undefined' || typeof console.log === 'undefined')) console.error(new Error('No aria expanded present in accordion section heading.'));
                // Only set the state when both `contentId` and `contentState` are taken from the DOM.
                if (contentId && contentState) window.sessionStorage.setItem(contentId, contentState);
            }
        }
    };
    // Read the state of the accordions from sessionStorage
    Accordion.prototype.setInitialState = function($section) {
        if (this.browserSupportsSessionStorage) {
            var $button = $section.querySelector('.' + this.sectionButtonClass);
            if ($button) {
                var contentId = $button.getAttribute('aria-controls');
                var contentState = contentId ? window.sessionStorage.getItem(contentId) : null;
                if (contentState !== null) this.setExpanded(contentState === 'true', $section);
            }
        }
    };
    return Accordion;
});


var $6d0087d128b600ac$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($b2fca1e5c52c6e7b$exports)));


// ESM Exports
// ===========
// This module is the package entry point for ES module users. In other words,
// it is the module they are interfacing with when they import from the whole
// package instead of from a submodule, like this:
//
// ```js
// import { map } from 'underscore';
// ```
//
// The difference with `./index-default`, which is the package entry point for
// CommonJS, AMD and UMD users, is purely technical. In ES modules, named and
// default exports are considered to be siblings, so when you have a default
// export, its properties are not automatically available as named exports. For
// this reason, we re-export the named exports in addition to providing the same
// default export as in `./index-default`.
// Default Export
// ==============
// In this module, we mix our bundled exports into the `_` object and export
// the result. This is analogous to setting `module.exports = _` in CommonJS.
// Hence, this module is also the entry point of our UMD bundle and the package
// entry point for CommonJS and AMD users. In other words, this is (the source
// of) the module you are interfacing with when you do any of the following:
//
// ```js
// // CommonJS
// var _ = require('underscore');
//
// // AMD
// define(['underscore'], function(_) {...});
//
// // UMD in the browser
// // _ is available as a global variable
// ```
var $aff2018c308031aa$exports = {};

$parcel$defineInteropFlag($aff2018c308031aa$exports);

$parcel$export($aff2018c308031aa$exports, "VERSION", () => $2d63c72f11d36dd8$export$a4ad2735b021c132);
$parcel$export($aff2018c308031aa$exports, "restArguments", () => $00091338bb34561a$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isObject", () => $6e3e7d3004a0bd6f$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isNull", () => $a042320c2c15e613$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isUndefined", () => $0d2e0eff9b6e26c2$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isBoolean", () => $5394bc2f01152bbc$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isElement", () => $cfeb64eb4197347f$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isString", () => $c60f1c14f06acd60$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isNumber", () => $8b732457fbe276dc$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isDate", () => $2e6aeb67ee40470b$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isRegExp", () => $37f38c538158829c$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isError", () => $b100e45f427f9ef6$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isSymbol", () => $3e5ddff5af045f50$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isArrayBuffer", () => $12134e4967df2b87$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isDataView", () => $282d5f466b13837a$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isArray", () => $f9e6c041730fdb31$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isFunction", () => $ecd89179b736cddb$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isArguments", () => $a68c3966b61ff959$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isFinite", () => $debcf2bd172293e4$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isNaN", () => $5a968955ec4f3425$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isTypedArray", () => $9077e7ed52c125e5$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isEmpty", () => $7a89a6b6e948e772$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isMatch", () => $375387b8b59ffb29$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isEqual", () => $d7cadaba8ed5bf16$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isMap", () => $112ab78c61fa9f88$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isWeakMap", () => $33e36c138b4bf873$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isSet", () => $ec84b0948615a45b$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "isWeakSet", () => $e8c59ef6a6f4fcee$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "keys", () => $6fe7302bdcad38ac$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "allKeys", () => $76c102325be5f353$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "values", () => $ebb4fbd725ae82a0$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "pairs", () => $6858269b58b81583$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "invert", () => $ba8d0fba6632eaff$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "functions", () => $7e9662b114b4a099$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "methods", () => $7e9662b114b4a099$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "extend", () => $cd665a7b16f49314$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "extendOwn", () => $f40532393fd97aec$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "assign", () => $f40532393fd97aec$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "defaults", () => $9225d9bed8720bc5$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "create", () => $bd444a42534a739d$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "clone", () => $ac5f44fcda61a289$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "tap", () => $4386162a0709f5b5$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "get", () => $80790876ee4b09c1$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "has", () => $4fb312c1270006dd$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "mapObject", () => $361a0ec142a97115$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "identity", () => $34b5571162c34d5a$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "constant", () => $92beb55e5504ffbe$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "noop", () => $ea593b64ef4e2a8e$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "toPath", () => $100e549c0eece915$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "property", () => $bcea3364d1615dfa$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "propertyOf", () => $4a4ca2b2793dbf28$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "matcher", () => $d488ba5b1a5b1ffd$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "matches", () => $d488ba5b1a5b1ffd$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "times", () => $93fb7833cb34acaa$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "random", () => $f9cdebf5ce2af7ea$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "now", () => $ff631391d2cf96ac$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "escape", () => $29bd69dc36818855$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "unescape", () => $987ff7a55bdcc95b$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "templateSettings", () => $799262f659d00f51$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "template", () => $78309a1f9f459973$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "result", () => $e687d77f3e8f8cc0$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "uniqueId", () => $409640a219323d5c$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "chain", () => $07d178e7c93d3e66$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "iteratee", () => $37d34a73637a8f26$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "partial", () => $1a2e147da63105f5$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "bind", () => $9b82ce32b9f64f95$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "bindAll", () => $cb918855b9157d53$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "memoize", () => $4498a1ed71e9fe6a$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "delay", () => $43f004011196acc1$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "defer", () => $0b0c55fd99270793$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "throttle", () => $c113ee3e9b3b083d$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "debounce", () => $daf83e4f50d19913$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "wrap", () => $0971039d46d98585$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "negate", () => $4d454b4b64719993$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "compose", () => $9f03098fdf5e98d2$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "after", () => $0c0c90fff32f81b8$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "before", () => $3668e405225021ed$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "once", () => $82a9d64a1bd25e8f$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "findKey", () => $79b73215b289181c$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "findIndex", () => $8f47a544aeb08a7e$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "findLastIndex", () => $3ae5e429277e4694$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "sortedIndex", () => $062e5c7017ea1c58$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "indexOf", () => $76649ff64c4c112d$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "lastIndexOf", () => $46b6a951c1416c2e$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "find", () => $a3b993f50683293a$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "detect", () => $a3b993f50683293a$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "findWhere", () => $f424b3ff2217dd6e$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "each", () => $b995362b61cbe134$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "forEach", () => $b995362b61cbe134$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "map", () => $c746756a67aa053b$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "collect", () => $c746756a67aa053b$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "reduce", () => $fbfad6943e87d98c$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "foldl", () => $fbfad6943e87d98c$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "inject", () => $fbfad6943e87d98c$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "reduceRight", () => $6821e7cd1cda490c$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "foldr", () => $6821e7cd1cda490c$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "filter", () => $3cab01f560c3a138$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "select", () => $3cab01f560c3a138$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "reject", () => $88d462cd31dad735$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "every", () => $1ed12610b787b54c$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "all", () => $1ed12610b787b54c$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "some", () => $1f6dd4637b6de52e$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "any", () => $1f6dd4637b6de52e$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "contains", () => $47db385fda09988c$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "includes", () => $47db385fda09988c$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "include", () => $47db385fda09988c$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "invoke", () => $1b37fa5b86fe2986$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "pluck", () => $64b7e156b18644d0$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "where", () => $4a123abd524cfc92$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "max", () => $f1fcbb9a3e80ebe3$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "min", () => $f4b1abaac39e8250$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "shuffle", () => $126b00d4f3d6622f$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "sample", () => $006c92d573cf9580$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "sortBy", () => $764739bcb0503f2e$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "groupBy", () => $fb9e1d043a6fe792$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "indexBy", () => $ac54a1aed9ba8a72$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "countBy", () => $85ce7e736ff1427c$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "partition", () => $1c3202b1cbae054a$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "toArray", () => $af549ed737dbc31a$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "size", () => $c1f52b9a7c4ef91e$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "pick", () => $3676c3d07a7362ef$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "omit", () => $9ba5eff4e454bc2e$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "first", () => $4584a922b20bbe9b$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "head", () => $4584a922b20bbe9b$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "take", () => $4584a922b20bbe9b$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "initial", () => $d0de77978a68d9ea$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "last", () => $5ea6e92bed107ca3$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "rest", () => $4b067ce637fc54a6$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "tail", () => $4b067ce637fc54a6$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "drop", () => $4b067ce637fc54a6$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "compact", () => $5fa8fc2d5a95b6b3$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "flatten", () => $23786b176608059b$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "without", () => $d1923ce94a67b9a2$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "uniq", () => $f0bec29b96d47a33$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "unique", () => $f0bec29b96d47a33$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "union", () => $4cbad72dc0b3402b$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "intersection", () => $640ee3b4c6854636$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "difference", () => $ef37b923cabd07c5$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "unzip", () => $e787e451ed8ddde4$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "transpose", () => $e787e451ed8ddde4$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "zip", () => $fe0814bdf6654e7d$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "object", () => $9a9112ffd6f5d502$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "range", () => $6fbcf963c33899f9$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "chunk", () => $6cd4738b38ff6a08$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "mixin", () => $add98ab171b98313$export$2e2bcd8739ae039);
$parcel$export($aff2018c308031aa$exports, "default", () => $a0b73385c05e176b$export$2e2bcd8739ae039);
// Named Exports
// =============
//     Underscore.js 1.13.1
//     https://underscorejs.org
//     (c) 2009-2021 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.
// Baseline setup.
// Current version.
var $2d63c72f11d36dd8$export$a4ad2735b021c132 = '1.13.1';
var $2d63c72f11d36dd8$export$e8e78c978b129247 = typeof self == 'object' && self.self === self && self || typeof $parcel$global == 'object' && $parcel$global.global === $parcel$global && $parcel$global || Function('return this')() || {};
var $2d63c72f11d36dd8$export$aabeece9448a227a = Array.prototype, $2d63c72f11d36dd8$export$e77bb59b5e655b3d = Object.prototype;
var $2d63c72f11d36dd8$export$e229dcb397ceea81 = typeof Symbol !== 'undefined' ? Symbol.prototype : null;
var $2d63c72f11d36dd8$export$4cbf152802aa238 = $2d63c72f11d36dd8$export$aabeece9448a227a.push, $2d63c72f11d36dd8$export$58adb3bec8346d0f = $2d63c72f11d36dd8$export$aabeece9448a227a.slice, $2d63c72f11d36dd8$export$f84e8e69fd4488a5 = $2d63c72f11d36dd8$export$e77bb59b5e655b3d.toString, $2d63c72f11d36dd8$export$5a15a386532a5ea4 = $2d63c72f11d36dd8$export$e77bb59b5e655b3d.hasOwnProperty;
var $2d63c72f11d36dd8$export$20eaf89d899ede58 = typeof ArrayBuffer !== 'undefined', $2d63c72f11d36dd8$export$a2e478ad34dac33e = typeof DataView !== 'undefined';
var $2d63c72f11d36dd8$export$552cf9b635cef256 = Array.isArray, $2d63c72f11d36dd8$export$e676cf06d7fd2114 = Object.keys, $2d63c72f11d36dd8$export$5b53dc95b548c58c = Object.create, $2d63c72f11d36dd8$export$35fc70fc5e80d5a7 = $2d63c72f11d36dd8$export$20eaf89d899ede58 && ArrayBuffer.isView;
var $2d63c72f11d36dd8$export$a739ba33a90be0a1 = isNaN, $2d63c72f11d36dd8$export$8b48b92f6c9d5ad = isFinite;
var $2d63c72f11d36dd8$export$7dcea4d27900b116 = !({
    toString: null
}).propertyIsEnumerable('toString');
var $2d63c72f11d36dd8$export$f8fa596d5e31cb19 = [
    'valueOf',
    'isPrototypeOf',
    'toString',
    'propertyIsEnumerable',
    'hasOwnProperty',
    'toLocaleString'
];
var $2d63c72f11d36dd8$export$63b3abc5cd28bc48 = Math.pow(2, 53) - 1;


// Some functions take a variable number of arguments, or a few expected
// arguments at the beginning and then a variable number of values to operate
// on. This helper accumulates all remaining arguments past the function’s
// argument length (or an explicit `startIndex`), into an array that becomes
// the last argument. Similar to ES6’s "rest parameter".
function $00091338bb34561a$export$2e2bcd8739ae039(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
        var length = Math.max(arguments.length - startIndex, 0), rest = Array(length), index = 0;
        for(; index < length; index++)rest[index] = arguments[index + startIndex];
        switch(startIndex){
            case 0:
                return func.call(this, rest);
            case 1:
                return func.call(this, arguments[0], rest);
            case 2:
                return func.call(this, arguments[0], arguments[1], rest);
        }
        var args = Array(startIndex + 1);
        for(index = 0; index < startIndex; index++)args[index] = arguments[index];
        args[startIndex] = rest;
        return func.apply(this, args);
    };
}


// Is a given variable an object?
function $6e3e7d3004a0bd6f$export$2e2bcd8739ae039(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
}


// Is a given value equal to null?
function $a042320c2c15e613$export$2e2bcd8739ae039(obj) {
    return obj === null;
}


// Is a given variable undefined?
function $0d2e0eff9b6e26c2$export$2e2bcd8739ae039(obj) {
    return obj === void 0;
}



function $5394bc2f01152bbc$export$2e2bcd8739ae039(obj) {
    return obj === true || obj === false || (0, $2d63c72f11d36dd8$export$f84e8e69fd4488a5).call(obj) === '[object Boolean]';
}


// Is a given value a DOM element?
function $cfeb64eb4197347f$export$2e2bcd8739ae039(obj) {
    return !!(obj && obj.nodeType === 1);
}



function $f579a1e3e166bc6c$export$2e2bcd8739ae039(name) {
    var tag = '[object ' + name + ']';
    return function(obj) {
        return (0, $2d63c72f11d36dd8$export$f84e8e69fd4488a5).call(obj) === tag;
    };
}


var $c60f1c14f06acd60$export$2e2bcd8739ae039 = (0, $f579a1e3e166bc6c$export$2e2bcd8739ae039)('String');



var $8b732457fbe276dc$export$2e2bcd8739ae039 = (0, $f579a1e3e166bc6c$export$2e2bcd8739ae039)('Number');



var $2e6aeb67ee40470b$export$2e2bcd8739ae039 = (0, $f579a1e3e166bc6c$export$2e2bcd8739ae039)('Date');



var $37f38c538158829c$export$2e2bcd8739ae039 = (0, $f579a1e3e166bc6c$export$2e2bcd8739ae039)('RegExp');



var $b100e45f427f9ef6$export$2e2bcd8739ae039 = (0, $f579a1e3e166bc6c$export$2e2bcd8739ae039)('Error');



var $3e5ddff5af045f50$export$2e2bcd8739ae039 = (0, $f579a1e3e166bc6c$export$2e2bcd8739ae039)('Symbol');



var $12134e4967df2b87$export$2e2bcd8739ae039 = (0, $f579a1e3e166bc6c$export$2e2bcd8739ae039)('ArrayBuffer');





var $ecd89179b736cddb$var$isFunction = (0, $f579a1e3e166bc6c$export$2e2bcd8739ae039)('Function');
// Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
// v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
var $ecd89179b736cddb$var$nodelist = (0, $2d63c72f11d36dd8$export$e8e78c978b129247).document && (0, $2d63c72f11d36dd8$export$e8e78c978b129247).document.childNodes;
if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof $ecd89179b736cddb$var$nodelist != 'function') $ecd89179b736cddb$var$isFunction = function(obj) {
    return typeof obj == 'function' || false;
};
var $ecd89179b736cddb$export$2e2bcd8739ae039 = $ecd89179b736cddb$var$isFunction;





var $a870cb15b080e803$export$2e2bcd8739ae039 = (0, $f579a1e3e166bc6c$export$2e2bcd8739ae039)('Object');


var $77d6d5ed2b916838$export$834f1807c25991c1 = (0, $2d63c72f11d36dd8$export$a2e478ad34dac33e) && (0, $a870cb15b080e803$export$2e2bcd8739ae039)(new DataView(new ArrayBuffer(8))), $77d6d5ed2b916838$export$f7bad96d83325a34 = typeof Map !== 'undefined' && (0, $a870cb15b080e803$export$2e2bcd8739ae039)(new Map);


var $282d5f466b13837a$var$isDataView = (0, $f579a1e3e166bc6c$export$2e2bcd8739ae039)('DataView');
// In IE 10 - Edge 13, we need a different heuristic
// to determine whether an object is a `DataView`.
function $282d5f466b13837a$var$ie10IsDataView(obj) {
    return obj != null && (0, $ecd89179b736cddb$export$2e2bcd8739ae039)(obj.getInt8) && (0, $12134e4967df2b87$export$2e2bcd8739ae039)(obj.buffer);
}
var $282d5f466b13837a$export$2e2bcd8739ae039 = (0, $77d6d5ed2b916838$export$834f1807c25991c1) ? $282d5f466b13837a$var$ie10IsDataView : $282d5f466b13837a$var$isDataView;




var // Is a given value an array?
// Delegates to ECMA5's native `Array.isArray`.
$f9e6c041730fdb31$export$2e2bcd8739ae039 = (0, $2d63c72f11d36dd8$export$552cf9b635cef256) || (0, $f579a1e3e166bc6c$export$2e2bcd8739ae039)('Array');





function $39edb832e07faa22$export$2e2bcd8739ae039(obj, key) {
    return obj != null && (0, $2d63c72f11d36dd8$export$5a15a386532a5ea4).call(obj, key);
}


var $a68c3966b61ff959$var$isArguments = (0, $f579a1e3e166bc6c$export$2e2bcd8739ae039)('Arguments');
// Define a fallback version of the method in browsers (ahem, IE < 9), where
// there isn't any inspectable "Arguments" type.
(function() {
    if (!$a68c3966b61ff959$var$isArguments(arguments)) $a68c3966b61ff959$var$isArguments = function(obj) {
        return (0, $39edb832e07faa22$export$2e2bcd8739ae039)(obj, 'callee');
    };
})();
var $a68c3966b61ff959$export$2e2bcd8739ae039 = $a68c3966b61ff959$var$isArguments;




function $debcf2bd172293e4$export$2e2bcd8739ae039(obj) {
    return !(0, $3e5ddff5af045f50$export$2e2bcd8739ae039)(obj) && (0, $2d63c72f11d36dd8$export$8b48b92f6c9d5ad)(obj) && !isNaN(parseFloat(obj));
}




function $5a968955ec4f3425$export$2e2bcd8739ae039(obj) {
    return (0, $8b732457fbe276dc$export$2e2bcd8739ae039)(obj) && (0, $2d63c72f11d36dd8$export$a739ba33a90be0a1)(obj);
}




// Predicate-generating function. Often useful outside of Underscore.
function $92beb55e5504ffbe$export$2e2bcd8739ae039(value) {
    return function() {
        return value;
    };
}



function $61cc4bd77dea34f8$export$2e2bcd8739ae039(getSizeProperty) {
    return function(collection) {
        var sizeProperty = getSizeProperty(collection);
        return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= (0, $2d63c72f11d36dd8$export$63b3abc5cd28bc48);
    };
}


// Internal helper to generate a function to obtain property `key` from `obj`.
function $23e52771e26c0d29$export$2e2bcd8739ae039(key) {
    return function(obj) {
        return obj == null ? void 0 : obj[key];
    };
}


var // Internal helper to obtain the `byteLength` property of an object.
$935303bff590dfe3$export$2e2bcd8739ae039 = (0, $23e52771e26c0d29$export$2e2bcd8739ae039)('byteLength');


var // Internal helper to determine whether we should spend extensive checks against
// `ArrayBuffer` et al.
$b0ba036a9e1182f7$export$2e2bcd8739ae039 = (0, $61cc4bd77dea34f8$export$2e2bcd8739ae039)((0, $935303bff590dfe3$export$2e2bcd8739ae039));


// Is a given value a typed array?
var $9077e7ed52c125e5$var$typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function $9077e7ed52c125e5$var$isTypedArray(obj) {
    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
    // Otherwise, fall back on the above regular expression.
    return (0, $2d63c72f11d36dd8$export$35fc70fc5e80d5a7) ? (0, $2d63c72f11d36dd8$export$35fc70fc5e80d5a7)(obj) && !(0, $282d5f466b13837a$export$2e2bcd8739ae039)(obj) : (0, $b0ba036a9e1182f7$export$2e2bcd8739ae039)(obj) && $9077e7ed52c125e5$var$typedArrayPattern.test((0, $2d63c72f11d36dd8$export$f84e8e69fd4488a5).call(obj));
}
var $9077e7ed52c125e5$export$2e2bcd8739ae039 = (0, $2d63c72f11d36dd8$export$20eaf89d899ede58) ? $9077e7ed52c125e5$var$isTypedArray : (0, $92beb55e5504ffbe$export$2e2bcd8739ae039)(false);



var // Internal helper to obtain the `length` property of an object.
$d9552e9372db9187$export$2e2bcd8739ae039 = (0, $23e52771e26c0d29$export$2e2bcd8739ae039)('length');











// Internal helper to create a simple lookup structure.
// `collectNonEnumProps` used to depend on `_.contains`, but this led to
// circular imports. `emulatedSet` is a one-off solution that only works for
// arrays of strings.
function $9b8218d47529a1ac$var$emulatedSet(keys) {
    var hash = {};
    for(var l = keys.length, i = 0; i < l; ++i)hash[keys[i]] = true;
    return {
        contains: function(key) {
            return hash[key];
        },
        push: function(key) {
            hash[key] = true;
            return keys.push(key);
        }
    };
}
function $9b8218d47529a1ac$export$2e2bcd8739ae039(obj, keys) {
    keys = $9b8218d47529a1ac$var$emulatedSet(keys);
    var nonEnumIdx = (0, $2d63c72f11d36dd8$export$f8fa596d5e31cb19).length;
    var constructor = obj.constructor;
    var proto = (0, $ecd89179b736cddb$export$2e2bcd8739ae039)(constructor) && constructor.prototype || (0, $2d63c72f11d36dd8$export$e77bb59b5e655b3d);
    // Constructor is a special case.
    var prop = 'constructor';
    if ((0, $39edb832e07faa22$export$2e2bcd8739ae039)(obj, prop) && !keys.contains(prop)) keys.push(prop);
    while(nonEnumIdx--){
        prop = (0, $2d63c72f11d36dd8$export$f8fa596d5e31cb19)[nonEnumIdx];
        if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) keys.push(prop);
    }
}


function $6fe7302bdcad38ac$export$2e2bcd8739ae039(obj) {
    if (!(0, $6e3e7d3004a0bd6f$export$2e2bcd8739ae039)(obj)) return [];
    if (0, $2d63c72f11d36dd8$export$e676cf06d7fd2114) return (0, $2d63c72f11d36dd8$export$e676cf06d7fd2114)(obj);
    var keys = [];
    for(var key in obj)if ((0, $39edb832e07faa22$export$2e2bcd8739ae039)(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (0, $2d63c72f11d36dd8$export$7dcea4d27900b116) (0, $9b8218d47529a1ac$export$2e2bcd8739ae039)(obj, keys);
    return keys;
}


function $7a89a6b6e948e772$export$2e2bcd8739ae039(obj) {
    if (obj == null) return true;
    // Skip the more expensive `toString`-based type checks if `obj` has no
    // `.length`.
    var length = (0, $d9552e9372db9187$export$2e2bcd8739ae039)(obj);
    if (typeof length == 'number' && ((0, $f9e6c041730fdb31$export$2e2bcd8739ae039)(obj) || (0, $c60f1c14f06acd60$export$2e2bcd8739ae039)(obj) || (0, $a68c3966b61ff959$export$2e2bcd8739ae039)(obj))) return length === 0;
    return (0, $d9552e9372db9187$export$2e2bcd8739ae039)((0, $6fe7302bdcad38ac$export$2e2bcd8739ae039)(obj)) === 0;
}



function $375387b8b59ffb29$export$2e2bcd8739ae039(object, attrs) {
    var _keys = (0, $6fe7302bdcad38ac$export$2e2bcd8739ae039)(attrs), length = _keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for(var i = 0; i < length; i++){
        var key = _keys[i];
        if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
}



function $51828dc883981eb1$export$2e2bcd8739ae039(obj) {
    if (obj instanceof $51828dc883981eb1$export$2e2bcd8739ae039) return obj;
    if (!(this instanceof $51828dc883981eb1$export$2e2bcd8739ae039)) return new $51828dc883981eb1$export$2e2bcd8739ae039(obj);
    this._wrapped = obj;
}
$51828dc883981eb1$export$2e2bcd8739ae039.VERSION = (0, $2d63c72f11d36dd8$export$a4ad2735b021c132);
// Extracts the result from a wrapped and chained object.
$51828dc883981eb1$export$2e2bcd8739ae039.prototype.value = function() {
    return this._wrapped;
};
// Provide unwrapping proxies for some methods used in engine operations
// such as arithmetic and JSON stringification.
$51828dc883981eb1$export$2e2bcd8739ae039.prototype.valueOf = $51828dc883981eb1$export$2e2bcd8739ae039.prototype.toJSON = $51828dc883981eb1$export$2e2bcd8739ae039.prototype.value;
$51828dc883981eb1$export$2e2bcd8739ae039.prototype.toString = function() {
    return String(this._wrapped);
};











function $3d46d3e4e4eb9906$export$2e2bcd8739ae039(bufferSource) {
    return new Uint8Array(bufferSource.buffer || bufferSource, bufferSource.byteOffset || 0, (0, $935303bff590dfe3$export$2e2bcd8739ae039)(bufferSource));
}


// We use this string twice, so give it a name for minification.
var $d7cadaba8ed5bf16$var$tagDataView = '[object DataView]';
// Internal recursive comparison function for `_.isEqual`.
function $d7cadaba8ed5bf16$var$eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return $d7cadaba8ed5bf16$var$deepEq(a, b, aStack, bStack);
}
// Internal recursive comparison function for `_.isEqual`.
function $d7cadaba8ed5bf16$var$deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof (0, $51828dc883981eb1$export$2e2bcd8739ae039)) a = a._wrapped;
    if (b instanceof (0, $51828dc883981eb1$export$2e2bcd8739ae039)) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = (0, $2d63c72f11d36dd8$export$f84e8e69fd4488a5).call(a);
    if (className !== (0, $2d63c72f11d36dd8$export$f84e8e69fd4488a5).call(b)) return false;
    // Work around a bug in IE 10 - Edge 13.
    if ((0, $77d6d5ed2b916838$export$834f1807c25991c1) && className == '[object Object]' && (0, $282d5f466b13837a$export$2e2bcd8739ae039)(a)) {
        if (!(0, $282d5f466b13837a$export$2e2bcd8739ae039)(b)) return false;
        className = $d7cadaba8ed5bf16$var$tagDataView;
    }
    switch(className){
        // These types are compared by value.
        case '[object RegExp]':
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case '[object String]':
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return '' + a === '' + b;
        case '[object Number]':
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case '[object Date]':
        case '[object Boolean]':
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case '[object Symbol]':
            return (0, $2d63c72f11d36dd8$export$e229dcb397ceea81).valueOf.call(a) === (0, $2d63c72f11d36dd8$export$e229dcb397ceea81).valueOf.call(b);
        case '[object ArrayBuffer]':
        case $d7cadaba8ed5bf16$var$tagDataView:
            // Coerce to typed array so we can fall through.
            return $d7cadaba8ed5bf16$var$deepEq((0, $3d46d3e4e4eb9906$export$2e2bcd8739ae039)(a), (0, $3d46d3e4e4eb9906$export$2e2bcd8739ae039)(b), aStack, bStack);
    }
    var areArrays = className === '[object Array]';
    if (!areArrays && (0, $9077e7ed52c125e5$export$2e2bcd8739ae039)(a)) {
        var byteLength = (0, $935303bff590dfe3$export$2e2bcd8739ae039)(a);
        if (byteLength !== (0, $935303bff590dfe3$export$2e2bcd8739ae039)(b)) return false;
        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
        areArrays = true;
    }
    if (!areArrays) {
        if (typeof a != 'object' || typeof b != 'object') return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !((0, $ecd89179b736cddb$export$2e2bcd8739ae039)(aCtor) && aCtor instanceof aCtor && (0, $ecd89179b736cddb$export$2e2bcd8739ae039)(bCtor) && bCtor instanceof bCtor) && 'constructor' in a && 'constructor' in b) return false;
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!$d7cadaba8ed5bf16$var$eq(a[length], b[length], aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var _keys = (0, $6fe7302bdcad38ac$export$2e2bcd8739ae039)(a), key;
        length = _keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if ((0, $6fe7302bdcad38ac$export$2e2bcd8739ae039)(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = _keys[length];
            if (!((0, $39edb832e07faa22$export$2e2bcd8739ae039)(b, key) && $d7cadaba8ed5bf16$var$eq(a[key], b[key], aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function $d7cadaba8ed5bf16$export$2e2bcd8739ae039(a, b) {
    return $d7cadaba8ed5bf16$var$eq(a, b);
}









function $76c102325be5f353$export$2e2bcd8739ae039(obj) {
    if (!(0, $6e3e7d3004a0bd6f$export$2e2bcd8739ae039)(obj)) return [];
    var keys = [];
    for(var key in obj)keys.push(key);
    // Ahem, IE < 9.
    if (0, $2d63c72f11d36dd8$export$7dcea4d27900b116) (0, $9b8218d47529a1ac$export$2e2bcd8739ae039)(obj, keys);
    return keys;
}


function $5d8a1e0d10a29a99$export$15230eca1f400e40(methods) {
    var length = (0, $d9552e9372db9187$export$2e2bcd8739ae039)(methods);
    return function(obj) {
        if (obj == null) return false;
        // `Map`, `WeakMap` and `Set` have no enumerable keys.
        var keys = (0, $76c102325be5f353$export$2e2bcd8739ae039)(obj);
        if ((0, $d9552e9372db9187$export$2e2bcd8739ae039)(keys)) return false;
        for(var i = 0; i < length; i++){
            if (!(0, $ecd89179b736cddb$export$2e2bcd8739ae039)(obj[methods[i]])) return false;
        }
        // If we are testing against `WeakMap`, we need to ensure that
        // `obj` doesn't have a `forEach` method in order to distinguish
        // it from a regular `Map`.
        return methods !== $5d8a1e0d10a29a99$export$2f74b890a72cf48 || !(0, $ecd89179b736cddb$export$2e2bcd8739ae039)(obj[$5d8a1e0d10a29a99$var$forEachName]);
    };
}
// In the interest of compact minification, we write
// each string in the fingerprints only once.
var $5d8a1e0d10a29a99$var$forEachName = 'forEach', $5d8a1e0d10a29a99$var$hasName = 'has', $5d8a1e0d10a29a99$var$commonInit = [
    'clear',
    'delete'
], $5d8a1e0d10a29a99$var$mapTail = [
    'get',
    $5d8a1e0d10a29a99$var$hasName,
    'set'
];
var $5d8a1e0d10a29a99$export$de9acb94190bb764 = $5d8a1e0d10a29a99$var$commonInit.concat($5d8a1e0d10a29a99$var$forEachName, $5d8a1e0d10a29a99$var$mapTail), $5d8a1e0d10a29a99$export$2f74b890a72cf48 = $5d8a1e0d10a29a99$var$commonInit.concat($5d8a1e0d10a29a99$var$mapTail), $5d8a1e0d10a29a99$export$60e14a5e2a057f78 = [
    'add'
].concat($5d8a1e0d10a29a99$var$commonInit, $5d8a1e0d10a29a99$var$forEachName, $5d8a1e0d10a29a99$var$hasName);


var $112ab78c61fa9f88$export$2e2bcd8739ae039 = (0, $77d6d5ed2b916838$export$f7bad96d83325a34) ? (0, $5d8a1e0d10a29a99$export$15230eca1f400e40)((0, $5d8a1e0d10a29a99$export$de9acb94190bb764)) : (0, $f579a1e3e166bc6c$export$2e2bcd8739ae039)('Map');





var $33e36c138b4bf873$export$2e2bcd8739ae039 = (0, $77d6d5ed2b916838$export$f7bad96d83325a34) ? (0, $5d8a1e0d10a29a99$export$15230eca1f400e40)((0, $5d8a1e0d10a29a99$export$2f74b890a72cf48)) : (0, $f579a1e3e166bc6c$export$2e2bcd8739ae039)('WeakMap');





var $ec84b0948615a45b$export$2e2bcd8739ae039 = (0, $77d6d5ed2b916838$export$f7bad96d83325a34) ? (0, $5d8a1e0d10a29a99$export$15230eca1f400e40)((0, $5d8a1e0d10a29a99$export$60e14a5e2a057f78)) : (0, $f579a1e3e166bc6c$export$2e2bcd8739ae039)('Set');



var $e8c59ef6a6f4fcee$export$2e2bcd8739ae039 = (0, $f579a1e3e166bc6c$export$2e2bcd8739ae039)('WeakSet');





function $ebb4fbd725ae82a0$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $6fe7302bdcad38ac$export$2e2bcd8739ae039)(obj);
    var length = _keys.length;
    var values = Array(length);
    for(var i = 0; i < length; i++)values[i] = obj[_keys[i]];
    return values;
}



function $6858269b58b81583$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $6fe7302bdcad38ac$export$2e2bcd8739ae039)(obj);
    var length = _keys.length;
    var pairs = Array(length);
    for(var i = 0; i < length; i++)pairs[i] = [
        _keys[i],
        obj[_keys[i]]
    ];
    return pairs;
}



function $ba8d0fba6632eaff$export$2e2bcd8739ae039(obj) {
    var result = {};
    var _keys = (0, $6fe7302bdcad38ac$export$2e2bcd8739ae039)(obj);
    for(var i = 0, length = _keys.length; i < length; i++)result[obj[_keys[i]]] = _keys[i];
    return result;
}



function $7e9662b114b4a099$export$2e2bcd8739ae039(obj) {
    var names = [];
    for(var key in obj)if ((0, $ecd89179b736cddb$export$2e2bcd8739ae039)(obj[key])) names.push(key);
    return names.sort();
}


// An internal function for creating assigner functions.
function $be67da832d3a72cd$export$2e2bcd8739ae039(keysFunc, defaults) {
    return function(obj) {
        var length = arguments.length;
        if (defaults) obj = Object(obj);
        if (length < 2 || obj == null) return obj;
        for(var index = 1; index < length; index++){
            var source = arguments[index], keys = keysFunc(source), l = keys.length;
            for(var i = 0; i < l; i++){
                var key = keys[i];
                if (!defaults || obj[key] === void 0) obj[key] = source[key];
            }
        }
        return obj;
    };
}



var // Extend a given object with all the properties in passed-in object(s).
$cd665a7b16f49314$export$2e2bcd8739ae039 = (0, $be67da832d3a72cd$export$2e2bcd8739ae039)((0, $76c102325be5f353$export$2e2bcd8739ae039));




var // Assigns a given object with all the own properties in the passed-in
// object(s).
// (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
$f40532393fd97aec$export$2e2bcd8739ae039 = (0, $be67da832d3a72cd$export$2e2bcd8739ae039)((0, $6fe7302bdcad38ac$export$2e2bcd8739ae039));




var // Fill in a given object with default properties.
$9225d9bed8720bc5$export$2e2bcd8739ae039 = (0, $be67da832d3a72cd$export$2e2bcd8739ae039)((0, $76c102325be5f353$export$2e2bcd8739ae039), true);




// Create a naked function reference for surrogate-prototype-swapping.
function $b700d0be25024b3f$var$ctor() {
    return function() {};
}
function $b700d0be25024b3f$export$2e2bcd8739ae039(prototype) {
    if (!(0, $6e3e7d3004a0bd6f$export$2e2bcd8739ae039)(prototype)) return {};
    if (0, $2d63c72f11d36dd8$export$5b53dc95b548c58c) return (0, $2d63c72f11d36dd8$export$5b53dc95b548c58c)(prototype);
    var Ctor = $b700d0be25024b3f$var$ctor();
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
}



function $bd444a42534a739d$export$2e2bcd8739ae039(prototype, props) {
    var result = (0, $b700d0be25024b3f$export$2e2bcd8739ae039)(prototype);
    if (props) (0, $f40532393fd97aec$export$2e2bcd8739ae039)(result, props);
    return result;
}





function $ac5f44fcda61a289$export$2e2bcd8739ae039(obj) {
    if (!(0, $6e3e7d3004a0bd6f$export$2e2bcd8739ae039)(obj)) return obj;
    return (0, $f9e6c041730fdb31$export$2e2bcd8739ae039)(obj) ? obj.slice() : (0, $cd665a7b16f49314$export$2e2bcd8739ae039)({}, obj);
}


// Invokes `interceptor` with the `obj` and then returns `obj`.
// The primary purpose of this method is to "tap into" a method chain, in
// order to perform operations on intermediate results within the chain.
function $4386162a0709f5b5$export$2e2bcd8739ae039(obj, interceptor) {
    interceptor(obj);
    return obj;
}





function $100e549c0eece915$export$2e2bcd8739ae039(path) {
    return (0, $f9e6c041730fdb31$export$2e2bcd8739ae039)(path) ? path : [
        path
    ];
}
(0, $51828dc883981eb1$export$2e2bcd8739ae039).toPath = $100e549c0eece915$export$2e2bcd8739ae039;


function $910c0dff4ed1facf$export$2e2bcd8739ae039(path) {
    return (0, $51828dc883981eb1$export$2e2bcd8739ae039).toPath(path);
}


// Internal function to obtain a nested property in `obj` along `path`.
function $6df0b60a061e6090$export$2e2bcd8739ae039(obj, path) {
    var length = path.length;
    for(var i = 0; i < length; i++){
        if (obj == null) return void 0;
        obj = obj[path[i]];
    }
    return length ? obj : void 0;
}



function $80790876ee4b09c1$export$2e2bcd8739ae039(object, path, defaultValue) {
    var value = (0, $6df0b60a061e6090$export$2e2bcd8739ae039)(object, (0, $910c0dff4ed1facf$export$2e2bcd8739ae039)(path));
    return (0, $0d2e0eff9b6e26c2$export$2e2bcd8739ae039)(value) ? defaultValue : value;
}




function $4fb312c1270006dd$export$2e2bcd8739ae039(obj, path) {
    path = (0, $910c0dff4ed1facf$export$2e2bcd8739ae039)(path);
    var length = path.length;
    for(var i = 0; i < length; i++){
        var key = path[i];
        if (!(0, $39edb832e07faa22$export$2e2bcd8739ae039)(obj, key)) return false;
        obj = obj[key];
    }
    return !!length;
}



// Keep the identity function around for default iteratees.
function $34b5571162c34d5a$export$2e2bcd8739ae039(value) {
    return value;
}







function $d488ba5b1a5b1ffd$export$2e2bcd8739ae039(attrs) {
    attrs = (0, $f40532393fd97aec$export$2e2bcd8739ae039)({}, attrs);
    return function(obj) {
        return (0, $375387b8b59ffb29$export$2e2bcd8739ae039)(obj, attrs);
    };
}




function $bcea3364d1615dfa$export$2e2bcd8739ae039(path) {
    path = (0, $910c0dff4ed1facf$export$2e2bcd8739ae039)(path);
    return function(obj) {
        return (0, $6df0b60a061e6090$export$2e2bcd8739ae039)(obj, path);
    };
}


// Internal function that returns an efficient (for current engines) version
// of the passed-in callback, to be repeatedly applied in other Underscore
// functions.
function $f32aac1c6eda188b$export$2e2bcd8739ae039(func, context, argCount) {
    if (context === void 0) return func;
    switch(argCount == null ? 3 : argCount){
        case 1:
            return function(value) {
                return func.call(context, value);
            };
        // The 2-argument case is omitted because we’re not using it.
        case 3:
            return function(value, index, collection) {
                return func.call(context, value, index, collection);
            };
        case 4:
            return function(accumulator, value, index, collection) {
                return func.call(context, accumulator, value, index, collection);
            };
    }
    return function() {
        return func.apply(context, arguments);
    };
}


function $7193386dd6feb6cd$export$2e2bcd8739ae039(value, context, argCount) {
    if (value == null) return 0, $34b5571162c34d5a$export$2e2bcd8739ae039;
    if ((0, $ecd89179b736cddb$export$2e2bcd8739ae039)(value)) return (0, $f32aac1c6eda188b$export$2e2bcd8739ae039)(value, context, argCount);
    if ((0, $6e3e7d3004a0bd6f$export$2e2bcd8739ae039)(value) && !(0, $f9e6c041730fdb31$export$2e2bcd8739ae039)(value)) return (0, $d488ba5b1a5b1ffd$export$2e2bcd8739ae039)(value);
    return (0, $bcea3364d1615dfa$export$2e2bcd8739ae039)(value);
}




function $37d34a73637a8f26$export$2e2bcd8739ae039(value, context) {
    return (0, $7193386dd6feb6cd$export$2e2bcd8739ae039)(value, context, Infinity);
}
(0, $51828dc883981eb1$export$2e2bcd8739ae039).iteratee = $37d34a73637a8f26$export$2e2bcd8739ae039;


function $b79b3fe14fe37daf$export$2e2bcd8739ae039(value, context, argCount) {
    if ((0, $51828dc883981eb1$export$2e2bcd8739ae039).iteratee !== (0, $37d34a73637a8f26$export$2e2bcd8739ae039)) return (0, $51828dc883981eb1$export$2e2bcd8739ae039).iteratee(value, context);
    return (0, $7193386dd6feb6cd$export$2e2bcd8739ae039)(value, context, argCount);
}



function $361a0ec142a97115$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $b79b3fe14fe37daf$export$2e2bcd8739ae039)(iteratee, context);
    var _keys = (0, $6fe7302bdcad38ac$export$2e2bcd8739ae039)(obj), length = _keys.length, results = {};
    for(var index = 0; index < length; index++){
        var currentKey = _keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}




// Predicate-generating function. Often useful outside of Underscore.
function $ea593b64ef4e2a8e$export$2e2bcd8739ae039() {}






function $4a4ca2b2793dbf28$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0, $ea593b64ef4e2a8e$export$2e2bcd8739ae039;
    return function(path) {
        return (0, $80790876ee4b09c1$export$2e2bcd8739ae039)(obj, path);
    };
}




function $93fb7833cb34acaa$export$2e2bcd8739ae039(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = (0, $f32aac1c6eda188b$export$2e2bcd8739ae039)(iteratee, context, 1);
    for(var i = 0; i < n; i++)accum[i] = iteratee(i);
    return accum;
}


// Return a random integer between `min` and `max` (inclusive).
function $f9cdebf5ce2af7ea$export$2e2bcd8739ae039(min, max) {
    if (max == null) {
        max = min;
        min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
}


// A (possibly faster) way to get the current timestamp as an integer.
var $ff631391d2cf96ac$export$2e2bcd8739ae039 = Date.now || function() {
    return new Date().getTime();
};



function $af20ba17f1dfce7b$export$2e2bcd8739ae039(map) {
    var escaper = function(match) {
        return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + (0, $6fe7302bdcad38ac$export$2e2bcd8739ae039)(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
        string = string == null ? '' : '' + string;
        return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
}


// Internal list of HTML entities for escaping.
var $83fd5a079fe500fb$export$2e2bcd8739ae039 = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
};


var // Function for escaping strings to HTML interpolation.
$29bd69dc36818855$export$2e2bcd8739ae039 = (0, $af20ba17f1dfce7b$export$2e2bcd8739ae039)((0, $83fd5a079fe500fb$export$2e2bcd8739ae039));





var // Internal list of HTML entities for unescaping.
$d17a70e2463640c6$export$2e2bcd8739ae039 = (0, $ba8d0fba6632eaff$export$2e2bcd8739ae039)((0, $83fd5a079fe500fb$export$2e2bcd8739ae039));


var // Function for unescaping strings from HTML interpolation.
$987ff7a55bdcc95b$export$2e2bcd8739ae039 = (0, $af20ba17f1dfce7b$export$2e2bcd8739ae039)((0, $d17a70e2463640c6$export$2e2bcd8739ae039));



var // By default, Underscore uses ERB-style template delimiters. Change the
// following template settings to use alternative delimiters.
$799262f659d00f51$export$2e2bcd8739ae039 = (0, $51828dc883981eb1$export$2e2bcd8739ae039).templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
};





// When customizing `_.templateSettings`, if you don't want to define an
// interpolation, evaluation or escaping regex, we need one that is
// guaranteed not to match.
var $78309a1f9f459973$var$noMatch = /(.)^/;
// Certain characters need to be escaped so that they can be put into a
// string literal.
var $78309a1f9f459973$var$escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
};
var $78309a1f9f459973$var$escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
function $78309a1f9f459973$var$escapeChar(match) {
    return '\\' + $78309a1f9f459973$var$escapes[match];
}
// In order to prevent third-party code injection through
// `_.templateSettings.variable`, we test it against the following regular
// expression. It is intentionally a bit more liberal than just matching valid
// identifiers, but still prevents possible loopholes through defaults or
// destructuring assignment.
var $78309a1f9f459973$var$bareIdentifier = /^\s*(\w|\$)+\s*$/;
function $78309a1f9f459973$export$2e2bcd8739ae039(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = (0, $9225d9bed8720bc5$export$2e2bcd8739ae039)({}, settings, (0, $51828dc883981eb1$export$2e2bcd8739ae039).templateSettings);
    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
        (settings.escape || $78309a1f9f459973$var$noMatch).source,
        (settings.interpolate || $78309a1f9f459973$var$noMatch).source,
        (settings.evaluate || $78309a1f9f459973$var$noMatch).source
    ].join('|') + '|$', 'g');
    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
        source += text.slice(index, offset).replace($78309a1f9f459973$var$escapeRegExp, $78309a1f9f459973$var$escapeChar);
        index = offset + match.length;
        if (escape) source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
        else if (interpolate) source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
        else if (evaluate) source += "';\n" + evaluate + "\n__p+='";
        // Adobe VMs need the match returned to produce the correct offset.
        return match;
    });
    source += "';\n";
    var argument = settings.variable;
    if (argument) {
        // Insure against third-party code injection. (CVE-2021-23358)
        if (!$78309a1f9f459973$var$bareIdentifier.test(argument)) throw new Error('variable is not a bare identifier: ' + argument);
    } else {
        // If a variable is not specified, place data values in local scope.
        source = 'with(obj||{}){\n' + source + '}\n';
        argument = 'obj';
    }
    source = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + source + 'return __p;\n';
    var render;
    try {
        render = new Function(argument, '_', source);
    } catch (e) {
        e.source = source;
        throw e;
    }
    var template = function(data) {
        return render.call(this, data, (0, $51828dc883981eb1$export$2e2bcd8739ae039));
    };
    // Provide the compiled source as a convenience for precompilation.
    template.source = 'function(' + argument + '){\n' + source + '}';
    return template;
}




function $e687d77f3e8f8cc0$export$2e2bcd8739ae039(obj, path, fallback) {
    path = (0, $910c0dff4ed1facf$export$2e2bcd8739ae039)(path);
    var length = path.length;
    if (!length) return (0, $ecd89179b736cddb$export$2e2bcd8739ae039)(fallback) ? fallback.call(obj) : fallback;
    for(var i = 0; i < length; i++){
        var prop = obj == null ? void 0 : obj[path[i]];
        if (prop === void 0) {
            prop = fallback;
            i = length; // Ensure we don't continue iterating.
        }
        obj = (0, $ecd89179b736cddb$export$2e2bcd8739ae039)(prop) ? prop.call(obj) : prop;
    }
    return obj;
}


// Generate a unique integer id (unique within the entire client session).
// Useful for temporary DOM ids.
var $409640a219323d5c$var$idCounter = 0;
function $409640a219323d5c$export$2e2bcd8739ae039(prefix) {
    var id = ++$409640a219323d5c$var$idCounter + '';
    return prefix ? prefix + id : id;
}



function $07d178e7c93d3e66$export$2e2bcd8739ae039(obj) {
    var instance = (0, $51828dc883981eb1$export$2e2bcd8739ae039)(obj);
    instance._chain = true;
    return instance;
}






function $d1106616df14cda0$export$2e2bcd8739ae039(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = (0, $b700d0be25024b3f$export$2e2bcd8739ae039)(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if ((0, $6e3e7d3004a0bd6f$export$2e2bcd8739ae039)(result)) return result;
    return self;
}



// Partially apply a function by creating a version that has had some of its
// arguments pre-filled, without changing its dynamic `this` context. `_` acts
// as a placeholder by default, allowing any combination of arguments to be
// pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
var $1a2e147da63105f5$var$partial = (0, $00091338bb34561a$export$2e2bcd8739ae039)(function(func, boundArgs) {
    var placeholder = $1a2e147da63105f5$var$partial.placeholder;
    var bound = function() {
        var position = 0, length = boundArgs.length;
        var args = Array(length);
        for(var i = 0; i < length; i++)args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
        while(position < arguments.length)args.push(arguments[position++]);
        return (0, $d1106616df14cda0$export$2e2bcd8739ae039)(func, bound, this, this, args);
    };
    return bound;
});
$1a2e147da63105f5$var$partial.placeholder = (0, $51828dc883981eb1$export$2e2bcd8739ae039);
var $1a2e147da63105f5$export$2e2bcd8739ae039 = $1a2e147da63105f5$var$partial;





var // Create a function bound to a given object (assigning `this`, and arguments,
// optionally).
$9b82ce32b9f64f95$export$2e2bcd8739ae039 = (0, $00091338bb34561a$export$2e2bcd8739ae039)(function(func, context, args) {
    if (!(0, $ecd89179b736cddb$export$2e2bcd8739ae039)(func)) throw new TypeError('Bind must be called on a function');
    var bound = (0, $00091338bb34561a$export$2e2bcd8739ae039)(function(callArgs) {
        return (0, $d1106616df14cda0$export$2e2bcd8739ae039)(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
});






var // Internal helper for collection methods to determine whether a collection
// should be iterated as an array or as an object.
// Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
// Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
$35c020f3a261c5a1$export$2e2bcd8739ae039 = (0, $61cc4bd77dea34f8$export$2e2bcd8739ae039)((0, $d9552e9372db9187$export$2e2bcd8739ae039));




function $65a64d9b8854b61f$export$2e2bcd8739ae039(input, depth, strict, output) {
    output = output || [];
    if (!depth && depth !== 0) depth = Infinity;
    else if (depth <= 0) return output.concat(input);
    var idx = output.length;
    for(var i = 0, length = (0, $d9552e9372db9187$export$2e2bcd8739ae039)(input); i < length; i++){
        var value = input[i];
        if ((0, $35c020f3a261c5a1$export$2e2bcd8739ae039)(value) && ((0, $f9e6c041730fdb31$export$2e2bcd8739ae039)(value) || (0, $a68c3966b61ff959$export$2e2bcd8739ae039)(value))) {
            // Flatten current level of array or arguments object.
            if (depth > 1) {
                $65a64d9b8854b61f$export$2e2bcd8739ae039(value, depth - 1, strict, output);
                idx = output.length;
            } else {
                var j = 0, len = value.length;
                while(j < len)output[idx++] = value[j++];
            }
        } else if (!strict) output[idx++] = value;
    }
    return output;
}



var // Bind a number of an object's methods to that object. Remaining arguments
// are the method names to be bound. Useful for ensuring that all callbacks
// defined on an object belong to it.
$cb918855b9157d53$export$2e2bcd8739ae039 = (0, $00091338bb34561a$export$2e2bcd8739ae039)(function(obj, keys) {
    keys = (0, $65a64d9b8854b61f$export$2e2bcd8739ae039)(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while(index--){
        var key = keys[index];
        obj[key] = (0, $9b82ce32b9f64f95$export$2e2bcd8739ae039)(obj[key], obj);
    }
    return obj;
});



function $4498a1ed71e9fe6a$export$2e2bcd8739ae039(func, hasher) {
    var memoize = function(key) {
        var cache = memoize.cache;
        var address = '' + (hasher ? hasher.apply(this, arguments) : key);
        if (!(0, $39edb832e07faa22$export$2e2bcd8739ae039)(cache, address)) cache[address] = func.apply(this, arguments);
        return cache[address];
    };
    memoize.cache = {};
    return memoize;
}



var // Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
$43f004011196acc1$export$2e2bcd8739ae039 = (0, $00091338bb34561a$export$2e2bcd8739ae039)(function(func, wait, args) {
    return setTimeout(function() {
        return func.apply(null, args);
    }, wait);
});





var // Defers a function, scheduling it to run after the current call stack has
// cleared.
$0b0c55fd99270793$export$2e2bcd8739ae039 = (0, $1a2e147da63105f5$export$2e2bcd8739ae039)((0, $43f004011196acc1$export$2e2bcd8739ae039), (0, $51828dc883981eb1$export$2e2bcd8739ae039), 1);



function $c113ee3e9b3b083d$export$2e2bcd8739ae039(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
        previous = options.leading === false ? 0 : (0, $ff631391d2cf96ac$export$2e2bcd8739ae039)();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function() {
        var _now = (0, $ff631391d2cf96ac$export$2e2bcd8739ae039)();
        if (!previous && options.leading === false) previous = _now;
        var remaining = wait - (_now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = _now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
}




function $daf83e4f50d19913$export$2e2bcd8739ae039(func, wait, immediate) {
    var timeout, previous, args, result, context;
    var later = function() {
        var passed = (0, $ff631391d2cf96ac$export$2e2bcd8739ae039)() - previous;
        if (wait > passed) timeout = setTimeout(later, wait - passed);
        else {
            timeout = null;
            if (!immediate) result = func.apply(context, args);
            // This check is needed because `func` can recursively invoke `debounced`.
            if (!timeout) args = context = null;
        }
    };
    var debounced = (0, $00091338bb34561a$export$2e2bcd8739ae039)(function(_args) {
        context = this;
        args = _args;
        previous = (0, $ff631391d2cf96ac$export$2e2bcd8739ae039)();
        if (!timeout) {
            timeout = setTimeout(later, wait);
            if (immediate) result = func.apply(context, args);
        }
        return result;
    });
    debounced.cancel = function() {
        clearTimeout(timeout);
        timeout = args = context = null;
    };
    return debounced;
}



function $0971039d46d98585$export$2e2bcd8739ae039(func, wrapper) {
    return (0, $1a2e147da63105f5$export$2e2bcd8739ae039)(wrapper, func);
}


// Returns a negated version of the passed-in predicate.
function $4d454b4b64719993$export$2e2bcd8739ae039(predicate) {
    return function() {
        return !predicate.apply(this, arguments);
    };
}


// Returns a function that is the composition of a list of functions, each
// consuming the return value of the function that follows.
function $9f03098fdf5e98d2$export$2e2bcd8739ae039() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
        var i = start;
        var result = args[start].apply(this, arguments);
        while(i--)result = args[i].call(this, result);
        return result;
    };
}


// Returns a function that will only be executed on and after the Nth call.
function $0c0c90fff32f81b8$export$2e2bcd8739ae039(times, func) {
    return function() {
        if (--times < 1) return func.apply(this, arguments);
    };
}


// Returns a function that will only be executed up to (but not including) the
// Nth call.
function $3668e405225021ed$export$2e2bcd8739ae039(times, func) {
    var memo;
    return function() {
        if (--times > 0) memo = func.apply(this, arguments);
        if (times <= 1) func = null;
        return memo;
    };
}




var // Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
$82a9d64a1bd25e8f$export$2e2bcd8739ae039 = (0, $1a2e147da63105f5$export$2e2bcd8739ae039)((0, $3668e405225021ed$export$2e2bcd8739ae039), 2);




function $79b73215b289181c$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $b79b3fe14fe37daf$export$2e2bcd8739ae039)(predicate, context);
    var _keys = (0, $6fe7302bdcad38ac$export$2e2bcd8739ae039)(obj), key;
    for(var i = 0, length = _keys.length; i < length; i++){
        key = _keys[i];
        if (predicate(obj[key], key, obj)) return key;
    }
}




function $e04e7205f71f5f02$export$2e2bcd8739ae039(dir) {
    return function(array, predicate, context) {
        predicate = (0, $b79b3fe14fe37daf$export$2e2bcd8739ae039)(predicate, context);
        var length = (0, $d9552e9372db9187$export$2e2bcd8739ae039)(array);
        var index = dir > 0 ? 0 : length - 1;
        for(; index >= 0 && index < length; index += dir){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    };
}


var // Returns the first index on an array-like that passes a truth test.
$8f47a544aeb08a7e$export$2e2bcd8739ae039 = (0, $e04e7205f71f5f02$export$2e2bcd8739ae039)(1);



var // Returns the last index on an array-like that passes a truth test.
$3ae5e429277e4694$export$2e2bcd8739ae039 = (0, $e04e7205f71f5f02$export$2e2bcd8739ae039)(-1);




function $062e5c7017ea1c58$export$2e2bcd8739ae039(array, obj, iteratee, context) {
    iteratee = (0, $b79b3fe14fe37daf$export$2e2bcd8739ae039)(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = (0, $d9552e9372db9187$export$2e2bcd8739ae039)(array);
    while(low < high){
        var mid = Math.floor((low + high) / 2);
        if (iteratee(array[mid]) < value) low = mid + 1;
        else high = mid;
    }
    return low;
}







function $d27d9875f79d1e0d$export$2e2bcd8739ae039(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
        var i = 0, length = (0, $d9552e9372db9187$export$2e2bcd8739ae039)(array);
        if (typeof idx == 'number') {
            if (dir > 0) i = idx >= 0 ? idx : Math.max(idx + length, i);
            else length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        } else if (sortedIndex && idx && length) {
            idx = sortedIndex(array, item);
            return array[idx] === item ? idx : -1;
        }
        if (item !== item) {
            idx = predicateFind((0, $2d63c72f11d36dd8$export$58adb3bec8346d0f).call(array, i, length), (0, $5a968955ec4f3425$export$2e2bcd8739ae039));
            return idx >= 0 ? idx + i : -1;
        }
        for(idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir){
            if (array[idx] === item) return idx;
        }
        return -1;
    };
}


var // Return the position of the first occurrence of an item in an array,
// or -1 if the item is not included in the array.
// If the array is large and already in sort order, pass `true`
// for **isSorted** to use binary search.
$76649ff64c4c112d$export$2e2bcd8739ae039 = (0, $d27d9875f79d1e0d$export$2e2bcd8739ae039)(1, (0, $8f47a544aeb08a7e$export$2e2bcd8739ae039), (0, $062e5c7017ea1c58$export$2e2bcd8739ae039));




var // Return the position of the last occurrence of an item in an array,
// or -1 if the item is not included in the array.
$46b6a951c1416c2e$export$2e2bcd8739ae039 = (0, $d27d9875f79d1e0d$export$2e2bcd8739ae039)(-1, (0, $3ae5e429277e4694$export$2e2bcd8739ae039));





function $a3b993f50683293a$export$2e2bcd8739ae039(obj, predicate, context) {
    var keyFinder = (0, $35c020f3a261c5a1$export$2e2bcd8739ae039)(obj) ? (0, $8f47a544aeb08a7e$export$2e2bcd8739ae039) : (0, $79b73215b289181c$export$2e2bcd8739ae039);
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
}




function $f424b3ff2217dd6e$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $a3b993f50683293a$export$2e2bcd8739ae039)(obj, (0, $d488ba5b1a5b1ffd$export$2e2bcd8739ae039)(attrs));
}





function $b995362b61cbe134$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $f32aac1c6eda188b$export$2e2bcd8739ae039)(iteratee, context);
    var i, length;
    if ((0, $35c020f3a261c5a1$export$2e2bcd8739ae039)(obj)) for(i = 0, length = obj.length; i < length; i++)iteratee(obj[i], i, obj);
    else {
        var _keys = (0, $6fe7302bdcad38ac$export$2e2bcd8739ae039)(obj);
        for(i = 0, length = _keys.length; i < length; i++)iteratee(obj[_keys[i]], _keys[i], obj);
    }
    return obj;
}





function $c746756a67aa053b$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $b79b3fe14fe37daf$export$2e2bcd8739ae039)(iteratee, context);
    var _keys = !(0, $35c020f3a261c5a1$export$2e2bcd8739ae039)(obj) && (0, $6fe7302bdcad38ac$export$2e2bcd8739ae039)(obj), length = (_keys || obj).length, results = Array(length);
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}





function $06dd3c43740688f9$export$2e2bcd8739ae039(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
        var _keys = !(0, $35c020f3a261c5a1$export$2e2bcd8739ae039)(obj) && (0, $6fe7302bdcad38ac$export$2e2bcd8739ae039)(obj), length = (_keys || obj).length, index = dir > 0 ? 0 : length - 1;
        if (!initial) {
            memo = obj[_keys ? _keys[index] : index];
            index += dir;
        }
        for(; index >= 0 && index < length; index += dir){
            var currentKey = _keys ? _keys[index] : index;
            memo = iteratee(memo, obj[currentKey], currentKey, obj);
        }
        return memo;
    };
    return function(obj, iteratee, memo, context) {
        var initial = arguments.length >= 3;
        return reducer(obj, (0, $f32aac1c6eda188b$export$2e2bcd8739ae039)(iteratee, context, 4), memo, initial);
    };
}


var // **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
$fbfad6943e87d98c$export$2e2bcd8739ae039 = (0, $06dd3c43740688f9$export$2e2bcd8739ae039)(1);



var // The right-associative version of reduce, also known as `foldr`.
$6821e7cd1cda490c$export$2e2bcd8739ae039 = (0, $06dd3c43740688f9$export$2e2bcd8739ae039)(-1);




function $3cab01f560c3a138$export$2e2bcd8739ae039(obj, predicate, context) {
    var results = [];
    predicate = (0, $b79b3fe14fe37daf$export$2e2bcd8739ae039)(predicate, context);
    (0, $b995362b61cbe134$export$2e2bcd8739ae039)(obj, function(value, index, list) {
        if (predicate(value, index, list)) results.push(value);
    });
    return results;
}





function $88d462cd31dad735$export$2e2bcd8739ae039(obj, predicate, context) {
    return (0, $3cab01f560c3a138$export$2e2bcd8739ae039)(obj, (0, $4d454b4b64719993$export$2e2bcd8739ae039)((0, $b79b3fe14fe37daf$export$2e2bcd8739ae039)(predicate)), context);
}





function $1ed12610b787b54c$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $b79b3fe14fe37daf$export$2e2bcd8739ae039)(predicate, context);
    var _keys = !(0, $35c020f3a261c5a1$export$2e2bcd8739ae039)(obj) && (0, $6fe7302bdcad38ac$export$2e2bcd8739ae039)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
}





function $1f6dd4637b6de52e$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $b79b3fe14fe37daf$export$2e2bcd8739ae039)(predicate, context);
    var _keys = !(0, $35c020f3a261c5a1$export$2e2bcd8739ae039)(obj) && (0, $6fe7302bdcad38ac$export$2e2bcd8739ae039)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
}





function $47db385fda09988c$export$2e2bcd8739ae039(obj, item, fromIndex, guard) {
    if (!(0, $35c020f3a261c5a1$export$2e2bcd8739ae039)(obj)) obj = (0, $ebb4fbd725ae82a0$export$2e2bcd8739ae039)(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return (0, $76649ff64c4c112d$export$2e2bcd8739ae039)(obj, item, fromIndex) >= 0;
}







var // Invoke a method (with arguments) on every item in a collection.
$1b37fa5b86fe2986$export$2e2bcd8739ae039 = (0, $00091338bb34561a$export$2e2bcd8739ae039)(function(obj, path, args) {
    var contextPath, func;
    if ((0, $ecd89179b736cddb$export$2e2bcd8739ae039)(path)) func = path;
    else {
        path = (0, $910c0dff4ed1facf$export$2e2bcd8739ae039)(path);
        contextPath = path.slice(0, -1);
        path = path[path.length - 1];
    }
    return (0, $c746756a67aa053b$export$2e2bcd8739ae039)(obj, function(context) {
        var method = func;
        if (!method) {
            if (contextPath && contextPath.length) context = (0, $6df0b60a061e6090$export$2e2bcd8739ae039)(context, contextPath);
            if (context == null) return void 0;
            method = context[path];
        }
        return method == null ? method : method.apply(context, args);
    });
});




function $64b7e156b18644d0$export$2e2bcd8739ae039(obj, key) {
    return (0, $c746756a67aa053b$export$2e2bcd8739ae039)(obj, (0, $bcea3364d1615dfa$export$2e2bcd8739ae039)(key));
}




function $4a123abd524cfc92$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $3cab01f560c3a138$export$2e2bcd8739ae039)(obj, (0, $d488ba5b1a5b1ffd$export$2e2bcd8739ae039)(attrs));
}






function $f1fcbb9a3e80ebe3$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity, value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
        obj = (0, $35c020f3a261c5a1$export$2e2bcd8739ae039)(obj) ? obj : (0, $ebb4fbd725ae82a0$export$2e2bcd8739ae039)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value > result) result = value;
        }
    } else {
        iteratee = (0, $b79b3fe14fe37daf$export$2e2bcd8739ae039)(iteratee, context);
        (0, $b995362b61cbe134$export$2e2bcd8739ae039)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}






function $f4b1abaac39e8250$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity, value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
        obj = (0, $35c020f3a261c5a1$export$2e2bcd8739ae039)(obj) ? obj : (0, $ebb4fbd725ae82a0$export$2e2bcd8739ae039)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value < result) result = value;
        }
    } else {
        iteratee = (0, $b79b3fe14fe37daf$export$2e2bcd8739ae039)(iteratee, context);
        (0, $b995362b61cbe134$export$2e2bcd8739ae039)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed < lastComputed || computed === Infinity && result === Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}







function $006c92d573cf9580$export$2e2bcd8739ae039(obj, n, guard) {
    if (n == null || guard) {
        if (!(0, $35c020f3a261c5a1$export$2e2bcd8739ae039)(obj)) obj = (0, $ebb4fbd725ae82a0$export$2e2bcd8739ae039)(obj);
        return obj[(0, $f9cdebf5ce2af7ea$export$2e2bcd8739ae039)(obj.length - 1)];
    }
    var sample = (0, $35c020f3a261c5a1$export$2e2bcd8739ae039)(obj) ? (0, $ac5f44fcda61a289$export$2e2bcd8739ae039)(obj) : (0, $ebb4fbd725ae82a0$export$2e2bcd8739ae039)(obj);
    var length = (0, $d9552e9372db9187$export$2e2bcd8739ae039)(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for(var index = 0; index < n; index++){
        var rand = (0, $f9cdebf5ce2af7ea$export$2e2bcd8739ae039)(index, last);
        var temp = sample[index];
        sample[index] = sample[rand];
        sample[rand] = temp;
    }
    return sample.slice(0, n);
}


function $126b00d4f3d6622f$export$2e2bcd8739ae039(obj) {
    return (0, $006c92d573cf9580$export$2e2bcd8739ae039)(obj, Infinity);
}






function $764739bcb0503f2e$export$2e2bcd8739ae039(obj, iteratee, context) {
    var index = 0;
    iteratee = (0, $b79b3fe14fe37daf$export$2e2bcd8739ae039)(iteratee, context);
    return (0, $64b7e156b18644d0$export$2e2bcd8739ae039)((0, $c746756a67aa053b$export$2e2bcd8739ae039)(obj, function(value, key, list) {
        return {
            value: value,
            index: index++,
            criteria: iteratee(value, key, list)
        };
    }).sort(function(left, right) {
        var a = left.criteria;
        var b = right.criteria;
        if (a !== b) {
            if (a > b || a === void 0) return 1;
            if (a < b || b === void 0) return -1;
        }
        return left.index - right.index;
    }), 'value');
}




function $884dddfcebade919$export$2e2bcd8739ae039(behavior, partition) {
    return function(obj, iteratee, context) {
        var result = partition ? [
            [],
            []
        ] : {};
        iteratee = (0, $b79b3fe14fe37daf$export$2e2bcd8739ae039)(iteratee, context);
        (0, $b995362b61cbe134$export$2e2bcd8739ae039)(obj, function(value, index) {
            var key = iteratee(value, index, obj);
            behavior(result, value, key);
        });
        return result;
    };
}



var // Groups the object's values by a criterion. Pass either a string attribute
// to group by, or a function that returns the criterion.
$fb9e1d043a6fe792$export$2e2bcd8739ae039 = (0, $884dddfcebade919$export$2e2bcd8739ae039)(function(result, value, key) {
    if ((0, $39edb832e07faa22$export$2e2bcd8739ae039)(result, key)) result[key].push(value);
    else result[key] = [
        value
    ];
});



var // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
// when you know that your index values will be unique.
$ac54a1aed9ba8a72$export$2e2bcd8739ae039 = (0, $884dddfcebade919$export$2e2bcd8739ae039)(function(result, value, key) {
    result[key] = value;
});




var // Counts instances of an object that group by a certain criterion. Pass
// either a string attribute to count by, or a function that returns the
// criterion.
$85ce7e736ff1427c$export$2e2bcd8739ae039 = (0, $884dddfcebade919$export$2e2bcd8739ae039)(function(result, value, key) {
    if ((0, $39edb832e07faa22$export$2e2bcd8739ae039)(result, key)) result[key]++;
    else result[key] = 1;
});



var // Split a collection into two arrays: one whose elements all pass the given
// truth test, and one whose elements all do not pass the truth test.
$1c3202b1cbae054a$export$2e2bcd8739ae039 = (0, $884dddfcebade919$export$2e2bcd8739ae039)(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
}, true);









// Safely create a real, live array from anything iterable.
var $af549ed737dbc31a$var$reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function $af549ed737dbc31a$export$2e2bcd8739ae039(obj) {
    if (!obj) return [];
    if ((0, $f9e6c041730fdb31$export$2e2bcd8739ae039)(obj)) return (0, $2d63c72f11d36dd8$export$58adb3bec8346d0f).call(obj);
    if ((0, $c60f1c14f06acd60$export$2e2bcd8739ae039)(obj)) // Keep surrogate pair characters together.
    return obj.match($af549ed737dbc31a$var$reStrSymbol);
    if ((0, $35c020f3a261c5a1$export$2e2bcd8739ae039)(obj)) return (0, $c746756a67aa053b$export$2e2bcd8739ae039)(obj, (0, $34b5571162c34d5a$export$2e2bcd8739ae039));
    return (0, $ebb4fbd725ae82a0$export$2e2bcd8739ae039)(obj);
}




function $c1f52b9a7c4ef91e$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0;
    return (0, $35c020f3a261c5a1$export$2e2bcd8739ae039)(obj) ? obj.length : (0, $6fe7302bdcad38ac$export$2e2bcd8739ae039)(obj).length;
}






// Internal `_.pick` helper function to determine whether `key` is an enumerable
// property name of `obj`.
function $d175c33d901c7d33$export$2e2bcd8739ae039(value, key, obj) {
    return key in obj;
}



var // Return a copy of the object only containing the allowed properties.
$3676c3d07a7362ef$export$2e2bcd8739ae039 = (0, $00091338bb34561a$export$2e2bcd8739ae039)(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if ((0, $ecd89179b736cddb$export$2e2bcd8739ae039)(iteratee)) {
        if (keys.length > 1) iteratee = (0, $f32aac1c6eda188b$export$2e2bcd8739ae039)(iteratee, keys[1]);
        keys = (0, $76c102325be5f353$export$2e2bcd8739ae039)(obj);
    } else {
        iteratee = (0, $d175c33d901c7d33$export$2e2bcd8739ae039);
        keys = (0, $65a64d9b8854b61f$export$2e2bcd8739ae039)(keys, false, false);
        obj = Object(obj);
    }
    for(var i = 0, length = keys.length; i < length; i++){
        var key = keys[i];
        var value = obj[key];
        if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
});









var // Return a copy of the object without the disallowed properties.
$9ba5eff4e454bc2e$export$2e2bcd8739ae039 = (0, $00091338bb34561a$export$2e2bcd8739ae039)(function(obj, keys) {
    var iteratee = keys[0], context;
    if ((0, $ecd89179b736cddb$export$2e2bcd8739ae039)(iteratee)) {
        iteratee = (0, $4d454b4b64719993$export$2e2bcd8739ae039)(iteratee);
        if (keys.length > 1) context = keys[1];
    } else {
        keys = (0, $c746756a67aa053b$export$2e2bcd8739ae039)((0, $65a64d9b8854b61f$export$2e2bcd8739ae039)(keys, false, false), String);
        iteratee = function(value, key) {
            return !(0, $47db385fda09988c$export$2e2bcd8739ae039)(keys, key);
        };
    }
    return (0, $3676c3d07a7362ef$export$2e2bcd8739ae039)(obj, iteratee, context);
});



function $d0de77978a68d9ea$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $2d63c72f11d36dd8$export$58adb3bec8346d0f).call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
}


function $4584a922b20bbe9b$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[0];
    return (0, $d0de77978a68d9ea$export$2e2bcd8739ae039)(array, array.length - n);
}




function $4b067ce637fc54a6$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $2d63c72f11d36dd8$export$58adb3bec8346d0f).call(array, n == null || guard ? 1 : n);
}


function $5ea6e92bed107ca3$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return (0, $4b067ce637fc54a6$export$2e2bcd8739ae039)(array, Math.max(0, array.length - n));
}




function $5fa8fc2d5a95b6b3$export$2e2bcd8739ae039(array) {
    return (0, $3cab01f560c3a138$export$2e2bcd8739ae039)(array, Boolean);
}



function $23786b176608059b$export$2e2bcd8739ae039(array, depth) {
    return (0, $65a64d9b8854b61f$export$2e2bcd8739ae039)(array, depth, false);
}







var // Take the difference between one array and a number of other arrays.
// Only the elements present in just the first array will remain.
$ef37b923cabd07c5$export$2e2bcd8739ae039 = (0, $00091338bb34561a$export$2e2bcd8739ae039)(function(array, rest) {
    rest = (0, $65a64d9b8854b61f$export$2e2bcd8739ae039)(rest, true, true);
    return (0, $3cab01f560c3a138$export$2e2bcd8739ae039)(array, function(value) {
        return !(0, $47db385fda09988c$export$2e2bcd8739ae039)(rest, value);
    });
});


var // Return a version of the array that does not contain the specified value(s).
$d1923ce94a67b9a2$export$2e2bcd8739ae039 = (0, $00091338bb34561a$export$2e2bcd8739ae039)(function(array, otherArrays) {
    return (0, $ef37b923cabd07c5$export$2e2bcd8739ae039)(array, otherArrays);
});






function $f0bec29b96d47a33$export$2e2bcd8739ae039(array, isSorted, iteratee, context) {
    if (!(0, $5394bc2f01152bbc$export$2e2bcd8739ae039)(isSorted)) {
        context = iteratee;
        iteratee = isSorted;
        isSorted = false;
    }
    if (iteratee != null) iteratee = (0, $b79b3fe14fe37daf$export$2e2bcd8739ae039)(iteratee, context);
    var result = [];
    var seen = [];
    for(var i = 0, length = (0, $d9552e9372db9187$export$2e2bcd8739ae039)(array); i < length; i++){
        var value = array[i], computed = iteratee ? iteratee(value, i, array) : value;
        if (isSorted && !iteratee) {
            if (!i || seen !== computed) result.push(value);
            seen = computed;
        } else if (iteratee) {
            if (!(0, $47db385fda09988c$export$2e2bcd8739ae039)(seen, computed)) {
                seen.push(computed);
                result.push(value);
            }
        } else if (!(0, $47db385fda09988c$export$2e2bcd8739ae039)(result, value)) result.push(value);
    }
    return result;
}





var // Produce an array that contains the union: each distinct element from all of
// the passed-in arrays.
$4cbad72dc0b3402b$export$2e2bcd8739ae039 = (0, $00091338bb34561a$export$2e2bcd8739ae039)(function(arrays) {
    return (0, $f0bec29b96d47a33$export$2e2bcd8739ae039)((0, $65a64d9b8854b61f$export$2e2bcd8739ae039)(arrays, true, true));
});




function $640ee3b4c6854636$export$2e2bcd8739ae039(array) {
    var result = [];
    var argsLength = arguments.length;
    for(var i = 0, length = (0, $d9552e9372db9187$export$2e2bcd8739ae039)(array); i < length; i++){
        var item = array[i];
        if ((0, $47db385fda09988c$export$2e2bcd8739ae039)(result, item)) continue;
        var j;
        for(j = 1; j < argsLength; j++){
            if (!(0, $47db385fda09988c$export$2e2bcd8739ae039)(arguments[j], item)) break;
        }
        if (j === argsLength) result.push(item);
    }
    return result;
}






function $e787e451ed8ddde4$export$2e2bcd8739ae039(array) {
    var length = array && (0, $f1fcbb9a3e80ebe3$export$2e2bcd8739ae039)(array, (0, $d9552e9372db9187$export$2e2bcd8739ae039)).length || 0;
    var result = Array(length);
    for(var index = 0; index < length; index++)result[index] = (0, $64b7e156b18644d0$export$2e2bcd8739ae039)(array, index);
    return result;
}




var // Zip together multiple lists into a single array -- elements that share
// an index go together.
$fe0814bdf6654e7d$export$2e2bcd8739ae039 = (0, $00091338bb34561a$export$2e2bcd8739ae039)((0, $e787e451ed8ddde4$export$2e2bcd8739ae039));



function $9a9112ffd6f5d502$export$2e2bcd8739ae039(list, values) {
    var result = {};
    for(var i = 0, length = (0, $d9552e9372db9187$export$2e2bcd8739ae039)(list); i < length; i++)if (values) result[list[i]] = values[i];
    else result[list[i][0]] = list[i][1];
    return result;
}


// Generate an integer Array containing an arithmetic progression. A port of
// the native Python `range()` function. See
// [the Python documentation](https://docs.python.org/library/functions.html#range).
function $6fbcf963c33899f9$export$2e2bcd8739ae039(start, stop, step) {
    if (stop == null) {
        stop = start || 0;
        start = 0;
    }
    if (!step) step = stop < start ? -1 : 1;
    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);
    for(var idx = 0; idx < length; idx++, start += step)range[idx] = start;
    return range;
}



function $6cd4738b38ff6a08$export$2e2bcd8739ae039(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while(i < length)result.push((0, $2d63c72f11d36dd8$export$58adb3bec8346d0f).call(array, i, i += count));
    return result;
}







function $be79f7cccb5c97d6$export$2e2bcd8739ae039(instance, obj) {
    return instance._chain ? (0, $51828dc883981eb1$export$2e2bcd8739ae039)(obj).chain() : obj;
}


function $add98ab171b98313$export$2e2bcd8739ae039(obj) {
    (0, $b995362b61cbe134$export$2e2bcd8739ae039)((0, $7e9662b114b4a099$export$2e2bcd8739ae039)(obj), function(name) {
        var func = (0, $51828dc883981eb1$export$2e2bcd8739ae039)[name] = obj[name];
        (0, $51828dc883981eb1$export$2e2bcd8739ae039).prototype[name] = function() {
            var args = [
                this._wrapped
            ];
            (0, $2d63c72f11d36dd8$export$4cbf152802aa238).apply(args, arguments);
            return (0, $be79f7cccb5c97d6$export$2e2bcd8739ae039)(this, func.apply((0, $51828dc883981eb1$export$2e2bcd8739ae039), args));
        };
    });
    return 0, $51828dc883981eb1$export$2e2bcd8739ae039;
}






// Add all mutator `Array` functions to the wrapper.
(0, $b995362b61cbe134$export$2e2bcd8739ae039)([
    'pop',
    'push',
    'reverse',
    'shift',
    'sort',
    'splice',
    'unshift'
], function(name) {
    var method = (0, $2d63c72f11d36dd8$export$aabeece9448a227a)[name];
    (0, $51828dc883981eb1$export$2e2bcd8739ae039).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) {
            method.apply(obj, arguments);
            if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
        }
        return (0, $be79f7cccb5c97d6$export$2e2bcd8739ae039)(this, obj);
    };
});
// Add all accessor `Array` functions to the wrapper.
(0, $b995362b61cbe134$export$2e2bcd8739ae039)([
    'concat',
    'join',
    'slice'
], function(name) {
    var method = (0, $2d63c72f11d36dd8$export$aabeece9448a227a)[name];
    (0, $51828dc883981eb1$export$2e2bcd8739ae039).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) obj = method.apply(obj, arguments);
        return (0, $be79f7cccb5c97d6$export$2e2bcd8739ae039)(this, obj);
    };
});
var $a0b73385c05e176b$export$2e2bcd8739ae039 = (0, $51828dc883981eb1$export$2e2bcd8739ae039);




// Add all of the Underscore functions to the wrapper object.
var $bab366cf4ee55a65$var$_ = (0, $add98ab171b98313$export$2e2bcd8739ae039)($aff2018c308031aa$exports);
// Legacy Node.js API.
$bab366cf4ee55a65$var$_._ = $bab366cf4ee55a65$var$_;
var // Export the Underscore API.
$bab366cf4ee55a65$export$2e2bcd8739ae039 = $bab366cf4ee55a65$var$_;





function $b1193ff8affee9e0$var$BackToTop($module) {
    this.$module = $module;
}
$b1193ff8affee9e0$var$BackToTop.prototype.checkScrollPosition = function(element) {
    var windowHeight = window.innerHeight;
    var showHeight = windowHeight > 480 ? 480 : windowHeight;
    var scrollPos = window.scrollY;
    if (scrollPos > showHeight) element.classList.add('lbh-back-to-top--visible');
    else element.classList.remove('lbh-back-to-top--visible');
};
$b1193ff8affee9e0$var$BackToTop.prototype.init = function() {
    // Check for module
    if (!this.$module) return;
    var throttled = (0, $c113ee3e9b3b083d$export$2e2bcd8739ae039)(this.checkScrollPosition, 200);
    var backToTop = this.$module;
    window.addEventListener('scroll', function() {
        throttled(backToTop);
    });
};
var $b1193ff8affee9e0$export$2e2bcd8739ae039 = $b1193ff8affee9e0$var$BackToTop;


var $10889d16d9717abf$exports = {};
(function(global1, factory) {
    $10889d16d9717abf$exports = factory();
})($10889d16d9717abf$exports, function() {
    'use strict';
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Window/detect.js
        var detect = 'Window' in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Window&flags=always
        if (typeof WorkerGlobalScope === "undefined" && typeof importScripts !== "function") (function(global1) {
            if (global1.constructor) global1.Window = global1.constructor;
            else (global1.Window = global1.constructor = new Function('return function Window() {}')()).prototype = this;
        })(this);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Document/detect.js
        var detect = "Document" in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Document&flags=always
        if (typeof WorkerGlobalScope === "undefined" && typeof importScripts !== "function") {
            if (this.HTMLDocument) // HTMLDocument is an extension of Document.  If the browser has HTMLDocument but not Document, the former will suffice as an alias for the latter.
            this.Document = this.HTMLDocument;
            else {
                // Create an empty function to act as the missing constructor for the document object, attach the document object as its prototype.  The function needs to be anonymous else it is hoisted and causes the feature detect to prematurely pass, preventing the assignments below being made.
                this.Document = this.HTMLDocument = document.constructor = new Function('return function Document() {}')();
                this.Document.prototype = document;
            }
        }
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Element/detect.js
        var detect = 'Element' in this && 'HTMLElement' in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Element&flags=always
        (function() {
            // IE8
            if (window.Element && !window.HTMLElement) {
                window.HTMLElement = window.Element;
                return;
            }
            // create Element constructor
            window.Element = window.HTMLElement = new Function('return function Element() {}')();
            // generate sandboxed iframe
            var vbody = document.appendChild(document.createElement('body'));
            var frame = vbody.appendChild(document.createElement('iframe'));
            // use sandboxed iframe to replicate Element functionality
            var frameDocument = frame.contentWindow.document;
            var prototype = Element.prototype = frameDocument.appendChild(frameDocument.createElement('*'));
            var cache = {};
            // polyfill Element.prototype on an element
            var shiv = function(element, deep) {
                var childNodes = element.childNodes || [], index = -1, key, value, childNode;
                if (element.nodeType === 1 && element.constructor !== Element) {
                    element.constructor = Element;
                    for(key in cache){
                        value = cache[key];
                        element[key] = value;
                    }
                }
                while(childNode = deep && childNodes[++index])shiv(childNode, deep);
                return element;
            };
            var elements = document.getElementsByTagName('*');
            var nativeCreateElement = document.createElement;
            var interval;
            var loopLimit = 100;
            prototype.attachEvent('onpropertychange', function(event) {
                var propertyName = event.propertyName, nonValue = !cache.hasOwnProperty(propertyName), newValue = prototype[propertyName], oldValue = cache[propertyName], index = -1, element;
                while(element = elements[++index]){
                    if (element.nodeType === 1) {
                        if (nonValue || element[propertyName] === oldValue) element[propertyName] = newValue;
                    }
                }
                cache[propertyName] = newValue;
            });
            prototype.constructor = Element;
            if (!prototype.hasAttribute) // <Element>.hasAttribute
            prototype.hasAttribute = function hasAttribute(name) {
                return this.getAttribute(name) !== null;
            };
            // Apply Element prototype to the pre-existing DOM as soon as the body element appears.
            function bodyCheck() {
                if (!loopLimit--) clearTimeout(interval);
                if (document.body && !document.body.prototype && /(complete|interactive)/.test(document.readyState)) {
                    shiv(document, true);
                    if (interval && document.body.prototype) clearTimeout(interval);
                    return !!document.body.prototype;
                }
                return false;
            }
            if (!bodyCheck()) {
                document.onreadystatechange = bodyCheck;
                interval = setInterval(bodyCheck, 25);
            }
            // Apply to any new elements created after load
            document.createElement = function createElement(nodeName) {
                var element = nativeCreateElement(String(nodeName).toLowerCase());
                return shiv(element);
            };
            // remove sandboxed iframe
            document.removeChild(vbody);
        })();
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Object/defineProperty/detect.js
        var detect = // In IE8, defineProperty could only act on DOM elements, so full support
        // for the feature requires the ability to set a property on an arbitrary object
        'defineProperty' in Object && function() {
            try {
                var a = {};
                Object.defineProperty(a, 'test', {
                    value: 42
                });
                return true;
            } catch (e) {
                return false;
            }
        }();
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Object.defineProperty&flags=always
        (function(nativeDefineProperty) {
            var supportsAccessors = Object.prototype.hasOwnProperty('__defineGetter__');
            var ERR_ACCESSORS_NOT_SUPPORTED = 'Getters & setters cannot be defined on this javascript engine';
            var ERR_VALUE_ACCESSORS = 'A property cannot both have accessors and be writable or have a value';
            Object.defineProperty = function defineProperty(object, property, descriptor) {
                // Where native support exists, assume it
                if (nativeDefineProperty && (object === window || object === document || object === Element.prototype || object instanceof Element)) return nativeDefineProperty(object, property, descriptor);
                if (object === null || !(object instanceof Object || typeof object === 'object')) throw new TypeError('Object.defineProperty called on non-object');
                if (!(descriptor instanceof Object)) throw new TypeError('Property description must be an object');
                var propertyString = String(property);
                var hasValueOrWritable = 'value' in descriptor || 'writable' in descriptor;
                var getterType = 'get' in descriptor && typeof descriptor.get;
                var setterType = 'set' in descriptor && typeof descriptor.set;
                // handle descriptor.get
                if (getterType) {
                    if (getterType !== 'function') throw new TypeError('Getter must be a function');
                    if (!supportsAccessors) throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
                    if (hasValueOrWritable) throw new TypeError(ERR_VALUE_ACCESSORS);
                    Object.__defineGetter__.call(object, propertyString, descriptor.get);
                } else object[propertyString] = descriptor.value;
                // handle descriptor.set
                if (setterType) {
                    if (setterType !== 'function') throw new TypeError('Setter must be a function');
                    if (!supportsAccessors) throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
                    if (hasValueOrWritable) throw new TypeError(ERR_VALUE_ACCESSORS);
                    Object.__defineSetter__.call(object, propertyString, descriptor.set);
                }
                // OK to define value unconditionally - if a getter has been specified as well, an error would be thrown above
                if ('value' in descriptor) object[propertyString] = descriptor.value;
                return object;
            };
        })(Object.defineProperty);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Event/detect.js
        var detect = function(global1) {
            if (!('Event' in global1)) return false;
            if (typeof global1.Event === 'function') return true;
            try {
                // In IE 9-11, the Event object exists but cannot be instantiated
                new Event('click');
                return true;
            } catch (e) {
                return false;
            }
        }(this);
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Event&flags=always
        (function() {
            var unlistenableWindowEvents = {
                click: 1,
                dblclick: 1,
                keyup: 1,
                keypress: 1,
                keydown: 1,
                mousedown: 1,
                mouseup: 1,
                mousemove: 1,
                mouseover: 1,
                mouseenter: 1,
                mouseleave: 1,
                mouseout: 1,
                storage: 1,
                storagecommit: 1,
                textinput: 1
            };
            // This polyfill depends on availability of `document` so will not run in a worker
            // However, we asssume there are no browsers with worker support that lack proper
            // support for `Event` within the worker
            if (typeof document === 'undefined' || typeof window === 'undefined') return;
            function indexOf(array, element) {
                var index = -1, length = array.length;
                while(++index < length){
                    if (index in array && array[index] === element) return index;
                }
                return -1;
            }
            var existingProto = window.Event && window.Event.prototype || null;
            window.Event = Window.prototype.Event = function Event1(type, eventInitDict) {
                if (!type) throw new Error('Not enough arguments');
                var event;
                // Shortcut if browser supports createEvent
                if ('createEvent' in document) {
                    event = document.createEvent('Event');
                    var bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
                    var cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;
                    event.initEvent(type, bubbles, cancelable);
                    return event;
                }
                event = document.createEventObject();
                event.type = type;
                event.bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
                event.cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;
                return event;
            };
            if (existingProto) Object.defineProperty(window.Event, 'prototype', {
                configurable: false,
                enumerable: false,
                writable: true,
                value: existingProto
            });
            if (!('createEvent' in document)) {
                window.addEventListener = Window.prototype.addEventListener = Document.prototype.addEventListener = Element.prototype.addEventListener = function addEventListener() {
                    var element = this, type = arguments[0], listener = arguments[1];
                    if (element === window && type in unlistenableWindowEvents) throw new Error('In IE8 the event: ' + type + ' is not available on the window object. Please see https://github.com/Financial-Times/polyfill-service/issues/317 for more information.');
                    if (!element._events) element._events = {};
                    if (!element._events[type]) {
                        element._events[type] = function(event) {
                            var list = element._events[event.type].list, events = list.slice(), index = -1, length = events.length, eventElement;
                            event.preventDefault = function preventDefault() {
                                if (event.cancelable !== false) event.returnValue = false;
                            };
                            event.stopPropagation = function stopPropagation() {
                                event.cancelBubble = true;
                            };
                            event.stopImmediatePropagation = function stopImmediatePropagation() {
                                event.cancelBubble = true;
                                event.cancelImmediate = true;
                            };
                            event.currentTarget = element;
                            event.relatedTarget = event.fromElement || null;
                            event.target = event.target || event.srcElement || element;
                            event.timeStamp = new Date().getTime();
                            if (event.clientX) {
                                event.pageX = event.clientX + document.documentElement.scrollLeft;
                                event.pageY = event.clientY + document.documentElement.scrollTop;
                            }
                            while(++index < length && !event.cancelImmediate)if (index in events) {
                                eventElement = events[index];
                                if (indexOf(list, eventElement) !== -1 && typeof eventElement === 'function') eventElement.call(element, event);
                            }
                        };
                        element._events[type].list = [];
                        if (element.attachEvent) element.attachEvent('on' + type, element._events[type]);
                    }
                    element._events[type].list.push(listener);
                };
                window.removeEventListener = Window.prototype.removeEventListener = Document.prototype.removeEventListener = Element.prototype.removeEventListener = function removeEventListener() {
                    var element = this, type = arguments[0], listener = arguments[1], index;
                    if (element._events && element._events[type] && element._events[type].list) {
                        index = indexOf(element._events[type].list, listener);
                        if (index !== -1) {
                            element._events[type].list.splice(index, 1);
                            if (!element._events[type].list.length) {
                                if (element.detachEvent) element.detachEvent('on' + type, element._events[type]);
                                delete element._events[type];
                            }
                        }
                    }
                };
                window.dispatchEvent = Window.prototype.dispatchEvent = Document.prototype.dispatchEvent = Element.prototype.dispatchEvent = function dispatchEvent(event) {
                    if (!arguments.length) throw new Error('Not enough arguments');
                    if (!event || typeof event.type !== 'string') throw new Error('DOM Events Exception 0');
                    var element = this, type = event.type;
                    try {
                        if (!event.bubbles) {
                            event.cancelBubble = true;
                            var cancelBubbleEvent = function(event) {
                                event.cancelBubble = true;
                                (element || window).detachEvent('on' + type, cancelBubbleEvent);
                            };
                            this.attachEvent('on' + type, cancelBubbleEvent);
                        }
                        this.fireEvent('on' + type, event);
                    } catch (error) {
                        event.target = element;
                        do {
                            event.currentTarget = element;
                            if ('_events' in element && typeof element._events[type] === 'function') element._events[type].call(element, event);
                            if (typeof element['on' + type] === 'function') element['on' + type].call(element, event);
                            element = element.nodeType === 9 ? element.parentWindow : element.parentNode;
                        }while (element && !event.cancelBubble);
                    }
                    return true;
                };
                // Add the DOMContentLoaded Event
                document.attachEvent('onreadystatechange', function() {
                    if (document.readyState === 'complete') document.dispatchEvent(new Event('DOMContentLoaded', {
                        bubbles: true
                    }));
                });
            }
        })();
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Function/prototype/bind/detect.js
        var detect = 'bind' in Function.prototype;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Function.prototype.bind&flags=always
        Object.defineProperty(Function.prototype, 'bind', {
            value: function bind(that) {
                // add necessary es5-shim utilities
                var $Array = Array;
                var $Object = Object;
                var ObjectPrototype = $Object.prototype;
                var ArrayPrototype = $Array.prototype;
                var Empty = function Empty() {};
                var to_string = ObjectPrototype.toString;
                var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
                var isCallable; /* inlined from https://npmjs.com/is-callable */ 
                var fnToStr = Function.prototype.toString, tryFunctionObject = function tryFunctionObject(value) {
                    try {
                        fnToStr.call(value);
                        return true;
                    } catch (e) {
                        return false;
                    }
                }, fnClass = '[object Function]', genClass = '[object GeneratorFunction]';
                isCallable = function isCallable(value) {
                    if (typeof value !== 'function') return false;
                    if (hasToStringTag) return tryFunctionObject(value);
                    var strClass = to_string.call(value);
                    return strClass === fnClass || strClass === genClass;
                };
                var array_slice = ArrayPrototype.slice;
                var array_concat = ArrayPrototype.concat;
                var array_push = ArrayPrototype.push;
                var max = Math.max;
                // /add necessary es5-shim utilities
                // 1. Let Target be the this value.
                var target = this;
                // 2. If IsCallable(Target) is false, throw a TypeError exception.
                if (!isCallable(target)) throw new TypeError('Function.prototype.bind called on incompatible ' + target);
                // 3. Let A be a new (possibly empty) internal list of all of the
                //   argument values provided after thisArg (arg1, arg2 etc), in order.
                // XXX slicedArgs will stand in for "A" if used
                var args = array_slice.call(arguments, 1); // for normal call
                // 4. Let F be a new native ECMAScript object.
                // 11. Set the [[Prototype]] internal property of F to the standard
                //   built-in Function prototype object as specified in 15.3.3.1.
                // 12. Set the [[Call]] internal property of F as described in
                //   15.3.4.5.1.
                // 13. Set the [[Construct]] internal property of F as described in
                //   15.3.4.5.2.
                // 14. Set the [[HasInstance]] internal property of F as described in
                //   15.3.4.5.3.
                var bound;
                var binder = function() {
                    if (this instanceof bound) {
                        // 15.3.4.5.2 [[Construct]]
                        // When the [[Construct]] internal method of a function object,
                        // F that was created using the bind function is called with a
                        // list of arguments ExtraArgs, the following steps are taken:
                        // 1. Let target be the value of F's [[TargetFunction]]
                        //   internal property.
                        // 2. If target has no [[Construct]] internal method, a
                        //   TypeError exception is thrown.
                        // 3. Let boundArgs be the value of F's [[BoundArgs]] internal
                        //   property.
                        // 4. Let args be a new list containing the same values as the
                        //   list boundArgs in the same order followed by the same
                        //   values as the list ExtraArgs in the same order.
                        // 5. Return the result of calling the [[Construct]] internal
                        //   method of target providing args as the arguments.
                        var result = target.apply(this, array_concat.call(args, array_slice.call(arguments)));
                        if ($Object(result) === result) return result;
                        return this;
                    } else // 15.3.4.5.1 [[Call]]
                    // When the [[Call]] internal method of a function object, F,
                    // which was created using the bind function is called with a
                    // this value and a list of arguments ExtraArgs, the following
                    // steps are taken:
                    // 1. Let boundArgs be the value of F's [[BoundArgs]] internal
                    //   property.
                    // 2. Let boundThis be the value of F's [[BoundThis]] internal
                    //   property.
                    // 3. Let target be the value of F's [[TargetFunction]] internal
                    //   property.
                    // 4. Let args be a new list containing the same values as the
                    //   list boundArgs in the same order followed by the same
                    //   values as the list ExtraArgs in the same order.
                    // 5. Return the result of calling the [[Call]] internal method
                    //   of target providing boundThis as the this value and
                    //   providing args as the arguments.
                    // equiv: target.call(this, ...boundArgs, ...args)
                    return target.apply(that, array_concat.call(args, array_slice.call(arguments)));
                };
                // 15. If the [[Class]] internal property of Target is "Function", then
                //     a. Let L be the length property of Target minus the length of A.
                //     b. Set the length own property of F to either 0 or L, whichever is
                //       larger.
                // 16. Else set the length own property of F to 0.
                var boundLength = max(0, target.length - args.length);
                // 17. Set the attributes of the length own property of F to the values
                //   specified in 15.3.5.1.
                var boundArgs = [];
                for(var i = 0; i < boundLength; i++)array_push.call(boundArgs, '$' + i);
                // XXX Build a dynamic function with desired amount of arguments is the only
                // way to set the length property of a function.
                // In environments where Content Security Policies enabled (Chrome extensions,
                // for ex.) all use of eval or Function costructor throws an exception.
                // However in all of these environments Function.prototype.bind exists
                // and so this code will never be executed.
                bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this, arguments); }')(binder);
                if (target.prototype) {
                    Empty.prototype = target.prototype;
                    bound.prototype = new Empty();
                    // Clean up dangling references.
                    Empty.prototype = null;
                }
                // TODO
                // 18. Set the [[Extensible]] internal property of F to true.
                // TODO
                // 19. Let thrower be the [[ThrowTypeError]] function Object (13.2.3).
                // 20. Call the [[DefineOwnProperty]] internal method of F with
                //   arguments "caller", PropertyDescriptor {[[Get]]: thrower, [[Set]]:
                //   thrower, [[Enumerable]]: false, [[Configurable]]: false}, and
                //   false.
                // 21. Call the [[DefineOwnProperty]] internal method of F with
                //   arguments "arguments", PropertyDescriptor {[[Get]]: thrower,
                //   [[Set]]: thrower, [[Enumerable]]: false, [[Configurable]]: false},
                //   and false.
                // TODO
                // NOTE Function objects created using Function.prototype.bind do not
                // have a prototype property or the [[Code]], [[FormalParameters]], and
                // [[Scope]] internal properties.
                // XXX can't delete prototype in pure-js.
                // 22. Return F.
                return bound;
            }
        });
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    var KEY_SPACE = 32;
    var DEBOUNCE_TIMEOUT_IN_SECONDS = 1;
    function Button($module) {
        this.$module = $module;
        this.debounceFormSubmitTimer = null;
    }
    /**
* JavaScript 'shim' to trigger the click event of element(s) when the space key is pressed.
*
* Created since some Assistive Technologies (for example some Screenreaders)
* will tell a user to press space on a 'button', so this functionality needs to be shimmed
* See https://github.com/alphagov/govuk_elements/pull/272#issuecomment-233028270
*
* @param {object} event event
*/ Button.prototype.handleKeyDown = function(event) {
        // get the target element
        var target = event.target;
        // if the element has a role='button' and the pressed key is a space, we'll simulate a click
        if (target.getAttribute('role') === 'button' && event.keyCode === KEY_SPACE) {
            event.preventDefault();
            // trigger the target's click event
            target.click();
        }
    };
    /**
* If the click quickly succeeds a previous click then nothing will happen.
* This stops people accidentally causing multiple form submissions by
* double clicking buttons.
*/ Button.prototype.debounce = function(event) {
        var target = event.target;
        // Check the button that is clicked on has the preventDoubleClick feature enabled
        if (target.getAttribute('data-prevent-double-click') !== 'true') return;
        // If the timer is still running then we want to prevent the click from submitting the form
        if (this.debounceFormSubmitTimer) {
            event.preventDefault();
            return false;
        }
        this.debounceFormSubmitTimer = setTimeout((function() {
            this.debounceFormSubmitTimer = null;
        }).bind(this), DEBOUNCE_TIMEOUT_IN_SECONDS * 1000);
    };
    /**
* Initialise an event listener for keydown at document level
* this will help listening for later inserted elements with a role="button"
*/ Button.prototype.init = function() {
        this.$module.addEventListener('keydown', this.handleKeyDown);
        this.$module.addEventListener('click', this.debounce);
    };
    return Button;
});


var $1216659f24e2aa91$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($10889d16d9717abf$exports)));


var $2d39b061fef9045c$exports = {};
(function(global1, factory) {
    $2d39b061fef9045c$exports = factory();
})($2d39b061fef9045c$exports, function() {
    'use strict';
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Object/defineProperty/detect.js
        var detect = // In IE8, defineProperty could only act on DOM elements, so full support
        // for the feature requires the ability to set a property on an arbitrary object
        'defineProperty' in Object && function() {
            try {
                var a = {};
                Object.defineProperty(a, 'test', {
                    value: 42
                });
                return true;
            } catch (e) {
                return false;
            }
        }();
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Object.defineProperty&flags=always
        (function(nativeDefineProperty) {
            var supportsAccessors = Object.prototype.hasOwnProperty('__defineGetter__');
            var ERR_ACCESSORS_NOT_SUPPORTED = 'Getters & setters cannot be defined on this javascript engine';
            var ERR_VALUE_ACCESSORS = 'A property cannot both have accessors and be writable or have a value';
            Object.defineProperty = function defineProperty(object, property, descriptor) {
                // Where native support exists, assume it
                if (nativeDefineProperty && (object === window || object === document || object === Element.prototype || object instanceof Element)) return nativeDefineProperty(object, property, descriptor);
                if (object === null || !(object instanceof Object || typeof object === 'object')) throw new TypeError('Object.defineProperty called on non-object');
                if (!(descriptor instanceof Object)) throw new TypeError('Property description must be an object');
                var propertyString = String(property);
                var hasValueOrWritable = 'value' in descriptor || 'writable' in descriptor;
                var getterType = 'get' in descriptor && typeof descriptor.get;
                var setterType = 'set' in descriptor && typeof descriptor.set;
                // handle descriptor.get
                if (getterType) {
                    if (getterType !== 'function') throw new TypeError('Getter must be a function');
                    if (!supportsAccessors) throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
                    if (hasValueOrWritable) throw new TypeError(ERR_VALUE_ACCESSORS);
                    Object.__defineGetter__.call(object, propertyString, descriptor.get);
                } else object[propertyString] = descriptor.value;
                // handle descriptor.set
                if (setterType) {
                    if (setterType !== 'function') throw new TypeError('Setter must be a function');
                    if (!supportsAccessors) throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
                    if (hasValueOrWritable) throw new TypeError(ERR_VALUE_ACCESSORS);
                    Object.__defineSetter__.call(object, propertyString, descriptor.set);
                }
                // OK to define value unconditionally - if a getter has been specified as well, an error would be thrown above
                if ('value' in descriptor) object[propertyString] = descriptor.value;
                return object;
            };
        })(Object.defineProperty);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Function/prototype/bind/detect.js
        var detect = 'bind' in Function.prototype;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Function.prototype.bind&flags=always
        Object.defineProperty(Function.prototype, 'bind', {
            value: function bind(that) {
                // add necessary es5-shim utilities
                var $Array = Array;
                var $Object = Object;
                var ObjectPrototype = $Object.prototype;
                var ArrayPrototype = $Array.prototype;
                var Empty = function Empty() {};
                var to_string = ObjectPrototype.toString;
                var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
                var isCallable; /* inlined from https://npmjs.com/is-callable */ 
                var fnToStr = Function.prototype.toString, tryFunctionObject = function tryFunctionObject(value) {
                    try {
                        fnToStr.call(value);
                        return true;
                    } catch (e) {
                        return false;
                    }
                }, fnClass = '[object Function]', genClass = '[object GeneratorFunction]';
                isCallable = function isCallable(value) {
                    if (typeof value !== 'function') return false;
                    if (hasToStringTag) return tryFunctionObject(value);
                    var strClass = to_string.call(value);
                    return strClass === fnClass || strClass === genClass;
                };
                var array_slice = ArrayPrototype.slice;
                var array_concat = ArrayPrototype.concat;
                var array_push = ArrayPrototype.push;
                var max = Math.max;
                // /add necessary es5-shim utilities
                // 1. Let Target be the this value.
                var target = this;
                // 2. If IsCallable(Target) is false, throw a TypeError exception.
                if (!isCallable(target)) throw new TypeError('Function.prototype.bind called on incompatible ' + target);
                // 3. Let A be a new (possibly empty) internal list of all of the
                //   argument values provided after thisArg (arg1, arg2 etc), in order.
                // XXX slicedArgs will stand in for "A" if used
                var args = array_slice.call(arguments, 1); // for normal call
                // 4. Let F be a new native ECMAScript object.
                // 11. Set the [[Prototype]] internal property of F to the standard
                //   built-in Function prototype object as specified in 15.3.3.1.
                // 12. Set the [[Call]] internal property of F as described in
                //   15.3.4.5.1.
                // 13. Set the [[Construct]] internal property of F as described in
                //   15.3.4.5.2.
                // 14. Set the [[HasInstance]] internal property of F as described in
                //   15.3.4.5.3.
                var bound;
                var binder = function() {
                    if (this instanceof bound) {
                        // 15.3.4.5.2 [[Construct]]
                        // When the [[Construct]] internal method of a function object,
                        // F that was created using the bind function is called with a
                        // list of arguments ExtraArgs, the following steps are taken:
                        // 1. Let target be the value of F's [[TargetFunction]]
                        //   internal property.
                        // 2. If target has no [[Construct]] internal method, a
                        //   TypeError exception is thrown.
                        // 3. Let boundArgs be the value of F's [[BoundArgs]] internal
                        //   property.
                        // 4. Let args be a new list containing the same values as the
                        //   list boundArgs in the same order followed by the same
                        //   values as the list ExtraArgs in the same order.
                        // 5. Return the result of calling the [[Construct]] internal
                        //   method of target providing args as the arguments.
                        var result = target.apply(this, array_concat.call(args, array_slice.call(arguments)));
                        if ($Object(result) === result) return result;
                        return this;
                    } else // 15.3.4.5.1 [[Call]]
                    // When the [[Call]] internal method of a function object, F,
                    // which was created using the bind function is called with a
                    // this value and a list of arguments ExtraArgs, the following
                    // steps are taken:
                    // 1. Let boundArgs be the value of F's [[BoundArgs]] internal
                    //   property.
                    // 2. Let boundThis be the value of F's [[BoundThis]] internal
                    //   property.
                    // 3. Let target be the value of F's [[TargetFunction]] internal
                    //   property.
                    // 4. Let args be a new list containing the same values as the
                    //   list boundArgs in the same order followed by the same
                    //   values as the list ExtraArgs in the same order.
                    // 5. Return the result of calling the [[Call]] internal method
                    //   of target providing boundThis as the this value and
                    //   providing args as the arguments.
                    // equiv: target.call(this, ...boundArgs, ...args)
                    return target.apply(that, array_concat.call(args, array_slice.call(arguments)));
                };
                // 15. If the [[Class]] internal property of Target is "Function", then
                //     a. Let L be the length property of Target minus the length of A.
                //     b. Set the length own property of F to either 0 or L, whichever is
                //       larger.
                // 16. Else set the length own property of F to 0.
                var boundLength = max(0, target.length - args.length);
                // 17. Set the attributes of the length own property of F to the values
                //   specified in 15.3.5.1.
                var boundArgs = [];
                for(var i = 0; i < boundLength; i++)array_push.call(boundArgs, '$' + i);
                // XXX Build a dynamic function with desired amount of arguments is the only
                // way to set the length property of a function.
                // In environments where Content Security Policies enabled (Chrome extensions,
                // for ex.) all use of eval or Function costructor throws an exception.
                // However in all of these environments Function.prototype.bind exists
                // and so this code will never be executed.
                bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this, arguments); }')(binder);
                if (target.prototype) {
                    Empty.prototype = target.prototype;
                    bound.prototype = new Empty();
                    // Clean up dangling references.
                    Empty.prototype = null;
                }
                // TODO
                // 18. Set the [[Extensible]] internal property of F to true.
                // TODO
                // 19. Let thrower be the [[ThrowTypeError]] function Object (13.2.3).
                // 20. Call the [[DefineOwnProperty]] internal method of F with
                //   arguments "caller", PropertyDescriptor {[[Get]]: thrower, [[Set]]:
                //   thrower, [[Enumerable]]: false, [[Configurable]]: false}, and
                //   false.
                // 21. Call the [[DefineOwnProperty]] internal method of F with
                //   arguments "arguments", PropertyDescriptor {[[Get]]: thrower,
                //   [[Set]]: thrower, [[Enumerable]]: false, [[Configurable]]: false},
                //   and false.
                // TODO
                // NOTE Function objects created using Function.prototype.bind do not
                // have a prototype property or the [[Code]], [[FormalParameters]], and
                // [[Scope]] internal properties.
                // XXX can't delete prototype in pure-js.
                // 22. Return F.
                return bound;
            }
        });
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Window/detect.js
        var detect = 'Window' in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Window&flags=always
        if (typeof WorkerGlobalScope === "undefined" && typeof importScripts !== "function") (function(global1) {
            if (global1.constructor) global1.Window = global1.constructor;
            else (global1.Window = global1.constructor = new Function('return function Window() {}')()).prototype = this;
        })(this);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Document/detect.js
        var detect = "Document" in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Document&flags=always
        if (typeof WorkerGlobalScope === "undefined" && typeof importScripts !== "function") {
            if (this.HTMLDocument) // HTMLDocument is an extension of Document.  If the browser has HTMLDocument but not Document, the former will suffice as an alias for the latter.
            this.Document = this.HTMLDocument;
            else {
                // Create an empty function to act as the missing constructor for the document object, attach the document object as its prototype.  The function needs to be anonymous else it is hoisted and causes the feature detect to prematurely pass, preventing the assignments below being made.
                this.Document = this.HTMLDocument = document.constructor = new Function('return function Document() {}')();
                this.Document.prototype = document;
            }
        }
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Element/detect.js
        var detect = 'Element' in this && 'HTMLElement' in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Element&flags=always
        (function() {
            // IE8
            if (window.Element && !window.HTMLElement) {
                window.HTMLElement = window.Element;
                return;
            }
            // create Element constructor
            window.Element = window.HTMLElement = new Function('return function Element() {}')();
            // generate sandboxed iframe
            var vbody = document.appendChild(document.createElement('body'));
            var frame = vbody.appendChild(document.createElement('iframe'));
            // use sandboxed iframe to replicate Element functionality
            var frameDocument = frame.contentWindow.document;
            var prototype = Element.prototype = frameDocument.appendChild(frameDocument.createElement('*'));
            var cache = {};
            // polyfill Element.prototype on an element
            var shiv = function(element, deep) {
                var childNodes = element.childNodes || [], index = -1, key, value, childNode;
                if (element.nodeType === 1 && element.constructor !== Element) {
                    element.constructor = Element;
                    for(key in cache){
                        value = cache[key];
                        element[key] = value;
                    }
                }
                while(childNode = deep && childNodes[++index])shiv(childNode, deep);
                return element;
            };
            var elements = document.getElementsByTagName('*');
            var nativeCreateElement = document.createElement;
            var interval;
            var loopLimit = 100;
            prototype.attachEvent('onpropertychange', function(event) {
                var propertyName = event.propertyName, nonValue = !cache.hasOwnProperty(propertyName), newValue = prototype[propertyName], oldValue = cache[propertyName], index = -1, element;
                while(element = elements[++index]){
                    if (element.nodeType === 1) {
                        if (nonValue || element[propertyName] === oldValue) element[propertyName] = newValue;
                    }
                }
                cache[propertyName] = newValue;
            });
            prototype.constructor = Element;
            if (!prototype.hasAttribute) // <Element>.hasAttribute
            prototype.hasAttribute = function hasAttribute(name) {
                return this.getAttribute(name) !== null;
            };
            // Apply Element prototype to the pre-existing DOM as soon as the body element appears.
            function bodyCheck() {
                if (!loopLimit--) clearTimeout(interval);
                if (document.body && !document.body.prototype && /(complete|interactive)/.test(document.readyState)) {
                    shiv(document, true);
                    if (interval && document.body.prototype) clearTimeout(interval);
                    return !!document.body.prototype;
                }
                return false;
            }
            if (!bodyCheck()) {
                document.onreadystatechange = bodyCheck;
                interval = setInterval(bodyCheck, 25);
            }
            // Apply to any new elements created after load
            document.createElement = function createElement(nodeName) {
                var element = nativeCreateElement(String(nodeName).toLowerCase());
                return shiv(element);
            };
            // remove sandboxed iframe
            document.removeChild(vbody);
        })();
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Event/detect.js
        var detect = function(global1) {
            if (!('Event' in global1)) return false;
            if (typeof global1.Event === 'function') return true;
            try {
                // In IE 9-11, the Event object exists but cannot be instantiated
                new Event('click');
                return true;
            } catch (e) {
                return false;
            }
        }(this);
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Event&flags=always
        (function() {
            var unlistenableWindowEvents = {
                click: 1,
                dblclick: 1,
                keyup: 1,
                keypress: 1,
                keydown: 1,
                mousedown: 1,
                mouseup: 1,
                mousemove: 1,
                mouseover: 1,
                mouseenter: 1,
                mouseleave: 1,
                mouseout: 1,
                storage: 1,
                storagecommit: 1,
                textinput: 1
            };
            // This polyfill depends on availability of `document` so will not run in a worker
            // However, we asssume there are no browsers with worker support that lack proper
            // support for `Event` within the worker
            if (typeof document === 'undefined' || typeof window === 'undefined') return;
            function indexOf(array, element) {
                var index = -1, length = array.length;
                while(++index < length){
                    if (index in array && array[index] === element) return index;
                }
                return -1;
            }
            var existingProto = window.Event && window.Event.prototype || null;
            window.Event = Window.prototype.Event = function Event1(type, eventInitDict) {
                if (!type) throw new Error('Not enough arguments');
                var event;
                // Shortcut if browser supports createEvent
                if ('createEvent' in document) {
                    event = document.createEvent('Event');
                    var bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
                    var cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;
                    event.initEvent(type, bubbles, cancelable);
                    return event;
                }
                event = document.createEventObject();
                event.type = type;
                event.bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
                event.cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;
                return event;
            };
            if (existingProto) Object.defineProperty(window.Event, 'prototype', {
                configurable: false,
                enumerable: false,
                writable: true,
                value: existingProto
            });
            if (!('createEvent' in document)) {
                window.addEventListener = Window.prototype.addEventListener = Document.prototype.addEventListener = Element.prototype.addEventListener = function addEventListener() {
                    var element = this, type = arguments[0], listener = arguments[1];
                    if (element === window && type in unlistenableWindowEvents) throw new Error('In IE8 the event: ' + type + ' is not available on the window object. Please see https://github.com/Financial-Times/polyfill-service/issues/317 for more information.');
                    if (!element._events) element._events = {};
                    if (!element._events[type]) {
                        element._events[type] = function(event) {
                            var list = element._events[event.type].list, events = list.slice(), index = -1, length = events.length, eventElement;
                            event.preventDefault = function preventDefault() {
                                if (event.cancelable !== false) event.returnValue = false;
                            };
                            event.stopPropagation = function stopPropagation() {
                                event.cancelBubble = true;
                            };
                            event.stopImmediatePropagation = function stopImmediatePropagation() {
                                event.cancelBubble = true;
                                event.cancelImmediate = true;
                            };
                            event.currentTarget = element;
                            event.relatedTarget = event.fromElement || null;
                            event.target = event.target || event.srcElement || element;
                            event.timeStamp = new Date().getTime();
                            if (event.clientX) {
                                event.pageX = event.clientX + document.documentElement.scrollLeft;
                                event.pageY = event.clientY + document.documentElement.scrollTop;
                            }
                            while(++index < length && !event.cancelImmediate)if (index in events) {
                                eventElement = events[index];
                                if (indexOf(list, eventElement) !== -1 && typeof eventElement === 'function') eventElement.call(element, event);
                            }
                        };
                        element._events[type].list = [];
                        if (element.attachEvent) element.attachEvent('on' + type, element._events[type]);
                    }
                    element._events[type].list.push(listener);
                };
                window.removeEventListener = Window.prototype.removeEventListener = Document.prototype.removeEventListener = Element.prototype.removeEventListener = function removeEventListener() {
                    var element = this, type = arguments[0], listener = arguments[1], index;
                    if (element._events && element._events[type] && element._events[type].list) {
                        index = indexOf(element._events[type].list, listener);
                        if (index !== -1) {
                            element._events[type].list.splice(index, 1);
                            if (!element._events[type].list.length) {
                                if (element.detachEvent) element.detachEvent('on' + type, element._events[type]);
                                delete element._events[type];
                            }
                        }
                    }
                };
                window.dispatchEvent = Window.prototype.dispatchEvent = Document.prototype.dispatchEvent = Element.prototype.dispatchEvent = function dispatchEvent(event) {
                    if (!arguments.length) throw new Error('Not enough arguments');
                    if (!event || typeof event.type !== 'string') throw new Error('DOM Events Exception 0');
                    var element = this, type = event.type;
                    try {
                        if (!event.bubbles) {
                            event.cancelBubble = true;
                            var cancelBubbleEvent = function(event) {
                                event.cancelBubble = true;
                                (element || window).detachEvent('on' + type, cancelBubbleEvent);
                            };
                            this.attachEvent('on' + type, cancelBubbleEvent);
                        }
                        this.fireEvent('on' + type, event);
                    } catch (error) {
                        event.target = element;
                        do {
                            event.currentTarget = element;
                            if ('_events' in element && typeof element._events[type] === 'function') element._events[type].call(element, event);
                            if (typeof element['on' + type] === 'function') element['on' + type].call(element, event);
                            element = element.nodeType === 9 ? element.parentWindow : element.parentNode;
                        }while (element && !event.cancelBubble);
                    }
                    return true;
                };
                // Add the DOMContentLoaded Event
                document.attachEvent('onreadystatechange', function() {
                    if (document.readyState === 'complete') document.dispatchEvent(new Event('DOMContentLoaded', {
                        bubbles: true
                    }));
                });
            }
        })();
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-service/master/packages/polyfill-library/polyfills/DOMTokenList/detect.js
        var detect = 'DOMTokenList' in this && function(x) {
            return 'classList' in x ? !x.classList.toggle('x', false) && !x.className : true;
        }(document.createElement('x'));
        if (detect) return;
        // Polyfill from https://raw.githubusercontent.com/Financial-Times/polyfill-service/master/packages/polyfill-library/polyfills/DOMTokenList/polyfill.js
        (function(global1) {
            var nativeImpl = "DOMTokenList" in global1 && global1.DOMTokenList;
            if (!nativeImpl || !!document.createElementNS && !!document.createElementNS('http://www.w3.org/2000/svg', 'svg') && !(document.createElementNS("http://www.w3.org/2000/svg", "svg").classList instanceof DOMTokenList)) global1.DOMTokenList = function() {
                var dpSupport = true;
                var defineGetter = function(object, name, fn, configurable) {
                    if (Object.defineProperty) Object.defineProperty(object, name, {
                        configurable: false === dpSupport ? true : !!configurable,
                        get: fn
                    });
                    else object.__defineGetter__(name, fn);
                };
                /** Ensure the browser allows Object.defineProperty to be used on native JavaScript objects. */ try {
                    defineGetter({}, "support");
                } catch (e) {
                    dpSupport = false;
                }
                var _DOMTokenList = function(el, prop) {
                    var that = this;
                    var tokens = [];
                    var tokenMap = {};
                    var length = 0;
                    var maxLength = 0;
                    var addIndexGetter = function(i) {
                        defineGetter(that, i, function() {
                            preop();
                            return tokens[i];
                        }, false);
                    };
                    var reindex = function() {
                        /** Define getter functions for array-like access to the tokenList's contents. */ if (length >= maxLength) for(; maxLength < length; ++maxLength)addIndexGetter(maxLength);
                    };
                    /** Helper function called at the start of each class method. Internal use only. */ var preop = function() {
                        var error;
                        var i;
                        var args = arguments;
                        var rSpace = /\s+/;
                        /** Validate the token/s passed to an instance method, if any. */ if (args.length) {
                            for(i = 0; i < args.length; ++i)if (rSpace.test(args[i])) {
                                error = new SyntaxError('String "' + args[i] + '" ' + "contains" + ' an invalid character');
                                error.code = 5;
                                error.name = "InvalidCharacterError";
                                throw error;
                            }
                        }
                        /** Split the new value apart by whitespace*/ if (typeof el[prop] === "object") tokens = ("" + el[prop].baseVal).replace(/^\s+|\s+$/g, "").split(rSpace);
                        else tokens = ("" + el[prop]).replace(/^\s+|\s+$/g, "").split(rSpace);
                        /** Avoid treating blank strings as single-item token lists */ if ("" === tokens[0]) tokens = [];
                        /** Repopulate the internal token lists */ tokenMap = {};
                        for(i = 0; i < tokens.length; ++i)tokenMap[tokens[i]] = true;
                        length = tokens.length;
                        reindex();
                    };
                    /** Populate our internal token list if the targeted attribute of the subject element isn't empty. */ preop();
                    /** Return the number of tokens in the underlying string. Read-only. */ defineGetter(that, "length", function() {
                        preop();
                        return length;
                    });
                    /** Override the default toString/toLocaleString methods to return a space-delimited list of tokens when typecast. */ that.toLocaleString = that.toString = function() {
                        preop();
                        return tokens.join(" ");
                    };
                    that.item = function(idx) {
                        preop();
                        return tokens[idx];
                    };
                    that.contains = function(token) {
                        preop();
                        return !!tokenMap[token];
                    };
                    that.add = function() {
                        preop.apply(that, args = arguments);
                        for(var args, token, i = 0, l = args.length; i < l; ++i){
                            token = args[i];
                            if (!tokenMap[token]) {
                                tokens.push(token);
                                tokenMap[token] = true;
                            }
                        }
                        /** Update the targeted attribute of the attached element if the token list's changed. */ if (length !== tokens.length) {
                            length = tokens.length >>> 0;
                            if (typeof el[prop] === "object") el[prop].baseVal = tokens.join(" ");
                            else el[prop] = tokens.join(" ");
                            reindex();
                        }
                    };
                    that.remove = function() {
                        preop.apply(that, args = arguments);
                        /** Build a hash of token names to compare against when recollecting our token list. */ for(var args, ignore = {}, i = 0, t = []; i < args.length; ++i){
                            ignore[args[i]] = true;
                            delete tokenMap[args[i]];
                        }
                        /** Run through our tokens list and reassign only those that aren't defined in the hash declared above. */ for(i = 0; i < tokens.length; ++i)if (!ignore[tokens[i]]) t.push(tokens[i]);
                        tokens = t;
                        length = t.length >>> 0;
                        /** Update the targeted attribute of the attached element. */ if (typeof el[prop] === "object") el[prop].baseVal = tokens.join(" ");
                        else el[prop] = tokens.join(" ");
                        reindex();
                    };
                    that.toggle = function(token, force) {
                        preop.apply(that, [
                            token
                        ]);
                        /** Token state's being forced. */ if (undefined !== force) {
                            if (force) {
                                that.add(token);
                                return true;
                            } else {
                                that.remove(token);
                                return false;
                            }
                        }
                        /** Token already exists in tokenList. Remove it, and return FALSE. */ if (tokenMap[token]) {
                            that.remove(token);
                            return false;
                        }
                        /** Otherwise, add the token and return TRUE. */ that.add(token);
                        return true;
                    };
                    return that;
                };
                return _DOMTokenList;
            }();
            // Add second argument to native DOMTokenList.toggle() if necessary
            (function() {
                var e = document.createElement('span');
                if (!('classList' in e)) return;
                e.classList.toggle('x', false);
                if (!e.classList.contains('x')) return;
                e.classList.constructor.prototype.toggle = function toggle(token /*, force*/ ) {
                    var force = arguments[1];
                    if (force === undefined) {
                        var add = !this.contains(token);
                        this[add ? 'add' : 'remove'](token);
                        return add;
                    }
                    force = !!force;
                    this[force ? 'add' : 'remove'](token);
                    return force;
                };
            })();
            // Add multiple arguments to native DOMTokenList.add() if necessary
            (function() {
                var e = document.createElement('span');
                if (!('classList' in e)) return;
                e.classList.add('a', 'b');
                if (e.classList.contains('b')) return;
                var native = e.classList.constructor.prototype.add;
                e.classList.constructor.prototype.add = function() {
                    var args = arguments;
                    var l = arguments.length;
                    for(var i = 0; i < l; i++)native.call(this, args[i]);
                };
            })();
            // Add multiple arguments to native DOMTokenList.remove() if necessary
            (function() {
                var e = document.createElement('span');
                if (!('classList' in e)) return;
                e.classList.add('a');
                e.classList.add('b');
                e.classList.remove('a', 'b');
                if (!e.classList.contains('b')) return;
                var native = e.classList.constructor.prototype.remove;
                e.classList.constructor.prototype.remove = function() {
                    var args = arguments;
                    var l = arguments.length;
                    for(var i = 0; i < l; i++)native.call(this, args[i]);
                };
            })();
        })(this);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-service/8717a9e04ac7aff99b4980fbedead98036b0929a/packages/polyfill-library/polyfills/Element/prototype/classList/detect.js
        var detect = 'document' in this && "classList" in document.documentElement && 'Element' in this && 'classList' in Element.prototype && function() {
            var e = document.createElement('span');
            e.classList.add('a', 'b');
            return e.classList.contains('b');
        }();
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Element.prototype.classList&flags=always
        (function(global1) {
            var dpSupport = true;
            var defineGetter = function(object, name, fn, configurable) {
                if (Object.defineProperty) Object.defineProperty(object, name, {
                    configurable: false === dpSupport ? true : !!configurable,
                    get: fn
                });
                else object.__defineGetter__(name, fn);
            };
            /** Ensure the browser allows Object.defineProperty to be used on native JavaScript objects. */ try {
                defineGetter({}, "support");
            } catch (e) {
                dpSupport = false;
            }
            /** Polyfills a property with a DOMTokenList */ var addProp = function(o, name, attr) {
                defineGetter(o.prototype, name, function() {
                    var tokenList;
                    var THIS = this, /** Prevent this from firing twice for some reason. What the hell, IE. */ gibberishProperty = "__defineGetter__DEFINE_PROPERTY" + name;
                    if (THIS[gibberishProperty]) return tokenList;
                    THIS[gibberishProperty] = true;
                    /**
           * IE8 can't define properties on native JavaScript objects, so we'll use a dumb hack instead.
           *
           * What this is doing is creating a dummy element ("reflection") inside a detached phantom node ("mirror")
           * that serves as the target of Object.defineProperty instead. While we could simply use the subject HTML
           * element instead, this would conflict with element types which use indexed properties (such as forms and
           * select lists).
           */ if (false === dpSupport) {
                        var visage;
                        var mirror = addProp.mirror || document.createElement("div");
                        var reflections = mirror.childNodes;
                        var l = reflections.length;
                        for(var i = 0; i < l; ++i)if (reflections[i]._R === THIS) {
                            visage = reflections[i];
                            break;
                        }
                        /** Couldn't find an element's reflection inside the mirror. Materialise one. */ visage || (visage = mirror.appendChild(document.createElement("div")));
                        tokenList = DOMTokenList.call(visage, THIS, attr);
                    } else tokenList = new DOMTokenList(THIS, attr);
                    defineGetter(THIS, name, function() {
                        return tokenList;
                    });
                    delete THIS[gibberishProperty];
                    return tokenList;
                }, true);
            };
            addProp(global1.Element, "classList", "className");
            addProp(global1.HTMLElement, "classList", "className");
            addProp(global1.HTMLLinkElement, "relList", "rel");
            addProp(global1.HTMLAnchorElement, "relList", "rel");
            addProp(global1.HTMLAreaElement, "relList", "rel");
        })(this);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    function CharacterCount($module) {
        this.$module = $module;
        this.$textarea = $module.querySelector('.govuk-js-character-count');
        if (this.$textarea) this.$countMessage = $module.querySelector('[id="' + this.$textarea.id + '-info"]');
    }
    CharacterCount.prototype.defaults = {
        characterCountAttribute: 'data-maxlength',
        wordCountAttribute: 'data-maxwords'
    };
    // Initialize component
    CharacterCount.prototype.init = function() {
        // Check for module
        var $module = this.$module;
        var $textarea = this.$textarea;
        var $countMessage = this.$countMessage;
        if (!$textarea || !$countMessage) return;
        // We move count message right after the field
        // Kept for backwards compatibility
        $textarea.insertAdjacentElement('afterend', $countMessage);
        // Read options set using dataset ('data-' values)
        this.options = this.getDataset($module);
        // Determine the limit attribute (characters or words)
        var countAttribute = this.defaults.characterCountAttribute;
        if (this.options.maxwords) countAttribute = this.defaults.wordCountAttribute;
        // Save the element limit
        this.maxLength = $module.getAttribute(countAttribute);
        // Check for limit
        if (!this.maxLength) return;
        // Remove hard limit if set
        $module.removeAttribute('maxlength');
        // When the page is restored after navigating 'back' in some browsers the
        // state of the character count is not restored until *after* the DOMContentLoaded
        // event is fired, so we need to sync after the pageshow event in browsers
        // that support it.
        if ('onpageshow' in window) window.addEventListener('pageshow', this.sync.bind(this));
        else window.addEventListener('DOMContentLoaded', this.sync.bind(this));
        this.sync();
    };
    CharacterCount.prototype.sync = function() {
        this.bindChangeEvents();
        this.updateCountMessage();
    };
    // Read data attributes
    CharacterCount.prototype.getDataset = function(element) {
        var dataset = {};
        var attributes = element.attributes;
        if (attributes) for(var i = 0; i < attributes.length; i++){
            var attribute = attributes[i];
            var match = attribute.name.match(/^data-(.+)/);
            if (match) dataset[match[1]] = attribute.value;
        }
        return dataset;
    };
    // Counts characters or words in text
    CharacterCount.prototype.count = function(text) {
        var length;
        if (this.options.maxwords) {
            var tokens = text.match(/\S+/g) || []; // Matches consecutive non-whitespace chars
            length = tokens.length;
        } else length = text.length;
        return length;
    };
    // Bind input propertychange to the elements and update based on the change
    CharacterCount.prototype.bindChangeEvents = function() {
        var $textarea = this.$textarea;
        $textarea.addEventListener('keyup', this.checkIfValueChanged.bind(this));
        // Bind focus/blur events to start/stop polling
        $textarea.addEventListener('focus', this.handleFocus.bind(this));
        $textarea.addEventListener('blur', this.handleBlur.bind(this));
    };
    // Speech recognition software such as Dragon NaturallySpeaking will modify the
    // fields by directly changing its `value`. These changes don't trigger events
    // in JavaScript, so we need to poll to handle when and if they occur.
    CharacterCount.prototype.checkIfValueChanged = function() {
        if (!this.$textarea.oldValue) this.$textarea.oldValue = '';
        if (this.$textarea.value !== this.$textarea.oldValue) {
            this.$textarea.oldValue = this.$textarea.value;
            this.updateCountMessage();
        }
    };
    // Update message box
    CharacterCount.prototype.updateCountMessage = function() {
        var countElement = this.$textarea;
        var options = this.options;
        var countMessage = this.$countMessage;
        // Determine the remaining number of characters/words
        var currentLength = this.count(countElement.value);
        var maxLength = this.maxLength;
        var remainingNumber = maxLength - currentLength;
        // Set threshold if presented in options
        var thresholdPercent = options.threshold ? options.threshold : 0;
        var thresholdValue = maxLength * thresholdPercent / 100;
        if (thresholdValue > currentLength) {
            countMessage.classList.add('govuk-character-count__message--disabled');
            // Ensure threshold is hidden for users of assistive technologies
            countMessage.setAttribute('aria-hidden', true);
        } else {
            countMessage.classList.remove('govuk-character-count__message--disabled');
            // Ensure threshold is visible for users of assistive technologies
            countMessage.removeAttribute('aria-hidden');
        }
        // Update styles
        if (remainingNumber < 0) {
            countElement.classList.add('govuk-textarea--error');
            countMessage.classList.remove('govuk-hint');
            countMessage.classList.add('govuk-error-message');
        } else {
            countElement.classList.remove('govuk-textarea--error');
            countMessage.classList.remove('govuk-error-message');
            countMessage.classList.add('govuk-hint');
        }
        // Update message
        var charVerb = 'remaining';
        var charNoun = 'character';
        var displayNumber = remainingNumber;
        if (options.maxwords) charNoun = 'word';
        charNoun = charNoun + (remainingNumber === -1 || remainingNumber === 1 ? '' : 's');
        charVerb = remainingNumber < 0 ? 'too many' : 'remaining';
        displayNumber = Math.abs(remainingNumber);
        countMessage.innerHTML = 'You have ' + displayNumber + ' ' + charNoun + ' ' + charVerb;
    };
    CharacterCount.prototype.handleFocus = function() {
        // Check if value changed on focus
        this.valueChecker = setInterval(this.checkIfValueChanged.bind(this), 1000);
    };
    CharacterCount.prototype.handleBlur = function() {
        // Cancel value checking on blur
        clearInterval(this.valueChecker);
    };
    return CharacterCount;
});


var $4a6964d4dfd8662c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($2d39b061fef9045c$exports)));


var $a57a2230e1392c1a$exports = {};
(function(global1, factory) {
    $a57a2230e1392c1a$exports = factory();
})($a57a2230e1392c1a$exports, function() {
    'use strict';
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Object/defineProperty/detect.js
        var detect = // In IE8, defineProperty could only act on DOM elements, so full support
        // for the feature requires the ability to set a property on an arbitrary object
        'defineProperty' in Object && function() {
            try {
                var a = {};
                Object.defineProperty(a, 'test', {
                    value: 42
                });
                return true;
            } catch (e) {
                return false;
            }
        }();
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Object.defineProperty&flags=always
        (function(nativeDefineProperty) {
            var supportsAccessors = Object.prototype.hasOwnProperty('__defineGetter__');
            var ERR_ACCESSORS_NOT_SUPPORTED = 'Getters & setters cannot be defined on this javascript engine';
            var ERR_VALUE_ACCESSORS = 'A property cannot both have accessors and be writable or have a value';
            Object.defineProperty = function defineProperty(object, property, descriptor) {
                // Where native support exists, assume it
                if (nativeDefineProperty && (object === window || object === document || object === Element.prototype || object instanceof Element)) return nativeDefineProperty(object, property, descriptor);
                if (object === null || !(object instanceof Object || typeof object === 'object')) throw new TypeError('Object.defineProperty called on non-object');
                if (!(descriptor instanceof Object)) throw new TypeError('Property description must be an object');
                var propertyString = String(property);
                var hasValueOrWritable = 'value' in descriptor || 'writable' in descriptor;
                var getterType = 'get' in descriptor && typeof descriptor.get;
                var setterType = 'set' in descriptor && typeof descriptor.set;
                // handle descriptor.get
                if (getterType) {
                    if (getterType !== 'function') throw new TypeError('Getter must be a function');
                    if (!supportsAccessors) throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
                    if (hasValueOrWritable) throw new TypeError(ERR_VALUE_ACCESSORS);
                    Object.__defineGetter__.call(object, propertyString, descriptor.get);
                } else object[propertyString] = descriptor.value;
                // handle descriptor.set
                if (setterType) {
                    if (setterType !== 'function') throw new TypeError('Setter must be a function');
                    if (!supportsAccessors) throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
                    if (hasValueOrWritable) throw new TypeError(ERR_VALUE_ACCESSORS);
                    Object.__defineSetter__.call(object, propertyString, descriptor.set);
                }
                // OK to define value unconditionally - if a getter has been specified as well, an error would be thrown above
                if ('value' in descriptor) object[propertyString] = descriptor.value;
                return object;
            };
        })(Object.defineProperty);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Function/prototype/bind/detect.js
        var detect = 'bind' in Function.prototype;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Function.prototype.bind&flags=always
        Object.defineProperty(Function.prototype, 'bind', {
            value: function bind(that) {
                // add necessary es5-shim utilities
                var $Array = Array;
                var $Object = Object;
                var ObjectPrototype = $Object.prototype;
                var ArrayPrototype = $Array.prototype;
                var Empty = function Empty() {};
                var to_string = ObjectPrototype.toString;
                var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
                var isCallable; /* inlined from https://npmjs.com/is-callable */ 
                var fnToStr = Function.prototype.toString, tryFunctionObject = function tryFunctionObject(value) {
                    try {
                        fnToStr.call(value);
                        return true;
                    } catch (e) {
                        return false;
                    }
                }, fnClass = '[object Function]', genClass = '[object GeneratorFunction]';
                isCallable = function isCallable(value) {
                    if (typeof value !== 'function') return false;
                    if (hasToStringTag) return tryFunctionObject(value);
                    var strClass = to_string.call(value);
                    return strClass === fnClass || strClass === genClass;
                };
                var array_slice = ArrayPrototype.slice;
                var array_concat = ArrayPrototype.concat;
                var array_push = ArrayPrototype.push;
                var max = Math.max;
                // /add necessary es5-shim utilities
                // 1. Let Target be the this value.
                var target = this;
                // 2. If IsCallable(Target) is false, throw a TypeError exception.
                if (!isCallable(target)) throw new TypeError('Function.prototype.bind called on incompatible ' + target);
                // 3. Let A be a new (possibly empty) internal list of all of the
                //   argument values provided after thisArg (arg1, arg2 etc), in order.
                // XXX slicedArgs will stand in for "A" if used
                var args = array_slice.call(arguments, 1); // for normal call
                // 4. Let F be a new native ECMAScript object.
                // 11. Set the [[Prototype]] internal property of F to the standard
                //   built-in Function prototype object as specified in 15.3.3.1.
                // 12. Set the [[Call]] internal property of F as described in
                //   15.3.4.5.1.
                // 13. Set the [[Construct]] internal property of F as described in
                //   15.3.4.5.2.
                // 14. Set the [[HasInstance]] internal property of F as described in
                //   15.3.4.5.3.
                var bound;
                var binder = function() {
                    if (this instanceof bound) {
                        // 15.3.4.5.2 [[Construct]]
                        // When the [[Construct]] internal method of a function object,
                        // F that was created using the bind function is called with a
                        // list of arguments ExtraArgs, the following steps are taken:
                        // 1. Let target be the value of F's [[TargetFunction]]
                        //   internal property.
                        // 2. If target has no [[Construct]] internal method, a
                        //   TypeError exception is thrown.
                        // 3. Let boundArgs be the value of F's [[BoundArgs]] internal
                        //   property.
                        // 4. Let args be a new list containing the same values as the
                        //   list boundArgs in the same order followed by the same
                        //   values as the list ExtraArgs in the same order.
                        // 5. Return the result of calling the [[Construct]] internal
                        //   method of target providing args as the arguments.
                        var result = target.apply(this, array_concat.call(args, array_slice.call(arguments)));
                        if ($Object(result) === result) return result;
                        return this;
                    } else // 15.3.4.5.1 [[Call]]
                    // When the [[Call]] internal method of a function object, F,
                    // which was created using the bind function is called with a
                    // this value and a list of arguments ExtraArgs, the following
                    // steps are taken:
                    // 1. Let boundArgs be the value of F's [[BoundArgs]] internal
                    //   property.
                    // 2. Let boundThis be the value of F's [[BoundThis]] internal
                    //   property.
                    // 3. Let target be the value of F's [[TargetFunction]] internal
                    //   property.
                    // 4. Let args be a new list containing the same values as the
                    //   list boundArgs in the same order followed by the same
                    //   values as the list ExtraArgs in the same order.
                    // 5. Return the result of calling the [[Call]] internal method
                    //   of target providing boundThis as the this value and
                    //   providing args as the arguments.
                    // equiv: target.call(this, ...boundArgs, ...args)
                    return target.apply(that, array_concat.call(args, array_slice.call(arguments)));
                };
                // 15. If the [[Class]] internal property of Target is "Function", then
                //     a. Let L be the length property of Target minus the length of A.
                //     b. Set the length own property of F to either 0 or L, whichever is
                //       larger.
                // 16. Else set the length own property of F to 0.
                var boundLength = max(0, target.length - args.length);
                // 17. Set the attributes of the length own property of F to the values
                //   specified in 15.3.5.1.
                var boundArgs = [];
                for(var i = 0; i < boundLength; i++)array_push.call(boundArgs, '$' + i);
                // XXX Build a dynamic function with desired amount of arguments is the only
                // way to set the length property of a function.
                // In environments where Content Security Policies enabled (Chrome extensions,
                // for ex.) all use of eval or Function costructor throws an exception.
                // However in all of these environments Function.prototype.bind exists
                // and so this code will never be executed.
                bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this, arguments); }')(binder);
                if (target.prototype) {
                    Empty.prototype = target.prototype;
                    bound.prototype = new Empty();
                    // Clean up dangling references.
                    Empty.prototype = null;
                }
                // TODO
                // 18. Set the [[Extensible]] internal property of F to true.
                // TODO
                // 19. Let thrower be the [[ThrowTypeError]] function Object (13.2.3).
                // 20. Call the [[DefineOwnProperty]] internal method of F with
                //   arguments "caller", PropertyDescriptor {[[Get]]: thrower, [[Set]]:
                //   thrower, [[Enumerable]]: false, [[Configurable]]: false}, and
                //   false.
                // 21. Call the [[DefineOwnProperty]] internal method of F with
                //   arguments "arguments", PropertyDescriptor {[[Get]]: thrower,
                //   [[Set]]: thrower, [[Enumerable]]: false, [[Configurable]]: false},
                //   and false.
                // TODO
                // NOTE Function objects created using Function.prototype.bind do not
                // have a prototype property or the [[Code]], [[FormalParameters]], and
                // [[Scope]] internal properties.
                // XXX can't delete prototype in pure-js.
                // 22. Return F.
                return bound;
            }
        });
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Window/detect.js
        var detect = 'Window' in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Window&flags=always
        if (typeof WorkerGlobalScope === "undefined" && typeof importScripts !== "function") (function(global1) {
            if (global1.constructor) global1.Window = global1.constructor;
            else (global1.Window = global1.constructor = new Function('return function Window() {}')()).prototype = this;
        })(this);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Document/detect.js
        var detect = "Document" in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Document&flags=always
        if (typeof WorkerGlobalScope === "undefined" && typeof importScripts !== "function") {
            if (this.HTMLDocument) // HTMLDocument is an extension of Document.  If the browser has HTMLDocument but not Document, the former will suffice as an alias for the latter.
            this.Document = this.HTMLDocument;
            else {
                // Create an empty function to act as the missing constructor for the document object, attach the document object as its prototype.  The function needs to be anonymous else it is hoisted and causes the feature detect to prematurely pass, preventing the assignments below being made.
                this.Document = this.HTMLDocument = document.constructor = new Function('return function Document() {}')();
                this.Document.prototype = document;
            }
        }
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Element/detect.js
        var detect = 'Element' in this && 'HTMLElement' in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Element&flags=always
        (function() {
            // IE8
            if (window.Element && !window.HTMLElement) {
                window.HTMLElement = window.Element;
                return;
            }
            // create Element constructor
            window.Element = window.HTMLElement = new Function('return function Element() {}')();
            // generate sandboxed iframe
            var vbody = document.appendChild(document.createElement('body'));
            var frame = vbody.appendChild(document.createElement('iframe'));
            // use sandboxed iframe to replicate Element functionality
            var frameDocument = frame.contentWindow.document;
            var prototype = Element.prototype = frameDocument.appendChild(frameDocument.createElement('*'));
            var cache = {};
            // polyfill Element.prototype on an element
            var shiv = function(element, deep) {
                var childNodes = element.childNodes || [], index = -1, key, value, childNode;
                if (element.nodeType === 1 && element.constructor !== Element) {
                    element.constructor = Element;
                    for(key in cache){
                        value = cache[key];
                        element[key] = value;
                    }
                }
                while(childNode = deep && childNodes[++index])shiv(childNode, deep);
                return element;
            };
            var elements = document.getElementsByTagName('*');
            var nativeCreateElement = document.createElement;
            var interval;
            var loopLimit = 100;
            prototype.attachEvent('onpropertychange', function(event) {
                var propertyName = event.propertyName, nonValue = !cache.hasOwnProperty(propertyName), newValue = prototype[propertyName], oldValue = cache[propertyName], index = -1, element;
                while(element = elements[++index]){
                    if (element.nodeType === 1) {
                        if (nonValue || element[propertyName] === oldValue) element[propertyName] = newValue;
                    }
                }
                cache[propertyName] = newValue;
            });
            prototype.constructor = Element;
            if (!prototype.hasAttribute) // <Element>.hasAttribute
            prototype.hasAttribute = function hasAttribute(name) {
                return this.getAttribute(name) !== null;
            };
            // Apply Element prototype to the pre-existing DOM as soon as the body element appears.
            function bodyCheck() {
                if (!loopLimit--) clearTimeout(interval);
                if (document.body && !document.body.prototype && /(complete|interactive)/.test(document.readyState)) {
                    shiv(document, true);
                    if (interval && document.body.prototype) clearTimeout(interval);
                    return !!document.body.prototype;
                }
                return false;
            }
            if (!bodyCheck()) {
                document.onreadystatechange = bodyCheck;
                interval = setInterval(bodyCheck, 25);
            }
            // Apply to any new elements created after load
            document.createElement = function createElement(nodeName) {
                var element = nativeCreateElement(String(nodeName).toLowerCase());
                return shiv(element);
            };
            // remove sandboxed iframe
            document.removeChild(vbody);
        })();
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Event/detect.js
        var detect = function(global1) {
            if (!('Event' in global1)) return false;
            if (typeof global1.Event === 'function') return true;
            try {
                // In IE 9-11, the Event object exists but cannot be instantiated
                new Event('click');
                return true;
            } catch (e) {
                return false;
            }
        }(this);
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Event&flags=always
        (function() {
            var unlistenableWindowEvents = {
                click: 1,
                dblclick: 1,
                keyup: 1,
                keypress: 1,
                keydown: 1,
                mousedown: 1,
                mouseup: 1,
                mousemove: 1,
                mouseover: 1,
                mouseenter: 1,
                mouseleave: 1,
                mouseout: 1,
                storage: 1,
                storagecommit: 1,
                textinput: 1
            };
            // This polyfill depends on availability of `document` so will not run in a worker
            // However, we asssume there are no browsers with worker support that lack proper
            // support for `Event` within the worker
            if (typeof document === 'undefined' || typeof window === 'undefined') return;
            function indexOf(array, element) {
                var index = -1, length = array.length;
                while(++index < length){
                    if (index in array && array[index] === element) return index;
                }
                return -1;
            }
            var existingProto = window.Event && window.Event.prototype || null;
            window.Event = Window.prototype.Event = function Event1(type, eventInitDict) {
                if (!type) throw new Error('Not enough arguments');
                var event;
                // Shortcut if browser supports createEvent
                if ('createEvent' in document) {
                    event = document.createEvent('Event');
                    var bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
                    var cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;
                    event.initEvent(type, bubbles, cancelable);
                    return event;
                }
                event = document.createEventObject();
                event.type = type;
                event.bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
                event.cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;
                return event;
            };
            if (existingProto) Object.defineProperty(window.Event, 'prototype', {
                configurable: false,
                enumerable: false,
                writable: true,
                value: existingProto
            });
            if (!('createEvent' in document)) {
                window.addEventListener = Window.prototype.addEventListener = Document.prototype.addEventListener = Element.prototype.addEventListener = function addEventListener() {
                    var element = this, type = arguments[0], listener = arguments[1];
                    if (element === window && type in unlistenableWindowEvents) throw new Error('In IE8 the event: ' + type + ' is not available on the window object. Please see https://github.com/Financial-Times/polyfill-service/issues/317 for more information.');
                    if (!element._events) element._events = {};
                    if (!element._events[type]) {
                        element._events[type] = function(event) {
                            var list = element._events[event.type].list, events = list.slice(), index = -1, length = events.length, eventElement;
                            event.preventDefault = function preventDefault() {
                                if (event.cancelable !== false) event.returnValue = false;
                            };
                            event.stopPropagation = function stopPropagation() {
                                event.cancelBubble = true;
                            };
                            event.stopImmediatePropagation = function stopImmediatePropagation() {
                                event.cancelBubble = true;
                                event.cancelImmediate = true;
                            };
                            event.currentTarget = element;
                            event.relatedTarget = event.fromElement || null;
                            event.target = event.target || event.srcElement || element;
                            event.timeStamp = new Date().getTime();
                            if (event.clientX) {
                                event.pageX = event.clientX + document.documentElement.scrollLeft;
                                event.pageY = event.clientY + document.documentElement.scrollTop;
                            }
                            while(++index < length && !event.cancelImmediate)if (index in events) {
                                eventElement = events[index];
                                if (indexOf(list, eventElement) !== -1 && typeof eventElement === 'function') eventElement.call(element, event);
                            }
                        };
                        element._events[type].list = [];
                        if (element.attachEvent) element.attachEvent('on' + type, element._events[type]);
                    }
                    element._events[type].list.push(listener);
                };
                window.removeEventListener = Window.prototype.removeEventListener = Document.prototype.removeEventListener = Element.prototype.removeEventListener = function removeEventListener() {
                    var element = this, type = arguments[0], listener = arguments[1], index;
                    if (element._events && element._events[type] && element._events[type].list) {
                        index = indexOf(element._events[type].list, listener);
                        if (index !== -1) {
                            element._events[type].list.splice(index, 1);
                            if (!element._events[type].list.length) {
                                if (element.detachEvent) element.detachEvent('on' + type, element._events[type]);
                                delete element._events[type];
                            }
                        }
                    }
                };
                window.dispatchEvent = Window.prototype.dispatchEvent = Document.prototype.dispatchEvent = Element.prototype.dispatchEvent = function dispatchEvent(event) {
                    if (!arguments.length) throw new Error('Not enough arguments');
                    if (!event || typeof event.type !== 'string') throw new Error('DOM Events Exception 0');
                    var element = this, type = event.type;
                    try {
                        if (!event.bubbles) {
                            event.cancelBubble = true;
                            var cancelBubbleEvent = function(event) {
                                event.cancelBubble = true;
                                (element || window).detachEvent('on' + type, cancelBubbleEvent);
                            };
                            this.attachEvent('on' + type, cancelBubbleEvent);
                        }
                        this.fireEvent('on' + type, event);
                    } catch (error) {
                        event.target = element;
                        do {
                            event.currentTarget = element;
                            if ('_events' in element && typeof element._events[type] === 'function') element._events[type].call(element, event);
                            if (typeof element['on' + type] === 'function') element['on' + type].call(element, event);
                            element = element.nodeType === 9 ? element.parentWindow : element.parentNode;
                        }while (element && !event.cancelBubble);
                    }
                    return true;
                };
                // Add the DOMContentLoaded Event
                document.attachEvent('onreadystatechange', function() {
                    if (document.readyState === 'complete') document.dispatchEvent(new Event('DOMContentLoaded', {
                        bubbles: true
                    }));
                });
            }
        })();
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-service/master/packages/polyfill-library/polyfills/DOMTokenList/detect.js
        var detect = 'DOMTokenList' in this && function(x) {
            return 'classList' in x ? !x.classList.toggle('x', false) && !x.className : true;
        }(document.createElement('x'));
        if (detect) return;
        // Polyfill from https://raw.githubusercontent.com/Financial-Times/polyfill-service/master/packages/polyfill-library/polyfills/DOMTokenList/polyfill.js
        (function(global1) {
            var nativeImpl = "DOMTokenList" in global1 && global1.DOMTokenList;
            if (!nativeImpl || !!document.createElementNS && !!document.createElementNS('http://www.w3.org/2000/svg', 'svg') && !(document.createElementNS("http://www.w3.org/2000/svg", "svg").classList instanceof DOMTokenList)) global1.DOMTokenList = function() {
                var dpSupport = true;
                var defineGetter = function(object, name, fn, configurable) {
                    if (Object.defineProperty) Object.defineProperty(object, name, {
                        configurable: false === dpSupport ? true : !!configurable,
                        get: fn
                    });
                    else object.__defineGetter__(name, fn);
                };
                /** Ensure the browser allows Object.defineProperty to be used on native JavaScript objects. */ try {
                    defineGetter({}, "support");
                } catch (e) {
                    dpSupport = false;
                }
                var _DOMTokenList = function(el, prop) {
                    var that = this;
                    var tokens = [];
                    var tokenMap = {};
                    var length = 0;
                    var maxLength = 0;
                    var addIndexGetter = function(i) {
                        defineGetter(that, i, function() {
                            preop();
                            return tokens[i];
                        }, false);
                    };
                    var reindex = function() {
                        /** Define getter functions for array-like access to the tokenList's contents. */ if (length >= maxLength) for(; maxLength < length; ++maxLength)addIndexGetter(maxLength);
                    };
                    /** Helper function called at the start of each class method. Internal use only. */ var preop = function() {
                        var error;
                        var i;
                        var args = arguments;
                        var rSpace = /\s+/;
                        /** Validate the token/s passed to an instance method, if any. */ if (args.length) {
                            for(i = 0; i < args.length; ++i)if (rSpace.test(args[i])) {
                                error = new SyntaxError('String "' + args[i] + '" ' + "contains" + ' an invalid character');
                                error.code = 5;
                                error.name = "InvalidCharacterError";
                                throw error;
                            }
                        }
                        /** Split the new value apart by whitespace*/ if (typeof el[prop] === "object") tokens = ("" + el[prop].baseVal).replace(/^\s+|\s+$/g, "").split(rSpace);
                        else tokens = ("" + el[prop]).replace(/^\s+|\s+$/g, "").split(rSpace);
                        /** Avoid treating blank strings as single-item token lists */ if ("" === tokens[0]) tokens = [];
                        /** Repopulate the internal token lists */ tokenMap = {};
                        for(i = 0; i < tokens.length; ++i)tokenMap[tokens[i]] = true;
                        length = tokens.length;
                        reindex();
                    };
                    /** Populate our internal token list if the targeted attribute of the subject element isn't empty. */ preop();
                    /** Return the number of tokens in the underlying string. Read-only. */ defineGetter(that, "length", function() {
                        preop();
                        return length;
                    });
                    /** Override the default toString/toLocaleString methods to return a space-delimited list of tokens when typecast. */ that.toLocaleString = that.toString = function() {
                        preop();
                        return tokens.join(" ");
                    };
                    that.item = function(idx) {
                        preop();
                        return tokens[idx];
                    };
                    that.contains = function(token) {
                        preop();
                        return !!tokenMap[token];
                    };
                    that.add = function() {
                        preop.apply(that, args = arguments);
                        for(var args, token, i = 0, l = args.length; i < l; ++i){
                            token = args[i];
                            if (!tokenMap[token]) {
                                tokens.push(token);
                                tokenMap[token] = true;
                            }
                        }
                        /** Update the targeted attribute of the attached element if the token list's changed. */ if (length !== tokens.length) {
                            length = tokens.length >>> 0;
                            if (typeof el[prop] === "object") el[prop].baseVal = tokens.join(" ");
                            else el[prop] = tokens.join(" ");
                            reindex();
                        }
                    };
                    that.remove = function() {
                        preop.apply(that, args = arguments);
                        /** Build a hash of token names to compare against when recollecting our token list. */ for(var args, ignore = {}, i = 0, t = []; i < args.length; ++i){
                            ignore[args[i]] = true;
                            delete tokenMap[args[i]];
                        }
                        /** Run through our tokens list and reassign only those that aren't defined in the hash declared above. */ for(i = 0; i < tokens.length; ++i)if (!ignore[tokens[i]]) t.push(tokens[i]);
                        tokens = t;
                        length = t.length >>> 0;
                        /** Update the targeted attribute of the attached element. */ if (typeof el[prop] === "object") el[prop].baseVal = tokens.join(" ");
                        else el[prop] = tokens.join(" ");
                        reindex();
                    };
                    that.toggle = function(token, force) {
                        preop.apply(that, [
                            token
                        ]);
                        /** Token state's being forced. */ if (undefined !== force) {
                            if (force) {
                                that.add(token);
                                return true;
                            } else {
                                that.remove(token);
                                return false;
                            }
                        }
                        /** Token already exists in tokenList. Remove it, and return FALSE. */ if (tokenMap[token]) {
                            that.remove(token);
                            return false;
                        }
                        /** Otherwise, add the token and return TRUE. */ that.add(token);
                        return true;
                    };
                    return that;
                };
                return _DOMTokenList;
            }();
            // Add second argument to native DOMTokenList.toggle() if necessary
            (function() {
                var e = document.createElement('span');
                if (!('classList' in e)) return;
                e.classList.toggle('x', false);
                if (!e.classList.contains('x')) return;
                e.classList.constructor.prototype.toggle = function toggle(token /*, force*/ ) {
                    var force = arguments[1];
                    if (force === undefined) {
                        var add = !this.contains(token);
                        this[add ? 'add' : 'remove'](token);
                        return add;
                    }
                    force = !!force;
                    this[force ? 'add' : 'remove'](token);
                    return force;
                };
            })();
            // Add multiple arguments to native DOMTokenList.add() if necessary
            (function() {
                var e = document.createElement('span');
                if (!('classList' in e)) return;
                e.classList.add('a', 'b');
                if (e.classList.contains('b')) return;
                var native = e.classList.constructor.prototype.add;
                e.classList.constructor.prototype.add = function() {
                    var args = arguments;
                    var l = arguments.length;
                    for(var i = 0; i < l; i++)native.call(this, args[i]);
                };
            })();
            // Add multiple arguments to native DOMTokenList.remove() if necessary
            (function() {
                var e = document.createElement('span');
                if (!('classList' in e)) return;
                e.classList.add('a');
                e.classList.add('b');
                e.classList.remove('a', 'b');
                if (!e.classList.contains('b')) return;
                var native = e.classList.constructor.prototype.remove;
                e.classList.constructor.prototype.remove = function() {
                    var args = arguments;
                    var l = arguments.length;
                    for(var i = 0; i < l; i++)native.call(this, args[i]);
                };
            })();
        })(this);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-service/8717a9e04ac7aff99b4980fbedead98036b0929a/packages/polyfill-library/polyfills/Element/prototype/classList/detect.js
        var detect = 'document' in this && "classList" in document.documentElement && 'Element' in this && 'classList' in Element.prototype && function() {
            var e = document.createElement('span');
            e.classList.add('a', 'b');
            return e.classList.contains('b');
        }();
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Element.prototype.classList&flags=always
        (function(global1) {
            var dpSupport = true;
            var defineGetter = function(object, name, fn, configurable) {
                if (Object.defineProperty) Object.defineProperty(object, name, {
                    configurable: false === dpSupport ? true : !!configurable,
                    get: fn
                });
                else object.__defineGetter__(name, fn);
            };
            /** Ensure the browser allows Object.defineProperty to be used on native JavaScript objects. */ try {
                defineGetter({}, "support");
            } catch (e) {
                dpSupport = false;
            }
            /** Polyfills a property with a DOMTokenList */ var addProp = function(o, name, attr) {
                defineGetter(o.prototype, name, function() {
                    var tokenList;
                    var THIS = this, /** Prevent this from firing twice for some reason. What the hell, IE. */ gibberishProperty = "__defineGetter__DEFINE_PROPERTY" + name;
                    if (THIS[gibberishProperty]) return tokenList;
                    THIS[gibberishProperty] = true;
                    /**
           * IE8 can't define properties on native JavaScript objects, so we'll use a dumb hack instead.
           *
           * What this is doing is creating a dummy element ("reflection") inside a detached phantom node ("mirror")
           * that serves as the target of Object.defineProperty instead. While we could simply use the subject HTML
           * element instead, this would conflict with element types which use indexed properties (such as forms and
           * select lists).
           */ if (false === dpSupport) {
                        var visage;
                        var mirror = addProp.mirror || document.createElement("div");
                        var reflections = mirror.childNodes;
                        var l = reflections.length;
                        for(var i = 0; i < l; ++i)if (reflections[i]._R === THIS) {
                            visage = reflections[i];
                            break;
                        }
                        /** Couldn't find an element's reflection inside the mirror. Materialise one. */ visage || (visage = mirror.appendChild(document.createElement("div")));
                        tokenList = DOMTokenList.call(visage, THIS, attr);
                    } else tokenList = new DOMTokenList(THIS, attr);
                    defineGetter(THIS, name, function() {
                        return tokenList;
                    });
                    delete THIS[gibberishProperty];
                    return tokenList;
                }, true);
            };
            addProp(global1.Element, "classList", "className");
            addProp(global1.HTMLElement, "classList", "className");
            addProp(global1.HTMLLinkElement, "relList", "rel");
            addProp(global1.HTMLAnchorElement, "relList", "rel");
            addProp(global1.HTMLAreaElement, "relList", "rel");
        })(this);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    /**
 * TODO: Ideally this would be a NodeList.prototype.forEach polyfill
 * This seems to fail in IE8, requires more investigation.
 * See: https://github.com/imagitama/nodelist-foreach-polyfill
 */ function nodeListForEach(nodes, callback) {
        if (window.NodeList.prototype.forEach) return nodes.forEach(callback);
        for(var i = 0; i < nodes.length; i++)callback.call(window, nodes[i], i, nodes);
    }
    function Checkboxes($module) {
        this.$module = $module;
        this.$inputs = $module.querySelectorAll('input[type="checkbox"]');
    }
    /**
 * Initialise Checkboxes
 *
 * Checkboxes can be associated with a 'conditionally revealed' content block –
 * for example, a checkbox for 'Phone' could reveal an additional form field for
 * the user to enter their phone number.
 *
 * These associations are made using a `data-aria-controls` attribute, which is
 * promoted to an aria-controls attribute during initialisation.
 *
 * We also need to restore the state of any conditional reveals on the page (for
 * example if the user has navigated back), and set up event handlers to keep
 * the reveal in sync with the checkbox state.
 */ Checkboxes.prototype.init = function() {
        var $module = this.$module;
        var $inputs = this.$inputs;
        nodeListForEach($inputs, function($input) {
            var target = $input.getAttribute('data-aria-controls');
            // Skip checkboxes without data-aria-controls attributes, or where the
            // target element does not exist.
            if (!target || !$module.querySelector('#' + target)) return;
            // Promote the data-aria-controls attribute to a aria-controls attribute
            // so that the relationship is exposed in the AOM
            $input.setAttribute('aria-controls', target);
            $input.removeAttribute('data-aria-controls');
        });
        // When the page is restored after navigating 'back' in some browsers the
        // state of form controls is not restored until *after* the DOMContentLoaded
        // event is fired, so we need to sync after the pageshow event in browsers
        // that support it.
        if ('onpageshow' in window) window.addEventListener('pageshow', this.syncAllConditionalReveals.bind(this));
        else window.addEventListener('DOMContentLoaded', this.syncAllConditionalReveals.bind(this));
        // Although we've set up handlers to sync state on the pageshow or
        // DOMContentLoaded event, init could be called after those events have fired,
        // for example if they are added to the page dynamically, so sync now too.
        this.syncAllConditionalReveals();
        $module.addEventListener('click', this.handleClick.bind(this));
    };
    /**
 * Sync the conditional reveal states for all inputs in this $module.
 */ Checkboxes.prototype.syncAllConditionalReveals = function() {
        nodeListForEach(this.$inputs, this.syncConditionalRevealWithInputState.bind(this));
    };
    /**
 * Sync conditional reveal with the input state
 *
 * Synchronise the visibility of the conditional reveal, and its accessible
 * state, with the input's checked state.
 *
 * @param {HTMLInputElement} $input Checkbox input
 */ Checkboxes.prototype.syncConditionalRevealWithInputState = function($input) {
        var $target = this.$module.querySelector('#' + $input.getAttribute('aria-controls'));
        if ($target && $target.classList.contains('govuk-checkboxes__conditional')) {
            var inputIsChecked = $input.checked;
            $input.setAttribute('aria-expanded', inputIsChecked);
            $target.classList.toggle('govuk-checkboxes__conditional--hidden', !inputIsChecked);
        }
    };
    /**
 * Uncheck other checkboxes
 *
 * Find any other checkbox inputs with the same name value, and uncheck them.
 * This is useful for when a “None of these" checkbox is checked.
 */ Checkboxes.prototype.unCheckAllInputsExcept = function($input) {
        var allInputsWithSameName = document.querySelectorAll('input[type="checkbox"][name="' + $input.name + '"]');
        nodeListForEach(allInputsWithSameName, function($inputWithSameName) {
            var hasSameFormOwner = $input.form === $inputWithSameName.form;
            if (hasSameFormOwner && $inputWithSameName !== $input) $inputWithSameName.checked = false;
        });
        this.syncAllConditionalReveals();
    };
    /**
 * Uncheck exclusive inputs
 *
 * Find any checkbox inputs with the same name value and the 'exclusive' behaviour,
 * and uncheck them. This helps prevent someone checking both a regular checkbox and a
 * "None of these" checkbox in the same fieldset.
 */ Checkboxes.prototype.unCheckExclusiveInputs = function($input) {
        var allInputsWithSameNameAndExclusiveBehaviour = document.querySelectorAll('input[data-behaviour="exclusive"][type="checkbox"][name="' + $input.name + '"]');
        nodeListForEach(allInputsWithSameNameAndExclusiveBehaviour, function($exclusiveInput) {
            var hasSameFormOwner = $input.form === $exclusiveInput.form;
            if (hasSameFormOwner) $exclusiveInput.checked = false;
        });
        this.syncAllConditionalReveals();
    };
    /**
 * Click event handler
 *
 * Handle a click within the $module – if the click occurred on a checkbox, sync
 * the state of any associated conditional reveal with the checkbox state.
 *
 * @param {MouseEvent} event Click event
 */ Checkboxes.prototype.handleClick = function(event) {
        var $target = event.target;
        // Ignore clicks on things that aren't checkbox inputs
        if ($target.type !== 'checkbox') return;
        // If the checkbox conditionally-reveals some content, sync the state
        var hasAriaControls = $target.getAttribute('aria-controls');
        if (hasAriaControls) this.syncConditionalRevealWithInputState($target);
        // No further behaviour needed for unchecking
        if (!$target.checked) return;
        // Handle 'exclusive' checkbox behaviour (ie "None of these")
        var hasBehaviourExclusive = $target.getAttribute('data-behaviour') === 'exclusive';
        if (hasBehaviourExclusive) this.unCheckAllInputsExcept($target);
        else this.unCheckExclusiveInputs($target);
    };
    return Checkboxes;
});


var $6bea6cff6136c5f9$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($a57a2230e1392c1a$exports)));


var $19091a8654fef294$var$COOKIE_NAME = 'seen_cookie_message';
// Set to false to allow testing so that the cookie is never set
var $19091a8654fef294$var$DROP_COOKIE = window.dropCookie === undefined ? true : window.dropCookie;
function $19091a8654fef294$var$CookieBanner($module) {
    this.$module = $module;
    this.$button = this.$module.querySelector('[data-behavior="lbh-cookie-close"]');
}
$19091a8654fef294$var$CookieBanner.prototype.checkCookies = function() {
    var nameEQ = $19091a8654fef294$var$COOKIE_NAME + '=';
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++){
        var c = ca[i];
        while(c.charAt(0) === ' ')c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};
$19091a8654fef294$var$CookieBanner.prototype.showCookieBanner = function() {
    this.$module.style.display = 'block';
    this.bindAcceptButton();
};
$19091a8654fef294$var$CookieBanner.prototype.bindAcceptButton = function() {
    var _module = this.$module;
    this.$button.addEventListener('click', function() {
        var date = new Date();
        date.setTime(date.getTime() + 31536000000);
        var expires = '; expires=' + date.toGMTString();
        if ($19091a8654fef294$var$DROP_COOKIE) document.cookie = $19091a8654fef294$var$COOKIE_NAME + '=true' + expires + '; path=/';
        _module.style.display = 'none';
    });
};
$19091a8654fef294$var$CookieBanner.prototype.init = function() {
    if (!this.$module) return false;
    var seenCookie = this.checkCookies();
    if (seenCookie === 'true') return false;
    else this.showCookieBanner();
};
var $19091a8654fef294$export$2e2bcd8739ae039 = $19091a8654fef294$var$CookieBanner;


var $0d6736ebbb866c9c$exports = {};
(function(global1, factory) {
    $0d6736ebbb866c9c$exports = factory();
})($0d6736ebbb866c9c$exports, function() {
    'use strict';
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Object/defineProperty/detect.js
        var detect = // In IE8, defineProperty could only act on DOM elements, so full support
        // for the feature requires the ability to set a property on an arbitrary object
        'defineProperty' in Object && function() {
            try {
                var a = {};
                Object.defineProperty(a, 'test', {
                    value: 42
                });
                return true;
            } catch (e) {
                return false;
            }
        }();
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Object.defineProperty&flags=always
        (function(nativeDefineProperty) {
            var supportsAccessors = Object.prototype.hasOwnProperty('__defineGetter__');
            var ERR_ACCESSORS_NOT_SUPPORTED = 'Getters & setters cannot be defined on this javascript engine';
            var ERR_VALUE_ACCESSORS = 'A property cannot both have accessors and be writable or have a value';
            Object.defineProperty = function defineProperty(object, property, descriptor) {
                // Where native support exists, assume it
                if (nativeDefineProperty && (object === window || object === document || object === Element.prototype || object instanceof Element)) return nativeDefineProperty(object, property, descriptor);
                if (object === null || !(object instanceof Object || typeof object === 'object')) throw new TypeError('Object.defineProperty called on non-object');
                if (!(descriptor instanceof Object)) throw new TypeError('Property description must be an object');
                var propertyString = String(property);
                var hasValueOrWritable = 'value' in descriptor || 'writable' in descriptor;
                var getterType = 'get' in descriptor && typeof descriptor.get;
                var setterType = 'set' in descriptor && typeof descriptor.set;
                // handle descriptor.get
                if (getterType) {
                    if (getterType !== 'function') throw new TypeError('Getter must be a function');
                    if (!supportsAccessors) throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
                    if (hasValueOrWritable) throw new TypeError(ERR_VALUE_ACCESSORS);
                    Object.__defineGetter__.call(object, propertyString, descriptor.get);
                } else object[propertyString] = descriptor.value;
                // handle descriptor.set
                if (setterType) {
                    if (setterType !== 'function') throw new TypeError('Setter must be a function');
                    if (!supportsAccessors) throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
                    if (hasValueOrWritable) throw new TypeError(ERR_VALUE_ACCESSORS);
                    Object.__defineSetter__.call(object, propertyString, descriptor.set);
                }
                // OK to define value unconditionally - if a getter has been specified as well, an error would be thrown above
                if ('value' in descriptor) object[propertyString] = descriptor.value;
                return object;
            };
        })(Object.defineProperty);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Function/prototype/bind/detect.js
        var detect = 'bind' in Function.prototype;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Function.prototype.bind&flags=always
        Object.defineProperty(Function.prototype, 'bind', {
            value: function bind(that) {
                // add necessary es5-shim utilities
                var $Array = Array;
                var $Object = Object;
                var ObjectPrototype = $Object.prototype;
                var ArrayPrototype = $Array.prototype;
                var Empty = function Empty() {};
                var to_string = ObjectPrototype.toString;
                var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
                var isCallable; /* inlined from https://npmjs.com/is-callable */ 
                var fnToStr = Function.prototype.toString, tryFunctionObject = function tryFunctionObject(value) {
                    try {
                        fnToStr.call(value);
                        return true;
                    } catch (e) {
                        return false;
                    }
                }, fnClass = '[object Function]', genClass = '[object GeneratorFunction]';
                isCallable = function isCallable(value) {
                    if (typeof value !== 'function') return false;
                    if (hasToStringTag) return tryFunctionObject(value);
                    var strClass = to_string.call(value);
                    return strClass === fnClass || strClass === genClass;
                };
                var array_slice = ArrayPrototype.slice;
                var array_concat = ArrayPrototype.concat;
                var array_push = ArrayPrototype.push;
                var max = Math.max;
                // /add necessary es5-shim utilities
                // 1. Let Target be the this value.
                var target = this;
                // 2. If IsCallable(Target) is false, throw a TypeError exception.
                if (!isCallable(target)) throw new TypeError('Function.prototype.bind called on incompatible ' + target);
                // 3. Let A be a new (possibly empty) internal list of all of the
                //   argument values provided after thisArg (arg1, arg2 etc), in order.
                // XXX slicedArgs will stand in for "A" if used
                var args = array_slice.call(arguments, 1); // for normal call
                // 4. Let F be a new native ECMAScript object.
                // 11. Set the [[Prototype]] internal property of F to the standard
                //   built-in Function prototype object as specified in 15.3.3.1.
                // 12. Set the [[Call]] internal property of F as described in
                //   15.3.4.5.1.
                // 13. Set the [[Construct]] internal property of F as described in
                //   15.3.4.5.2.
                // 14. Set the [[HasInstance]] internal property of F as described in
                //   15.3.4.5.3.
                var bound;
                var binder = function() {
                    if (this instanceof bound) {
                        // 15.3.4.5.2 [[Construct]]
                        // When the [[Construct]] internal method of a function object,
                        // F that was created using the bind function is called with a
                        // list of arguments ExtraArgs, the following steps are taken:
                        // 1. Let target be the value of F's [[TargetFunction]]
                        //   internal property.
                        // 2. If target has no [[Construct]] internal method, a
                        //   TypeError exception is thrown.
                        // 3. Let boundArgs be the value of F's [[BoundArgs]] internal
                        //   property.
                        // 4. Let args be a new list containing the same values as the
                        //   list boundArgs in the same order followed by the same
                        //   values as the list ExtraArgs in the same order.
                        // 5. Return the result of calling the [[Construct]] internal
                        //   method of target providing args as the arguments.
                        var result = target.apply(this, array_concat.call(args, array_slice.call(arguments)));
                        if ($Object(result) === result) return result;
                        return this;
                    } else // 15.3.4.5.1 [[Call]]
                    // When the [[Call]] internal method of a function object, F,
                    // which was created using the bind function is called with a
                    // this value and a list of arguments ExtraArgs, the following
                    // steps are taken:
                    // 1. Let boundArgs be the value of F's [[BoundArgs]] internal
                    //   property.
                    // 2. Let boundThis be the value of F's [[BoundThis]] internal
                    //   property.
                    // 3. Let target be the value of F's [[TargetFunction]] internal
                    //   property.
                    // 4. Let args be a new list containing the same values as the
                    //   list boundArgs in the same order followed by the same
                    //   values as the list ExtraArgs in the same order.
                    // 5. Return the result of calling the [[Call]] internal method
                    //   of target providing boundThis as the this value and
                    //   providing args as the arguments.
                    // equiv: target.call(this, ...boundArgs, ...args)
                    return target.apply(that, array_concat.call(args, array_slice.call(arguments)));
                };
                // 15. If the [[Class]] internal property of Target is "Function", then
                //     a. Let L be the length property of Target minus the length of A.
                //     b. Set the length own property of F to either 0 or L, whichever is
                //       larger.
                // 16. Else set the length own property of F to 0.
                var boundLength = max(0, target.length - args.length);
                // 17. Set the attributes of the length own property of F to the values
                //   specified in 15.3.5.1.
                var boundArgs = [];
                for(var i = 0; i < boundLength; i++)array_push.call(boundArgs, '$' + i);
                // XXX Build a dynamic function with desired amount of arguments is the only
                // way to set the length property of a function.
                // In environments where Content Security Policies enabled (Chrome extensions,
                // for ex.) all use of eval or Function costructor throws an exception.
                // However in all of these environments Function.prototype.bind exists
                // and so this code will never be executed.
                bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this, arguments); }')(binder);
                if (target.prototype) {
                    Empty.prototype = target.prototype;
                    bound.prototype = new Empty();
                    // Clean up dangling references.
                    Empty.prototype = null;
                }
                // TODO
                // 18. Set the [[Extensible]] internal property of F to true.
                // TODO
                // 19. Let thrower be the [[ThrowTypeError]] function Object (13.2.3).
                // 20. Call the [[DefineOwnProperty]] internal method of F with
                //   arguments "caller", PropertyDescriptor {[[Get]]: thrower, [[Set]]:
                //   thrower, [[Enumerable]]: false, [[Configurable]]: false}, and
                //   false.
                // 21. Call the [[DefineOwnProperty]] internal method of F with
                //   arguments "arguments", PropertyDescriptor {[[Get]]: thrower,
                //   [[Set]]: thrower, [[Enumerable]]: false, [[Configurable]]: false},
                //   and false.
                // TODO
                // NOTE Function objects created using Function.prototype.bind do not
                // have a prototype property or the [[Code]], [[FormalParameters]], and
                // [[Scope]] internal properties.
                // XXX can't delete prototype in pure-js.
                // 22. Return F.
                return bound;
            }
        });
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Window/detect.js
        var detect = 'Window' in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Window&flags=always
        if (typeof WorkerGlobalScope === "undefined" && typeof importScripts !== "function") (function(global1) {
            if (global1.constructor) global1.Window = global1.constructor;
            else (global1.Window = global1.constructor = new Function('return function Window() {}')()).prototype = this;
        })(this);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Document/detect.js
        var detect = "Document" in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Document&flags=always
        if (typeof WorkerGlobalScope === "undefined" && typeof importScripts !== "function") {
            if (this.HTMLDocument) // HTMLDocument is an extension of Document.  If the browser has HTMLDocument but not Document, the former will suffice as an alias for the latter.
            this.Document = this.HTMLDocument;
            else {
                // Create an empty function to act as the missing constructor for the document object, attach the document object as its prototype.  The function needs to be anonymous else it is hoisted and causes the feature detect to prematurely pass, preventing the assignments below being made.
                this.Document = this.HTMLDocument = document.constructor = new Function('return function Document() {}')();
                this.Document.prototype = document;
            }
        }
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Element/detect.js
        var detect = 'Element' in this && 'HTMLElement' in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Element&flags=always
        (function() {
            // IE8
            if (window.Element && !window.HTMLElement) {
                window.HTMLElement = window.Element;
                return;
            }
            // create Element constructor
            window.Element = window.HTMLElement = new Function('return function Element() {}')();
            // generate sandboxed iframe
            var vbody = document.appendChild(document.createElement('body'));
            var frame = vbody.appendChild(document.createElement('iframe'));
            // use sandboxed iframe to replicate Element functionality
            var frameDocument = frame.contentWindow.document;
            var prototype = Element.prototype = frameDocument.appendChild(frameDocument.createElement('*'));
            var cache = {};
            // polyfill Element.prototype on an element
            var shiv = function(element, deep) {
                var childNodes = element.childNodes || [], index = -1, key, value, childNode;
                if (element.nodeType === 1 && element.constructor !== Element) {
                    element.constructor = Element;
                    for(key in cache){
                        value = cache[key];
                        element[key] = value;
                    }
                }
                while(childNode = deep && childNodes[++index])shiv(childNode, deep);
                return element;
            };
            var elements = document.getElementsByTagName('*');
            var nativeCreateElement = document.createElement;
            var interval;
            var loopLimit = 100;
            prototype.attachEvent('onpropertychange', function(event) {
                var propertyName = event.propertyName, nonValue = !cache.hasOwnProperty(propertyName), newValue = prototype[propertyName], oldValue = cache[propertyName], index = -1, element;
                while(element = elements[++index]){
                    if (element.nodeType === 1) {
                        if (nonValue || element[propertyName] === oldValue) element[propertyName] = newValue;
                    }
                }
                cache[propertyName] = newValue;
            });
            prototype.constructor = Element;
            if (!prototype.hasAttribute) // <Element>.hasAttribute
            prototype.hasAttribute = function hasAttribute(name) {
                return this.getAttribute(name) !== null;
            };
            // Apply Element prototype to the pre-existing DOM as soon as the body element appears.
            function bodyCheck() {
                if (!loopLimit--) clearTimeout(interval);
                if (document.body && !document.body.prototype && /(complete|interactive)/.test(document.readyState)) {
                    shiv(document, true);
                    if (interval && document.body.prototype) clearTimeout(interval);
                    return !!document.body.prototype;
                }
                return false;
            }
            if (!bodyCheck()) {
                document.onreadystatechange = bodyCheck;
                interval = setInterval(bodyCheck, 25);
            }
            // Apply to any new elements created after load
            document.createElement = function createElement(nodeName) {
                var element = nativeCreateElement(String(nodeName).toLowerCase());
                return shiv(element);
            };
            // remove sandboxed iframe
            document.removeChild(vbody);
        })();
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Event/detect.js
        var detect = function(global1) {
            if (!('Event' in global1)) return false;
            if (typeof global1.Event === 'function') return true;
            try {
                // In IE 9-11, the Event object exists but cannot be instantiated
                new Event('click');
                return true;
            } catch (e) {
                return false;
            }
        }(this);
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Event&flags=always
        (function() {
            var unlistenableWindowEvents = {
                click: 1,
                dblclick: 1,
                keyup: 1,
                keypress: 1,
                keydown: 1,
                mousedown: 1,
                mouseup: 1,
                mousemove: 1,
                mouseover: 1,
                mouseenter: 1,
                mouseleave: 1,
                mouseout: 1,
                storage: 1,
                storagecommit: 1,
                textinput: 1
            };
            // This polyfill depends on availability of `document` so will not run in a worker
            // However, we asssume there are no browsers with worker support that lack proper
            // support for `Event` within the worker
            if (typeof document === 'undefined' || typeof window === 'undefined') return;
            function indexOf(array, element) {
                var index = -1, length = array.length;
                while(++index < length){
                    if (index in array && array[index] === element) return index;
                }
                return -1;
            }
            var existingProto = window.Event && window.Event.prototype || null;
            window.Event = Window.prototype.Event = function Event1(type, eventInitDict) {
                if (!type) throw new Error('Not enough arguments');
                var event;
                // Shortcut if browser supports createEvent
                if ('createEvent' in document) {
                    event = document.createEvent('Event');
                    var bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
                    var cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;
                    event.initEvent(type, bubbles, cancelable);
                    return event;
                }
                event = document.createEventObject();
                event.type = type;
                event.bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
                event.cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;
                return event;
            };
            if (existingProto) Object.defineProperty(window.Event, 'prototype', {
                configurable: false,
                enumerable: false,
                writable: true,
                value: existingProto
            });
            if (!('createEvent' in document)) {
                window.addEventListener = Window.prototype.addEventListener = Document.prototype.addEventListener = Element.prototype.addEventListener = function addEventListener() {
                    var element = this, type = arguments[0], listener = arguments[1];
                    if (element === window && type in unlistenableWindowEvents) throw new Error('In IE8 the event: ' + type + ' is not available on the window object. Please see https://github.com/Financial-Times/polyfill-service/issues/317 for more information.');
                    if (!element._events) element._events = {};
                    if (!element._events[type]) {
                        element._events[type] = function(event) {
                            var list = element._events[event.type].list, events = list.slice(), index = -1, length = events.length, eventElement;
                            event.preventDefault = function preventDefault() {
                                if (event.cancelable !== false) event.returnValue = false;
                            };
                            event.stopPropagation = function stopPropagation() {
                                event.cancelBubble = true;
                            };
                            event.stopImmediatePropagation = function stopImmediatePropagation() {
                                event.cancelBubble = true;
                                event.cancelImmediate = true;
                            };
                            event.currentTarget = element;
                            event.relatedTarget = event.fromElement || null;
                            event.target = event.target || event.srcElement || element;
                            event.timeStamp = new Date().getTime();
                            if (event.clientX) {
                                event.pageX = event.clientX + document.documentElement.scrollLeft;
                                event.pageY = event.clientY + document.documentElement.scrollTop;
                            }
                            while(++index < length && !event.cancelImmediate)if (index in events) {
                                eventElement = events[index];
                                if (indexOf(list, eventElement) !== -1 && typeof eventElement === 'function') eventElement.call(element, event);
                            }
                        };
                        element._events[type].list = [];
                        if (element.attachEvent) element.attachEvent('on' + type, element._events[type]);
                    }
                    element._events[type].list.push(listener);
                };
                window.removeEventListener = Window.prototype.removeEventListener = Document.prototype.removeEventListener = Element.prototype.removeEventListener = function removeEventListener() {
                    var element = this, type = arguments[0], listener = arguments[1], index;
                    if (element._events && element._events[type] && element._events[type].list) {
                        index = indexOf(element._events[type].list, listener);
                        if (index !== -1) {
                            element._events[type].list.splice(index, 1);
                            if (!element._events[type].list.length) {
                                if (element.detachEvent) element.detachEvent('on' + type, element._events[type]);
                                delete element._events[type];
                            }
                        }
                    }
                };
                window.dispatchEvent = Window.prototype.dispatchEvent = Document.prototype.dispatchEvent = Element.prototype.dispatchEvent = function dispatchEvent(event) {
                    if (!arguments.length) throw new Error('Not enough arguments');
                    if (!event || typeof event.type !== 'string') throw new Error('DOM Events Exception 0');
                    var element = this, type = event.type;
                    try {
                        if (!event.bubbles) {
                            event.cancelBubble = true;
                            var cancelBubbleEvent = function(event) {
                                event.cancelBubble = true;
                                (element || window).detachEvent('on' + type, cancelBubbleEvent);
                            };
                            this.attachEvent('on' + type, cancelBubbleEvent);
                        }
                        this.fireEvent('on' + type, event);
                    } catch (error) {
                        event.target = element;
                        do {
                            event.currentTarget = element;
                            if ('_events' in element && typeof element._events[type] === 'function') element._events[type].call(element, event);
                            if (typeof element['on' + type] === 'function') element['on' + type].call(element, event);
                            element = element.nodeType === 9 ? element.parentWindow : element.parentNode;
                        }while (element && !event.cancelBubble);
                    }
                    return true;
                };
                // Add the DOMContentLoaded Event
                document.attachEvent('onreadystatechange', function() {
                    if (document.readyState === 'complete') document.dispatchEvent(new Event('DOMContentLoaded', {
                        bubbles: true
                    }));
                });
            }
        })();
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    /**
 * TODO: Ideally this would be a NodeList.prototype.forEach polyfill
 * This seems to fail in IE8, requires more investigation.
 * See: https://github.com/imagitama/nodelist-foreach-polyfill
 */ // Used to generate a unique string, allows multiple instances of the component without
    // Them conflicting with each other.
    // https://stackoverflow.com/a/8809472
    function generateUniqueID() {
        var d = new Date().getTime();
        if (typeof window.performance !== 'undefined' && typeof window.performance.now === 'function') d += window.performance.now(); // use high-precision timer if available
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
        });
    }
    /**
 * JavaScript 'polyfill' for HTML5's <details> and <summary> elements
 * and 'shim' to add accessiblity enhancements for all browsers
 *
 * http://caniuse.com/#feat=details
 */ var KEY_ENTER = 13;
    var KEY_SPACE = 32;
    function Details($module) {
        this.$module = $module;
    }
    Details.prototype.init = function() {
        if (!this.$module) return;
        // If there is native details support, we want to avoid running code to polyfill native behaviour.
        var hasNativeDetails = typeof this.$module.open === 'boolean';
        if (hasNativeDetails) return;
        this.polyfillDetails();
    };
    Details.prototype.polyfillDetails = function() {
        var $module = this.$module;
        // Save shortcuts to the inner summary and content elements
        var $summary = this.$summary = $module.getElementsByTagName('summary').item(0);
        var $content = this.$content = $module.getElementsByTagName('div').item(0);
        // If <details> doesn't have a <summary> and a <div> representing the content
        // it means the required HTML structure is not met so the script will stop
        if (!$summary || !$content) return;
        // If the content doesn't have an ID, assign it one now
        // which we'll need for the summary's aria-controls assignment
        if (!$content.id) $content.id = 'details-content-' + generateUniqueID();
        // Add ARIA role="group" to details
        $module.setAttribute('role', 'group');
        // Add role=button to summary
        $summary.setAttribute('role', 'button');
        // Add aria-controls
        $summary.setAttribute('aria-controls', $content.id);
        // Set tabIndex so the summary is keyboard accessible for non-native elements
        //
        // We have to use the camelcase `tabIndex` property as there is a bug in IE6/IE7 when we set the correct attribute lowercase:
        // See http://web.archive.org/web/20170120194036/http://www.saliences.com/browserBugs/tabIndex.html for more information.
        $summary.tabIndex = 0;
        // Detect initial open state
        var openAttr = $module.getAttribute('open') !== null;
        if (openAttr === true) {
            $summary.setAttribute('aria-expanded', 'true');
            $content.setAttribute('aria-hidden', 'false');
        } else {
            $summary.setAttribute('aria-expanded', 'false');
            $content.setAttribute('aria-hidden', 'true');
            $content.style.display = 'none';
        }
        // Bind an event to handle summary elements
        this.polyfillHandleInputs($summary, this.polyfillSetAttributes.bind(this));
    };
    /**
* Define a statechange function that updates aria-expanded and style.display
* @param {object} summary element
*/ Details.prototype.polyfillSetAttributes = function() {
        var $module = this.$module;
        var $summary = this.$summary;
        var $content = this.$content;
        var expanded = $summary.getAttribute('aria-expanded') === 'true';
        var hidden = $content.getAttribute('aria-hidden') === 'true';
        $summary.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        $content.setAttribute('aria-hidden', hidden ? 'false' : 'true');
        $content.style.display = expanded ? 'none' : '';
        var hasOpenAttr = $module.getAttribute('open') !== null;
        if (!hasOpenAttr) $module.setAttribute('open', 'open');
        else $module.removeAttribute('open');
        return true;
    };
    /**
* Handle cross-modal click events
* @param {object} node element
* @param {function} callback function
*/ Details.prototype.polyfillHandleInputs = function(node, callback) {
        node.addEventListener('keypress', function(event) {
            var target = event.target;
            // When the key gets pressed - check if it is enter or space
            if (event.keyCode === KEY_ENTER || event.keyCode === KEY_SPACE) {
                if (target.nodeName.toLowerCase() === 'summary') {
                    // Prevent space from scrolling the page
                    // and enter from submitting a form
                    event.preventDefault();
                    // Click to let the click event do all the necessary action
                    if (target.click) target.click();
                    else // except Safari 5.1 and under don't support .click() here
                    callback(event);
                }
            }
        });
        // Prevent keyup to prevent clicking twice in Firefox when using space key
        node.addEventListener('keyup', function(event) {
            var target = event.target;
            if (event.keyCode === KEY_SPACE) {
                if (target.nodeName.toLowerCase() === 'summary') event.preventDefault();
            }
        });
        node.addEventListener('click', callback);
    };
    return Details;
});


var $f1ae81c0f993c217$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($0d6736ebbb866c9c$exports)));


var $c93410a392caa9db$exports = {};
(function(global1, factory) {
    $c93410a392caa9db$exports = factory();
})($c93410a392caa9db$exports, function() {
    'use strict';
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Object/defineProperty/detect.js
        var detect = // In IE8, defineProperty could only act on DOM elements, so full support
        // for the feature requires the ability to set a property on an arbitrary object
        'defineProperty' in Object && function() {
            try {
                var a = {};
                Object.defineProperty(a, 'test', {
                    value: 42
                });
                return true;
            } catch (e) {
                return false;
            }
        }();
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Object.defineProperty&flags=always
        (function(nativeDefineProperty) {
            var supportsAccessors = Object.prototype.hasOwnProperty('__defineGetter__');
            var ERR_ACCESSORS_NOT_SUPPORTED = 'Getters & setters cannot be defined on this javascript engine';
            var ERR_VALUE_ACCESSORS = 'A property cannot both have accessors and be writable or have a value';
            Object.defineProperty = function defineProperty(object, property, descriptor) {
                // Where native support exists, assume it
                if (nativeDefineProperty && (object === window || object === document || object === Element.prototype || object instanceof Element)) return nativeDefineProperty(object, property, descriptor);
                if (object === null || !(object instanceof Object || typeof object === 'object')) throw new TypeError('Object.defineProperty called on non-object');
                if (!(descriptor instanceof Object)) throw new TypeError('Property description must be an object');
                var propertyString = String(property);
                var hasValueOrWritable = 'value' in descriptor || 'writable' in descriptor;
                var getterType = 'get' in descriptor && typeof descriptor.get;
                var setterType = 'set' in descriptor && typeof descriptor.set;
                // handle descriptor.get
                if (getterType) {
                    if (getterType !== 'function') throw new TypeError('Getter must be a function');
                    if (!supportsAccessors) throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
                    if (hasValueOrWritable) throw new TypeError(ERR_VALUE_ACCESSORS);
                    Object.__defineGetter__.call(object, propertyString, descriptor.get);
                } else object[propertyString] = descriptor.value;
                // handle descriptor.set
                if (setterType) {
                    if (setterType !== 'function') throw new TypeError('Setter must be a function');
                    if (!supportsAccessors) throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
                    if (hasValueOrWritable) throw new TypeError(ERR_VALUE_ACCESSORS);
                    Object.__defineSetter__.call(object, propertyString, descriptor.set);
                }
                // OK to define value unconditionally - if a getter has been specified as well, an error would be thrown above
                if ('value' in descriptor) object[propertyString] = descriptor.value;
                return object;
            };
        })(Object.defineProperty);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Function/prototype/bind/detect.js
        var detect = 'bind' in Function.prototype;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Function.prototype.bind&flags=always
        Object.defineProperty(Function.prototype, 'bind', {
            value: function bind(that) {
                // add necessary es5-shim utilities
                var $Array = Array;
                var $Object = Object;
                var ObjectPrototype = $Object.prototype;
                var ArrayPrototype = $Array.prototype;
                var Empty = function Empty() {};
                var to_string = ObjectPrototype.toString;
                var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
                var isCallable; /* inlined from https://npmjs.com/is-callable */ 
                var fnToStr = Function.prototype.toString, tryFunctionObject = function tryFunctionObject(value) {
                    try {
                        fnToStr.call(value);
                        return true;
                    } catch (e) {
                        return false;
                    }
                }, fnClass = '[object Function]', genClass = '[object GeneratorFunction]';
                isCallable = function isCallable(value) {
                    if (typeof value !== 'function') return false;
                    if (hasToStringTag) return tryFunctionObject(value);
                    var strClass = to_string.call(value);
                    return strClass === fnClass || strClass === genClass;
                };
                var array_slice = ArrayPrototype.slice;
                var array_concat = ArrayPrototype.concat;
                var array_push = ArrayPrototype.push;
                var max = Math.max;
                // /add necessary es5-shim utilities
                // 1. Let Target be the this value.
                var target = this;
                // 2. If IsCallable(Target) is false, throw a TypeError exception.
                if (!isCallable(target)) throw new TypeError('Function.prototype.bind called on incompatible ' + target);
                // 3. Let A be a new (possibly empty) internal list of all of the
                //   argument values provided after thisArg (arg1, arg2 etc), in order.
                // XXX slicedArgs will stand in for "A" if used
                var args = array_slice.call(arguments, 1); // for normal call
                // 4. Let F be a new native ECMAScript object.
                // 11. Set the [[Prototype]] internal property of F to the standard
                //   built-in Function prototype object as specified in 15.3.3.1.
                // 12. Set the [[Call]] internal property of F as described in
                //   15.3.4.5.1.
                // 13. Set the [[Construct]] internal property of F as described in
                //   15.3.4.5.2.
                // 14. Set the [[HasInstance]] internal property of F as described in
                //   15.3.4.5.3.
                var bound;
                var binder = function() {
                    if (this instanceof bound) {
                        // 15.3.4.5.2 [[Construct]]
                        // When the [[Construct]] internal method of a function object,
                        // F that was created using the bind function is called with a
                        // list of arguments ExtraArgs, the following steps are taken:
                        // 1. Let target be the value of F's [[TargetFunction]]
                        //   internal property.
                        // 2. If target has no [[Construct]] internal method, a
                        //   TypeError exception is thrown.
                        // 3. Let boundArgs be the value of F's [[BoundArgs]] internal
                        //   property.
                        // 4. Let args be a new list containing the same values as the
                        //   list boundArgs in the same order followed by the same
                        //   values as the list ExtraArgs in the same order.
                        // 5. Return the result of calling the [[Construct]] internal
                        //   method of target providing args as the arguments.
                        var result = target.apply(this, array_concat.call(args, array_slice.call(arguments)));
                        if ($Object(result) === result) return result;
                        return this;
                    } else // 15.3.4.5.1 [[Call]]
                    // When the [[Call]] internal method of a function object, F,
                    // which was created using the bind function is called with a
                    // this value and a list of arguments ExtraArgs, the following
                    // steps are taken:
                    // 1. Let boundArgs be the value of F's [[BoundArgs]] internal
                    //   property.
                    // 2. Let boundThis be the value of F's [[BoundThis]] internal
                    //   property.
                    // 3. Let target be the value of F's [[TargetFunction]] internal
                    //   property.
                    // 4. Let args be a new list containing the same values as the
                    //   list boundArgs in the same order followed by the same
                    //   values as the list ExtraArgs in the same order.
                    // 5. Return the result of calling the [[Call]] internal method
                    //   of target providing boundThis as the this value and
                    //   providing args as the arguments.
                    // equiv: target.call(this, ...boundArgs, ...args)
                    return target.apply(that, array_concat.call(args, array_slice.call(arguments)));
                };
                // 15. If the [[Class]] internal property of Target is "Function", then
                //     a. Let L be the length property of Target minus the length of A.
                //     b. Set the length own property of F to either 0 or L, whichever is
                //       larger.
                // 16. Else set the length own property of F to 0.
                var boundLength = max(0, target.length - args.length);
                // 17. Set the attributes of the length own property of F to the values
                //   specified in 15.3.5.1.
                var boundArgs = [];
                for(var i = 0; i < boundLength; i++)array_push.call(boundArgs, '$' + i);
                // XXX Build a dynamic function with desired amount of arguments is the only
                // way to set the length property of a function.
                // In environments where Content Security Policies enabled (Chrome extensions,
                // for ex.) all use of eval or Function costructor throws an exception.
                // However in all of these environments Function.prototype.bind exists
                // and so this code will never be executed.
                bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this, arguments); }')(binder);
                if (target.prototype) {
                    Empty.prototype = target.prototype;
                    bound.prototype = new Empty();
                    // Clean up dangling references.
                    Empty.prototype = null;
                }
                // TODO
                // 18. Set the [[Extensible]] internal property of F to true.
                // TODO
                // 19. Let thrower be the [[ThrowTypeError]] function Object (13.2.3).
                // 20. Call the [[DefineOwnProperty]] internal method of F with
                //   arguments "caller", PropertyDescriptor {[[Get]]: thrower, [[Set]]:
                //   thrower, [[Enumerable]]: false, [[Configurable]]: false}, and
                //   false.
                // 21. Call the [[DefineOwnProperty]] internal method of F with
                //   arguments "arguments", PropertyDescriptor {[[Get]]: thrower,
                //   [[Set]]: thrower, [[Enumerable]]: false, [[Configurable]]: false},
                //   and false.
                // TODO
                // NOTE Function objects created using Function.prototype.bind do not
                // have a prototype property or the [[Code]], [[FormalParameters]], and
                // [[Scope]] internal properties.
                // XXX can't delete prototype in pure-js.
                // 22. Return F.
                return bound;
            }
        });
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Window/detect.js
        var detect = 'Window' in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Window&flags=always
        if (typeof WorkerGlobalScope === "undefined" && typeof importScripts !== "function") (function(global1) {
            if (global1.constructor) global1.Window = global1.constructor;
            else (global1.Window = global1.constructor = new Function('return function Window() {}')()).prototype = this;
        })(this);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Document/detect.js
        var detect = "Document" in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Document&flags=always
        if (typeof WorkerGlobalScope === "undefined" && typeof importScripts !== "function") {
            if (this.HTMLDocument) // HTMLDocument is an extension of Document.  If the browser has HTMLDocument but not Document, the former will suffice as an alias for the latter.
            this.Document = this.HTMLDocument;
            else {
                // Create an empty function to act as the missing constructor for the document object, attach the document object as its prototype.  The function needs to be anonymous else it is hoisted and causes the feature detect to prematurely pass, preventing the assignments below being made.
                this.Document = this.HTMLDocument = document.constructor = new Function('return function Document() {}')();
                this.Document.prototype = document;
            }
        }
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Element/detect.js
        var detect = 'Element' in this && 'HTMLElement' in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Element&flags=always
        (function() {
            // IE8
            if (window.Element && !window.HTMLElement) {
                window.HTMLElement = window.Element;
                return;
            }
            // create Element constructor
            window.Element = window.HTMLElement = new Function('return function Element() {}')();
            // generate sandboxed iframe
            var vbody = document.appendChild(document.createElement('body'));
            var frame = vbody.appendChild(document.createElement('iframe'));
            // use sandboxed iframe to replicate Element functionality
            var frameDocument = frame.contentWindow.document;
            var prototype = Element.prototype = frameDocument.appendChild(frameDocument.createElement('*'));
            var cache = {};
            // polyfill Element.prototype on an element
            var shiv = function(element, deep) {
                var childNodes = element.childNodes || [], index = -1, key, value, childNode;
                if (element.nodeType === 1 && element.constructor !== Element) {
                    element.constructor = Element;
                    for(key in cache){
                        value = cache[key];
                        element[key] = value;
                    }
                }
                while(childNode = deep && childNodes[++index])shiv(childNode, deep);
                return element;
            };
            var elements = document.getElementsByTagName('*');
            var nativeCreateElement = document.createElement;
            var interval;
            var loopLimit = 100;
            prototype.attachEvent('onpropertychange', function(event) {
                var propertyName = event.propertyName, nonValue = !cache.hasOwnProperty(propertyName), newValue = prototype[propertyName], oldValue = cache[propertyName], index = -1, element;
                while(element = elements[++index]){
                    if (element.nodeType === 1) {
                        if (nonValue || element[propertyName] === oldValue) element[propertyName] = newValue;
                    }
                }
                cache[propertyName] = newValue;
            });
            prototype.constructor = Element;
            if (!prototype.hasAttribute) // <Element>.hasAttribute
            prototype.hasAttribute = function hasAttribute(name) {
                return this.getAttribute(name) !== null;
            };
            // Apply Element prototype to the pre-existing DOM as soon as the body element appears.
            function bodyCheck() {
                if (!loopLimit--) clearTimeout(interval);
                if (document.body && !document.body.prototype && /(complete|interactive)/.test(document.readyState)) {
                    shiv(document, true);
                    if (interval && document.body.prototype) clearTimeout(interval);
                    return !!document.body.prototype;
                }
                return false;
            }
            if (!bodyCheck()) {
                document.onreadystatechange = bodyCheck;
                interval = setInterval(bodyCheck, 25);
            }
            // Apply to any new elements created after load
            document.createElement = function createElement(nodeName) {
                var element = nativeCreateElement(String(nodeName).toLowerCase());
                return shiv(element);
            };
            // remove sandboxed iframe
            document.removeChild(vbody);
        })();
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Event/detect.js
        var detect = function(global1) {
            if (!('Event' in global1)) return false;
            if (typeof global1.Event === 'function') return true;
            try {
                // In IE 9-11, the Event object exists but cannot be instantiated
                new Event('click');
                return true;
            } catch (e) {
                return false;
            }
        }(this);
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Event&flags=always
        (function() {
            var unlistenableWindowEvents = {
                click: 1,
                dblclick: 1,
                keyup: 1,
                keypress: 1,
                keydown: 1,
                mousedown: 1,
                mouseup: 1,
                mousemove: 1,
                mouseover: 1,
                mouseenter: 1,
                mouseleave: 1,
                mouseout: 1,
                storage: 1,
                storagecommit: 1,
                textinput: 1
            };
            // This polyfill depends on availability of `document` so will not run in a worker
            // However, we asssume there are no browsers with worker support that lack proper
            // support for `Event` within the worker
            if (typeof document === 'undefined' || typeof window === 'undefined') return;
            function indexOf(array, element) {
                var index = -1, length = array.length;
                while(++index < length){
                    if (index in array && array[index] === element) return index;
                }
                return -1;
            }
            var existingProto = window.Event && window.Event.prototype || null;
            window.Event = Window.prototype.Event = function Event1(type, eventInitDict) {
                if (!type) throw new Error('Not enough arguments');
                var event;
                // Shortcut if browser supports createEvent
                if ('createEvent' in document) {
                    event = document.createEvent('Event');
                    var bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
                    var cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;
                    event.initEvent(type, bubbles, cancelable);
                    return event;
                }
                event = document.createEventObject();
                event.type = type;
                event.bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
                event.cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;
                return event;
            };
            if (existingProto) Object.defineProperty(window.Event, 'prototype', {
                configurable: false,
                enumerable: false,
                writable: true,
                value: existingProto
            });
            if (!('createEvent' in document)) {
                window.addEventListener = Window.prototype.addEventListener = Document.prototype.addEventListener = Element.prototype.addEventListener = function addEventListener() {
                    var element = this, type = arguments[0], listener = arguments[1];
                    if (element === window && type in unlistenableWindowEvents) throw new Error('In IE8 the event: ' + type + ' is not available on the window object. Please see https://github.com/Financial-Times/polyfill-service/issues/317 for more information.');
                    if (!element._events) element._events = {};
                    if (!element._events[type]) {
                        element._events[type] = function(event) {
                            var list = element._events[event.type].list, events = list.slice(), index = -1, length = events.length, eventElement;
                            event.preventDefault = function preventDefault() {
                                if (event.cancelable !== false) event.returnValue = false;
                            };
                            event.stopPropagation = function stopPropagation() {
                                event.cancelBubble = true;
                            };
                            event.stopImmediatePropagation = function stopImmediatePropagation() {
                                event.cancelBubble = true;
                                event.cancelImmediate = true;
                            };
                            event.currentTarget = element;
                            event.relatedTarget = event.fromElement || null;
                            event.target = event.target || event.srcElement || element;
                            event.timeStamp = new Date().getTime();
                            if (event.clientX) {
                                event.pageX = event.clientX + document.documentElement.scrollLeft;
                                event.pageY = event.clientY + document.documentElement.scrollTop;
                            }
                            while(++index < length && !event.cancelImmediate)if (index in events) {
                                eventElement = events[index];
                                if (indexOf(list, eventElement) !== -1 && typeof eventElement === 'function') eventElement.call(element, event);
                            }
                        };
                        element._events[type].list = [];
                        if (element.attachEvent) element.attachEvent('on' + type, element._events[type]);
                    }
                    element._events[type].list.push(listener);
                };
                window.removeEventListener = Window.prototype.removeEventListener = Document.prototype.removeEventListener = Element.prototype.removeEventListener = function removeEventListener() {
                    var element = this, type = arguments[0], listener = arguments[1], index;
                    if (element._events && element._events[type] && element._events[type].list) {
                        index = indexOf(element._events[type].list, listener);
                        if (index !== -1) {
                            element._events[type].list.splice(index, 1);
                            if (!element._events[type].list.length) {
                                if (element.detachEvent) element.detachEvent('on' + type, element._events[type]);
                                delete element._events[type];
                            }
                        }
                    }
                };
                window.dispatchEvent = Window.prototype.dispatchEvent = Document.prototype.dispatchEvent = Element.prototype.dispatchEvent = function dispatchEvent(event) {
                    if (!arguments.length) throw new Error('Not enough arguments');
                    if (!event || typeof event.type !== 'string') throw new Error('DOM Events Exception 0');
                    var element = this, type = event.type;
                    try {
                        if (!event.bubbles) {
                            event.cancelBubble = true;
                            var cancelBubbleEvent = function(event) {
                                event.cancelBubble = true;
                                (element || window).detachEvent('on' + type, cancelBubbleEvent);
                            };
                            this.attachEvent('on' + type, cancelBubbleEvent);
                        }
                        this.fireEvent('on' + type, event);
                    } catch (error) {
                        event.target = element;
                        do {
                            event.currentTarget = element;
                            if ('_events' in element && typeof element._events[type] === 'function') element._events[type].call(element, event);
                            if (typeof element['on' + type] === 'function') element['on' + type].call(element, event);
                            element = element.nodeType === 9 ? element.parentWindow : element.parentNode;
                        }while (element && !event.cancelBubble);
                    }
                    return true;
                };
                // Add the DOMContentLoaded Event
                document.attachEvent('onreadystatechange', function() {
                    if (document.readyState === 'complete') document.dispatchEvent(new Event('DOMContentLoaded', {
                        bubbles: true
                    }));
                });
            }
        })();
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-service/1f3c09b402f65bf6e393f933a15ba63f1b86ef1f/packages/polyfill-library/polyfills/Element/prototype/matches/detect.js
        var detect = 'document' in this && "matches" in document.documentElement;
        if (detect) return;
        // Polyfill from https://raw.githubusercontent.com/Financial-Times/polyfill-service/1f3c09b402f65bf6e393f933a15ba63f1b86ef1f/packages/polyfill-library/polyfills/Element/prototype/matches/polyfill.js
        Element.prototype.matches = Element.prototype.webkitMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.mozMatchesSelector || function matches(selector) {
            var element = this;
            var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
            var index = 0;
            while(elements[index] && elements[index] !== element)++index;
            return !!elements[index];
        };
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-service/1f3c09b402f65bf6e393f933a15ba63f1b86ef1f/packages/polyfill-library/polyfills/Element/prototype/closest/detect.js
        var detect = 'document' in this && "closest" in document.documentElement;
        if (detect) return;
        // Polyfill from https://raw.githubusercontent.com/Financial-Times/polyfill-service/1f3c09b402f65bf6e393f933a15ba63f1b86ef1f/packages/polyfill-library/polyfills/Element/prototype/closest/polyfill.js
        Element.prototype.closest = function closest(selector) {
            var node = this;
            while(node){
                if (node.matches(selector)) return node;
                else node = 'SVGElement' in window && node instanceof SVGElement ? node.parentNode : node.parentElement;
            }
            return null;
        };
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    function ErrorSummary($module) {
        this.$module = $module;
    }
    ErrorSummary.prototype.init = function() {
        var $module = this.$module;
        if (!$module) return;
        $module.focus();
        $module.addEventListener('click', this.handleClick.bind(this));
    };
    /**
* Click event handler
*
* @param {MouseEvent} event - Click event
*/ ErrorSummary.prototype.handleClick = function(event) {
        var target = event.target;
        if (this.focusTarget(target)) event.preventDefault();
    };
    /**
 * Focus the target element
 *
 * By default, the browser will scroll the target into view. Because our labels
 * or legends appear above the input, this means the user will be presented with
 * an input without any context, as the label or legend will be off the top of
 * the screen.
 *
 * Manually handling the click event, scrolling the question into view and then
 * focussing the element solves this.
 *
 * This also results in the label and/or legend being announced correctly in
 * NVDA (as tested in 2018.3.2) - without this only the field type is announced
 * (e.g. "Edit, has autocomplete").
 *
 * @param {HTMLElement} $target - Event target
 * @returns {boolean} True if the target was able to be focussed
 */ ErrorSummary.prototype.focusTarget = function($target) {
        // If the element that was clicked was not a link, return early
        if ($target.tagName !== 'A' || $target.href === false) return false;
        var inputId = this.getFragmentFromUrl($target.href);
        var $input = document.getElementById(inputId);
        if (!$input) return false;
        var $legendOrLabel = this.getAssociatedLegendOrLabel($input);
        if (!$legendOrLabel) return false;
        // Scroll the legend or label into view *before* calling focus on the input to
        // avoid extra scrolling in browsers that don't support `preventScroll` (which
        // at time of writing is most of them...)
        $legendOrLabel.scrollIntoView();
        $input.focus({
            preventScroll: true
        });
        return true;
    };
    /**
 * Get fragment from URL
 *
 * Extract the fragment (everything after the hash) from a URL, but not including
 * the hash.
 *
 * @param {string} url - URL
 * @returns {string} Fragment from URL, without the hash
 */ ErrorSummary.prototype.getFragmentFromUrl = function(url) {
        if (url.indexOf('#') === -1) return false;
        return url.split('#').pop();
    };
    /**
 * Get associated legend or label
 *
 * Returns the first element that exists from this list:
 *
 * - The `<legend>` associated with the closest `<fieldset>` ancestor, as long
 *   as the top of it is no more than half a viewport height away from the
 *   bottom of the input
 * - The first `<label>` that is associated with the input using for="inputId"
 * - The closest parent `<label>`
 *
 * @param {HTMLElement} $input - The input
 * @returns {HTMLElement} Associated legend or label, or null if no associated
 *                        legend or label can be found
 */ ErrorSummary.prototype.getAssociatedLegendOrLabel = function($input) {
        var $fieldset = $input.closest('fieldset');
        if ($fieldset) {
            var legends = $fieldset.getElementsByTagName('legend');
            if (legends.length) {
                var $candidateLegend = legends[0];
                // If the input type is radio or checkbox, always use the legend if there
                // is one.
                if ($input.type === 'checkbox' || $input.type === 'radio') return $candidateLegend;
                // For other input types, only scroll to the fieldset’s legend (instead of
                // the label associated with the input) if the input would end up in the
                // top half of the screen.
                //
                // This should avoid situations where the input either ends up off the
                // screen, or obscured by a software keyboard.
                var legendTop = $candidateLegend.getBoundingClientRect().top;
                var inputRect = $input.getBoundingClientRect();
                // If the browser doesn't support Element.getBoundingClientRect().height
                // or window.innerHeight (like IE8), bail and just link to the label.
                if (inputRect.height && window.innerHeight) {
                    var inputBottom = inputRect.top + inputRect.height;
                    if (inputBottom - legendTop < window.innerHeight / 2) return $candidateLegend;
                }
            }
        }
        return document.querySelector("label[for='" + $input.getAttribute('id') + "']") || $input.closest('label');
    };
    return ErrorSummary;
});


var $45f8a1b841892427$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c93410a392caa9db$exports)));


/* global L */ window.L = window.L || {};
if (L !== {}) {
    var $8040fecc34f37497$var$map = L.map;
    var $8040fecc34f37497$var$control = L.control;
    var $8040fecc34f37497$var$tileLayer = L.tileLayer;
    var $8040fecc34f37497$var$icon = L.icon;
    var $8040fecc34f37497$var$marker = L.marker;
}
function $8040fecc34f37497$var$Map($module) {
    this.$module = $module;
    this.moduleId = this.$module.getAttribute("id");
    this.accessToken = this.$module.getAttribute("data-access-token");
    this.map = null;
    this.markerLat = this.$module.getAttribute("data-marker-lat") || null;
    this.markerLng = this.$module.getAttribute("data-marker-lng") || null;
    this.centreLat = this.$module.getAttribute("data-centre-lat") || this.markerLat || 51.549;
    this.centreLng = this.$module.getAttribute("data-centre-lng") || this.markerLng || -0.077928;
    this.maxZoom = this.$module.getAttribute("data-max-zoom") || 19;
    this.minZoom = this.$module.getAttribute("data-min-zoom") || 12;
    this.initialZoom = this.$module.getAttribute("data-initial-zoom") || 15;
    this.showZoomControl = this.$module.getAttribute("data-show-zoom-control") || true;
    this.minLat = this.$module.getAttribute("data-min-lat") || 51.491112;
    this.minLng = this.$module.getAttribute("data-min-lng") || -0.275464;
    this.maxLat = this.$module.getAttribute("data-max-lat") || 51.607351;
    this.maxLng = this.$module.getAttribute("data-max-lng") || 0.096129;
}
$8040fecc34f37497$var$Map.prototype.initLeaflet = function() {
    this.map = $8040fecc34f37497$var$map(this.moduleId, {
        zoomControl: false,
        maxZoom: this.maxZoom,
        minZoom: this.minZoom,
        center: [
            this.centreLat,
            this.centreLng
        ],
        zoom: this.initialZoom
    });
    if (this.showZoomControl) $8040fecc34f37497$var$control.zoom({
        position: "topright"
    }).addTo(this.map);
};
$8040fecc34f37497$var$Map.prototype.setBounds = function() {
    // Limit the view to the extend of the map
    this.map.setMaxBounds([
        [
            this.minLat,
            this.minLng
        ],
        [
            this.maxLat,
            this.maxLng
        ]
    ]);
};
$8040fecc34f37497$var$Map.prototype.initMapboxTiles = function() {
    var osmStreet = $8040fecc34f37497$var$tileLayer("https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}", {
        fadeAnimation: false,
        opacity: 1,
        attribution: 'Map data &copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery \xa9 <a href="https://mapbox.com">Mapbox</a>',
        maxZoom: this.maxZoom,
        id: "mapbox.streets",
        accessToken: this.accessToken
    });
    this.map.addLayer(osmStreet);
};
$8040fecc34f37497$var$Map.prototype.addMarker = function() {
    if (this.markerLat !== null && this.markerLng !== null) {
        var mapIcon = $8040fecc34f37497$var$icon({
            iconUrl: "../../../assets/images/contact/map-marker.svg",
            iconSize: [
                48,
                48
            ],
            iconAnchor: [
                24,
                48
            ]
        });
        $8040fecc34f37497$var$marker([
            this.markerLat,
            this.markerLng
        ], {
            icon: mapIcon
        }).addTo(this.map);
    }
};
$8040fecc34f37497$var$Map.prototype.init = function() {
    // Check for module
    if (!this.$module || L == {}) return;
    this.initLeaflet();
    this.setBounds();
    this.initMapboxTiles();
    this.addMarker();
};
var $8040fecc34f37497$export$2e2bcd8739ae039 = $8040fecc34f37497$var$Map;


var $c7d5121aca823445$exports = {};
(function(global1, factory) {
    $c7d5121aca823445$exports = factory();
})($c7d5121aca823445$exports, function() {
    'use strict';
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Object/defineProperty/detect.js
        var detect = // In IE8, defineProperty could only act on DOM elements, so full support
        // for the feature requires the ability to set a property on an arbitrary object
        'defineProperty' in Object && function() {
            try {
                var a = {};
                Object.defineProperty(a, 'test', {
                    value: 42
                });
                return true;
            } catch (e) {
                return false;
            }
        }();
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Object.defineProperty&flags=always
        (function(nativeDefineProperty) {
            var supportsAccessors = Object.prototype.hasOwnProperty('__defineGetter__');
            var ERR_ACCESSORS_NOT_SUPPORTED = 'Getters & setters cannot be defined on this javascript engine';
            var ERR_VALUE_ACCESSORS = 'A property cannot both have accessors and be writable or have a value';
            Object.defineProperty = function defineProperty(object, property, descriptor) {
                // Where native support exists, assume it
                if (nativeDefineProperty && (object === window || object === document || object === Element.prototype || object instanceof Element)) return nativeDefineProperty(object, property, descriptor);
                if (object === null || !(object instanceof Object || typeof object === 'object')) throw new TypeError('Object.defineProperty called on non-object');
                if (!(descriptor instanceof Object)) throw new TypeError('Property description must be an object');
                var propertyString = String(property);
                var hasValueOrWritable = 'value' in descriptor || 'writable' in descriptor;
                var getterType = 'get' in descriptor && typeof descriptor.get;
                var setterType = 'set' in descriptor && typeof descriptor.set;
                // handle descriptor.get
                if (getterType) {
                    if (getterType !== 'function') throw new TypeError('Getter must be a function');
                    if (!supportsAccessors) throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
                    if (hasValueOrWritable) throw new TypeError(ERR_VALUE_ACCESSORS);
                    Object.__defineGetter__.call(object, propertyString, descriptor.get);
                } else object[propertyString] = descriptor.value;
                // handle descriptor.set
                if (setterType) {
                    if (setterType !== 'function') throw new TypeError('Setter must be a function');
                    if (!supportsAccessors) throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
                    if (hasValueOrWritable) throw new TypeError(ERR_VALUE_ACCESSORS);
                    Object.__defineSetter__.call(object, propertyString, descriptor.set);
                }
                // OK to define value unconditionally - if a getter has been specified as well, an error would be thrown above
                if ('value' in descriptor) object[propertyString] = descriptor.value;
                return object;
            };
        })(Object.defineProperty);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Function/prototype/bind/detect.js
        var detect = 'bind' in Function.prototype;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Function.prototype.bind&flags=always
        Object.defineProperty(Function.prototype, 'bind', {
            value: function bind(that) {
                // add necessary es5-shim utilities
                var $Array = Array;
                var $Object = Object;
                var ObjectPrototype = $Object.prototype;
                var ArrayPrototype = $Array.prototype;
                var Empty = function Empty() {};
                var to_string = ObjectPrototype.toString;
                var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
                var isCallable; /* inlined from https://npmjs.com/is-callable */ 
                var fnToStr = Function.prototype.toString, tryFunctionObject = function tryFunctionObject(value) {
                    try {
                        fnToStr.call(value);
                        return true;
                    } catch (e) {
                        return false;
                    }
                }, fnClass = '[object Function]', genClass = '[object GeneratorFunction]';
                isCallable = function isCallable(value) {
                    if (typeof value !== 'function') return false;
                    if (hasToStringTag) return tryFunctionObject(value);
                    var strClass = to_string.call(value);
                    return strClass === fnClass || strClass === genClass;
                };
                var array_slice = ArrayPrototype.slice;
                var array_concat = ArrayPrototype.concat;
                var array_push = ArrayPrototype.push;
                var max = Math.max;
                // /add necessary es5-shim utilities
                // 1. Let Target be the this value.
                var target = this;
                // 2. If IsCallable(Target) is false, throw a TypeError exception.
                if (!isCallable(target)) throw new TypeError('Function.prototype.bind called on incompatible ' + target);
                // 3. Let A be a new (possibly empty) internal list of all of the
                //   argument values provided after thisArg (arg1, arg2 etc), in order.
                // XXX slicedArgs will stand in for "A" if used
                var args = array_slice.call(arguments, 1); // for normal call
                // 4. Let F be a new native ECMAScript object.
                // 11. Set the [[Prototype]] internal property of F to the standard
                //   built-in Function prototype object as specified in 15.3.3.1.
                // 12. Set the [[Call]] internal property of F as described in
                //   15.3.4.5.1.
                // 13. Set the [[Construct]] internal property of F as described in
                //   15.3.4.5.2.
                // 14. Set the [[HasInstance]] internal property of F as described in
                //   15.3.4.5.3.
                var bound;
                var binder = function() {
                    if (this instanceof bound) {
                        // 15.3.4.5.2 [[Construct]]
                        // When the [[Construct]] internal method of a function object,
                        // F that was created using the bind function is called with a
                        // list of arguments ExtraArgs, the following steps are taken:
                        // 1. Let target be the value of F's [[TargetFunction]]
                        //   internal property.
                        // 2. If target has no [[Construct]] internal method, a
                        //   TypeError exception is thrown.
                        // 3. Let boundArgs be the value of F's [[BoundArgs]] internal
                        //   property.
                        // 4. Let args be a new list containing the same values as the
                        //   list boundArgs in the same order followed by the same
                        //   values as the list ExtraArgs in the same order.
                        // 5. Return the result of calling the [[Construct]] internal
                        //   method of target providing args as the arguments.
                        var result = target.apply(this, array_concat.call(args, array_slice.call(arguments)));
                        if ($Object(result) === result) return result;
                        return this;
                    } else // 15.3.4.5.1 [[Call]]
                    // When the [[Call]] internal method of a function object, F,
                    // which was created using the bind function is called with a
                    // this value and a list of arguments ExtraArgs, the following
                    // steps are taken:
                    // 1. Let boundArgs be the value of F's [[BoundArgs]] internal
                    //   property.
                    // 2. Let boundThis be the value of F's [[BoundThis]] internal
                    //   property.
                    // 3. Let target be the value of F's [[TargetFunction]] internal
                    //   property.
                    // 4. Let args be a new list containing the same values as the
                    //   list boundArgs in the same order followed by the same
                    //   values as the list ExtraArgs in the same order.
                    // 5. Return the result of calling the [[Call]] internal method
                    //   of target providing boundThis as the this value and
                    //   providing args as the arguments.
                    // equiv: target.call(this, ...boundArgs, ...args)
                    return target.apply(that, array_concat.call(args, array_slice.call(arguments)));
                };
                // 15. If the [[Class]] internal property of Target is "Function", then
                //     a. Let L be the length property of Target minus the length of A.
                //     b. Set the length own property of F to either 0 or L, whichever is
                //       larger.
                // 16. Else set the length own property of F to 0.
                var boundLength = max(0, target.length - args.length);
                // 17. Set the attributes of the length own property of F to the values
                //   specified in 15.3.5.1.
                var boundArgs = [];
                for(var i = 0; i < boundLength; i++)array_push.call(boundArgs, '$' + i);
                // XXX Build a dynamic function with desired amount of arguments is the only
                // way to set the length property of a function.
                // In environments where Content Security Policies enabled (Chrome extensions,
                // for ex.) all use of eval or Function costructor throws an exception.
                // However in all of these environments Function.prototype.bind exists
                // and so this code will never be executed.
                bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this, arguments); }')(binder);
                if (target.prototype) {
                    Empty.prototype = target.prototype;
                    bound.prototype = new Empty();
                    // Clean up dangling references.
                    Empty.prototype = null;
                }
                // TODO
                // 18. Set the [[Extensible]] internal property of F to true.
                // TODO
                // 19. Let thrower be the [[ThrowTypeError]] function Object (13.2.3).
                // 20. Call the [[DefineOwnProperty]] internal method of F with
                //   arguments "caller", PropertyDescriptor {[[Get]]: thrower, [[Set]]:
                //   thrower, [[Enumerable]]: false, [[Configurable]]: false}, and
                //   false.
                // 21. Call the [[DefineOwnProperty]] internal method of F with
                //   arguments "arguments", PropertyDescriptor {[[Get]]: thrower,
                //   [[Set]]: thrower, [[Enumerable]]: false, [[Configurable]]: false},
                //   and false.
                // TODO
                // NOTE Function objects created using Function.prototype.bind do not
                // have a prototype property or the [[Code]], [[FormalParameters]], and
                // [[Scope]] internal properties.
                // XXX can't delete prototype in pure-js.
                // 22. Return F.
                return bound;
            }
        });
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Window/detect.js
        var detect = 'Window' in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Window&flags=always
        if (typeof WorkerGlobalScope === "undefined" && typeof importScripts !== "function") (function(global1) {
            if (global1.constructor) global1.Window = global1.constructor;
            else (global1.Window = global1.constructor = new Function('return function Window() {}')()).prototype = this;
        })(this);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Document/detect.js
        var detect = "Document" in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Document&flags=always
        if (typeof WorkerGlobalScope === "undefined" && typeof importScripts !== "function") {
            if (this.HTMLDocument) // HTMLDocument is an extension of Document.  If the browser has HTMLDocument but not Document, the former will suffice as an alias for the latter.
            this.Document = this.HTMLDocument;
            else {
                // Create an empty function to act as the missing constructor for the document object, attach the document object as its prototype.  The function needs to be anonymous else it is hoisted and causes the feature detect to prematurely pass, preventing the assignments below being made.
                this.Document = this.HTMLDocument = document.constructor = new Function('return function Document() {}')();
                this.Document.prototype = document;
            }
        }
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Element/detect.js
        var detect = 'Element' in this && 'HTMLElement' in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Element&flags=always
        (function() {
            // IE8
            if (window.Element && !window.HTMLElement) {
                window.HTMLElement = window.Element;
                return;
            }
            // create Element constructor
            window.Element = window.HTMLElement = new Function('return function Element() {}')();
            // generate sandboxed iframe
            var vbody = document.appendChild(document.createElement('body'));
            var frame = vbody.appendChild(document.createElement('iframe'));
            // use sandboxed iframe to replicate Element functionality
            var frameDocument = frame.contentWindow.document;
            var prototype = Element.prototype = frameDocument.appendChild(frameDocument.createElement('*'));
            var cache = {};
            // polyfill Element.prototype on an element
            var shiv = function(element, deep) {
                var childNodes = element.childNodes || [], index = -1, key, value, childNode;
                if (element.nodeType === 1 && element.constructor !== Element) {
                    element.constructor = Element;
                    for(key in cache){
                        value = cache[key];
                        element[key] = value;
                    }
                }
                while(childNode = deep && childNodes[++index])shiv(childNode, deep);
                return element;
            };
            var elements = document.getElementsByTagName('*');
            var nativeCreateElement = document.createElement;
            var interval;
            var loopLimit = 100;
            prototype.attachEvent('onpropertychange', function(event) {
                var propertyName = event.propertyName, nonValue = !cache.hasOwnProperty(propertyName), newValue = prototype[propertyName], oldValue = cache[propertyName], index = -1, element;
                while(element = elements[++index]){
                    if (element.nodeType === 1) {
                        if (nonValue || element[propertyName] === oldValue) element[propertyName] = newValue;
                    }
                }
                cache[propertyName] = newValue;
            });
            prototype.constructor = Element;
            if (!prototype.hasAttribute) // <Element>.hasAttribute
            prototype.hasAttribute = function hasAttribute(name) {
                return this.getAttribute(name) !== null;
            };
            // Apply Element prototype to the pre-existing DOM as soon as the body element appears.
            function bodyCheck() {
                if (!loopLimit--) clearTimeout(interval);
                if (document.body && !document.body.prototype && /(complete|interactive)/.test(document.readyState)) {
                    shiv(document, true);
                    if (interval && document.body.prototype) clearTimeout(interval);
                    return !!document.body.prototype;
                }
                return false;
            }
            if (!bodyCheck()) {
                document.onreadystatechange = bodyCheck;
                interval = setInterval(bodyCheck, 25);
            }
            // Apply to any new elements created after load
            document.createElement = function createElement(nodeName) {
                var element = nativeCreateElement(String(nodeName).toLowerCase());
                return shiv(element);
            };
            // remove sandboxed iframe
            document.removeChild(vbody);
        })();
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Event/detect.js
        var detect = function(global1) {
            if (!('Event' in global1)) return false;
            if (typeof global1.Event === 'function') return true;
            try {
                // In IE 9-11, the Event object exists but cannot be instantiated
                new Event('click');
                return true;
            } catch (e) {
                return false;
            }
        }(this);
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Event&flags=always
        (function() {
            var unlistenableWindowEvents = {
                click: 1,
                dblclick: 1,
                keyup: 1,
                keypress: 1,
                keydown: 1,
                mousedown: 1,
                mouseup: 1,
                mousemove: 1,
                mouseover: 1,
                mouseenter: 1,
                mouseleave: 1,
                mouseout: 1,
                storage: 1,
                storagecommit: 1,
                textinput: 1
            };
            // This polyfill depends on availability of `document` so will not run in a worker
            // However, we asssume there are no browsers with worker support that lack proper
            // support for `Event` within the worker
            if (typeof document === 'undefined' || typeof window === 'undefined') return;
            function indexOf(array, element) {
                var index = -1, length = array.length;
                while(++index < length){
                    if (index in array && array[index] === element) return index;
                }
                return -1;
            }
            var existingProto = window.Event && window.Event.prototype || null;
            window.Event = Window.prototype.Event = function Event1(type, eventInitDict) {
                if (!type) throw new Error('Not enough arguments');
                var event;
                // Shortcut if browser supports createEvent
                if ('createEvent' in document) {
                    event = document.createEvent('Event');
                    var bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
                    var cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;
                    event.initEvent(type, bubbles, cancelable);
                    return event;
                }
                event = document.createEventObject();
                event.type = type;
                event.bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
                event.cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;
                return event;
            };
            if (existingProto) Object.defineProperty(window.Event, 'prototype', {
                configurable: false,
                enumerable: false,
                writable: true,
                value: existingProto
            });
            if (!('createEvent' in document)) {
                window.addEventListener = Window.prototype.addEventListener = Document.prototype.addEventListener = Element.prototype.addEventListener = function addEventListener() {
                    var element = this, type = arguments[0], listener = arguments[1];
                    if (element === window && type in unlistenableWindowEvents) throw new Error('In IE8 the event: ' + type + ' is not available on the window object. Please see https://github.com/Financial-Times/polyfill-service/issues/317 for more information.');
                    if (!element._events) element._events = {};
                    if (!element._events[type]) {
                        element._events[type] = function(event) {
                            var list = element._events[event.type].list, events = list.slice(), index = -1, length = events.length, eventElement;
                            event.preventDefault = function preventDefault() {
                                if (event.cancelable !== false) event.returnValue = false;
                            };
                            event.stopPropagation = function stopPropagation() {
                                event.cancelBubble = true;
                            };
                            event.stopImmediatePropagation = function stopImmediatePropagation() {
                                event.cancelBubble = true;
                                event.cancelImmediate = true;
                            };
                            event.currentTarget = element;
                            event.relatedTarget = event.fromElement || null;
                            event.target = event.target || event.srcElement || element;
                            event.timeStamp = new Date().getTime();
                            if (event.clientX) {
                                event.pageX = event.clientX + document.documentElement.scrollLeft;
                                event.pageY = event.clientY + document.documentElement.scrollTop;
                            }
                            while(++index < length && !event.cancelImmediate)if (index in events) {
                                eventElement = events[index];
                                if (indexOf(list, eventElement) !== -1 && typeof eventElement === 'function') eventElement.call(element, event);
                            }
                        };
                        element._events[type].list = [];
                        if (element.attachEvent) element.attachEvent('on' + type, element._events[type]);
                    }
                    element._events[type].list.push(listener);
                };
                window.removeEventListener = Window.prototype.removeEventListener = Document.prototype.removeEventListener = Element.prototype.removeEventListener = function removeEventListener() {
                    var element = this, type = arguments[0], listener = arguments[1], index;
                    if (element._events && element._events[type] && element._events[type].list) {
                        index = indexOf(element._events[type].list, listener);
                        if (index !== -1) {
                            element._events[type].list.splice(index, 1);
                            if (!element._events[type].list.length) {
                                if (element.detachEvent) element.detachEvent('on' + type, element._events[type]);
                                delete element._events[type];
                            }
                        }
                    }
                };
                window.dispatchEvent = Window.prototype.dispatchEvent = Document.prototype.dispatchEvent = Element.prototype.dispatchEvent = function dispatchEvent(event) {
                    if (!arguments.length) throw new Error('Not enough arguments');
                    if (!event || typeof event.type !== 'string') throw new Error('DOM Events Exception 0');
                    var element = this, type = event.type;
                    try {
                        if (!event.bubbles) {
                            event.cancelBubble = true;
                            var cancelBubbleEvent = function(event) {
                                event.cancelBubble = true;
                                (element || window).detachEvent('on' + type, cancelBubbleEvent);
                            };
                            this.attachEvent('on' + type, cancelBubbleEvent);
                        }
                        this.fireEvent('on' + type, event);
                    } catch (error) {
                        event.target = element;
                        do {
                            event.currentTarget = element;
                            if ('_events' in element && typeof element._events[type] === 'function') element._events[type].call(element, event);
                            if (typeof element['on' + type] === 'function') element['on' + type].call(element, event);
                            element = element.nodeType === 9 ? element.parentWindow : element.parentNode;
                        }while (element && !event.cancelBubble);
                    }
                    return true;
                };
                // Add the DOMContentLoaded Event
                document.attachEvent('onreadystatechange', function() {
                    if (document.readyState === 'complete') document.dispatchEvent(new Event('DOMContentLoaded', {
                        bubbles: true
                    }));
                });
            }
        })();
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-service/master/packages/polyfill-library/polyfills/DOMTokenList/detect.js
        var detect = 'DOMTokenList' in this && function(x) {
            return 'classList' in x ? !x.classList.toggle('x', false) && !x.className : true;
        }(document.createElement('x'));
        if (detect) return;
        // Polyfill from https://raw.githubusercontent.com/Financial-Times/polyfill-service/master/packages/polyfill-library/polyfills/DOMTokenList/polyfill.js
        (function(global1) {
            var nativeImpl = "DOMTokenList" in global1 && global1.DOMTokenList;
            if (!nativeImpl || !!document.createElementNS && !!document.createElementNS('http://www.w3.org/2000/svg', 'svg') && !(document.createElementNS("http://www.w3.org/2000/svg", "svg").classList instanceof DOMTokenList)) global1.DOMTokenList = function() {
                var dpSupport = true;
                var defineGetter = function(object, name, fn, configurable) {
                    if (Object.defineProperty) Object.defineProperty(object, name, {
                        configurable: false === dpSupport ? true : !!configurable,
                        get: fn
                    });
                    else object.__defineGetter__(name, fn);
                };
                /** Ensure the browser allows Object.defineProperty to be used on native JavaScript objects. */ try {
                    defineGetter({}, "support");
                } catch (e) {
                    dpSupport = false;
                }
                var _DOMTokenList = function(el, prop) {
                    var that = this;
                    var tokens = [];
                    var tokenMap = {};
                    var length = 0;
                    var maxLength = 0;
                    var addIndexGetter = function(i) {
                        defineGetter(that, i, function() {
                            preop();
                            return tokens[i];
                        }, false);
                    };
                    var reindex = function() {
                        /** Define getter functions for array-like access to the tokenList's contents. */ if (length >= maxLength) for(; maxLength < length; ++maxLength)addIndexGetter(maxLength);
                    };
                    /** Helper function called at the start of each class method. Internal use only. */ var preop = function() {
                        var error;
                        var i;
                        var args = arguments;
                        var rSpace = /\s+/;
                        /** Validate the token/s passed to an instance method, if any. */ if (args.length) {
                            for(i = 0; i < args.length; ++i)if (rSpace.test(args[i])) {
                                error = new SyntaxError('String "' + args[i] + '" ' + "contains" + ' an invalid character');
                                error.code = 5;
                                error.name = "InvalidCharacterError";
                                throw error;
                            }
                        }
                        /** Split the new value apart by whitespace*/ if (typeof el[prop] === "object") tokens = ("" + el[prop].baseVal).replace(/^\s+|\s+$/g, "").split(rSpace);
                        else tokens = ("" + el[prop]).replace(/^\s+|\s+$/g, "").split(rSpace);
                        /** Avoid treating blank strings as single-item token lists */ if ("" === tokens[0]) tokens = [];
                        /** Repopulate the internal token lists */ tokenMap = {};
                        for(i = 0; i < tokens.length; ++i)tokenMap[tokens[i]] = true;
                        length = tokens.length;
                        reindex();
                    };
                    /** Populate our internal token list if the targeted attribute of the subject element isn't empty. */ preop();
                    /** Return the number of tokens in the underlying string. Read-only. */ defineGetter(that, "length", function() {
                        preop();
                        return length;
                    });
                    /** Override the default toString/toLocaleString methods to return a space-delimited list of tokens when typecast. */ that.toLocaleString = that.toString = function() {
                        preop();
                        return tokens.join(" ");
                    };
                    that.item = function(idx) {
                        preop();
                        return tokens[idx];
                    };
                    that.contains = function(token) {
                        preop();
                        return !!tokenMap[token];
                    };
                    that.add = function() {
                        preop.apply(that, args = arguments);
                        for(var args, token, i = 0, l = args.length; i < l; ++i){
                            token = args[i];
                            if (!tokenMap[token]) {
                                tokens.push(token);
                                tokenMap[token] = true;
                            }
                        }
                        /** Update the targeted attribute of the attached element if the token list's changed. */ if (length !== tokens.length) {
                            length = tokens.length >>> 0;
                            if (typeof el[prop] === "object") el[prop].baseVal = tokens.join(" ");
                            else el[prop] = tokens.join(" ");
                            reindex();
                        }
                    };
                    that.remove = function() {
                        preop.apply(that, args = arguments);
                        /** Build a hash of token names to compare against when recollecting our token list. */ for(var args, ignore = {}, i = 0, t = []; i < args.length; ++i){
                            ignore[args[i]] = true;
                            delete tokenMap[args[i]];
                        }
                        /** Run through our tokens list and reassign only those that aren't defined in the hash declared above. */ for(i = 0; i < tokens.length; ++i)if (!ignore[tokens[i]]) t.push(tokens[i]);
                        tokens = t;
                        length = t.length >>> 0;
                        /** Update the targeted attribute of the attached element. */ if (typeof el[prop] === "object") el[prop].baseVal = tokens.join(" ");
                        else el[prop] = tokens.join(" ");
                        reindex();
                    };
                    that.toggle = function(token, force) {
                        preop.apply(that, [
                            token
                        ]);
                        /** Token state's being forced. */ if (undefined !== force) {
                            if (force) {
                                that.add(token);
                                return true;
                            } else {
                                that.remove(token);
                                return false;
                            }
                        }
                        /** Token already exists in tokenList. Remove it, and return FALSE. */ if (tokenMap[token]) {
                            that.remove(token);
                            return false;
                        }
                        /** Otherwise, add the token and return TRUE. */ that.add(token);
                        return true;
                    };
                    return that;
                };
                return _DOMTokenList;
            }();
            // Add second argument to native DOMTokenList.toggle() if necessary
            (function() {
                var e = document.createElement('span');
                if (!('classList' in e)) return;
                e.classList.toggle('x', false);
                if (!e.classList.contains('x')) return;
                e.classList.constructor.prototype.toggle = function toggle(token /*, force*/ ) {
                    var force = arguments[1];
                    if (force === undefined) {
                        var add = !this.contains(token);
                        this[add ? 'add' : 'remove'](token);
                        return add;
                    }
                    force = !!force;
                    this[force ? 'add' : 'remove'](token);
                    return force;
                };
            })();
            // Add multiple arguments to native DOMTokenList.add() if necessary
            (function() {
                var e = document.createElement('span');
                if (!('classList' in e)) return;
                e.classList.add('a', 'b');
                if (e.classList.contains('b')) return;
                var native = e.classList.constructor.prototype.add;
                e.classList.constructor.prototype.add = function() {
                    var args = arguments;
                    var l = arguments.length;
                    for(var i = 0; i < l; i++)native.call(this, args[i]);
                };
            })();
            // Add multiple arguments to native DOMTokenList.remove() if necessary
            (function() {
                var e = document.createElement('span');
                if (!('classList' in e)) return;
                e.classList.add('a');
                e.classList.add('b');
                e.classList.remove('a', 'b');
                if (!e.classList.contains('b')) return;
                var native = e.classList.constructor.prototype.remove;
                e.classList.constructor.prototype.remove = function() {
                    var args = arguments;
                    var l = arguments.length;
                    for(var i = 0; i < l; i++)native.call(this, args[i]);
                };
            })();
        })(this);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-service/8717a9e04ac7aff99b4980fbedead98036b0929a/packages/polyfill-library/polyfills/Element/prototype/classList/detect.js
        var detect = 'document' in this && "classList" in document.documentElement && 'Element' in this && 'classList' in Element.prototype && function() {
            var e = document.createElement('span');
            e.classList.add('a', 'b');
            return e.classList.contains('b');
        }();
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Element.prototype.classList&flags=always
        (function(global1) {
            var dpSupport = true;
            var defineGetter = function(object, name, fn, configurable) {
                if (Object.defineProperty) Object.defineProperty(object, name, {
                    configurable: false === dpSupport ? true : !!configurable,
                    get: fn
                });
                else object.__defineGetter__(name, fn);
            };
            /** Ensure the browser allows Object.defineProperty to be used on native JavaScript objects. */ try {
                defineGetter({}, "support");
            } catch (e) {
                dpSupport = false;
            }
            /** Polyfills a property with a DOMTokenList */ var addProp = function(o, name, attr) {
                defineGetter(o.prototype, name, function() {
                    var tokenList;
                    var THIS = this, /** Prevent this from firing twice for some reason. What the hell, IE. */ gibberishProperty = "__defineGetter__DEFINE_PROPERTY" + name;
                    if (THIS[gibberishProperty]) return tokenList;
                    THIS[gibberishProperty] = true;
                    /**
           * IE8 can't define properties on native JavaScript objects, so we'll use a dumb hack instead.
           *
           * What this is doing is creating a dummy element ("reflection") inside a detached phantom node ("mirror")
           * that serves as the target of Object.defineProperty instead. While we could simply use the subject HTML
           * element instead, this would conflict with element types which use indexed properties (such as forms and
           * select lists).
           */ if (false === dpSupport) {
                        var visage;
                        var mirror = addProp.mirror || document.createElement("div");
                        var reflections = mirror.childNodes;
                        var l = reflections.length;
                        for(var i = 0; i < l; ++i)if (reflections[i]._R === THIS) {
                            visage = reflections[i];
                            break;
                        }
                        /** Couldn't find an element's reflection inside the mirror. Materialise one. */ visage || (visage = mirror.appendChild(document.createElement("div")));
                        tokenList = DOMTokenList.call(visage, THIS, attr);
                    } else tokenList = new DOMTokenList(THIS, attr);
                    defineGetter(THIS, name, function() {
                        return tokenList;
                    });
                    delete THIS[gibberishProperty];
                    return tokenList;
                }, true);
            };
            addProp(global1.Element, "classList", "className");
            addProp(global1.HTMLElement, "classList", "className");
            addProp(global1.HTMLLinkElement, "relList", "rel");
            addProp(global1.HTMLAnchorElement, "relList", "rel");
            addProp(global1.HTMLAreaElement, "relList", "rel");
        })(this);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    /**
 * TODO: Ideally this would be a NodeList.prototype.forEach polyfill
 * This seems to fail in IE8, requires more investigation.
 * See: https://github.com/imagitama/nodelist-foreach-polyfill
 */ function nodeListForEach(nodes, callback) {
        if (window.NodeList.prototype.forEach) return nodes.forEach(callback);
        for(var i = 0; i < nodes.length; i++)callback.call(window, nodes[i], i, nodes);
    }
    function Radios($module) {
        this.$module = $module;
        this.$inputs = $module.querySelectorAll('input[type="radio"]');
    }
    /**
 * Initialise Radios
 *
 * Radios can be associated with a 'conditionally revealed' content block – for
 * example, a radio for 'Phone' could reveal an additional form field for the
 * user to enter their phone number.
 *
 * These associations are made using a `data-aria-controls` attribute, which is
 * promoted to an aria-controls attribute during initialisation.
 *
 * We also need to restore the state of any conditional reveals on the page (for
 * example if the user has navigated back), and set up event handlers to keep
 * the reveal in sync with the radio state.
 */ Radios.prototype.init = function() {
        var $module = this.$module;
        var $inputs = this.$inputs;
        nodeListForEach($inputs, function($input) {
            var target = $input.getAttribute('data-aria-controls');
            // Skip radios without data-aria-controls attributes, or where the
            // target element does not exist.
            if (!target || !$module.querySelector('#' + target)) return;
            // Promote the data-aria-controls attribute to a aria-controls attribute
            // so that the relationship is exposed in the AOM
            $input.setAttribute('aria-controls', target);
            $input.removeAttribute('data-aria-controls');
        });
        // When the page is restored after navigating 'back' in some browsers the
        // state of form controls is not restored until *after* the DOMContentLoaded
        // event is fired, so we need to sync after the pageshow event in browsers
        // that support it.
        if ('onpageshow' in window) window.addEventListener('pageshow', this.syncAllConditionalReveals.bind(this));
        else window.addEventListener('DOMContentLoaded', this.syncAllConditionalReveals.bind(this));
        // Although we've set up handlers to sync state on the pageshow or
        // DOMContentLoaded event, init could be called after those events have fired,
        // for example if they are added to the page dynamically, so sync now too.
        this.syncAllConditionalReveals();
        // Handle events
        $module.addEventListener('click', this.handleClick.bind(this));
    };
    /**
 * Sync the conditional reveal states for all inputs in this $module.
 */ Radios.prototype.syncAllConditionalReveals = function() {
        nodeListForEach(this.$inputs, this.syncConditionalRevealWithInputState.bind(this));
    };
    /**
 * Sync conditional reveal with the input state
 *
 * Synchronise the visibility of the conditional reveal, and its accessible
 * state, with the input's checked state.
 *
 * @param {HTMLInputElement} $input Radio input
 */ Radios.prototype.syncConditionalRevealWithInputState = function($input) {
        var $target = document.querySelector('#' + $input.getAttribute('aria-controls'));
        if ($target && $target.classList.contains('govuk-radios__conditional')) {
            var inputIsChecked = $input.checked;
            $input.setAttribute('aria-expanded', inputIsChecked);
            $target.classList.toggle('govuk-radios__conditional--hidden', !inputIsChecked);
        }
    };
    /**
 * Click event handler
 *
 * Handle a click within the $module – if the click occurred on a radio, sync
 * the state of the conditional reveal for all radio buttons in the same form
 * with the same name (because checking one radio could have un-checked a radio
 * in another $module)
 *
 * @param {MouseEvent} event Click event
 */ Radios.prototype.handleClick = function(event) {
        var $clickedInput = event.target;
        // Ignore clicks on things that aren't radio buttons
        if ($clickedInput.type !== 'radio') return;
        // We only need to consider radios with conditional reveals, which will have
        // aria-controls attributes.
        var $allInputs = document.querySelectorAll('input[type="radio"][aria-controls]');
        nodeListForEach($allInputs, (function($input) {
            var hasSameFormOwner = $input.form === $clickedInput.form;
            var hasSameName = $input.name === $clickedInput.name;
            if (hasSameName && hasSameFormOwner) this.syncConditionalRevealWithInputState($input);
        }).bind(this));
    };
    return Radios;
});


var $a830587fbd40a058$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c7d5121aca823445$exports)));


var $bdebc129c64cd17b$exports = {};
(function(global1, factory) {
    $bdebc129c64cd17b$exports = factory();
})($bdebc129c64cd17b$exports, function() {
    'use strict';
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Object/defineProperty/detect.js
        var detect = // In IE8, defineProperty could only act on DOM elements, so full support
        // for the feature requires the ability to set a property on an arbitrary object
        'defineProperty' in Object && function() {
            try {
                var a = {};
                Object.defineProperty(a, 'test', {
                    value: 42
                });
                return true;
            } catch (e) {
                return false;
            }
        }();
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Object.defineProperty&flags=always
        (function(nativeDefineProperty) {
            var supportsAccessors = Object.prototype.hasOwnProperty('__defineGetter__');
            var ERR_ACCESSORS_NOT_SUPPORTED = 'Getters & setters cannot be defined on this javascript engine';
            var ERR_VALUE_ACCESSORS = 'A property cannot both have accessors and be writable or have a value';
            Object.defineProperty = function defineProperty(object, property, descriptor) {
                // Where native support exists, assume it
                if (nativeDefineProperty && (object === window || object === document || object === Element.prototype || object instanceof Element)) return nativeDefineProperty(object, property, descriptor);
                if (object === null || !(object instanceof Object || typeof object === 'object')) throw new TypeError('Object.defineProperty called on non-object');
                if (!(descriptor instanceof Object)) throw new TypeError('Property description must be an object');
                var propertyString = String(property);
                var hasValueOrWritable = 'value' in descriptor || 'writable' in descriptor;
                var getterType = 'get' in descriptor && typeof descriptor.get;
                var setterType = 'set' in descriptor && typeof descriptor.set;
                // handle descriptor.get
                if (getterType) {
                    if (getterType !== 'function') throw new TypeError('Getter must be a function');
                    if (!supportsAccessors) throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
                    if (hasValueOrWritable) throw new TypeError(ERR_VALUE_ACCESSORS);
                    Object.__defineGetter__.call(object, propertyString, descriptor.get);
                } else object[propertyString] = descriptor.value;
                // handle descriptor.set
                if (setterType) {
                    if (setterType !== 'function') throw new TypeError('Setter must be a function');
                    if (!supportsAccessors) throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
                    if (hasValueOrWritable) throw new TypeError(ERR_VALUE_ACCESSORS);
                    Object.__defineSetter__.call(object, propertyString, descriptor.set);
                }
                // OK to define value unconditionally - if a getter has been specified as well, an error would be thrown above
                if ('value' in descriptor) object[propertyString] = descriptor.value;
                return object;
            };
        })(Object.defineProperty);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Function/prototype/bind/detect.js
        var detect = 'bind' in Function.prototype;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Function.prototype.bind&flags=always
        Object.defineProperty(Function.prototype, 'bind', {
            value: function bind(that) {
                // add necessary es5-shim utilities
                var $Array = Array;
                var $Object = Object;
                var ObjectPrototype = $Object.prototype;
                var ArrayPrototype = $Array.prototype;
                var Empty = function Empty() {};
                var to_string = ObjectPrototype.toString;
                var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
                var isCallable; /* inlined from https://npmjs.com/is-callable */ 
                var fnToStr = Function.prototype.toString, tryFunctionObject = function tryFunctionObject(value) {
                    try {
                        fnToStr.call(value);
                        return true;
                    } catch (e) {
                        return false;
                    }
                }, fnClass = '[object Function]', genClass = '[object GeneratorFunction]';
                isCallable = function isCallable(value) {
                    if (typeof value !== 'function') return false;
                    if (hasToStringTag) return tryFunctionObject(value);
                    var strClass = to_string.call(value);
                    return strClass === fnClass || strClass === genClass;
                };
                var array_slice = ArrayPrototype.slice;
                var array_concat = ArrayPrototype.concat;
                var array_push = ArrayPrototype.push;
                var max = Math.max;
                // /add necessary es5-shim utilities
                // 1. Let Target be the this value.
                var target = this;
                // 2. If IsCallable(Target) is false, throw a TypeError exception.
                if (!isCallable(target)) throw new TypeError('Function.prototype.bind called on incompatible ' + target);
                // 3. Let A be a new (possibly empty) internal list of all of the
                //   argument values provided after thisArg (arg1, arg2 etc), in order.
                // XXX slicedArgs will stand in for "A" if used
                var args = array_slice.call(arguments, 1); // for normal call
                // 4. Let F be a new native ECMAScript object.
                // 11. Set the [[Prototype]] internal property of F to the standard
                //   built-in Function prototype object as specified in 15.3.3.1.
                // 12. Set the [[Call]] internal property of F as described in
                //   15.3.4.5.1.
                // 13. Set the [[Construct]] internal property of F as described in
                //   15.3.4.5.2.
                // 14. Set the [[HasInstance]] internal property of F as described in
                //   15.3.4.5.3.
                var bound;
                var binder = function() {
                    if (this instanceof bound) {
                        // 15.3.4.5.2 [[Construct]]
                        // When the [[Construct]] internal method of a function object,
                        // F that was created using the bind function is called with a
                        // list of arguments ExtraArgs, the following steps are taken:
                        // 1. Let target be the value of F's [[TargetFunction]]
                        //   internal property.
                        // 2. If target has no [[Construct]] internal method, a
                        //   TypeError exception is thrown.
                        // 3. Let boundArgs be the value of F's [[BoundArgs]] internal
                        //   property.
                        // 4. Let args be a new list containing the same values as the
                        //   list boundArgs in the same order followed by the same
                        //   values as the list ExtraArgs in the same order.
                        // 5. Return the result of calling the [[Construct]] internal
                        //   method of target providing args as the arguments.
                        var result = target.apply(this, array_concat.call(args, array_slice.call(arguments)));
                        if ($Object(result) === result) return result;
                        return this;
                    } else // 15.3.4.5.1 [[Call]]
                    // When the [[Call]] internal method of a function object, F,
                    // which was created using the bind function is called with a
                    // this value and a list of arguments ExtraArgs, the following
                    // steps are taken:
                    // 1. Let boundArgs be the value of F's [[BoundArgs]] internal
                    //   property.
                    // 2. Let boundThis be the value of F's [[BoundThis]] internal
                    //   property.
                    // 3. Let target be the value of F's [[TargetFunction]] internal
                    //   property.
                    // 4. Let args be a new list containing the same values as the
                    //   list boundArgs in the same order followed by the same
                    //   values as the list ExtraArgs in the same order.
                    // 5. Return the result of calling the [[Call]] internal method
                    //   of target providing boundThis as the this value and
                    //   providing args as the arguments.
                    // equiv: target.call(this, ...boundArgs, ...args)
                    return target.apply(that, array_concat.call(args, array_slice.call(arguments)));
                };
                // 15. If the [[Class]] internal property of Target is "Function", then
                //     a. Let L be the length property of Target minus the length of A.
                //     b. Set the length own property of F to either 0 or L, whichever is
                //       larger.
                // 16. Else set the length own property of F to 0.
                var boundLength = max(0, target.length - args.length);
                // 17. Set the attributes of the length own property of F to the values
                //   specified in 15.3.5.1.
                var boundArgs = [];
                for(var i = 0; i < boundLength; i++)array_push.call(boundArgs, '$' + i);
                // XXX Build a dynamic function with desired amount of arguments is the only
                // way to set the length property of a function.
                // In environments where Content Security Policies enabled (Chrome extensions,
                // for ex.) all use of eval or Function costructor throws an exception.
                // However in all of these environments Function.prototype.bind exists
                // and so this code will never be executed.
                bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this, arguments); }')(binder);
                if (target.prototype) {
                    Empty.prototype = target.prototype;
                    bound.prototype = new Empty();
                    // Clean up dangling references.
                    Empty.prototype = null;
                }
                // TODO
                // 18. Set the [[Extensible]] internal property of F to true.
                // TODO
                // 19. Let thrower be the [[ThrowTypeError]] function Object (13.2.3).
                // 20. Call the [[DefineOwnProperty]] internal method of F with
                //   arguments "caller", PropertyDescriptor {[[Get]]: thrower, [[Set]]:
                //   thrower, [[Enumerable]]: false, [[Configurable]]: false}, and
                //   false.
                // 21. Call the [[DefineOwnProperty]] internal method of F with
                //   arguments "arguments", PropertyDescriptor {[[Get]]: thrower,
                //   [[Set]]: thrower, [[Enumerable]]: false, [[Configurable]]: false},
                //   and false.
                // TODO
                // NOTE Function objects created using Function.prototype.bind do not
                // have a prototype property or the [[Code]], [[FormalParameters]], and
                // [[Scope]] internal properties.
                // XXX can't delete prototype in pure-js.
                // 22. Return F.
                return bound;
            }
        });
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-service/master/packages/polyfill-library/polyfills/DOMTokenList/detect.js
        var detect = 'DOMTokenList' in this && function(x) {
            return 'classList' in x ? !x.classList.toggle('x', false) && !x.className : true;
        }(document.createElement('x'));
        if (detect) return;
        // Polyfill from https://raw.githubusercontent.com/Financial-Times/polyfill-service/master/packages/polyfill-library/polyfills/DOMTokenList/polyfill.js
        (function(global1) {
            var nativeImpl = "DOMTokenList" in global1 && global1.DOMTokenList;
            if (!nativeImpl || !!document.createElementNS && !!document.createElementNS('http://www.w3.org/2000/svg', 'svg') && !(document.createElementNS("http://www.w3.org/2000/svg", "svg").classList instanceof DOMTokenList)) global1.DOMTokenList = function() {
                var dpSupport = true;
                var defineGetter = function(object, name, fn, configurable) {
                    if (Object.defineProperty) Object.defineProperty(object, name, {
                        configurable: false === dpSupport ? true : !!configurable,
                        get: fn
                    });
                    else object.__defineGetter__(name, fn);
                };
                /** Ensure the browser allows Object.defineProperty to be used on native JavaScript objects. */ try {
                    defineGetter({}, "support");
                } catch (e) {
                    dpSupport = false;
                }
                var _DOMTokenList = function(el, prop) {
                    var that = this;
                    var tokens = [];
                    var tokenMap = {};
                    var length = 0;
                    var maxLength = 0;
                    var addIndexGetter = function(i) {
                        defineGetter(that, i, function() {
                            preop();
                            return tokens[i];
                        }, false);
                    };
                    var reindex = function() {
                        /** Define getter functions for array-like access to the tokenList's contents. */ if (length >= maxLength) for(; maxLength < length; ++maxLength)addIndexGetter(maxLength);
                    };
                    /** Helper function called at the start of each class method. Internal use only. */ var preop = function() {
                        var error;
                        var i;
                        var args = arguments;
                        var rSpace = /\s+/;
                        /** Validate the token/s passed to an instance method, if any. */ if (args.length) {
                            for(i = 0; i < args.length; ++i)if (rSpace.test(args[i])) {
                                error = new SyntaxError('String "' + args[i] + '" ' + "contains" + ' an invalid character');
                                error.code = 5;
                                error.name = "InvalidCharacterError";
                                throw error;
                            }
                        }
                        /** Split the new value apart by whitespace*/ if (typeof el[prop] === "object") tokens = ("" + el[prop].baseVal).replace(/^\s+|\s+$/g, "").split(rSpace);
                        else tokens = ("" + el[prop]).replace(/^\s+|\s+$/g, "").split(rSpace);
                        /** Avoid treating blank strings as single-item token lists */ if ("" === tokens[0]) tokens = [];
                        /** Repopulate the internal token lists */ tokenMap = {};
                        for(i = 0; i < tokens.length; ++i)tokenMap[tokens[i]] = true;
                        length = tokens.length;
                        reindex();
                    };
                    /** Populate our internal token list if the targeted attribute of the subject element isn't empty. */ preop();
                    /** Return the number of tokens in the underlying string. Read-only. */ defineGetter(that, "length", function() {
                        preop();
                        return length;
                    });
                    /** Override the default toString/toLocaleString methods to return a space-delimited list of tokens when typecast. */ that.toLocaleString = that.toString = function() {
                        preop();
                        return tokens.join(" ");
                    };
                    that.item = function(idx) {
                        preop();
                        return tokens[idx];
                    };
                    that.contains = function(token) {
                        preop();
                        return !!tokenMap[token];
                    };
                    that.add = function() {
                        preop.apply(that, args = arguments);
                        for(var args, token, i = 0, l = args.length; i < l; ++i){
                            token = args[i];
                            if (!tokenMap[token]) {
                                tokens.push(token);
                                tokenMap[token] = true;
                            }
                        }
                        /** Update the targeted attribute of the attached element if the token list's changed. */ if (length !== tokens.length) {
                            length = tokens.length >>> 0;
                            if (typeof el[prop] === "object") el[prop].baseVal = tokens.join(" ");
                            else el[prop] = tokens.join(" ");
                            reindex();
                        }
                    };
                    that.remove = function() {
                        preop.apply(that, args = arguments);
                        /** Build a hash of token names to compare against when recollecting our token list. */ for(var args, ignore = {}, i = 0, t = []; i < args.length; ++i){
                            ignore[args[i]] = true;
                            delete tokenMap[args[i]];
                        }
                        /** Run through our tokens list and reassign only those that aren't defined in the hash declared above. */ for(i = 0; i < tokens.length; ++i)if (!ignore[tokens[i]]) t.push(tokens[i]);
                        tokens = t;
                        length = t.length >>> 0;
                        /** Update the targeted attribute of the attached element. */ if (typeof el[prop] === "object") el[prop].baseVal = tokens.join(" ");
                        else el[prop] = tokens.join(" ");
                        reindex();
                    };
                    that.toggle = function(token, force) {
                        preop.apply(that, [
                            token
                        ]);
                        /** Token state's being forced. */ if (undefined !== force) {
                            if (force) {
                                that.add(token);
                                return true;
                            } else {
                                that.remove(token);
                                return false;
                            }
                        }
                        /** Token already exists in tokenList. Remove it, and return FALSE. */ if (tokenMap[token]) {
                            that.remove(token);
                            return false;
                        }
                        /** Otherwise, add the token and return TRUE. */ that.add(token);
                        return true;
                    };
                    return that;
                };
                return _DOMTokenList;
            }();
            // Add second argument to native DOMTokenList.toggle() if necessary
            (function() {
                var e = document.createElement('span');
                if (!('classList' in e)) return;
                e.classList.toggle('x', false);
                if (!e.classList.contains('x')) return;
                e.classList.constructor.prototype.toggle = function toggle(token /*, force*/ ) {
                    var force = arguments[1];
                    if (force === undefined) {
                        var add = !this.contains(token);
                        this[add ? 'add' : 'remove'](token);
                        return add;
                    }
                    force = !!force;
                    this[force ? 'add' : 'remove'](token);
                    return force;
                };
            })();
            // Add multiple arguments to native DOMTokenList.add() if necessary
            (function() {
                var e = document.createElement('span');
                if (!('classList' in e)) return;
                e.classList.add('a', 'b');
                if (e.classList.contains('b')) return;
                var native = e.classList.constructor.prototype.add;
                e.classList.constructor.prototype.add = function() {
                    var args = arguments;
                    var l = arguments.length;
                    for(var i = 0; i < l; i++)native.call(this, args[i]);
                };
            })();
            // Add multiple arguments to native DOMTokenList.remove() if necessary
            (function() {
                var e = document.createElement('span');
                if (!('classList' in e)) return;
                e.classList.add('a');
                e.classList.add('b');
                e.classList.remove('a', 'b');
                if (!e.classList.contains('b')) return;
                var native = e.classList.constructor.prototype.remove;
                e.classList.constructor.prototype.remove = function() {
                    var args = arguments;
                    var l = arguments.length;
                    for(var i = 0; i < l; i++)native.call(this, args[i]);
                };
            })();
        })(this);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Document/detect.js
        var detect = "Document" in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Document&flags=always
        if (typeof WorkerGlobalScope === "undefined" && typeof importScripts !== "function") {
            if (this.HTMLDocument) // HTMLDocument is an extension of Document.  If the browser has HTMLDocument but not Document, the former will suffice as an alias for the latter.
            this.Document = this.HTMLDocument;
            else {
                // Create an empty function to act as the missing constructor for the document object, attach the document object as its prototype.  The function needs to be anonymous else it is hoisted and causes the feature detect to prematurely pass, preventing the assignments below being made.
                this.Document = this.HTMLDocument = document.constructor = new Function('return function Document() {}')();
                this.Document.prototype = document;
            }
        }
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Element/detect.js
        var detect = 'Element' in this && 'HTMLElement' in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Element&flags=always
        (function() {
            // IE8
            if (window.Element && !window.HTMLElement) {
                window.HTMLElement = window.Element;
                return;
            }
            // create Element constructor
            window.Element = window.HTMLElement = new Function('return function Element() {}')();
            // generate sandboxed iframe
            var vbody = document.appendChild(document.createElement('body'));
            var frame = vbody.appendChild(document.createElement('iframe'));
            // use sandboxed iframe to replicate Element functionality
            var frameDocument = frame.contentWindow.document;
            var prototype = Element.prototype = frameDocument.appendChild(frameDocument.createElement('*'));
            var cache = {};
            // polyfill Element.prototype on an element
            var shiv = function(element, deep) {
                var childNodes = element.childNodes || [], index = -1, key, value, childNode;
                if (element.nodeType === 1 && element.constructor !== Element) {
                    element.constructor = Element;
                    for(key in cache){
                        value = cache[key];
                        element[key] = value;
                    }
                }
                while(childNode = deep && childNodes[++index])shiv(childNode, deep);
                return element;
            };
            var elements = document.getElementsByTagName('*');
            var nativeCreateElement = document.createElement;
            var interval;
            var loopLimit = 100;
            prototype.attachEvent('onpropertychange', function(event) {
                var propertyName = event.propertyName, nonValue = !cache.hasOwnProperty(propertyName), newValue = prototype[propertyName], oldValue = cache[propertyName], index = -1, element;
                while(element = elements[++index]){
                    if (element.nodeType === 1) {
                        if (nonValue || element[propertyName] === oldValue) element[propertyName] = newValue;
                    }
                }
                cache[propertyName] = newValue;
            });
            prototype.constructor = Element;
            if (!prototype.hasAttribute) // <Element>.hasAttribute
            prototype.hasAttribute = function hasAttribute(name) {
                return this.getAttribute(name) !== null;
            };
            // Apply Element prototype to the pre-existing DOM as soon as the body element appears.
            function bodyCheck() {
                if (!loopLimit--) clearTimeout(interval);
                if (document.body && !document.body.prototype && /(complete|interactive)/.test(document.readyState)) {
                    shiv(document, true);
                    if (interval && document.body.prototype) clearTimeout(interval);
                    return !!document.body.prototype;
                }
                return false;
            }
            if (!bodyCheck()) {
                document.onreadystatechange = bodyCheck;
                interval = setInterval(bodyCheck, 25);
            }
            // Apply to any new elements created after load
            document.createElement = function createElement(nodeName) {
                var element = nativeCreateElement(String(nodeName).toLowerCase());
                return shiv(element);
            };
            // remove sandboxed iframe
            document.removeChild(vbody);
        })();
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-service/8717a9e04ac7aff99b4980fbedead98036b0929a/packages/polyfill-library/polyfills/Element/prototype/classList/detect.js
        var detect = 'document' in this && "classList" in document.documentElement && 'Element' in this && 'classList' in Element.prototype && function() {
            var e = document.createElement('span');
            e.classList.add('a', 'b');
            return e.classList.contains('b');
        }();
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Element.prototype.classList&flags=always
        (function(global1) {
            var dpSupport = true;
            var defineGetter = function(object, name, fn, configurable) {
                if (Object.defineProperty) Object.defineProperty(object, name, {
                    configurable: false === dpSupport ? true : !!configurable,
                    get: fn
                });
                else object.__defineGetter__(name, fn);
            };
            /** Ensure the browser allows Object.defineProperty to be used on native JavaScript objects. */ try {
                defineGetter({}, "support");
            } catch (e) {
                dpSupport = false;
            }
            /** Polyfills a property with a DOMTokenList */ var addProp = function(o, name, attr) {
                defineGetter(o.prototype, name, function() {
                    var tokenList;
                    var THIS = this, /** Prevent this from firing twice for some reason. What the hell, IE. */ gibberishProperty = "__defineGetter__DEFINE_PROPERTY" + name;
                    if (THIS[gibberishProperty]) return tokenList;
                    THIS[gibberishProperty] = true;
                    /**
           * IE8 can't define properties on native JavaScript objects, so we'll use a dumb hack instead.
           *
           * What this is doing is creating a dummy element ("reflection") inside a detached phantom node ("mirror")
           * that serves as the target of Object.defineProperty instead. While we could simply use the subject HTML
           * element instead, this would conflict with element types which use indexed properties (such as forms and
           * select lists).
           */ if (false === dpSupport) {
                        var visage;
                        var mirror = addProp.mirror || document.createElement("div");
                        var reflections = mirror.childNodes;
                        var l = reflections.length;
                        for(var i = 0; i < l; ++i)if (reflections[i]._R === THIS) {
                            visage = reflections[i];
                            break;
                        }
                        /** Couldn't find an element's reflection inside the mirror. Materialise one. */ visage || (visage = mirror.appendChild(document.createElement("div")));
                        tokenList = DOMTokenList.call(visage, THIS, attr);
                    } else tokenList = new DOMTokenList(THIS, attr);
                    defineGetter(THIS, name, function() {
                        return tokenList;
                    });
                    delete THIS[gibberishProperty];
                    return tokenList;
                }, true);
            };
            addProp(global1.Element, "classList", "className");
            addProp(global1.HTMLElement, "classList", "className");
            addProp(global1.HTMLLinkElement, "relList", "rel");
            addProp(global1.HTMLAnchorElement, "relList", "rel");
            addProp(global1.HTMLAreaElement, "relList", "rel");
        })(this);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-library/master/polyfills/Element/prototype/nextElementSibling/detect.js
        var detect = 'document' in this && "nextElementSibling" in document.documentElement;
        if (detect) return;
        // Polyfill from https://raw.githubusercontent.com/Financial-Times/polyfill-library/master/polyfills/Element/prototype/nextElementSibling/polyfill.js
        Object.defineProperty(Element.prototype, "nextElementSibling", {
            get: function() {
                var el = this.nextSibling;
                while(el && el.nodeType !== 1)el = el.nextSibling;
                return el;
            }
        });
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://raw.githubusercontent.com/Financial-Times/polyfill-library/master/polyfills/Element/prototype/previousElementSibling/detect.js
        var detect = 'document' in this && "previousElementSibling" in document.documentElement;
        if (detect) return;
        // Polyfill from https://raw.githubusercontent.com/Financial-Times/polyfill-library/master/polyfills/Element/prototype/previousElementSibling/polyfill.js
        Object.defineProperty(Element.prototype, 'previousElementSibling', {
            get: function() {
                var el = this.previousSibling;
                while(el && el.nodeType !== 1)el = el.previousSibling;
                return el;
            }
        });
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Window/detect.js
        var detect = 'Window' in this;
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Window&flags=always
        if (typeof WorkerGlobalScope === "undefined" && typeof importScripts !== "function") (function(global1) {
            if (global1.constructor) global1.Window = global1.constructor;
            else (global1.Window = global1.constructor = new Function('return function Window() {}')()).prototype = this;
        })(this);
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    (function(undefined) {
        // Detection from https://github.com/Financial-Times/polyfill-service/blob/master/packages/polyfill-library/polyfills/Event/detect.js
        var detect = function(global1) {
            if (!('Event' in global1)) return false;
            if (typeof global1.Event === 'function') return true;
            try {
                // In IE 9-11, the Event object exists but cannot be instantiated
                new Event('click');
                return true;
            } catch (e) {
                return false;
            }
        }(this);
        if (detect) return;
        // Polyfill from https://cdn.polyfill.io/v2/polyfill.js?features=Event&flags=always
        (function() {
            var unlistenableWindowEvents = {
                click: 1,
                dblclick: 1,
                keyup: 1,
                keypress: 1,
                keydown: 1,
                mousedown: 1,
                mouseup: 1,
                mousemove: 1,
                mouseover: 1,
                mouseenter: 1,
                mouseleave: 1,
                mouseout: 1,
                storage: 1,
                storagecommit: 1,
                textinput: 1
            };
            // This polyfill depends on availability of `document` so will not run in a worker
            // However, we asssume there are no browsers with worker support that lack proper
            // support for `Event` within the worker
            if (typeof document === 'undefined' || typeof window === 'undefined') return;
            function indexOf(array, element) {
                var index = -1, length = array.length;
                while(++index < length){
                    if (index in array && array[index] === element) return index;
                }
                return -1;
            }
            var existingProto = window.Event && window.Event.prototype || null;
            window.Event = Window.prototype.Event = function Event1(type, eventInitDict) {
                if (!type) throw new Error('Not enough arguments');
                var event;
                // Shortcut if browser supports createEvent
                if ('createEvent' in document) {
                    event = document.createEvent('Event');
                    var bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
                    var cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;
                    event.initEvent(type, bubbles, cancelable);
                    return event;
                }
                event = document.createEventObject();
                event.type = type;
                event.bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
                event.cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;
                return event;
            };
            if (existingProto) Object.defineProperty(window.Event, 'prototype', {
                configurable: false,
                enumerable: false,
                writable: true,
                value: existingProto
            });
            if (!('createEvent' in document)) {
                window.addEventListener = Window.prototype.addEventListener = Document.prototype.addEventListener = Element.prototype.addEventListener = function addEventListener() {
                    var element = this, type = arguments[0], listener = arguments[1];
                    if (element === window && type in unlistenableWindowEvents) throw new Error('In IE8 the event: ' + type + ' is not available on the window object. Please see https://github.com/Financial-Times/polyfill-service/issues/317 for more information.');
                    if (!element._events) element._events = {};
                    if (!element._events[type]) {
                        element._events[type] = function(event) {
                            var list = element._events[event.type].list, events = list.slice(), index = -1, length = events.length, eventElement;
                            event.preventDefault = function preventDefault() {
                                if (event.cancelable !== false) event.returnValue = false;
                            };
                            event.stopPropagation = function stopPropagation() {
                                event.cancelBubble = true;
                            };
                            event.stopImmediatePropagation = function stopImmediatePropagation() {
                                event.cancelBubble = true;
                                event.cancelImmediate = true;
                            };
                            event.currentTarget = element;
                            event.relatedTarget = event.fromElement || null;
                            event.target = event.target || event.srcElement || element;
                            event.timeStamp = new Date().getTime();
                            if (event.clientX) {
                                event.pageX = event.clientX + document.documentElement.scrollLeft;
                                event.pageY = event.clientY + document.documentElement.scrollTop;
                            }
                            while(++index < length && !event.cancelImmediate)if (index in events) {
                                eventElement = events[index];
                                if (indexOf(list, eventElement) !== -1 && typeof eventElement === 'function') eventElement.call(element, event);
                            }
                        };
                        element._events[type].list = [];
                        if (element.attachEvent) element.attachEvent('on' + type, element._events[type]);
                    }
                    element._events[type].list.push(listener);
                };
                window.removeEventListener = Window.prototype.removeEventListener = Document.prototype.removeEventListener = Element.prototype.removeEventListener = function removeEventListener() {
                    var element = this, type = arguments[0], listener = arguments[1], index;
                    if (element._events && element._events[type] && element._events[type].list) {
                        index = indexOf(element._events[type].list, listener);
                        if (index !== -1) {
                            element._events[type].list.splice(index, 1);
                            if (!element._events[type].list.length) {
                                if (element.detachEvent) element.detachEvent('on' + type, element._events[type]);
                                delete element._events[type];
                            }
                        }
                    }
                };
                window.dispatchEvent = Window.prototype.dispatchEvent = Document.prototype.dispatchEvent = Element.prototype.dispatchEvent = function dispatchEvent(event) {
                    if (!arguments.length) throw new Error('Not enough arguments');
                    if (!event || typeof event.type !== 'string') throw new Error('DOM Events Exception 0');
                    var element = this, type = event.type;
                    try {
                        if (!event.bubbles) {
                            event.cancelBubble = true;
                            var cancelBubbleEvent = function(event) {
                                event.cancelBubble = true;
                                (element || window).detachEvent('on' + type, cancelBubbleEvent);
                            };
                            this.attachEvent('on' + type, cancelBubbleEvent);
                        }
                        this.fireEvent('on' + type, event);
                    } catch (error) {
                        event.target = element;
                        do {
                            event.currentTarget = element;
                            if ('_events' in element && typeof element._events[type] === 'function') element._events[type].call(element, event);
                            if (typeof element['on' + type] === 'function') element['on' + type].call(element, event);
                            element = element.nodeType === 9 ? element.parentWindow : element.parentNode;
                        }while (element && !event.cancelBubble);
                    }
                    return true;
                };
                // Add the DOMContentLoaded Event
                document.attachEvent('onreadystatechange', function() {
                    if (document.readyState === 'complete') document.dispatchEvent(new Event('DOMContentLoaded', {
                        bubbles: true
                    }));
                });
            }
        })();
    }).call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof $parcel$global && $parcel$global || {});
    /**
 * TODO: Ideally this would be a NodeList.prototype.forEach polyfill
 * This seems to fail in IE8, requires more investigation.
 * See: https://github.com/imagitama/nodelist-foreach-polyfill
 */ function nodeListForEach(nodes, callback) {
        if (window.NodeList.prototype.forEach) return nodes.forEach(callback);
        for(var i = 0; i < nodes.length; i++)callback.call(window, nodes[i], i, nodes);
    }
    function Tabs($module) {
        this.$module = $module;
        this.$tabs = $module.querySelectorAll('.govuk-tabs__tab');
        this.keys = {
            left: 37,
            right: 39,
            up: 38,
            down: 40
        };
        this.jsHiddenClass = 'govuk-tabs__panel--hidden';
    }
    Tabs.prototype.init = function() {
        if (typeof window.matchMedia === 'function') this.setupResponsiveChecks();
        else this.setup();
    };
    Tabs.prototype.setupResponsiveChecks = function() {
        this.mql = window.matchMedia('(min-width: 40.0625em)');
        this.mql.addListener(this.checkMode.bind(this));
        this.checkMode();
    };
    Tabs.prototype.checkMode = function() {
        if (this.mql.matches) this.setup();
        else this.teardown();
    };
    Tabs.prototype.setup = function() {
        var $module = this.$module;
        var $tabs = this.$tabs;
        var $tabList = $module.querySelector('.govuk-tabs__list');
        var $tabListItems = $module.querySelectorAll('.govuk-tabs__list-item');
        if (!$tabs || !$tabList || !$tabListItems) return;
        $tabList.setAttribute('role', 'tablist');
        nodeListForEach($tabListItems, function($item) {
            $item.setAttribute('role', 'presentation');
        });
        nodeListForEach($tabs, (function($tab) {
            // Set HTML attributes
            this.setAttributes($tab);
            // Save bounded functions to use when removing event listeners during teardown
            $tab.boundTabClick = this.onTabClick.bind(this);
            $tab.boundTabKeydown = this.onTabKeydown.bind(this);
            // Handle events
            $tab.addEventListener('click', $tab.boundTabClick, true);
            $tab.addEventListener('keydown', $tab.boundTabKeydown, true);
            // Remove old active panels
            this.hideTab($tab);
        }).bind(this));
        // Show either the active tab according to the URL's hash or the first tab
        var $activeTab = this.getTab(window.location.hash) || this.$tabs[0];
        this.showTab($activeTab);
        // Handle hashchange events
        $module.boundOnHashChange = this.onHashChange.bind(this);
        window.addEventListener('hashchange', $module.boundOnHashChange, true);
    };
    Tabs.prototype.teardown = function() {
        var $module = this.$module;
        var $tabs = this.$tabs;
        var $tabList = $module.querySelector('.govuk-tabs__list');
        var $tabListItems = $module.querySelectorAll('.govuk-tabs__list-item');
        if (!$tabs || !$tabList || !$tabListItems) return;
        $tabList.removeAttribute('role');
        nodeListForEach($tabListItems, function($item) {
            $item.removeAttribute('role', 'presentation');
        });
        nodeListForEach($tabs, (function($tab) {
            // Remove events
            $tab.removeEventListener('click', $tab.boundTabClick, true);
            $tab.removeEventListener('keydown', $tab.boundTabKeydown, true);
            // Unset HTML attributes
            this.unsetAttributes($tab);
        }).bind(this));
        // Remove hashchange event handler
        window.removeEventListener('hashchange', $module.boundOnHashChange, true);
    };
    Tabs.prototype.onHashChange = function(e) {
        var hash = window.location.hash;
        var $tabWithHash = this.getTab(hash);
        if (!$tabWithHash) return;
        // Prevent changing the hash
        if (this.changingHash) {
            this.changingHash = false;
            return;
        }
        // Show either the active tab according to the URL's hash or the first tab
        var $previousTab = this.getCurrentTab();
        this.hideTab($previousTab);
        this.showTab($tabWithHash);
        $tabWithHash.focus();
    };
    Tabs.prototype.hideTab = function($tab) {
        this.unhighlightTab($tab);
        this.hidePanel($tab);
    };
    Tabs.prototype.showTab = function($tab) {
        this.highlightTab($tab);
        this.showPanel($tab);
    };
    Tabs.prototype.getTab = function(hash) {
        return this.$module.querySelector('.govuk-tabs__tab[href="' + hash + '"]');
    };
    Tabs.prototype.setAttributes = function($tab) {
        // set tab attributes
        var panelId = this.getHref($tab).slice(1);
        $tab.setAttribute('id', 'tab_' + panelId);
        $tab.setAttribute('role', 'tab');
        $tab.setAttribute('aria-controls', panelId);
        $tab.setAttribute('aria-selected', 'false');
        $tab.setAttribute('tabindex', '-1');
        // set panel attributes
        var $panel = this.getPanel($tab);
        $panel.setAttribute('role', 'tabpanel');
        $panel.setAttribute('aria-labelledby', $tab.id);
        $panel.classList.add(this.jsHiddenClass);
    };
    Tabs.prototype.unsetAttributes = function($tab) {
        // unset tab attributes
        $tab.removeAttribute('id');
        $tab.removeAttribute('role');
        $tab.removeAttribute('aria-controls');
        $tab.removeAttribute('aria-selected');
        $tab.removeAttribute('tabindex');
        // unset panel attributes
        var $panel = this.getPanel($tab);
        $panel.removeAttribute('role');
        $panel.removeAttribute('aria-labelledby');
        $panel.classList.remove(this.jsHiddenClass);
    };
    Tabs.prototype.onTabClick = function(e) {
        if (!e.target.classList.contains('govuk-tabs__tab')) // Allow events on child DOM elements to bubble up to tab parent
        return false;
        e.preventDefault();
        var $newTab = e.target;
        var $currentTab = this.getCurrentTab();
        this.hideTab($currentTab);
        this.showTab($newTab);
        this.createHistoryEntry($newTab);
    };
    Tabs.prototype.createHistoryEntry = function($tab) {
        var $panel = this.getPanel($tab);
        // Save and restore the id
        // so the page doesn't jump when a user clicks a tab (which changes the hash)
        var id = $panel.id;
        $panel.id = '';
        this.changingHash = true;
        window.location.hash = this.getHref($tab).slice(1);
        $panel.id = id;
    };
    Tabs.prototype.onTabKeydown = function(e) {
        switch(e.keyCode){
            case this.keys.left:
            case this.keys.up:
                this.activatePreviousTab();
                e.preventDefault();
                break;
            case this.keys.right:
            case this.keys.down:
                this.activateNextTab();
                e.preventDefault();
                break;
        }
    };
    Tabs.prototype.activateNextTab = function() {
        var currentTab = this.getCurrentTab();
        var nextTabListItem = currentTab.parentNode.nextElementSibling;
        if (nextTabListItem) var nextTab = nextTabListItem.querySelector('.govuk-tabs__tab');
        if (nextTab) {
            this.hideTab(currentTab);
            this.showTab(nextTab);
            nextTab.focus();
            this.createHistoryEntry(nextTab);
        }
    };
    Tabs.prototype.activatePreviousTab = function() {
        var currentTab = this.getCurrentTab();
        var previousTabListItem = currentTab.parentNode.previousElementSibling;
        if (previousTabListItem) var previousTab = previousTabListItem.querySelector('.govuk-tabs__tab');
        if (previousTab) {
            this.hideTab(currentTab);
            this.showTab(previousTab);
            previousTab.focus();
            this.createHistoryEntry(previousTab);
        }
    };
    Tabs.prototype.getPanel = function($tab) {
        var $panel = this.$module.querySelector(this.getHref($tab));
        return $panel;
    };
    Tabs.prototype.showPanel = function($tab) {
        var $panel = this.getPanel($tab);
        $panel.classList.remove(this.jsHiddenClass);
    };
    Tabs.prototype.hidePanel = function(tab) {
        var $panel = this.getPanel(tab);
        $panel.classList.add(this.jsHiddenClass);
    };
    Tabs.prototype.unhighlightTab = function($tab) {
        $tab.setAttribute('aria-selected', 'false');
        $tab.parentNode.classList.remove('govuk-tabs__list-item--selected');
        $tab.setAttribute('tabindex', '-1');
    };
    Tabs.prototype.highlightTab = function($tab) {
        $tab.setAttribute('aria-selected', 'true');
        $tab.parentNode.classList.add('govuk-tabs__list-item--selected');
        $tab.setAttribute('tabindex', '0');
    };
    Tabs.prototype.getCurrentTab = function() {
        return this.$module.querySelector('.govuk-tabs__list-item--selected .govuk-tabs__tab');
    };
    // this is because IE doesn't always return the actual value but a relative full path
    // should be a utility function most prob
    // http://labs.thesedays.com/blog/2010/01/08/getting-the-href-value-with-jquery-in-ie/
    Tabs.prototype.getHref = function($tab) {
        var href = $tab.getAttribute('href');
        var hash = href.slice(href.indexOf('#'), href.length);
        return hash;
    };
    return Tabs;
});


var $c3fcf88523a53093$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($bdebc129c64cd17b$exports)));


function $8f1147b8806ac72e$var$Collapsible($module) {
    this.$module = $module;
}
const $8f1147b8806ac72e$var$handleToggle = (button, content)=>{
    if (content.hasAttribute("hidden")) {
        content.removeAttribute("hidden");
        button.setAttribute("aria-expanded", true);
    } else {
        content.setAttribute("hidden", "");
        button.setAttribute("aria-expanded", false);
    }
};
$8f1147b8806ac72e$var$Collapsible.prototype.init = function() {
    const button = this.$module.querySelector('[data-behavior="lbh-collapsible-toggle"]');
    const content = this.$module.querySelector('[data-behavior="lbh-collapsible-content"]');
    button.addEventListener("click", ()=>$8f1147b8806ac72e$var$handleToggle(button, content));
};
var $8f1147b8806ac72e$export$2e2bcd8739ae039 = $8f1147b8806ac72e$var$Collapsible;


function $f4347ff8e99312c6$var$nodeListForEach(nodes, callback) {
    if (window.NodeList.prototype.forEach) return nodes.forEach(callback);
    for(var i = 0; i < nodes.length; i++)callback.call(window, nodes[i], i, nodes);
}
function $f4347ff8e99312c6$export$eb5ff443d10caf06(options) {
    // Set the options to an empty object by default if no options are passed.
    options = typeof options !== "undefined" ? options : {};
    (0, (/*@__PURE__*/$parcel$interopDefault($bfc2f5739098ea1c$exports))).initAll();
    // Allow the user to initialise GOV.UK Frontend in only certain sections of the page
    // Defaults to the entire document if nothing is set.
    var scope = typeof options.scope !== "undefined" ? options.scope : document;
    var $cookieBanner = scope.querySelector('[data-module="lbh-cookie-banner"]');
    if ($cookieBanner) new (0, $19091a8654fef294$export$2e2bcd8739ae039)($cookieBanner).init();
    var $maps = scope.querySelectorAll('[data-module="lbh-map"]');
    $f4347ff8e99312c6$var$nodeListForEach($maps, function($map) {
        new (0, $8040fecc34f37497$export$2e2bcd8739ae039)($map).init();
    });
    var $backToTop = scope.querySelector('[data-module="lbh-back-to-top"]');
    if ($backToTop) new (0, $b1193ff8affee9e0$export$2e2bcd8739ae039)($backToTop).init();
    const $collapsibles = scope.querySelectorAll('[data-module="lbh-collapsible"]');
    $f4347ff8e99312c6$var$nodeListForEach($collapsibles, function($collapsible) {
        new (0, $8f1147b8806ac72e$export$2e2bcd8739ae039)($collapsible).init();
    });
}




var $b302555736d21bd7$exports = {};

$b302555736d21bd7$exports = (parcelRequire("7we3r"));


//activate the start button
document.getElementById("start-button").onclick = function() {
    document.getElementById("location-search").hidden = false;
    document.getElementById("start-button").style.display = "none";
    window.scrollBy(0, 100);
};
// Create a variable for the postcode.
let $35da740d59af89ba$var$postcode = document.getElementById("postcode");
//Enter key listener that calls the GetAddressesviaPoxy function
$35da740d59af89ba$var$postcode.addEventListener("keyup", (e)=>{
    if (e.key == "Enter") $35da740d59af89ba$var$GetAddressesViaProxy();
});
//eventlistener for the button
document.getElementById("search").addEventListener("click", $35da740d59af89ba$var$GetAddressesViaProxy);
//listener for the clear x in the input
$35da740d59af89ba$var$postcode.addEventListener("search", (e)=>{
    document.getElementById("error_message").innerHTML = "";
    document.getElementById("addresses").innerHTML = "";
    document.getElementById("address-details").innerHTML = "";
    //document.getElementById("show-results-button-div").innerHTML = "";
    document.getElementById("results").innerHTML = "";
});
function $35da740d59af89ba$var$GetAddressesViaProxy() {
    document.getElementById("error_message").innerHTML = "";
    document.getElementById("addresses").innerHTML = '<p class="loading-text"> Loading addresses...</p>';
    document.getElementById("address-details").innerHTML = "";
    //document.getElementById("show-results-button-div").innerHTML = "";
    document.getElementById("results").innerHTML = "";
    document.getElementById("addresses").scrollIntoView({
        block: "nearest"
    });
    //Get the postcode value
    let address_input = document.getElementById("postcode").value;
    //test against postcode regex
    let postcode_regex = new RegExp("^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$");
    let isPostcode = postcode_regex.test(address_input);
    let results = null;
    if (!address_input) document.getElementById("error_message").innerHTML = "Please enter some text in the location search.";
    else {
        //prepare query to send to the API, depending if we ave got a postcode or not
        let APIQueryString = "";
        if (isPostcode) APIQueryString = `${"https://zwb5f0hl7b.execute-api.us-east-1.amazonaws.com/production/address-v2-proxy"}?format=detailed&usage_code=C,X,LP02&postcode=${address_input}`;
        else APIQueryString = `${"https://zwb5f0hl7b.execute-api.us-east-1.amazonaws.com/production/address-v2-proxy"}?format=detailed&usage_code=C,X,LP02&query=${address_input}`;
        //First call to get the list of addresses from a postcode
        fetch(APIQueryString, {
            method: "get"
        }).then((response1)=>response1.json()).then((data)=>{
            //Get API error messages if the UPRN values are not right
            if (data.data.errors) {
                document.getElementById("error_message").innerHTML = response.data.errors[0].message;
                document.getElementById("addresses").innerHTML = "";
            //If there are no errors...
            } else {
                results = data.data.data.address;
                let pageCount = data.data.data.pageCount;
                //If there are no results, the postcode is not right.
                if (results.length === 0) {
                    document.getElementById("error_message").innerHTML = "No Hackney location found. Please amend your search.";
                    document.getElementById("addresses").innerHTML = "";
                    document.getElementById("address-details").innerHTML = "";
                } else {
                    //If there are results from the addresses proxy, we list them.
                    //first, replace list element with a clone of itself, in order to remove previous listeners
                    //let listElement = document.getElementById("addresses");
                    document.getElementById("addresses").replaceWith(document.getElementById("addresses").cloneNode(true));
                    //now fill the list
                    document.getElementById("addresses").innerHTML = "<div class='govuk-form-group lbh-form-group'><select class='govuk-select govuk-!-width-full lbh-select' id='selectedAddress' name='selectedAddress'>";
                    document.getElementById("selectedAddress").innerHTML = "<option disabled selected value> Select a location from the list </option>";
                    for(let index = 0; index < results.length; ++index)//if (results[index].addressStatus == 'Approved' && (results[index].usagePrimary == 'Commercial' || results[index].usagePrimary == 'Dual Use')){
                    if (results[index].commercialOccupier) document.getElementById("selectedAddress").innerHTML += "<option value='" + results[index].UPRN + "/" + results[index].singleLineAddress + "/" + results[index].usageDescription + "/" + results[index].ward + "'>" + results[index].commercialOccupier + " - " + results[index].singleLineAddress + "</option>";
                    else document.getElementById("selectedAddress").innerHTML += "<option value='" + results[index].UPRN + "/" + results[index].singleLineAddress + "/" + results[index].usageDescription + "/" + results[index].ward + "'>" + results[index].singleLineAddress + "</option>";
                    //load more pages of results if needed
                    if (pageCount > 1) for(let pgindex = 2; pgindex <= pageCount; ++pgindex)$35da740d59af89ba$var$loadAddressAPIPageViaProxy(APIQueryString, address_input, pgindex);
                    //close list of addresses
                    document.getElementById("addresses").innerHTML += "</select></div>";
                    //capture the change event - when an address is selected - we load the list of results using the UPRN selected.
                    document.getElementById("addresses").addEventListener("change", (event)=>{
                        //get the selected UPRN and address details from the list of addresses
                        let selectedAddressDetails = document.querySelector("#selectedAddress").value.split("/");
                        let selectedUPRN = selectedAddressDetails[0];
                        $35da740d59af89ba$var$loadRegisterInfo(selectedUPRN);
                        document.getElementById("results").innerHTML = "";
                    });
                    window.scrollBy(0, 50);
                }
            }
        }).catch((error)=>{
            console.log(error);
            document.getElementById("error_message").innerHTML = "Sorry, an error occured while retrieving locations";
            document.getElementById("addresses").innerHTML = "";
        });
    }
}
//function to add one page of results to the options list
function $35da740d59af89ba$var$loadAddressAPIPageViaProxy(APIQueryString, address_input, pg) {
    let results = null;
    let full_address = null;
    let UPRN = null;
    fetch(APIQueryString + `&page=${pg}`, {
        method: "get"
    }).then((response1)=>response1.json()).then((data)=>{
        results = data.data.data.address;
        for(let index = 0; index < results.length; ++index)//if (results[index].addressStatus == 'Approved' && (results[index].usagePrimary == 'Commercial' || results[index].usagePrimary == 'Dual Use')){
        if (results[index].commercialOccupier) document.getElementById("selectedAddress").innerHTML += "<option value='" + results[index].UPRN + "/" + results[index].singleLineAddress + "/" + results[index].usageDescription + "/" + results[index].ward + "'>" + results[index].commercialOccupier + " - " + results[index].singleLineAddress + "</option>";
        else document.getElementById("selectedAddress").innerHTML += "<option value='" + results[index].UPRN + "/" + results[index].singleLineAddress + "/" + results[index].usageDescription + "/" + results[index].ward + "'>" + results[index].singleLineAddress + "</option>";
    });
}
function $35da740d59af89ba$var$loadRegisterInfo(selectedUPRN) {
    const url = `${"https://map2.hackney.gov.uk/geoserver//licensing/ows/"}?service=WFS&version=1.0.0&request=GetFeature&outputFormat=json&typeName=licensing_act_2003_premises&cql_filter=uprn='${selectedUPRN}'`;
    (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get(url).then((res)=>{
        const resultsContainer = document.getElementById("results");
        // 1. DATA VALIDATION
        if (res.data.numberReturned === 0) {
            resultsContainer.innerHTML = '<span class="govuk-error-message lbh-error-message">No license found at this location. <br> Note: data is under review and will be added gradually. If you can&#39;t find the information you are looking for, please contact us at licensing@hackney.gov.uk.</span>';
            return;
        }
        if (res.data.numberReturned > 1) {
            resultsContainer.innerHTML = '<span class="govuk-error-message lbh-error-message">There are multiple licenses associated to this address. Please contact us at licensing@hackney.gov.uk.</span>';
            return;
        }
        // 2. INITIALIZE PAGE
        resultsContainer.innerHTML = '<p class="loading-text"> Retrieving information...</p>';
        resultsContainer.scrollIntoView({
            block: "nearest"
        });
        let textSection = "<h3>License details: </h3>";
        const featureProperties = res.data.features[0].properties;
        // 3. BUILD SUMMARY LIST (Main Details)
        textSection += `<dl class="govuk-summary-list lbh-summary-list">`;
        if (featureProperties.premises_name) textSection += `<div class="govuk-summary-list__row"><dt class="govuk-summary-list__key">Premises name</dt><dd class="govuk-summary-list__value">${featureProperties.premises_name}</dd></div>`;
        if (featureProperties.premises_full_address) textSection += `<div class="govuk-summary-list__row"><dt class="govuk-summary-list__key">Premises address</dt><dd class="govuk-summary-list__value">${featureProperties.premises_full_address}</dd></div>`;
        if (featureProperties.ward) textSection += `<div class="govuk-summary-list__row"><dt class="govuk-summary-list__key">Ward</dt><dd class="govuk-summary-list__value">${featureProperties.ward}</dd></div>`;
        if (featureProperties.licence_number) textSection += `<div class="govuk-summary-list__row"><dt class="govuk-summary-list__key">Licence number</dt><dd class="govuk-summary-list__value">${featureProperties.licence_number}</dd></div>`;
        // Licence Holder Logic
        if (featureProperties.licence_holder_1_full_line) {
            let holders = featureProperties.licence_holder_1_full_line;
            if (featureProperties.licence_holder_2_full_line) holders += `<br>${featureProperties.licence_holder_2_full_line}`;
            if (featureProperties.licence_holder_3_full_line) holders += `<br>${featureProperties.licence_holder_3_full_line}`;
            textSection += `<div class="govuk-summary-list__row"><dt class="govuk-summary-list__key">Premises licence holder(s)</dt><dd class="govuk-summary-list__value">${holders}</dd></div>`;
        }
        if (featureProperties.designated_premises_supervisor) textSection += `<div class="govuk-summary-list__row"><dt class="govuk-summary-list__key">Designated premises supervisor (DPS)</dt><dd class="govuk-summary-list__value">${featureProperties.designated_premises_supervisor}</dd></div>`;
        if (featureProperties.date_granted) textSection += `<div class="govuk-summary-list__row"><dt class="govuk-summary-list__key">Date granted</dt><dd class="govuk-summary-list__value">${featureProperties.date_granted}</dd></div>`;
        // Licence Status with Tag logic
        if (featureProperties.licence_status) {
            const redStatuses = [
                "Surrendered",
                "Revoked",
                "Lapsed",
                "Deferred",
                "In Mediation",
                "In-consultation",
                "Invalid",
                "Invalid code",
                "Sub-Committee",
                "Suspended",
                "Unknown/empty"
            ];
            const tagColor = redStatuses.includes(featureProperties.licence_status) ? "lbh-tag--red" : "lbh-tag--green";
            textSection += `<div class="govuk-summary-list__row">
          <dt class="govuk-summary-list__key">Licence status</dt>
          <dd class="govuk-summary-list__value"><span class="govuk-tag lbh-tag ${tagColor}">${featureProperties.licence_status}</span></dd>
        </div>`;
        }
        textSection += `</dl>`; // Close Summary List
        // 4. BUILD ACTIVITIES TABLE
        const inactiveStatuses = [
            "Surrendered",
            "Revoked",
            "Lapsed",
            "Invalid"
        ];
        if (!inactiveStatuses.includes(featureProperties.licence_status)) {
            textSection += `<br><br>
          <table class="govuk-table lbh-table">
            <caption class="govuk-table__caption lbh-heading-h3">
              The times the licence authorises the carrying out of licensable activities:
            </caption>
            <tbody class="govuk-table__body">`;
            /**
         * Helper function to build a multi-column row
         * This mirrors your original logic of checking time1, time2, time3
         */ const buildActivityRow = (label, props)=>{
                // props = { t1, l1, t2, l2, t3, l3 }
                if (!props.t1) return "";
                let row = `<tr class="govuk-table__row">
            <th scope="row" class="govuk-table__header">${label}</th>
            <td class="govuk-table__cell govuk-table__cell--numeric">
              ${props.l1 ? props.l1 + '<br>' : ''}${props.t1}
            </td>`;
                // Add second column if exists, otherwise empty cell
                row += `<td class="govuk-table__cell govuk-table__cell--numeric">
            ${props.t2 ? (props.l2 ? props.l2 + '<br>' : '') + props.t2 : ''}
          </td>`;
                // Add third column if exists, otherwise empty cell
                row += `<td class="govuk-table__cell govuk-table__cell--numeric">
            ${props.t3 ? (props.l3 ? props.l3 + '<br>' : '') + props.t3 : ''}
          </td>`;
                row += `</tr>`;
                return row;
            };
            // Add each activity using the multi-column helper
            textSection += buildActivityRow("Plays", {
                t1: featureProperties.playstime1,
                l1: featureProperties.playslocation1,
                t2: featureProperties.playstime2,
                l2: featureProperties.playslocation2,
                t3: featureProperties.playstime3,
                l3: featureProperties.playslocation3
            });
            textSection += buildActivityRow("Exhibition of films", {
                t1: featureProperties.filmstime1,
                l1: featureProperties.filmslocation1,
                t2: featureProperties.filmstime2,
                l2: featureProperties.filmslocation2,
                t3: featureProperties.filmstime3,
                l3: featureProperties.filmslocation3
            });
            textSection += buildActivityRow("Indoor sporting events", {
                t1: featureProperties.indoortime1,
                l1: featureProperties.sportslocation1,
                t2: featureProperties.indoortime2,
                l2: featureProperties.sportslocation2,
                t3: featureProperties.indoortime3,
                l3: featureProperties.sportslocation3
            });
            textSection += buildActivityRow("Boxing", {
                t1: featureProperties.boxingtime1,
                l1: featureProperties.boxinglocation1,
                t2: featureProperties.boxingtime2,
                l2: featureProperties.boxinglocation2,
                t3: featureProperties.boxingtime3,
                l3: featureProperties.boxinglocation3
            });
            textSection += buildActivityRow("Live music", {
                t1: featureProperties.livemusictime1,
                l1: featureProperties.livemusiclocation1,
                t2: featureProperties.livemusictime2,
                l2: featureProperties.livemusiclocation2,
                t3: featureProperties.livemusictime3,
                l3: featureProperties.livemusiclocation3
            });
            textSection += buildActivityRow("Recorded music", {
                t1: featureProperties.recordemusictime1,
                l1: featureProperties.recordedlocation1,
                t2: featureProperties.recordemusictime2,
                l2: featureProperties.recordedlocation2,
                t3: featureProperties.recordemusictime3,
                l3: featureProperties.recordedlocation3
            });
            textSection += buildActivityRow("Performances of dance", {
                t1: featureProperties.dancetime1,
                l1: featureProperties.perf_dance_location1,
                t2: featureProperties.dancetime2,
                l2: featureProperties.perf_dance_location2,
                t3: featureProperties.dancetime3,
                l3: featureProperties.perf_dance_location3
            });
            textSection += buildActivityRow("Entertainment of a similar description to live music recorded music and performances of dance", {
                t1: featureProperties.other_enter_time1,
                l1: featureProperties.other_enter_location1,
                t2: featureProperties.other_enter_time2,
                l2: featureProperties.other_enter_location2,
                t3: featureProperties.other_enter_time3,
                l3: featureProperties.other_enter_location3
            });
            textSection += buildActivityRow("Late night refreshment", {
                t1: featureProperties.latenighttime1,
                l1: featureProperties.latenightlocation1,
                t2: featureProperties.latenighttime2,
                l2: featureProperties.latenightlocation2,
                t3: featureProperties.latenighttime3,
                l3: featureProperties.latenightlocation3
            });
            // Alcohol specific label including sale type (On/Off)
            const alcoholLabel = `Supply of alcohol<br>(${featureProperties.alcoholsaletype || ''})`;
            textSection += buildActivityRow(alcoholLabel, {
                t1: featureProperties.alcoholtimes1,
                l1: featureProperties.alcohollocation1,
                t2: featureProperties.alcoholtimes2,
                l2: featureProperties.alcohollocation2,
                t3: featureProperties.alcoholtimes3,
                l3: featureProperties.alcohollocation3
            });
            // Opening times
            textSection += buildActivityRow("Opening times", {
                t1: featureProperties.openinghourstimes1,
                l1: "",
                t2: featureProperties.openinghourstimes2,
                l2: "",
                t3: featureProperties.openinghourstimes3,
                l3: ""
            });
            textSection += `</tbody></table>`;
        }
        // 5. BUILD CONDITIONS ACCORDION
        const formatConditionText = (text)=>{
            if (!text) return "";
            return text.replace(/\u0001/g, '<br>') // Cleans up the database separator
            .replace(/\n/g, '<br>'); // Cleans up standard newlines
        };
        // We handle Mandatory categories individually so we can put extra spacing between them
        let mandatoryParts = [];
        if (featureProperties.mandatory_cond_alcohol_supply) mandatoryParts.push(`<strong>Supply of Alcohol</strong><br>${formatConditionText(featureProperties.mandatory_cond_alcohol_supply)}`);
        if (featureProperties.mandatory_cond_door_supervision) mandatoryParts.push(`<strong>Door Supervision</strong><br>${formatConditionText(featureProperties.mandatory_cond_door_supervision)}`);
        if (featureProperties.mandatory_cond_film_exhibition) mandatoryParts.push(`<strong>Film Exhibition</strong><br>${formatConditionText(featureProperties.mandatory_cond_film_exhibition)}`);
        // Join the parts with a double break for that "clean" spacing
        let mandatoryText = mandatoryParts.join('<br><br>');
        let annex2Text = formatConditionText((featureProperties.opening_schedule || "") + (featureProperties.responsible_authority || ""));
        let annex3Text = formatConditionText(featureProperties.committee_hearing || "");
        textSection += `<br><br><h3 class="lbh-heading-h3">Conditions</h3>
        <div class="govuk-accordion lbh-accordion" data-module="govuk-accordion" id="accordion-licence">`;
        // Mandatory Section
        textSection += `
        <div class="govuk-accordion__section">
          <div class="govuk-accordion__section-header">
            <h5 class="govuk-accordion__section-heading">
              <span class="govuk-accordion__section-button">Mandatory Conditions</span>
            </h5>
          </div>
          <div class="govuk-accordion__section-content">
            <p class="govuk-body">${mandatoryText || "No mandatory conditions specified."}</p>
          </div>
        </div>`;
        // Annex 2 Section (consistent with your clean look)
        if (annex2Text) textSection += `
          <div class="govuk-accordion__section">
            <div class="govuk-accordion__section-header">
              <h5 class="govuk-accordion__section-heading">
                <span class="govuk-accordion__section-button">Annex 2 - Conditions consistent with Operating Schedule</span>
              </h5>
            </div>
            <div class="govuk-accordion__section-content">
              <p class="govuk-body">${annex2Text}</p>
            </div>
          </div>`;
        // Annex 3 Section
        if (annex3Text) textSection += `
          <div class="govuk-accordion__section">
            <div class="govuk-accordion__section-header">
              <h5 class="govuk-accordion__section-heading">
                <span class="govuk-accordion__section-button">Annex 3 - Conditions attached after Authority hearing</span>
              </h5>
            </div>
            <div class="govuk-accordion__section-content">
              <p class="govuk-body">${annex3Text}</p>
            </div>
          </div>`;
        textSection += `</div>`; // End Accordion
        // 6. FINAL RENDER & INITIALIZATION
        resultsContainer.innerHTML = textSection;
        const accordionElem = document.querySelector('[data-module="govuk-accordion"]');
        if (accordionElem) new (0, $6d0087d128b600ac$export$2e2bcd8739ae039)(accordionElem).init();
    }).catch((error)=>{
        console.error('Fetch Error:', error);
        document.getElementById("error_message").innerHTML = 'Sorry, there was a problem retrieving the results for this address.';
    });
}


//# sourceMappingURL=lbh-licensing-register.42d3ca7e.js.map
